import React from 'react';
import { registerIcons } from '@fluentui/react';
import { p4Tokens } from '../../styles/themes/default/p4FluentTheme';

export enum P4SVGIcon {
  TradeCounterStockAdjustPlus = 'TRADE_COUNTER_STOCK_ADJUST_PLUS',
  TradeCounterVoidLine = 'TRADE_COUNTER_VOID_LINE',
  TradeCounterBatchAllocation = 'TRADE_COUNTER_BATCH_ALLOCATION',
  StockAdjustmentPrintWorkspace = 'STOCK_ADJUSTMENT_PRINT_WORKSPACE',
  SalesOrderDeliveryAddress = 'SALES_ORDER_DELIVERY_ADDRESS',
  CustomerGlobalContact = 'CUSTOMER_GLOBAL_CONTACT',
}

const Icon = ({ icon, fillColor }: { icon: string | P4SVGIcon; fillColor: string }) => {
  switch (icon) {
    case 'binlocations':
      return (
        <g>
          <line
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.7866"
            strokeLinecap="round"
            strokeMiterlimit="10"
            x1="6.9"
            y1="7"
            x2="6.9"
            y2="50.8"
          />
          <line
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.7866"
            strokeLinecap="round"
            strokeMiterlimit="10"
            x1="51.4"
            y1="7"
            x2="51.4"
            y2="50.8"
          />
          <line
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.7866"
            strokeLinecap="round"
            strokeMiterlimit="10"
            x1="30.5"
            y1="7"
            x2="30.5"
            y2="50.8"
          />
          <line
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.7866"
            strokeLinecap="round"
            strokeMiterlimit="10"
            x1="50.8"
            y1="48.1"
            x2="7"
            y2="48.1"
          />
          <line
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.7866"
            strokeLinecap="round"
            strokeMiterlimit="10"
            x1="50.8"
            y1="29.6"
            x2="7"
            y2="29.6"
          />
          <path
            fill="#FFFFFF"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.1911"
            strokeMiterlimit="10"
            d="M27.3,46.1H22c-0.3,0-0.6-0.3-0.6-0.6V32.2
	c0-0.3,0.3-0.6,0.6-0.6h5.3c0.3,0,0.6,0.3,0.6,0.6v13.3C27.9,45.8,27.6,46.1,27.3,46.1z"
          />
          <path
            fill="#FFFFFF"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.1911"
            strokeMiterlimit="10"
            d="M38.8,46.1h-5.3c-0.3,0-0.6-0.3-0.6-0.6
	V32.2c0-0.3,0.3-0.6,0.6-0.6h5.3c0.3,0,0.6,0.3,0.6,0.6v13.3C39.5,45.8,39.2,46.1,38.8,46.1z"
          />
          <path
            fill="#FFFFFF"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.1911"
            strokeMiterlimit="10"
            d="M48.3,46.1H43c-0.3,0-0.6-0.3-0.6-0.6V32.2
	c0-0.3,0.3-0.6,0.6-0.6h5.3c0.3,0,0.6,0.3,0.6,0.6v13.3C48.9,45.8,48.6,46.1,48.3,46.1z"
          />
          <path
            fill="#FFFFFF"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.1911"
            strokeMiterlimit="10"
            d="M38.8,27.6h-5.3c-0.3,0-0.6-0.3-0.6-0.6
	V13.7c0-0.3,0.3-0.6,0.6-0.6h5.3c0.3,0,0.6,0.3,0.6,0.6V27C39.5,27.3,39.2,27.6,38.8,27.6z"
          />
          <path
            fill="#FFFFFF"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.1911"
            strokeMiterlimit="10"
            d="M48.3,27.6H43c-0.3,0-0.6-0.3-0.6-0.6V13.7
	c0-0.3,0.3-0.6,0.6-0.6h5.3c0.3,0,0.6,0.3,0.6,0.6V27C48.9,27.3,48.6,27.6,48.3,27.6z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M19.1,45.8H9.7c-0.4,0-0.7-0.3-0.7-0.7v-9.4c0-0.4,0.3-0.7,0.7-0.7h9.4c0.4,0,0.7,0.3,0.7,0.7v9.4
	C19.7,45.5,19.4,45.8,19.1,45.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M27.5,27.6h-9.4c-0.4,0-0.7-0.3-0.7-0.7v-9.4c0-0.4,0.3-0.7,0.7-0.7h9.4c0.4,0,0.7,0.3,0.7,0.7v9.4
	C28.2,27.3,27.8,27.6,27.5,27.6z"
          />
          <line
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.7866"
            strokeLinecap="round"
            strokeMiterlimit="10"
            x1="50.8"
            y1="10.5"
            x2="7"
            y2="10.5"
          />
        </g>
      );
    case 'bincontents':
      return (
        <g>
          <g>
            <line
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.7866"
              strokeLinecap="round"
              strokeMiterlimit="10"
              x1="2.4"
              y1="3.7"
              x2="2.4"
              y2="47.6"
            />
            <line
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.7866"
              strokeLinecap="round"
              strokeMiterlimit="10"
              x1="46.9"
              y1="3.7"
              x2="46.9"
              y2="47.6"
            />
            <line
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.7866"
              strokeLinecap="round"
              strokeMiterlimit="10"
              x1="26"
              y1="3.7"
              x2="26"
              y2="47.6"
            />
            <line
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.7866"
              strokeLinecap="round"
              strokeMiterlimit="10"
              x1="46.3"
              y1="44.8"
              x2="2.5"
              y2="44.8"
            />
            <line
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.7866"
              strokeLinecap="round"
              strokeMiterlimit="10"
              x1="46.3"
              y1="26.4"
              x2="2.5"
              y2="26.4"
            />
            <path
              fill="#FFFFFF"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.1911"
              strokeMiterlimit="10"
              d="M22.8,42.8h-5.3c-0.3,0-0.6-0.3-0.6-0.6V28.9c0-0.3,0.3-0.6,0.6-0.6h5.3c0.3,0,0.6,0.3,0.6,0.6v13.3
				C23.4,42.5,23.1,42.8,22.8,42.8z"
            />
            <path
              fill="#FFFFFF"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.1911"
              strokeMiterlimit="10"
              d="M34.3,42.8H29c-0.3,0-0.6-0.3-0.6-0.6V28.9c0-0.3,0.3-0.6,0.6-0.6h5.3c0.3,0,0.6,0.3,0.6,0.6v13.3
				C34.9,42.5,34.7,42.8,34.3,42.8z"
            />
            <path
              fill="#FFFFFF"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.1911"
              strokeMiterlimit="10"
              d="M43.8,42.8h-5.3c-0.3,0-0.6-0.3-0.6-0.6V28.9c0-0.3,0.3-0.6,0.6-0.6h5.3c0.3,0,0.6,0.3,0.6,0.6v13.3
				C44.4,42.5,44.1,42.8,43.8,42.8z"
            />
            <path
              fill="#FFFFFF"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.1911"
              strokeMiterlimit="10"
              d="M34.3,24.4H29c-0.3,0-0.6-0.3-0.6-0.6V10.4c0-0.3,0.3-0.6,0.6-0.6h5.3c0.3,0,0.6,0.3,0.6,0.6v13.3
				C34.9,24.1,34.7,24.4,34.3,24.4z"
            />
            <path
              fill="#FFFFFF"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.1911"
              strokeMiterlimit="10"
              d="M43.8,24.4h-5.3c-0.3,0-0.6-0.3-0.6-0.6V10.4c0-0.3,0.3-0.6,0.6-0.6h5.3c0.3,0,0.6,0.3,0.6,0.6v13.3
				C44.4,24.1,44.1,24.4,43.8,24.4z"
            />
            <path
              fill="#2C3279"
              d="M14.5,42.5H5.2c-0.4,0-0.7-0.3-0.7-0.7v-9.4c0-0.4,0.3-0.7,0.7-0.7h9.4c0.4,0,0.7,0.3,0.7,0.7v9.4
				C15.2,42.2,14.9,42.5,14.5,42.5z"
            />
            <path
              fill="#2C3279"
              d="M23,24.4h-9.4c-0.4,0-0.7-0.3-0.7-0.7v-9.4c0-0.4,0.3-0.7,0.7-0.7H23c0.4,0,0.7,0.3,0.7,0.7v9.4
				C23.6,24,23.3,24.4,23,24.4z"
            />
            <line
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.7866"
              strokeLinecap="round"
              strokeMiterlimit="10"
              x1="46.3"
              y1="7.3"
              x2="2.5"
              y2="7.3"
            />
          </g>
          <g>
            <path
              fill="#2C3279"
              d="M45.1,35.1c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C53.9,39,50,35.1,45.1,35.1z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M44.3,46.9v-1c0-1.2,0.3-1.5,1.2-2.3c0.7-0.7,1.5-1.3,1.5-2.3c0-1-0.8-1.8-1.8-1.8c-1.1,0-1.8,0.8-1.9,1.9
					l-1.7-0.2c0.3-1.9,1.7-3.1,3.7-3.1c1.9,0,3.3,1.1,3.3,3.1c0,0.9-0.3,1.5-0.7,2c0,0,0,0-1,1c0,0,0,0-0.2,0.2
					c-0.7,0.7-0.8,0.9-0.8,1.8v0.7H44.3z M45.1,48.1c0.6,0,1.1,0.5,1.1,1.1s-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1
					S44.5,48.1,45.1,48.1z"
            />
          </g>
        </g>
      );
    case 'configuration':
      return (
        <g>
          <circle fill={p4Tokens.colorBrandMenuForeground1} cx="41.7" cy="38.8" r="2.1" />
          <circle fill={p4Tokens.colorBrandMenuForeground1} cx="21.6" cy="23.2" r="3.4" />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.2"
            d="M36.5,17.1l-2-3.6c-0.3-0.5-0.9-0.5-1.4-0.3L31,14.5l0,0
	c-0.9-0.9-2-1.8-3.2-2.5l0.6-2.3c0.1-0.5-0.2-1-0.7-1.2l-4-1.1c-0.5-0.1-1,0.2-1.2,0.7L22,10.4l0,0c-1.3,0-2.5,0-3.9,0.5l-1.2-2.1
	c-0.3-0.5-0.9-0.6-1.4-0.4l-3.6,2c-0.5,0.3-0.4,0.8-0.1,1.2l1.2,2.1l0,0c-1.1,1-1.9,2-2.5,3.2l-2.4-0.6c-0.5-0.1-1,0.2-1.2,0.7
	l-1.1,4c-0.1,0.5,0.2,1,0.7,1.2l2.3,0.6l0,0c0,1.3,0,2.5,0.5,4l-2.1,1.2c-0.5,0.3-0.5,0.7-0.3,1.2l2,3.6c0.3,0.5,0.7,0.6,1.1,0.3
	l2.1-1.2l0,0c1,1.1,2,1.9,3.2,2.5l-0.6,2.3c-0.1,0.5,0.2,1,0.7,1.2l4,1.1c0.5,0.1,1-0.2,1.2-0.7l0.6-2.3l0.1,0
	c1.3,0,2.6-0.1,4.1-0.6l1.2,2.1c0.3,0.5,0.6,0.7,1.1,0.4l3.6-2c0.5-0.3,0.7-0.8,0.4-1.3l-1.2-2.1l0,0c1.1-1,1.8-1.9,2.4-3.1l2.3,0.6
	c0.5,0.1,1-0.2,1.2-0.7l1.1-4c0.1-0.5-0.2-1-0.7-1.2l-2.3-0.6l0,0c0-1.3-0.1-2.6-0.5-4l2.1-1.2C36.4,18.1,36.8,17.6,36.5,17.1z
	 M16.3,19c0.5-0.7,1.2-1.2,1.9-1.7c1-0.6,2-0.8,3-0.9c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0
	c0.1,0,0.1,0,0.2,0c0.2,0,0.4,0.1,0.6,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.1,0,0.2,0.1c0.1,0,0.2,0.1,0.3,0.1
	c0.1,0,0.1,0,0.2,0.1c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0.1,0.2,0.1c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.1,0.2,0.2,0.4,0.2
	c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.2,0.2,0.2,0.2c0.4,0.4,0.7,0.9,1,1.4
	c0.5,0.9,0.8,1.9,0.9,2.9c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.3-0.1,0.5-0.1,0.8c0,0.1,0,0.2-0.1,0.3
	c0,0.2-0.1,0.3-0.1,0.5c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.1-0.1,0.2c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.1-0.1,0.3-0.2,0.4
	c-0.1,0.1-0.1,0.2-0.2,0.3c-0.6,0.9-1.3,1.6-2.3,2.2c-0.8,0.5-1.7,0.7-2.6,0.9c-0.1,0-0.2,0-0.3,0c-0.3,0-0.7,0-1,0
	c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0c-0.2,0-0.3-0.1-0.5-0.1c-1.8-0.4-3.4-1.5-4.4-3.2c-0.5-0.8-0.8-1.7-0.9-2.6
	c0-0.4-0.1-0.8,0-1.1c0-0.1,0-0.3,0-0.4c0-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.2-0.6,0.3-0.9c0-0.1,0-0.1,0.1-0.2c0-0.1,0.1-0.2,0.1-0.3
	c0-0.1,0.1-0.2,0.2-0.3c0.1-0.2,0.2-0.4,0.3-0.6c0-0.1,0.1-0.1,0.1-0.2C16.2,19.1,16.3,19.1,16.3,19z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.2"
            strokeMiterlimit="10"
            d="M48.8,31.8l-2-1.6c-0.3-0.2-0.7-0.1-0.9,0.2
	L45,31.5l0,0c-0.7-0.3-1.6-0.6-2.4-0.7l-0.2-1.5c0-0.3-0.3-0.6-0.7-0.5l-2.6,0.3c-0.3,0-0.6,0.3-0.5,0.7l0.2,1.5l0,0
	c-0.8,0.3-1.4,0.6-2.2,1.2l-1.2-0.9c-0.3-0.2-0.7-0.2-0.9,0.1l-1.6,2c-0.2,0.3-0.1,0.5,0.2,0.8l1.2,0.9l0,0
	c-0.4,0.9-0.6,1.6-0.7,2.5l-1.5,0.2c-0.3,0-0.6,0.3-0.5,0.7l0.3,2.6c0,0.3,0.3,0.6,0.7,0.5l1.5-0.2l0,0c0.3,0.8,0.6,1.5,1.2,2.2
	l-0.9,1.2c-0.2,0.3-0.1,0.5,0.1,0.8l2,1.6c0.3,0.2,0.5,0.2,0.7-0.1l0.9-1.2l0,0c0.9,0.4,1.6,0.6,2.4,0.7l0.2,1.5
	c0,0.3,0.3,0.6,0.7,0.5l2.6-0.3c0.3,0,0.6-0.3,0.5-0.7l-0.2-1.5l0,0c0.8-0.3,1.5-0.7,2.2-1.3l1.2,0.9c0.3,0.2,0.5,0.3,0.7,0l1.6-2
	c0.2-0.3,0.2-0.6-0.1-0.8L49,42.1l0,0c0.4-0.9,0.6-1.6,0.7-2.4l1.5-0.2c0.3,0,0.6-0.3,0.5-0.7l-0.3-2.6c0-0.3-0.3-0.6-0.7-0.5
	L49.2,36l0,0c-0.3-0.8-0.6-1.5-1.3-2.2l0.9-1.2C49,32.3,49.1,32,48.8,31.8z M37.4,37.6c0.1-0.5,0.4-1,0.8-1.5c0.4-0.6,1-1,1.6-1.3
	c0.1,0,0.1-0.1,0.2-0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2-0.1c0.1,0,0.1,0,0.2-0.1c0,0,0.1,0,0.1,0c0.1,0,0.3-0.1,0.4-0.1
	c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0
	c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0.1c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.1,0.1,0.2,0.1
	c0.3,0.1,0.7,0.3,1,0.6c0.5,0.4,1,0.9,1.2,1.5c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0.1,0.2
	c0.1,0.2,0.1,0.3,0.1,0.5c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2
	c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.2c-0.1,0.7-0.4,1.3-0.8,1.9c-0.4,0.5-0.8,0.9-1.3,1.1c-0.1,0-0.1,0.1-0.2,0.1
	c-0.2,0.1-0.4,0.2-0.6,0.2c-0.1,0-0.1,0-0.2,0.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0.1c-1.2,0.2-2.4-0.1-3.4-0.9
	c-0.5-0.4-0.9-0.8-1.1-1.3c-0.1-0.2-0.2-0.4-0.3-0.7c0-0.1-0.1-0.2-0.1-0.2c-0.1-0.2-0.1-0.4-0.1-0.6c0-0.2,0-0.4,0-0.6
	c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2s0-0.1,0-0.2c0-0.1,0-0.3,0.1-0.4c0,0,0-0.1,0-0.1C37.4,37.7,37.4,37.7,37.4,37.6z"
          />
          <circle fill="none" stroke="#FFFFFB" strokeWidth="3" strokeMiterlimit="10" cx="21.6" cy="23.2" r="9.9" />
        </g>
      );
    case 'list':
      return (
        <g>
          <path
            fill={fillColor}
            d="M6 29.714c0-1.262 0.895-2.286 1.997-2.286h22.006c1.103 0 1.997 1.015 1.997 2.286 0 1.262-0.895 2.286-1.997 2.286h-22.006c-1.103 0-1.997-1.015-1.997-2.286v0zM6 20.571c0-1.262 0.895-2.286 1.997-2.286h22.006c1.103 0 1.997 1.015 1.997 2.286 0 1.262-0.895 2.286-1.997 2.286h-22.006c-1.103 0-1.997-1.015-1.997-2.286v0zM6 11.429c0-1.262 0.895-2.286 1.997-2.286h22.006c1.103 0 1.997 1.015 1.997 2.286 0 1.262-0.895 2.286-1.997 2.286h-22.006c-1.103 0-1.997-1.015-1.997-2.286v0zM6 2.286c0-1.262 0.895-2.286 1.997-2.286h22.006c1.103 0 1.997 1.015 1.997 2.286 0 1.262-0.895 2.286-1.997 2.286h-22.006c-1.103 0-1.997-1.015-1.997-2.286v0zM2 32c1.105 0 2-1.023 2-2.286s-0.895-2.286-2-2.286c-1.105 0-2 1.023-2 2.286s0.895 2.286 2 2.286v0zM2 22.857c1.105 0 2-1.023 2-2.286s-0.895-2.286-2-2.286c-1.105 0-2 1.023-2 2.286s0.895 2.286 2 2.286v0zM2 13.714c1.105 0 2-1.023 2-2.286s-0.895-2.286-2-2.286c-1.105 0-2 1.023-2 2.286s0.895 2.286 2 2.286v0zM2 4.571c1.105 0 2-1.023 2-2.286s-0.895-2.286-2-2.286c-1.105 0-2 1.023-2 2.286s0.895 2.286 2 2.286v0z"
          />
        </g>
      );
    case 'menuoptions':
      return (
        <g>
          <path
            fill={fillColor}
            d="M11.413 0h-8.213c-1.778 0-3.2 1.407-3.2 3.165v8.123c0 1.758 1.422 3.165 3.2 3.165h8.213c1.778 0 3.2-1.407 3.2-3.165v-8.123c0-1.723-1.422-3.165-3.2-3.165v0zM13.191 11.288c0 0.985-0.782 1.758-1.778 1.758h-8.213c-0.996 0-1.778-0.774-1.778-1.758v-8.123c0-0.985 0.782-1.758 1.778-1.758h8.213c0.996 0 1.778 0.774 1.778 1.758v8.123z"
          />
          <path
            fill={fillColor}
            d="M28.8 0h-8.213c-1.778 0-3.2 1.407-3.2 3.165v8.123c0 1.758 1.422 3.165 3.2 3.165h8.213c1.778 0 3.2-1.407 3.2-3.165v-8.123c0-1.723-1.422-3.165-3.2-3.165v0zM30.578 11.288c0 0.985-0.782 1.758-1.778 1.758h-8.213c-0.996 0-1.778-0.774-1.778-1.758v-8.123c0-0.985 0.782-1.758 1.778-1.758h8.213c0.996 0 1.778 0.774 1.778 1.758v8.123z"
          />
          <path
            fill={fillColor}
            d="M11.413 17.301h-8.213c-1.778 0-3.2 1.407-3.2 3.165v8.123c0 1.758 1.422 3.165 3.2 3.165h8.213c1.778 0 3.2-1.407 3.2-3.165v-8.123c0-1.723-1.422-3.165-3.2-3.165v0zM13.191 28.589c0 0.985-0.782 1.758-1.778 1.758h-8.213c-0.996 0-1.778-0.774-1.778-1.758v-8.123c0-0.985 0.782-1.758 1.778-1.758h8.213c0.996 0 1.778 0.774 1.778 1.758v8.123z"
          />
          <path
            fill={fillColor}
            d="M28.8 17.301h-8.213c-1.778 0-3.2 1.407-3.2 3.165v8.123c0 1.758 1.422 3.165 3.2 3.165h8.213c1.778 0 3.2-1.407 3.2-3.165v-8.123c0-1.723-1.422-3.165-3.2-3.165v0zM30.578 28.589c0 0.985-0.782 1.758-1.778 1.758h-8.213c-0.996 0-1.778-0.774-1.778-1.758v-8.123c0-0.985 0.782-1.758 1.778-1.758h8.213c0.996 0 1.778 0.774 1.778 1.758v8.123z"
          />
        </g>
      );
    case 'event':
      return (
        <g>
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground1}
            strokeMiterlimit="10"
            d="M45.5,43.2H10.8c-0.6,0-1.1-0.5-1.1-1.1V24.9c0-0.6,0.5-1.1,1.1-1.1
	h34.7c0.6,0,1.1,0.5,1.1,1.1v17.2C46.6,42.7,46.1,43.2,45.5,43.2z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M45.5,14h-3.8v2.3c0,1.6-1.2,2.8-2.8,2.8
	s-2.8-1.3-2.8-2.8V14H20.4v2.3c0,1.6-1.2,2.8-2.8,2.8s-2.8-1.3-2.8-2.8V14H11c-2.2,0-3.9,1.6-3.9,3.7v25c0,2.2,1.8,4.1,3.9,4.1h34.5
	c2.2,0,3.9-1.9,3.9-4.1v-25C49.4,15.6,47.7,14,45.5,14z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M39,17.6L39,17.6c-0.8,0-1.3-0.6-1.3-1.3v-3.6c0-0.7,0.6-1.3,1.3-1.3l0,0c0.7,0,1.3,0.6,1.3,1.3v3.6
	C40.3,17,39.8,17.6,39,17.6z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M17.6,17.6L17.6,17.6c-0.8,0-1.3-0.6-1.3-1.3v-3.6c0-0.7,0.6-1.3,1.3-1.3l0,0c0.7,0,1.3,0.6,1.3,1.3v3.6
	C18.9,17,18.3,17.6,17.6,17.6z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            stroke={p4Tokens.colorBrandMenuForeground1}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M21,29.7h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8H21c0.4,0,0.8,0.3,0.8,0.8V29C21.8,29.4,21.4,29.7,21,29.7z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M21,35.3h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8H21c0.4,0,0.8,0.3,0.8,0.8v2.8C21.8,35,21.4,35.3,21,35.3z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M21,41.1h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8H21c0.4,0,0.8,0.3,0.8,0.8v2.8C21.8,40.8,21.4,41.1,21,41.1z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M26.8,29.7H24c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8h2.8c0.4,0,0.8,0.3,0.8,0.8V29C27.6,29.4,27.2,29.7,26.8,29.7z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M26.8,35.3H24c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8h2.8c0.4,0,0.8,0.3,0.8,0.8v2.8C27.6,35,27.2,35.3,26.8,35.3z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M26.8,41.1H24c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8h2.8c0.4,0,0.8,0.3,0.8,0.8v2.8C27.6,40.8,27.2,41.1,26.8,41.1z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M32.6,29.7h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8h2.8c0.4,0,0.8,0.3,0.8,0.8V29C33.4,29.4,33,29.7,32.6,29.7z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M32.6,35.3h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8h2.8c0.4,0,0.8,0.3,0.8,0.8v2.8C33.4,35,33,35.3,32.6,35.3z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M32.6,41.1h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8h2.8c0.4,0,0.8,0.3,0.8,0.8v2.8C33.4,40.8,33,41.1,32.6,41.1z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M38.4,29.7h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8h2.8c0.4,0,0.8,0.3,0.8,0.8V29C39.2,29.4,38.8,29.7,38.4,29.7z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M38.4,35.3h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8h2.8c0.4,0,0.8,0.3,0.8,0.8v2.8C39.2,35,38.8,35.3,38.4,35.3z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M38.4,41.1h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8h2.8c0.4,0,0.8,0.3,0.8,0.8v2.8C39.2,40.8,38.8,41.1,38.4,41.1z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M44.2,29.7h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8h2.8c0.4,0,0.8,0.3,0.8,0.8V29C45,29.4,44.7,29.7,44.2,29.7z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M44.2,35.3h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8h2.8c0.4,0,0.8,0.3,0.8,0.8v2.8C45,35,44.7,35.3,44.2,35.3z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M15.2,35.3h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8h2.8c0.4,0,0.8,0.3,0.8,0.8v2.8C16,35,15.7,35.3,15.2,35.3z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M15.2,41.1h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8h2.8c0.4,0,0.8,0.3,0.8,0.8v2.8C16,40.8,15.7,41.1,15.2,41.1z"
          />
        </g>
      );
    case 'goodsinward':
      return (
        <g>
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M50.4,47.3c0-0.5-0.4-1-1-1l0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0l-6.6-0.1c-0.2,0-0.5-0.2-0.5-0.4l0-0.6
	c0-0.3-0.3-0.5-0.6-0.4l-5.8,2.1c-0.4,0.1-0.4,0.7,0,0.8l5.8,2.1c0.3,0.1,0.6-0.1,0.6-0.4l0-0.7c0-0.2,0.2-0.4,0.5-0.4l6.7,0.1l0,0
	C50,48.3,50.4,47.8,50.4,47.3z"
          />
          <circle
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            cx="24.6"
            cy="45.6"
            r="2.1"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground1}
            strokeWidth="1.45"
            d="M43.1,35.5L29.4,40c-1.2,0.4-2.6-0.3-3-1.5l-3.6-10.8
	c-0.4-1.2,0.3-2.6,1.5-3L38,20.2c1.2-0.4,2.6,0.3,3,1.5l3.6,10.8C45,33.7,44.3,35.1,43.1,35.5z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground1}
            strokeWidth="1.2443"
            d="M35.7,19.2l-10.9,3.6c-0.8,0.3-1.7-0.2-2-1l-2-6.1
	c-0.3-0.8,0.2-1.7,1-2l10.9-3.6c0.8-0.3,1.7,0.2,2,1l2,6.1C37,18.1,36.5,19,35.7,19.2z"
          />
          <line
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="2"
            strokeLinecap="round"
            x1="30.1"
            y1="43.6"
            x2="48.1"
            y2="37.2"
          />
          <polyline
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="2"
            strokeLinecap="round"
            points="22.3,40.7 12.8,12.1 7.5,8.8 "
          />
          <circle
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.6794"
            cx="24.6"
            cy="45.6"
            r="4.9"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            stroke={p4Tokens.colorBrandMenuForeground1}
            strokeWidth="1.3085"
            d="M27.2,23.5l2.3,5.5c0.1,0.2,0.4,0.4,0.7,0.3l5.6-1.8
	c0.3-0.1,0.4-0.3,0.3-0.5l-2-5.3"
          />
          <polyline
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeLinecap="round"
            points="16.6,24.9 15.4,32.1 18.9,41.7 "
          />
          <line
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeLinecap="round"
            x1="19.7"
            y1="34.4"
            x2="16.7"
            y2="35.6"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M24.6,12.8l1.3,3.5c0,0.1,0.1,0.1,0.2,0.1l5.4-2c0.1,0,0.1-0.1,0.1-0.2l-1.4-3.2L24.6,12.8z"
          />
        </g>
      );
    case 'invoice':
      return (
        <g>
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3071"
            strokeMiterlimit="10"
            d="M12.2,46.8h25c1.1,0,2.1-0.9,2.1-2.1V8.7
		c0-1.1-0.9-2.1-2.1-2.1H24.9L10.1,20.8v23.9C10.1,45.9,11,46.8,12.2,46.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeMiterlimit="10"
            d="M11.8,20.6h11c1.1,0,2.1-0.9,2.1-2.1v-11L11.8,20.6z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M14.3,27.6h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H14.3c-0.2,0-0.3,0.1-0.3,0.3v0.7
		C14,27.4,14.1,27.6,14.3,27.6z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M14.3,33.6h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H14.3c-0.2,0-0.3,0.1-0.3,0.3v0.7
		C14,33.4,14.1,33.6,14.3,33.6z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M14.3,39.5H31c0.2,0,0.3-0.1,0.3-0.3v-0.8c0-0.2-0.1-0.3-0.3-0.3H14.3c-0.2,0-0.3,0.1-0.3,0.3v0.8
		C14,39.4,14.1,39.5,14.3,39.5z"
          />
          <path fill={p4Tokens.colorBrandMenuBackground1} d="M12.3,19.7h9.9c1,0,1.9-0.8,1.9-1.8V8.5L12.3,19.7z" />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M42.4,34.4c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C51.1,38.3,47.2,34.4,42.4,34.4z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            d="M38.7,47.1h2.4V40h-2.4v-1.5h6.7V40h-2.4v7.1h2.4v1.5h-6.7V47.1z"
          />
        </g>
      );
    case 'credit':
      return (
        <g>
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3071"
            strokeMiterlimit="10"
            d="M12.4,47.1h25c1.1,0,2.1-0.9,2.1-2.1V8.9
		c0-1.1-0.9-2.1-2.1-2.1H25.1L10.3,21.1V45C10.3,46.1,11.3,47.1,12.4,47.1z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeMiterlimit="10"
            d="M12.1,20.8h11c1.1,0,2.1-0.9,2.1-2.1v-11L12.1,20.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M14.5,27.9h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H14.5c-0.2,0-0.3,0.1-0.3,0.3v0.7
		C14.2,27.7,14.4,27.9,14.5,27.9z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M14.5,33.8h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H14.5c-0.2,0-0.3,0.1-0.3,0.3v0.7
		C14.2,33.7,14.4,33.8,14.5,33.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M14.5,39.8h16.7c0.2,0,0.3-0.1,0.3-0.3v-0.8c0-0.2-0.1-0.3-0.3-0.3H14.5c-0.2,0-0.3,0.1-0.3,0.3v0.8
		C14.2,39.7,14.4,39.8,14.5,39.8z"
          />
          <path fill={p4Tokens.colorBrandMenuBackground1} d="M12.6,20h9.9c1,0,1.9-0.8,1.9-1.8V8.8L12.6,20z" />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M42.6,34.5c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C51.3,38.4,47.4,34.5,42.6,34.5z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            d="M38.1,43.4c0-3.3,2-5.3,4.7-5.3c1.3,0,2.3,0.6,2.9,1.3l-1,1.1c-0.5-0.5-1.1-0.8-1.9-0.8
		c-1.7,0-2.8,1.4-2.8,3.7c0,2.3,1.2,3.7,2.9,3.7c0.8,0,1.5-0.4,2-1l1,1.1c-0.8,1-1.9,1.5-3.2,1.5C40.2,48.7,38.1,46.8,38.1,43.4z"
          />
        </g>
      );
    case 'nominalaccount':
      return (
        <g>
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3071"
            strokeMiterlimit="10"
            d="M15.2,45.4h25c1.1,0,2.1-0.9,2.1-2.1V7.3
	c0-1.1-0.9-2.1-2.1-2.1H27.9L13.1,19.4v23.9C13.1,44.5,14,45.4,15.2,45.4z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeMiterlimit="10"
            d="M14.8,19.2h11c1.1,0,2.1-0.9,2.1-2.1v-11L14.8,19.2z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M17.3,26.2h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H17.3c-0.2,0-0.3,0.1-0.3,0.3v0.7
	C17,26.1,17.1,26.2,17.3,26.2z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M17.3,32.2h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H17.3c-0.2,0-0.3,0.1-0.3,0.3v0.7
	C17,32.1,17.1,32.2,17.3,32.2z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M17.3,38.2H34c0.2,0,0.3-0.1,0.3-0.3v-0.8c0-0.2-0.1-0.3-0.3-0.3H17.3c-0.2,0-0.3,0.1-0.3,0.3v0.8
	C17,38,17.1,38.2,17.3,38.2z"
          />
          <path fill={p4Tokens.colorBrandMenuBackground1} d="M15.3,18.3h9.9c1,0,1.9-0.8,1.9-1.8V7.2L15.3,18.3z" />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground1}
            strokeWidth="0.8742"
            strokeMiterlimit="10"
            d="M20.2,52.9H6.5c-1.1,0-2-0.9-2-2V32.3
		c0-1.1,0.9-2,2-2h13.7c1.1,0,2,0.9,2,2v18.6C22.2,52,21.3,52.9,20.2,52.9z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M11.5,43.1l-4.2-4.2c-0.1-0.1-0.1-0.4,0-0.5l0.3-0.3c0.1-0.1,0.4-0.1,0.5,0l4.2,4.2c0.1,0.1,0.1,0.4,0,0.5
			L12,43.1C11.8,43.2,11.6,43.2,11.5,43.1z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M7.2,42.3l4.2-4.2c0.1-0.1,0.4-0.1,0.5,0l0.3,0.3c0.1,0.1,0.1,0.4,0,0.5L8,43.1c-0.1,0.1-0.4,0.1-0.5,0
			l-0.3-0.3C7.1,42.7,7.1,42.5,7.2,42.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M10.1,45.6v2.3h2.3V49h-2.3v2.3H9V49H6.7v-1.1H9v-2.3H10.1z"
          />
          <line
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground1}
            strokeWidth="1.4818"
            strokeLinecap="round"
            strokeMiterlimit="10"
            x1="14.8"
            y1="39.9"
            x2="19.3"
            y2="39.9"
          />
          <line
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground1}
            strokeWidth="1.4818"
            strokeLinecap="round"
            strokeMiterlimit="10"
            x1="14.8"
            y1="42.4"
            x2="19.3"
            y2="42.4"
          />
          <line
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground1}
            strokeWidth="1.4818"
            strokeLinecap="round"
            strokeMiterlimit="10"
            x1="14.8"
            y1="48.4"
            x2="19.3"
            y2="48.4"
          />
          <line
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground1}
            strokeWidth="3.672"
            strokeLinecap="round"
            strokeMiterlimit="10"
            x1="8.3"
            y1="34.2"
            x2="18.6"
            y2="34.2"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M45.5,33.3c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C54.3,37.2,50.3,33.3,45.5,33.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            d="M41.3,47.1v-0.9c1.2-0.6,2-1.7,2-3c0-0.4,0-0.8-0.1-1.2h-1.8v-1.1H43c-0.1-0.5-0.2-1.2-0.2-1.9
		c0-2.1,1.4-3.4,3.3-3.4c0.9,0,1.5,0.2,1.9,0.4l-0.3,1.1c-0.3-0.2-0.8-0.3-1.6-0.3c-1.4,0-1.9,0.9-1.9,2.2c0,0.7,0.1,1.3,0.2,1.9H47
		V42h-2.4c0.1,0.7,0.1,1.3-0.1,1.9c-0.2,0.7-0.6,1.4-1.2,1.9v0h5.2v1.3H41.3z"
          />
        </g>
      );

    case 'nominalaudit':
      return (
        <g>
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.1049"
            strokeMiterlimit="10"
            d="M52.9,51.3l-7.1-6.8l-3.2,3.3l7.1,6.8
		c0.9,0.9,2.4,0.9,3.3-0.1C53.8,53.6,53.8,52.2,52.9,51.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M25.5,15.6h-9.1c-0.3,0-0.6-0.2-0.6-0.4v-0.4c0-0.2,0.3-0.4,0.6-0.4h9.1c0.3,0,0.6,0.2,0.6,0.4v0.4
		C26.1,15.4,25.8,15.6,25.5,15.6z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M25.5,20.5h-9.1c-0.3,0-0.6-0.2-0.6-0.4v-0.4c0-0.2,0.3-0.4,0.6-0.4h9.1c0.3,0,0.6,0.2,0.6,0.4v0.4
		C26.1,20.3,25.8,20.5,25.5,20.5z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M25.5,25h-9.1c-0.3,0-0.6-0.2-0.6-0.4v-0.4c0-0.2,0.3-0.4,0.6-0.4h9.1c0.3,0,0.6,0.2,0.6,0.4v0.4
		C26.1,24.8,25.8,25,25.5,25z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M23.2,30.3h-7c-0.2,0-0.4-0.2-0.4-0.4v-0.4c0-0.2,0.2-0.4,0.4-0.4h7c0.2,0,0.4,0.2,0.4,0.4v0.4
		C23.6,30.2,23.5,30.3,23.2,30.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M14.7,13.9l-2.1,2.4c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2,0-0.3-0.1l-1.3-1c-0.2-0.2-0.3-0.5-0.1-0.7
		c0.2-0.2,0.5-0.3,0.7-0.1l0.9,0.7l1.8-2c0.2-0.2,0.5-0.2,0.7,0C14.9,13.4,14.9,13.7,14.7,13.9z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M14.7,19l-2.1,2.4c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2,0-0.3-0.1l-1.3-1c-0.2-0.2-0.3-0.5-0.1-0.7
		c0.2-0.2,0.5-0.3,0.7-0.1l0.9,0.7l1.8-2c0.2-0.2,0.5-0.2,0.7,0C14.9,18.4,14.9,18.8,14.7,19z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M14.7,23.8l-2.1,2.4c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2,0-0.3-0.1l-1.3-1c-0.2-0.2-0.3-0.5-0.1-0.7
		c0.2-0.2,0.5-0.3,0.7-0.1l0.9,0.7l1.8-2c0.2-0.2,0.5-0.2,0.7,0C14.9,23.3,14.9,23.6,14.7,23.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M14.7,28.7L12.6,31c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2,0-0.3-0.1l-1.3-1c-0.2-0.2-0.3-0.5-0.1-0.7
		c0.2-0.2,0.5-0.3,0.7-0.1l0.9,0.7l1.8-2c0.2-0.2,0.5-0.2,0.7,0C14.9,28.1,14.9,28.5,14.7,28.7z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M29.7,3.1H6.1c-0.8,0-1.9,1.1-1.9,2.5v30.6c0,1.4,1.1,2.5,2.5,2.5h16c-0.4-1-0.4-1.5-0.5-2.7H6.9l0-27.3
		h23.4l0,16.4c0.9-0.2,0.9-0.3,1.9-0.4c0.2,0,0.4,0,0.6,0V5.6C32.9,4.2,31.7,3.1,29.7,3.1z M22.1,5.9c0,0.2-0.2,0.3-0.4,0.3h-6.6
		c-0.2,0-0.4-0.1-0.4-0.3V5.5c0-0.2,0.2-0.3,0.4-0.3h6.6c0.2,0,0.4,0.1,0.4,0.3V5.9z"
          />
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground2}
                d="M26.1,28.8c-4.3,4.5-4.2,11.6,0.3,15.9c3.8,3.7,9.6,4.1,13.9,1.4l1.5,1.5l3.8-3.9L44,42
				c2.4-4.3,1.7-9.9-2-13.5C37.5,24.2,30.4,24.3,26.1,28.8z M40.9,29.6c3.9,3.7,4,9.9,0.2,13.8c-3.7,3.9-9.9,4-13.8,0.2
				c-3.9-3.7-4-9.9-0.2-13.8C30.9,25.9,37,25.8,40.9,29.6z"
              />
            </g>
          </g>
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            d="M40.7,45.6c0,0,0.9-0.8,1.5-1.4s1.3-1.7,1.3-1.7l1.1,1.1l-2.9,2.9L40.7,45.6z"
          />
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                stroke={p4Tokens.colorBrandMenuForeground1}
                strokeWidth="0.4316"
                strokeMiterlimit="10"
                d="M29.8,43.1v-1c1.3-0.7,2.2-2,2.2-3.5
				c0-0.5,0-0.9-0.1-1.4h-2V36h1.8c-0.1-0.6-0.2-1.4-0.2-2.1c0-2.3,1.6-3.8,3.8-3.8c1,0,1.7,0.2,2.2,0.5l-0.4,1.3
				c-0.4-0.2-0.9-0.4-1.8-0.4c-1.5,0-2.1,1.1-2.1,2.5c0,0.8,0.1,1.5,0.2,2.1h2.8v1.2h-2.7c0.1,0.7,0.1,1.5-0.1,2.2
				c-0.2,0.8-0.7,1.6-1.4,2.1v0H38v1.4H29.8z"
              />
            </g>
          </g>
        </g>
      );

    case 'nominaltransactions':
      return (
        <g>
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3071"
            strokeMiterlimit="10"
            d="M12.1,45.6h25c1.1,0,2.1-0.9,2.1-2.1V7.5
		c0-1.1-0.9-2.1-2.1-2.1H24.8L10,19.7v23.9C10,44.7,10.9,45.6,12.1,45.6z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeMiterlimit="10"
            d="M11.7,19.4h11c1.1,0,2.1-0.9,2.1-2.1v-11L11.7,19.4z"
          />
          <path fill={p4Tokens.colorBrandMenuBackground1} d="M12.2,18.5h9.9c1,0,1.9-0.8,1.9-1.8V7.4L12.2,18.5z" />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M42.2,33.2c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7S51,46.8,51,42C51,37.2,47.1,33.2,42.2,33.2z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M38.6,47.4v-0.9c1.2-0.6,2-1.7,2-3c0-0.4,0-0.8-0.1-1.2h-1.8v-1.1h1.6c-0.1-0.5-0.2-1.2-0.2-1.9
			c0-2.1,1.4-3.4,3.3-3.4c0.9,0,1.5,0.2,1.9,0.4l-0.3,1.1c-0.3-0.2-0.8-0.3-1.6-0.3c-1.4,0-1.9,0.9-1.9,2.2c0,0.7,0.1,1.3,0.2,1.9
			h2.5v1.1h-2.4c0.1,0.7,0.1,1.3-0.1,1.9c-0.2,0.7-0.6,1.4-1.2,1.9v0h5.2v1.3H38.6z"
            />
          </g>
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M16,31.5c0,0.4,0.3,0.8,0.7,0.8v0h0c0,0,0,0,0,0c0,0,0,0,0,0h13c0.2,0,0.3,0.2,0.3,0.3v0.5
		c0,0.2,0.2,0.4,0.4,0.3l4.2-1.7c0.3-0.1,0.3-0.5,0-0.6l-4.2-1.7c-0.2-0.1-0.4,0.1-0.4,0.3v0.6c0,0.2-0.1,0.3-0.3,0.3H16.7v0
		C16.3,30.7,16,31.1,16,31.5z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M35,25.1c0-0.4-0.3-0.8-0.7-0.8v0h0c0,0,0,0,0,0c0,0,0,0,0,0h-13c-0.2,0-0.3-0.2-0.3-0.3v-0.5
		c0-0.2-0.2-0.4-0.4-0.3l-4.2,1.7c-0.3,0.1-0.3,0.5,0,0.6l4.2,1.7c0.2,0.1,0.4-0.1,0.4-0.3v-0.6c0-0.2,0.1-0.3,0.3-0.3h13.1v0
		C34.6,25.9,35,25.5,35,25.1z"
          />
          <g>
            <circle fill={p4Tokens.colorBrandMenuForeground1} cx="24.3" cy="45.6" r="8.2" />
            <circle fill={p4Tokens.colorBrandMenuBackground1} cx="24.3" cy="45.6" r="6.5" />
            <polygon fill={p4Tokens.colorBrandMenuForeground1} points="25,45.6 28.6,42.1 24.5,44.9 		" />
            <polygon fill={p4Tokens.colorBrandMenuForeground1} points="23.6,45.7 21.4,43.9 24.1,45 		" />
            <rect x="24.2" y="39" fill={p4Tokens.colorBrandMenuForeground1} width="0.3" height="0.7" />

            <rect
              x="27.4"
              y="39.8"
              transform="matrix(0.8656 0.5007 -0.5007 0.8656 23.7451 -8.3447)"
              fill={p4Tokens.colorBrandMenuForeground1}
              width="0.1"
              height="0.5"
            />

            <rect
              x="18.8"
              y="42.2"
              transform="matrix(0.5074 -0.8617 0.8617 0.5074 -27.2819 37.1477)"
              fill={p4Tokens.colorBrandMenuForeground1}
              width="0.1"
              height="0.5"
            />

            <rect
              x="21.1"
              y="39.9"
              transform="matrix(0.8707 -0.4918 0.4918 0.8707 -16.9945 15.5916)"
              fill={p4Tokens.colorBrandMenuForeground1}
              width="0.1"
              height="0.5"
            />

            <rect
              x="18"
              y="45.2"
              transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 63.6978 27.4322)"
              fill={p4Tokens.colorBrandMenuForeground1}
              width="0.3"
              height="0.7"
            />
            <circle fill={p4Tokens.colorBrandMenuForeground1} cx="24.3" cy="45.6" r="0.8" />
            <circle
              fill={p4Tokens.colorBrandMenuForeground1}
              stroke={p4Tokens.colorBrandMenuForeground1}
              strokeMiterlimit="10"
              cx="24.3"
              cy="45.6"
              r="0.5"
            />
          </g>
        </g>
      );
    case 'order':
      return (
        <g>
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3071"
            strokeMiterlimit="10"
            d="M11.8,47.6h25c1.1,0,2.1-0.9,2.1-2.1V9.5
		c0-1.1-0.9-2.1-2.1-2.1H24.5L9.7,21.6v23.9C9.7,46.7,10.6,47.6,11.8,47.6z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeMiterlimit="10"
            d="M11.5,21.4h11c1.1,0,2.1-0.9,2.1-2.1v-11L11.5,21.4z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M13.9,28.4h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H13.9c-0.2,0-0.3,0.1-0.3,0.3v0.7
		C13.6,28.2,13.7,28.4,13.9,28.4z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M13.9,34.4h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H13.9c-0.2,0-0.3,0.1-0.3,0.3V34
		C13.6,34.2,13.7,34.4,13.9,34.4z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M13.9,40.4h16.7c0.2,0,0.3-0.1,0.3-0.3v-0.8c0-0.2-0.1-0.3-0.3-0.3H13.9c-0.2,0-0.3,0.1-0.3,0.3v0.8
		C13.6,40.2,13.7,40.4,13.9,40.4z"
          />
          <path fill={p4Tokens.colorBrandMenuBackground1} d="M12,20.5h9.9c1,0,1.9-0.8,1.9-1.8V9.4L12,20.5z" />
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M42,35.2c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C50.7,39.1,46.8,35.2,42,35.2z"
              />
            </g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                d="M38.4,49.4v-0.9c1.2-0.6,2-1.7,2-3c0-0.4,0-0.8-0.1-1.2h-1.8v-1.1h1.6c-0.1-0.5-0.2-1.2-0.2-1.9
				c0-2.1,1.4-3.4,3.3-3.4c0.9,0,1.5,0.2,1.9,0.4l-0.3,1.1c-0.3-0.2-0.8-0.3-1.6-0.3c-1.4,0-1.9,0.9-1.9,2.2c0,0.7,0.1,1.3,0.2,1.9
				H44v1.1h-2.4c0.1,0.7,0.1,1.3-0.1,1.9c-0.2,0.7-0.6,1.4-1.2,1.9v0h5.2v1.3H38.4z"
              />
            </g>
          </g>
        </g>
      );
    case P4SVGIcon.SalesOrderDeliveryAddress:
      return (
        <g id="g10">
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3071"
            strokeMiterlimit="10"
            d="m 11.8,47.6 h 25 c 1.1,0 2.1,-0.9 2.1,-2.1 V 9.5 C 38.9,8.4 38,7.4 36.8,7.4 H 24.5 L 9.7,21.6 v 23.9 c 0,1.2 0.9,2.1 2.1,2.1 z"
            id="path1"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeMiterlimit="10"
            d="m 11.5,21.4 h 11 c 1.1,0 2.1,-0.9 2.1,-2.1 v -11 z"
            id="path2"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="m 13.9,28.4 h 20.4 c 0.2,0 0.3,-0.1 0.3,-0.3 v -0.7 c 0,-0.2 -0.1,-0.3 -0.3,-0.3 H 13.9 c -0.2,0 -0.3,0.1 -0.3,0.3 v 0.7 c 0,0.1 0.1,0.3 0.3,0.3 z"
            id="path3"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="m 13.9,34.4 h 20.4 c 0.2,0 0.3,-0.1 0.3,-0.3 v -0.7 c 0,-0.2 -0.1,-0.3 -0.3,-0.3 H 13.9 c -0.2,0 -0.3,0.1 -0.3,0.3 V 34 c 0,0.2 0.1,0.4 0.3,0.4 z"
            id="path4"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="m 13.9,40.4 h 16.7 c 0.2,0 0.3,-0.1 0.3,-0.3 V 39.3 C 30.9,39.1 30.8,39 30.6,39 H 13.9 c -0.2,0 -0.3,0.1 -0.3,0.3 v 0.8 c 0,0.1 0.1,0.3 0.3,0.3 z"
            id="path5"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            d="m 12,20.5 h 9.9 c 1,0 1.9,-0.8 1.9,-1.8 V 9.4 Z"
            id="path6"
          />
          <g id="g9">
            <g id="g7">
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="m 42,35.2 c -4.8,0 -8.7,3.9 -8.7,8.7 0,4.8 3.9,8.7 8.7,8.7 4.8,0 8.7,-3.9 8.7,-8.7 0,-4.8 -3.9,-8.7 -8.7,-8.7 z"
                id="path7"
              />
              <path
                fill={p4Tokens.colorBrandMenuForeground2}
                d="m 37.012979,41.235868 h 9.808306 c 0.09616,0 0.14424,-0.1 0.14424,-0.3 v -0.7 c 0,-0.2 -0.04808,-0.3 -0.14424,-0.3 h -9.808306 c -0.09616,0 -0.14424,0.1 -0.14424,0.3 v 0.7 c 0,0.1 0.04808,0.3 0.14424,0.3 z"
                id="path3-6"
                style={{ strokeWidth: 0.7, fill: p4Tokens.colorBrandMenuForeground3, fillOpacity: 1 }}
              />
              <path
                fill={p4Tokens.colorBrandMenuForeground2}
                d="m 36.969823,44.414693 h 9.808307 c 0.09616,0 0.144239,-0.1 0.144239,-0.3 v -0.7 c 0,-0.2 -0.04808,-0.3 -0.144239,-0.3 h -9.808307 c -0.09616,0 -0.144239,0.1 -0.144239,0.3 v 0.7 c 0,0.1 0.04808,0.3 0.144239,0.3 z"
                id="path3-6-9"
                style={{ strokeWidth: 0.7, fill: p4Tokens.colorBrandMenuForeground3, fillOpacity: 1 }}
              />
              <path
                fill={p4Tokens.colorBrandMenuForeground2}
                d="m 37.051862,47.777096 h 9.808307 c 0.09616,0 0.144239,-0.1 0.144239,-0.3 v -0.7 c 0,-0.2 -0.04808,-0.3 -0.144239,-0.3 h -9.808307 c -0.09616,0 -0.144239,0.1 -0.144239,0.3 v 0.7 c 0,0.1 0.04808,0.3 0.144239,0.3 z"
                id="path3-6-2"
                style={{ strokeWidth: 0.7, fill: p4Tokens.colorBrandMenuForeground3, fillOpacity: 1 }}
              />
            </g>
            <g id="g8" />
          </g>
        </g>
      );
    case 'pricelist':
      return (
        <g>
          <g>
            <circle
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3"
              strokeMiterlimit="10"
              cx="26"
              cy="15.7"
              r="9.1"
            />
            <path
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3"
              strokeMiterlimit="10"
              d="M41,33.4v9.4c0,0.2,0,0.2-0.2,0.2H11.2
		c-0.2,0-0.3,0-0.3-0.2v-9.4c0-0.2,0-0.3,0-0.5c0.1-2.2,1-4.3,2.4-5.8c0,0,0.1-0.1,0.1-0.1c0.7-0.7,1.5-1.3,2.4-1.8
		c0.1,0,0.1-0.1,0.2-0.1c0.2-0.1,0.5-0.2,0.8-0.3c0.1,0,0.1,0,0.2-0.1c0.2-0.1,0.5-0.1,0.7-0.2c0.3,0.3,0.6,0.6,0.9,0.8
		c0.8,0.6,1.7,1.2,2.7,1.6c0.2,0.1,0.4,0.2,0.5,0.2c0.7,0.3,1.4,0.5,2.1,0.6C24.7,28,25.4,28,26,28c0.6,0,1.2,0,2-0.1
		c1.4-0.2,2.5-0.8,2.8-0.9c0.7-0.3,1.4-0.8,2.1-1.3c0,0,0,0,0,0c0.1,0,1.1-0.8,1.5-1.1c3.7,0.9,6.4,4.2,6.6,8.3
		C41,33.1,41,33.3,41,33.4z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M41,34.2c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C49.8,38.1,45.8,34.2,41,34.2z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M37.4,48.4v-0.9c1.2-0.6,2-1.7,2-3c0-0.4,0-0.8-0.1-1.2h-1.8v-1.1h1.6c-0.1-0.5-0.2-1.2-0.2-1.9
		c0-2.1,1.4-3.4,3.3-3.4c0.9,0,1.5,0.2,1.9,0.4l-0.3,1.1c-0.3-0.2-0.8-0.3-1.6-0.3c-1.4,0-1.9,0.9-1.9,2.2c0,0.7,0.1,1.3,0.2,1.9
		h2.5v1.1h-2.4c0.1,0.7,0.1,1.3-0.1,1.9c-0.2,0.7-0.6,1.4-1.2,1.9v0h5.2v1.3H37.4z"
            />
          </g>
        </g>
      );
    case 'product':
      return (
        <g>
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.2035"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
		M28.5,25.8c0,0-17.7-8-18-7.5s0.1,22.6,0.1,22.6l17.7,7.6L28.5,25.8z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
		M10.7,18c2.1-1,16-6.3,16.8-6.4c1,0,18.7,6.2,18.2,6.5c-0.4,0.3-15.9,7.2-17.1,7.5C27.6,25.9,10.8,17.9,10.7,18"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
		M28.7,25.7c0,0,17.2-8.1,17.2-7.5c0,10.2,0.2,22-0.2,22.3c-0.7,0.4-16.9,8.5-17.1,8S28.7,25.7,28.7,25.7z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M33.3,14L17,21v9.9c0,0,3.8,2,3.9,1.2c0.2-3.1,0.2-9.6,0.2-9.3l16.5-7.3L33.3,14z"
          />
        </g>
      );
    case 'productimport':
      return (
        <g>
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.2035"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="M28.5,25.8c0,0-17.7-8-18-7.5s0.1,22.6,0.1,22.6l17.7,7.6L28.5,25.8z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="M10.7,18c2.1-1,16-6.3,16.8-6.4c1,0,18.7,6.2,18.2,6.5c-0.4,0.3-15.9,7.2-17.1,7.5C27.6,25.9,10.8,17.9,10.7,18"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="M28.7,25.7c0,0,17.2-8.1,17.2-7.5c0,10.2,0.2,22-0.2,22.3c-0.7,0.4-16.9,8.5-17.1,8S28.7,25.7,28.7,25.7z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M33.3,14L17,21v9.9c0,0,3.8,2,3.9,1.2c0.2-3.1,0.2-9.6,0.2-9.3l16.5-7.3L33.3,14z"
          />
          {/* Inward-pointing arrow for import */}
          <path fill={p4Tokens.colorBrandMenuForeground1} d="M2,30 L8,30 L8,27 L14,32 L8,37 L8,34 L2,34 Z" />
        </g>
      );
    case 'productcategory':
      return (
        <g>
          <g>
            <path
              className="st23"
              fill="none"
              stroke="#808285"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              d="M20.2,23.7c0,0,17.2-8.1,17.2-7.5c0,10.2,0.2,22-0.2,22.3C36.4,39,20.2,47,20,46.6S20.2,23.7,20.2,23.7z"
            />
            <g>
              <path
                className="st22"
                fill="none"
                stroke="#808285"
                strokeWidth="1.2035"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                d="M20,23.9c0,0-17.7-8-18-7.5c-0.3,0.4,0.1,22.6,0.1,22.6l17.7,7.6L20,23.9z"
              />
              <path
                className="st23"
                fill="none"
                stroke="#808285"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                d="M2.2,16.1c2.1-1,16-6.3,16.8-6.4c1,0,18.7,6.2,18.2,6.5c-0.4,0.3-15.9,7.2-17.1,7.5C19,24,2.3,16,2.2,16.1
          "
              />
              <path
                className="st8"
                fill="#2C3279"
                d="M24.8,12.1l-16.3,7V29c0,0,3.8,2,3.9,1.2c0.2-3.1,0.2-9.6,0.2-9.3L29,13.6L24.8,12.1z"
              />
            </g>
          </g>
          <path
            className="st4"
            stroke="#808285"
            d="M48.8,28.1c0.3,0.8,1,1.3,1.9,1.3c1.1,0,2-0.9,2-2s-0.9-2-2-2c-0.9,0-1.6,0.6-1.9,1.3h-5.1V15.4h5.1
      c0.3,0.8,1,1.3,1.9,1.3c1.1,0,2-0.9,2-2s-0.9-2-2-2c-0.9,0-1.6,0.6-1.9,1.3h-5.8c-0.4,0-0.7,0.3-0.7,0.7v12h-4.6v1.3h4.6v11.9
      c0,0.4,0.3,0.7,0.7,0.7h5.8c0.3,0.8,1,1.3,1.9,1.3c1.1,0,2-0.9,2-2s-0.9-2-2-2c-0.9,0-1.6,0.6-1.9,1.3h-5.1V28.1H48.8z"
          />
          <circle className="st61" fill="#2C3279" stroke="#808285" strokeWidth="0.75" cx="51.5" cy="15" r="2.9" />
          <circle className="st61" fill="#2C3279" stroke="#808285" strokeWidth="0.75" cx="51.5" cy="27.3" r="2.9" />
          <circle className="st61" fill="#2C3279" stroke="#808285" strokeWidth="0.75" cx="51.5" cy="39.7" r="2.9" />
        </g>
      );
    case 'productaudit':
      return (
        <g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.1049"
              strokeMiterlimit="10"
              d="M51.5,50.7l-7.1-6.8l-3.2,3.3l7.1,6.8
		c0.9,0.9,2.4,0.9,3.3-0.1C52.5,53,52.4,51.6,51.5,50.7z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M24.1,15H15c-0.3,0-0.6-0.2-0.6-0.4v-0.4c0-0.2,0.3-0.4,0.6-0.4h9.1c0.3,0,0.6,0.2,0.6,0.4v0.4
		C24.7,14.8,24.4,15,24.1,15z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M24.1,19.9H15c-0.3,0-0.6-0.2-0.6-0.4V19c0-0.2,0.3-0.4,0.6-0.4h9.1c0.3,0,0.6,0.2,0.6,0.4v0.4
		C24.7,19.7,24.4,19.9,24.1,19.9z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M24.1,24.4H15c-0.3,0-0.6-0.2-0.6-0.4v-0.4c0-0.2,0.3-0.4,0.6-0.4h9.1c0.3,0,0.6,0.2,0.6,0.4v0.4
		C24.7,24.2,24.4,24.4,24.1,24.4z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M21.8,29.7h-7c-0.2,0-0.4-0.2-0.4-0.4v-0.4c0-0.2,0.2-0.4,0.4-0.4h7c0.2,0,0.4,0.2,0.4,0.4v0.4
		C22.3,29.5,22.1,29.7,21.8,29.7z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M13.4,13.3l-2.1,2.4c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2,0-0.3-0.1l-1.3-1C9,14.5,9,14.1,9.2,13.9
		c0.2-0.2,0.5-0.3,0.7-0.1l0.9,0.7l1.8-2c0.2-0.2,0.5-0.2,0.7,0C13.5,12.7,13.6,13.1,13.4,13.3z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M13.4,18.3l-2.1,2.4c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2,0-0.3-0.1l-1.3-1C9,19.5,9,19.2,9.2,19
		c0.2-0.2,0.5-0.3,0.7-0.1l0.9,0.7l1.8-2c0.2-0.2,0.5-0.2,0.7,0C13.5,17.8,13.6,18.1,13.4,18.3z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M13.4,23.2l-2.1,2.4c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2,0-0.3-0.1l-1.3-1C9,24.4,9,24,9.2,23.8
		c0.2-0.2,0.5-0.3,0.7-0.1l0.9,0.7l1.8-2c0.2-0.2,0.5-0.2,0.7,0C13.5,22.6,13.6,23,13.4,23.2z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M13.4,28.1l-2.1,2.4c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2,0-0.3-0.1l-1.3-1C9,29.2,9,28.9,9.2,28.7
		c0.2-0.2,0.5-0.3,0.7-0.1l0.9,0.7l1.8-2c0.2-0.2,0.5-0.2,0.7,0C13.5,27.5,13.6,27.8,13.4,28.1z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M28.3,2.4H4.7C4,2.4,2.8,3.6,2.8,5v30.6c0,1.4,1.1,2.5,2.5,2.5h16c-0.4-1-0.4-1.5-0.5-2.7H5.6l0-27.3H29
		l0,16.4c0.9-0.2,0.9-0.3,1.9-0.4c0.2,0,0.4,0,0.6,0V5C31.5,3.6,30.4,2.4,28.3,2.4z M20.7,5.2c0,0.2-0.2,0.3-0.4,0.3h-6.6
		c-0.2,0-0.4-0.1-0.4-0.3V4.9c0-0.2,0.2-0.3,0.4-0.3h6.6c0.2,0,0.4,0.1,0.4,0.3V5.2z"
            />
            <g>
              <g>
                <path
                  fill={p4Tokens.colorBrandMenuForeground2}
                  d="M24.7,28.2C20.4,32.6,20.5,39.7,25,44c3.8,3.7,9.6,4.1,13.9,1.4l1.5,1.5l3.8-3.9l-1.6-1.5
				c2.4-4.3,1.7-9.9-2-13.5C36.1,23.6,29,23.7,24.7,28.2z M39.5,29c3.9,3.7,4,9.9,0.2,13.8c-3.7,3.9-9.9,4-13.8,0.2
				c-3.9-3.7-4-9.9-0.2-13.8C29.5,25.3,35.7,25.2,39.5,29z"
                />
              </g>
            </g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M39.3,45c0,0,0.9-0.8,1.5-1.4c0.6-0.6,1.3-1.7,1.3-1.7l1.1,1.1l-2.9,2.9L39.3,45z"
            />
          </g>
          <g>
            <g>
              <polygon fill={p4Tokens.colorBrandMenuForeground1} points="25.8,32.4 32.4,34.7 32.4,42.2 25.8,39.8 		" />
              <polygon fill={p4Tokens.colorBrandMenuForeground1} points="33.6,34.7 40.3,32.4 40.3,39.9 33.6,42.3 		" />
              <polygon fill={p4Tokens.colorBrandMenuForeground1} points="26.5,31.3 33,33.7 39.7,31.3 32.9,28.7 		" />
            </g>
          </g>
        </g>
      );
    case 'salestransactions':
      return (
        <g>
          <g>
            <path
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3071"
              strokeMiterlimit="10"
              d="M13.2,45.1h25c1.1,0,2.1-0.9,2.1-2.1V7
		c0-1.1-0.9-2.1-2.1-2.1H25.9L11.1,19.1V43C11.1,44.2,12,45.1,13.2,45.1z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeMiterlimit="10"
              d="M12.9,18.9h11c1.1,0,2.1-0.9,2.1-2.1v-11L12.9,18.9z"
            />
            <path fill={p4Tokens.colorBrandMenuBackground1} d="M13.4,18h9.9c1,0,1.9-0.8,1.9-1.8V6.9L13.4,18z" />
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M43.4,32.7c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C52.1,36.6,48.2,32.7,43.4,32.7z
			"
              />
            </g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                d="M39.8,46.9V46c1.2-0.6,2-1.7,2-3c0-0.4,0-0.8-0.1-1.2h-1.8v-1.1h1.6c-0.1-0.5-0.2-1.2-0.2-1.9
			c0-2.1,1.4-3.4,3.3-3.4c0.9,0,1.5,0.2,1.9,0.4L46.2,37c-0.3-0.2-0.8-0.3-1.6-0.3c-1.4,0-1.9,0.9-1.9,2.2c0,0.7,0.1,1.3,0.2,1.9
			h2.5v1.1h-2.4c0.1,0.7,0.1,1.3-0.1,1.9c-0.2,0.7-0.6,1.4-1.2,1.9v0H47v1.3H39.8z"
              />
            </g>
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M17.1,31c0,0.4,0.3,0.8,0.7,0.8v0h0c0,0,0,0,0,0s0,0,0,0h13c0.2,0,0.3,0.2,0.3,0.3v0.5
		c0,0.2,0.2,0.4,0.4,0.3l4.2-1.7c0.3-0.1,0.3-0.5,0-0.6l-4.2-1.7c-0.2-0.1-0.4,0.1-0.4,0.3v0.6c0,0.2-0.1,0.3-0.3,0.3H17.8v0
		C17.4,30.2,17.1,30.5,17.1,31z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M36.1,24.5c0-0.4-0.3-0.8-0.7-0.8v0h0c0,0,0,0,0,0c0,0,0,0,0,0h-13c-0.2,0-0.3-0.2-0.3-0.3v-0.5
		c0-0.2-0.2-0.4-0.4-0.3l-4.2,1.7c-0.3,0.1-0.3,0.5,0,0.6l4.2,1.7c0.2,0.1,0.4-0.1,0.4-0.3v-0.6c0-0.2,0.1-0.3,0.3-0.3h13.1v0
		C35.8,25.3,36.1,25,36.1,24.5z"
            />
            <g>
              <circle fill={p4Tokens.colorBrandMenuForeground1} cx="25.5" cy="45" r="8.2" />
              <circle fill={p4Tokens.colorBrandMenuBackground1} cx="25.5" cy="45" r="6.5" />
              <polygon fill={p4Tokens.colorBrandMenuForeground1} points="26.2,45 29.7,41.6 25.6,44.3 		" />
              <polygon fill={p4Tokens.colorBrandMenuForeground1} points="24.7,45.2 22.5,43.3 25.2,44.4 		" />
              <rect x="25.4" y="38.5" fill={p4Tokens.colorBrandMenuForeground1} width="0.3" height="0.7" />

              <rect
                x="28.5"
                y="39.3"
                transform="matrix(0.8656 0.5007 -0.5007 0.8656 23.6207 -8.9833)"
                fill={p4Tokens.colorBrandMenuForeground1}
                width="0.1"
                height="0.5"
              />

              <rect
                x="19.9"
                y="41.7"
                transform="matrix(0.5074 -0.8617 0.8617 0.5074 -26.2518 37.8478)"
                fill={p4Tokens.colorBrandMenuForeground1}
                width="0.1"
                height="0.5"
              />

              <rect
                x="22.2"
                y="39.3"
                transform="matrix(0.8707 -0.4918 0.4918 0.8707 -16.5777 16.0748)"
                fill={p4Tokens.colorBrandMenuForeground1}
                width="0.1"
                height="0.5"
              />

              <rect
                x="19.1"
                y="44.7"
                transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 64.2741 25.7537)"
                fill={p4Tokens.colorBrandMenuForeground1}
                width="0.3"
                height="0.7"
              />
              <circle fill={p4Tokens.colorBrandMenuForeground1} cx="25.5" cy="45" r="0.8" />
              <circle
                fill={p4Tokens.colorBrandMenuForeground1}
                stroke={p4Tokens.colorBrandMenuForeground1}
                strokeMiterlimit="10"
                cx="25.5"
                cy="45"
                r="0.5"
              />
            </g>
          </g>
        </g>
      );
    case 'vattransactions':
      return (
        <g>
          <g>
            <path
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3071"
              strokeMiterlimit="10"
              d="M12.1,45.6h25c1.1,0,2.1-0.9,2.1-2.1V7.5
		c0-1.1-0.9-2.1-2.1-2.1H24.8L10,19.7v23.9C10,44.7,10.9,45.6,12.1,45.6z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeMiterlimit="10"
              d="M11.7,19.4h11c1.1,0,2.1-0.9,2.1-2.1v-11L11.7,19.4z"
            />
            <path fill={p4Tokens.colorBrandMenuBackground1} d="M12.2,18.5h9.9c1,0,1.9-0.8,1.9-1.8V7.4L12.2,18.5z" />
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M42.2,33.2c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7S51,46.8,51,42C51,37.2,47.1,33.2,42.2,33.2z"
              />
            </g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                d="M38.6,47.4v-0.9c1.2-0.6,2-1.7,2-3c0-0.4,0-0.8-0.1-1.2h-1.8v-1.1h1.6c-0.1-0.5-0.2-1.2-0.2-1.9
			c0-2.1,1.4-3.4,3.3-3.4c0.9,0,1.5,0.2,1.9,0.4l-0.3,1.1c-0.3-0.2-0.8-0.3-1.6-0.3c-1.4,0-1.9,0.9-1.9,2.2c0,0.7,0.1,1.3,0.2,1.9
			h2.5v1.1h-2.4c0.1,0.7,0.1,1.3-0.1,1.9c-0.2,0.7-0.6,1.4-1.2,1.9v0h5.2v1.3H38.6z"
              />
            </g>
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M16,31.5c0,0.4,0.3,0.8,0.7,0.8v0h0c0,0,0,0,0,0c0,0,0,0,0,0h13c0.2,0,0.3,0.2,0.3,0.3v0.5
		c0,0.2,0.2,0.4,0.4,0.3l4.2-1.7c0.3-0.1,0.3-0.5,0-0.6l-4.2-1.7c-0.2-0.1-0.4,0.1-0.4,0.3v0.6c0,0.2-0.1,0.3-0.3,0.3H16.7v0
		C16.3,30.7,16,31.1,16,31.5z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M35,25.1c0-0.4-0.3-0.8-0.7-0.8v0h0c0,0,0,0,0,0c0,0,0,0,0,0h-13c-0.2,0-0.3-0.2-0.3-0.3v-0.5
		c0-0.2-0.2-0.4-0.4-0.3l-4.2,1.7c-0.3,0.1-0.3,0.5,0,0.6l4.2,1.7c0.2,0.1,0.4-0.1,0.4-0.3v-0.6c0-0.2,0.1-0.3,0.3-0.3h13.1v0
		C34.6,25.9,35,25.5,35,25.1z"
            />
            <g>
              <circle fill={p4Tokens.colorBrandMenuForeground1} cx="24.3" cy="45.6" r="8.2" />
              <circle fill={p4Tokens.colorBrandMenuBackground1} cx="24.3" cy="45.6" r="6.5" />
              <polygon fill={p4Tokens.colorBrandMenuForeground1} points="25,45.6 28.6,42.1 24.5,44.9 		" />
              <polygon fill={p4Tokens.colorBrandMenuForeground1} points="23.6,45.7 21.4,43.9 24.1,45 		" />
              <rect x="24.2" y="39" fill={p4Tokens.colorBrandMenuForeground1} width="0.3" height="0.7" />

              <rect
                x="27.4"
                y="39.8"
                transform="matrix(0.8656 0.5007 -0.5007 0.8656 23.7451 -8.3447)"
                fill={p4Tokens.colorBrandMenuForeground1}
                width="0.1"
                height="0.5"
              />

              <rect
                x="18.8"
                y="42.2"
                transform="matrix(0.5074 -0.8617 0.8617 0.5074 -27.2819 37.1477)"
                fill={p4Tokens.colorBrandMenuForeground1}
                width="0.1"
                height="0.5"
              />

              <rect
                x="21.1"
                y="39.9"
                transform="matrix(0.8707 -0.4918 0.4918 0.8707 -16.9945 15.5916)"
                fill={p4Tokens.colorBrandMenuForeground1}
                width="0.1"
                height="0.5"
              />

              <rect
                x="18"
                y="45.2"
                transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 63.6978 27.4322)"
                fill={p4Tokens.colorBrandMenuForeground1}
                width="0.3"
                height="0.7"
              />
              <circle fill={p4Tokens.colorBrandMenuForeground1} cx="24.3" cy="45.6" r="0.8" />
              <circle
                fill={p4Tokens.colorBrandMenuForeground1}
                stroke={p4Tokens.colorBrandMenuForeground1}
                strokeMiterlimit="10"
                cx="24.3"
                cy="45.6"
                r="0.5"
              />
            </g>
          </g>
        </g>
      );
    case 'stocktransactions':
      return (
        <g>
          <g>
            <path
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3071"
              strokeMiterlimit="10"
              d="M11.6,44.8h25c1.1,0,2.1-0.9,2.1-2.1V6.6
		c0-1.1-0.9-2.1-2.1-2.1H24.3L9.5,18.8v23.9C9.5,43.8,10.5,44.8,11.6,44.8z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeMiterlimit="10"
              d="M11.3,18.6h11c1.1,0,2.1-0.9,2.1-2.1v-11L11.3,18.6z"
            />
            <path fill={p4Tokens.colorBrandMenuBackground1} d="M11.8,17.7h9.9c1,0,1.9-0.8,1.9-1.8V6.5L11.8,17.7z" />
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M41.8,32.4c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C50.5,36.3,46.6,32.4,41.8,32.4z
			"
              />
            </g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                d="M38.2,46.6v-0.9c1.2-0.6,2-1.7,2-3c0-0.4,0-0.8-0.1-1.2h-1.8v-1.1h1.6c-0.1-0.5-0.2-1.2-0.2-1.9
			c0-2.1,1.4-3.4,3.3-3.4c0.9,0,1.5,0.2,1.9,0.4l-0.3,1.1c-0.3-0.2-0.8-0.3-1.6-0.3c-1.4,0-1.9,0.9-1.9,2.2c0,0.7,0.1,1.3,0.2,1.9
			h2.5v1.1h-2.4c0.1,0.7,0.1,1.3-0.1,1.9c-0.2,0.7-0.6,1.4-1.2,1.9v0h5.2v1.3H38.2z"
              />
            </g>
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M15.5,30.6c0,0.4,0.3,0.8,0.7,0.8v0h0c0,0,0,0,0,0c0,0,0,0,0,0h13c0.2,0,0.3,0.2,0.3,0.3v0.5
		c0,0.2,0.2,0.4,0.4,0.3l4.2-1.7c0.3-0.1,0.3-0.5,0-0.6l-4.2-1.7c-0.2-0.1-0.4,0.1-0.4,0.3v0.6c0,0.2-0.1,0.3-0.3,0.3H16.2v0
		C15.8,29.9,15.5,30.2,15.5,30.6z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M34.5,24.2c0-0.4-0.3-0.8-0.7-0.8v0h0c0,0,0,0,0,0c0,0,0,0,0,0h-13c-0.2,0-0.3-0.2-0.3-0.3v-0.5
		c0-0.2-0.2-0.4-0.4-0.3L15.7,24c-0.3,0.1-0.3,0.5,0,0.6l4.2,1.7c0.2,0.1,0.4-0.1,0.4-0.3v-0.6c0-0.2,0.1-0.3,0.3-0.3h13.1v0
		C34.2,25,34.5,24.7,34.5,24.2z"
            />
            <g>
              <circle fill={p4Tokens.colorBrandMenuForeground1} cx="23.9" cy="44.7" r="8.2" />
              <circle fill={p4Tokens.colorBrandMenuBackground1} cx="23.9" cy="44.7" r="6.5" />
              <polygon fill={p4Tokens.colorBrandMenuForeground1} points="24.6,44.7 28.1,41.3 24,44 		" />
              <polygon fill={p4Tokens.colorBrandMenuForeground1} points="23.1,44.8 20.9,43 23.6,44.1 		" />
              <rect x="23.8" y="38.2" fill={p4Tokens.colorBrandMenuForeground1} width="0.3" height="0.7" />

              <rect
                x="26.9"
                y="39"
                transform="matrix(0.8656 0.5007 -0.5007 0.8656 23.2478 -8.2322)"
                fill={p4Tokens.colorBrandMenuForeground1}
                width="0.1"
                height="0.5"
              />

              <rect
                x="18.3"
                y="41.3"
                transform="matrix(0.5074 -0.8617 0.8617 0.5074 -26.7579 36.3244)"
                fill={p4Tokens.colorBrandMenuForeground1}
                width="0.1"
                height="0.5"
              />

              <rect
                x="20.6"
                y="39"
                transform="matrix(0.8707 -0.4918 0.4918 0.8707 -16.6258 15.2537)"
                fill={p4Tokens.colorBrandMenuForeground1}
                width="0.1"
                height="0.5"
              />

              <rect
                x="17.5"
                y="44.4"
                transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 62.3695 27.0204)"
                fill={p4Tokens.colorBrandMenuForeground1}
                width="0.3"
                height="0.7"
              />
              <circle fill={p4Tokens.colorBrandMenuForeground1} cx="23.9" cy="44.7" r="0.8" />
              <circle
                fill={p4Tokens.colorBrandMenuForeground1}
                stroke={p4Tokens.colorBrandMenuForeground1}
                strokeMiterlimit="10"
                cx="23.9"
                cy="44.7"
                r="0.5"
              />
            </g>
          </g>
        </g>
      );
    case 'stockadjustment':
      return (
        <g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.2035"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              d="
		M28.6,23.5c0,0-17.7-8-18-7.5c-0.3,0.4,0.1,22.6,0.1,22.6l17.7,7.6L28.6,23.5z"
            />

            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              d="
		M10.8,15.7c2.1-1,16-6.3,16.8-6.4c1,0,18.7,6.2,18.2,6.5c-0.4,0.3-15.9,7.2-17.1,7.5C27.7,23.6,10.9,15.6,10.8,15.7"
            />

            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              d="
		M28.8,23.4c0,0,17.2-8.1,17.2-7.5c0,10.2,0.2,22-0.2,22.3c-0.7,0.4-16.9,8.5-17.1,8C28.5,45.8,28.8,23.4,28.8,23.4z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M33.4,11.7l-16.3,7v9.9c0,0,3.8,2,3.9,1.2c0.2-3.1,0.2-9.6,0.2-9.3l16.5-7.3L33.4,11.7z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M16.4,37.6c-3,0-5.5,2.5-5.5,5.5c0,3,2.5,5.5,5.5,5.5s5.5-2.5,5.5-5.5C21.9,40.1,19.5,37.6,16.4,37.6z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M17,39.4v2.9h2.9v1.4H17v3h-1.4v-3h-2.9v-1.4h2.9v-2.9H17z"
            />
          </g>
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M41.4,37.3c-3,0-5.5,2.5-5.5,5.5c0,3,2.5,5.5,5.5,5.5s5.5-2.5,5.5-5.5C46.9,39.8,44.5,37.3,41.4,37.3z"
              />
            </g>
          </g>
          <rect x="37.7" y="42.1" fill={p4Tokens.colorBrandMenuBackground1} width="7.1" height="1.8" />
        </g>
      );
    case 'stocktransfer':
      return (
        <g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.2035"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              d="
		M29,24.5c0,0-17.7-8-18-7.5c-0.3,0.4,0.1,22.6,0.1,22.6l17.7,7.6L29,24.5z"
            />

            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              d="
		M11.2,16.7c2.1-1,16-6.3,16.8-6.4c1,0,18.7,6.2,18.2,6.5c-0.4,0.3-15.9,7.2-17.1,7.5C28,24.6,11.3,16.6,11.2,16.7"
            />

            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              d="
		M29.2,24.4c0,0,17.2-8.1,17.2-7.5c0,10.2,0.2,22-0.2,22.3c-0.7,0.4-16.9,8.5-17.1,8C28.9,46.8,29.2,24.4,29.2,24.4z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M33.8,12.7l-16.3,7v9.9c0,0,3.8,2,3.9,1.2c0.2-3.1,0.2-9.6,0.2-9.3L38,14.2L33.8,12.7z"
            />
          </g>
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M45.1,27.2c-0.2-0.3-0.6-0.5-0.9-0.4l0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0L34,31.9c-0.1,0.1-0.3,0-0.4-0.2
	l-0.2-0.4c-0.1-0.2-0.3-0.2-0.5-0.1l-2.6,3c-0.2,0.2,0,0.5,0.3,0.5l4-0.3c0.2,0,0.3-0.2,0.2-0.4l-0.2-0.5c-0.1-0.2,0-0.3,0.1-0.4
	l10.3-5.1l0,0C45.2,27.9,45.3,27.5,45.1,27.2z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M30.3,40.3c0.2,0.3,0.6,0.5,0.9,0.4l0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0l10.2-5.1c0.1-0.1,0.3,0,0.4,0.2
	l0.2,0.4c0.1,0.2,0.3,0.2,0.5,0.1l2.6-3c0.2-0.2,0-0.5-0.3-0.5l-4,0.3c-0.2,0-0.3,0.2-0.2,0.4l0.2,0.5c0.1,0.2,0,0.3-0.1,0.4
	l-10.3,5.1l0,0C30.2,39.5,30.1,40,30.3,40.3z"
          />
        </g>
      );
    case 'supplier':
      return (
        <g>
          <g>
            <circle
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3"
              strokeMiterlimit="10"
              cx="43.4"
              cy="34.1"
              r="5.1"
            />
            <path
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3"
              strokeMiterlimit="10"
              d="M51.8,44.6v5.2c0,0.1,0,0.1-0.1,0.1H35.2
		c-0.1,0-0.2,0-0.2-0.1v-5.2c0-0.1,0-0.2,0-0.3c0.1-1.2,0.6-2.4,1.3-3.2c0,0,0,0,0.1-0.1c0.4-0.4,0.8-0.7,1.3-1c0,0,0.1,0,0.1,0
		c0.1-0.1,0.3-0.1,0.4-0.2c0,0,0.1,0,0.1,0c0.1,0,0.3-0.1,0.4-0.1c0.2,0.2,0.3,0.3,0.5,0.4c0.5,0.4,1,0.7,1.5,0.9
		c0.1,0,0.2,0.1,0.3,0.1c0.4,0.1,0.8,0.3,1.2,0.3c0.5,0.1,0.9,0.1,1.2,0.1c0.3,0,0.7,0,1.1,0c0.8-0.1,1.4-0.4,1.6-0.5
		c0.4-0.2,0.8-0.4,1.2-0.7c0,0,0,0,0,0c0,0,0.6-0.4,0.8-0.6c2.1,0.5,3.6,2.3,3.7,4.6C51.8,44.4,51.8,44.5,51.8,44.6z"
            />
          </g>
          <g>
            <circle
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3"
              strokeMiterlimit="10"
              cx="28.7"
              cy="11"
              r="5.1"
            />
            <path
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3"
              strokeMiterlimit="10"
              d="M37,21.5v5.2c0,0.1,0,0.1-0.1,0.1H20.4
		c-0.1,0-0.2,0-0.2-0.1v-5.2c0-0.1,0-0.2,0-0.3c0.1-1.2,0.6-2.4,1.3-3.2c0,0,0,0,0.1-0.1c0.4-0.4,0.8-0.7,1.3-1c0,0,0.1,0,0.1,0
		c0.1-0.1,0.3-0.1,0.4-0.2c0,0,0.1,0,0.1,0c0.1,0,0.3-0.1,0.4-0.1c0.2,0.2,0.3,0.3,0.5,0.4c0.5,0.4,1,0.7,1.5,0.9
		c0.1,0,0.2,0.1,0.3,0.1c0.4,0.1,0.8,0.3,1.2,0.3c0.5,0.1,0.9,0.1,1.2,0.1c0.3,0,0.7,0,1.1,0c0.8-0.1,1.4-0.4,1.6-0.5
		c0.4-0.2,0.8-0.4,1.2-0.7c0,0,0,0,0,0c0,0,0.6-0.4,0.8-0.6c2.1,0.5,3.6,2.3,3.7,4.6C37,21.3,37,21.4,37,21.5z"
            />
          </g>
          <g>
            <circle
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3"
              strokeMiterlimit="10"
              cx="13.3"
              cy="34.1"
              r="5.1"
            />
            <path
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3"
              strokeMiterlimit="10"
              d="M21.7,44.6v5.2c0,0.1,0,0.1-0.1,0.1H5
		c-0.1,0-0.2,0-0.2-0.1v-5.2c0-0.1,0-0.2,0-0.3c0.1-1.2,0.6-2.4,1.3-3.2c0,0,0,0,0.1-0.1c0.4-0.4,0.8-0.7,1.3-1c0,0,0.1,0,0.1,0
		c0.1-0.1,0.3-0.1,0.4-0.2c0,0,0.1,0,0.1,0c0.1,0,0.3-0.1,0.4-0.1c0.2,0.2,0.3,0.3,0.5,0.4c0.5,0.4,1,0.7,1.5,0.9
		c0.1,0,0.2,0.1,0.3,0.1c0.4,0.1,0.8,0.3,1.2,0.3c0.5,0.1,0.9,0.1,1.2,0.1c0.3,0,0.7,0,1.1,0c0.8-0.1,1.4-0.4,1.6-0.5
		c0.4-0.2,0.8-0.4,1.2-0.7c0,0,0,0,0,0c0,0,0.6-0.4,0.8-0.6c2.1,0.5,3.6,2.3,3.7,4.6C21.6,44.4,21.7,44.5,21.7,44.6z"
            />
          </g>
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            stroke={p4Tokens.colorBrandMenuForeground1}
            strokeWidth="1.4"
            strokeMiterlimit="10"
            d="M28.3,29.6L28.3,29.6c-0.3,0-0.6,0.3-0.6,0.6v6
	c0,0.3,0.3,0.6,0.6,0.6l0,0c0.3,0,0.6-0.3,0.6-0.6v-6C28.8,29.9,28.6,29.6,28.3,29.6z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            stroke={p4Tokens.colorBrandMenuForeground1}
            strokeWidth="1.4"
            strokeMiterlimit="10"
            d="M27.9,35.8L27.9,35.8c-0.2,0.2-0.2,0.6,0.1,0.8
	l5,4c0.2,0.2,0.6,0.2,0.8-0.1l0,0c0.2-0.2,0.2-0.6-0.1-0.8l-5-4C28.5,35.5,28.1,35.5,27.9,35.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            stroke={p4Tokens.colorBrandMenuForeground1}
            strokeWidth="1.4"
            strokeMiterlimit="10"
            d="M22.8,40.4L22.8,40.4c-0.2-0.2-0.2-0.6,0.1-0.8
	l4.8-3.8c0.2-0.2,0.6-0.2,0.8,0.1l0,0c0.2,0.2,0.2,0.6-0.1,0.8l-4.8,3.8C23.4,40.7,23,40.6,22.8,40.4z"
          />
        </g>
      );
    case 'supplieraudit':
      return (
        <g>
          <g>
            <g>
              <ellipse fill={p4Tokens.colorBrandMenuForeground1} cx="33.5" cy="33.1" rx="3.9" ry="3.9" />
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M37.2,37c-0.9,1-2.2,1.6-3.7,1.6c-1.5,0-2.8-0.6-3.7-1.6c-0.1,0-0.2,0-0.2,0.1c0,0,0,0-0.1,0
			c-0.1,0-0.2,0.1-0.3,0.1c0,0,0,0-0.1,0c-0.4,0.2-0.7,0.5-1,0.8c0,0,0,0,0,0.1c-0.6,0.7-1,1.6-1,2.5c0,0.1,0,0.1,0,0.2v4.1
			c0,0.1,0,0.2,0.1,0.2c0,0,3.5,1.3,6.4,1.3s6.3-1.3,6.3-1.3c0.1,0,0.1-0.1,0.1-0.2v-4.1c0-0.1,0-0.1,0-0.2
			C39.9,38.8,38.7,37.4,37.2,37z"
              />
            </g>
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.1049"
              strokeMiterlimit="10"
              d="M52.1,51.1l-7.1-6.8l-3.2,3.3l7.1,6.8
		c0.9,0.9,2.4,0.9,3.3-0.1C53.1,53.5,53.1,52,52.1,51.1z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M24.7,15.4h-9.1c-0.3,0-0.6-0.2-0.6-0.4v-0.4c0-0.2,0.3-0.4,0.6-0.4h9.1c0.3,0,0.6,0.2,0.6,0.4V15
		C25.3,15.2,25.1,15.4,24.7,15.4z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M24.7,20.3h-9.1c-0.3,0-0.6-0.2-0.6-0.4v-0.4c0-0.2,0.3-0.4,0.6-0.4h9.1c0.3,0,0.6,0.2,0.6,0.4v0.4
		C25.3,20.1,25.1,20.3,24.7,20.3z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M24.7,24.8h-9.1c-0.3,0-0.6-0.2-0.6-0.4V24c0-0.2,0.3-0.4,0.6-0.4h9.1c0.3,0,0.6,0.2,0.6,0.4v0.4
		C25.3,24.6,25.1,24.8,24.7,24.8z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M22.5,30.2h-7c-0.2,0-0.4-0.2-0.4-0.4v-0.4c0-0.2,0.2-0.4,0.4-0.4h7c0.2,0,0.4,0.2,0.4,0.4v0.4
		C22.9,30,22.7,30.2,22.5,30.2z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M14,13.7l-2.1,2.4c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2,0-0.3-0.1l-1.3-1c-0.2-0.2-0.3-0.5-0.1-0.7
		c0.2-0.2,0.5-0.3,0.7-0.1l0.9,0.7l1.8-2c0.2-0.2,0.5-0.2,0.7,0C14.2,13.2,14.2,13.5,14,13.7z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M14,18.8l-2.1,2.4c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2,0-0.3-0.1l-1.3-1c-0.2-0.2-0.3-0.5-0.1-0.7
		c0.2-0.2,0.5-0.3,0.7-0.1l0.9,0.7l1.8-2c0.2-0.2,0.5-0.2,0.7,0C14.2,18.2,14.2,18.6,14,18.8z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M14,23.6L11.9,26c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2,0-0.3-0.1l-1.3-1c-0.2-0.2-0.3-0.5-0.1-0.7
		c0.2-0.2,0.5-0.3,0.7-0.1l0.9,0.7l1.8-2c0.2-0.2,0.5-0.2,0.7,0C14.2,23.1,14.2,23.4,14,23.6z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M14,28.5l-2.1,2.4C11.8,31,11.7,31,11.5,31c-0.1,0-0.2,0-0.3-0.1l-1.3-1c-0.2-0.2-0.3-0.5-0.1-0.7
		c0.2-0.2,0.5-0.3,0.7-0.1l0.9,0.7l1.8-2c0.2-0.2,0.5-0.2,0.7,0C14.2,28,14.2,28.3,14,28.5z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M28.9,2.9H5.4C4.6,2.9,3.5,4,3.5,5.4V36c0,1.4,1.1,2.5,2.5,2.5h16c-0.4-1-0.4-1.5-0.5-2.7H6.2l0-27.3h23.4
		l0,16.4c0.9-0.2,0.9-0.3,1.9-0.4c0.2,0,0.4,0,0.6,0V5.4C32.1,4,31,2.9,28.9,2.9z M21.4,5.7c0,0.2-0.2,0.3-0.4,0.3h-6.6
		C14.2,6,14,5.9,14,5.7V5.4C14,5.2,14.2,5,14.4,5h6.6c0.2,0,0.4,0.1,0.4,0.3V5.7z"
            />
            <g>
              <g>
                <path
                  fill={p4Tokens.colorBrandMenuForeground2}
                  d="M25.3,28.6c-4.3,4.5-4.2,11.6,0.3,15.9c3.8,3.7,9.6,4.1,13.9,1.4l1.5,1.5l3.8-3.9l-1.6-1.5
				c2.4-4.3,1.7-9.9-2-13.5C36.7,24,29.6,24.1,25.3,28.6z M40.2,29.4c3.9,3.7,4,9.9,0.2,13.8c-3.7,3.9-9.9,4-13.8,0.2
				c-3.9-3.7-4-9.9-0.2-13.8C30.1,25.8,36.3,25.7,40.2,29.4z"
                />
              </g>
            </g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M39.9,45.4c0,0,0.9-0.8,1.5-1.4c0.6-0.6,1.3-1.7,1.3-1.7l1.1,1.1l-2.9,2.9L39.9,45.4z"
            />
          </g>
        </g>
      );

    case 'vatauthority':
      return (
        <g>
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3071"
            strokeMiterlimit="10"
            d="M12.3,47.2h25c1.1,0,2.1-0.9,2.1-2.1V9.1
	C39.4,8,38.5,7,37.3,7H25L10.2,21.2v23.9C10.2,46.3,11.1,47.2,12.3,47.2z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeMiterlimit="10"
            d="M11.9,21h11c1.1,0,2.1-0.9,2.1-2.1v-11L11.9,21z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M14.4,28h20.4c0.2,0,0.3-0.1,0.3-0.3V27c0-0.2-0.1-0.3-0.3-0.3H14.4c-0.2,0-0.3,0.1-0.3,0.3v0.7
	C14.1,27.9,14.2,28,14.4,28z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M14.4,34h20.4c0.2,0,0.3-0.1,0.3-0.3V33c0-0.2-0.1-0.3-0.3-0.3H14.4c-0.2,0-0.3,0.1-0.3,0.3v0.7
	C14.1,33.9,14.2,34,14.4,34z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M14.4,40h16.7c0.2,0,0.3-0.1,0.3-0.3v-0.8c0-0.2-0.1-0.3-0.3-0.3H14.4c-0.2,0-0.3,0.1-0.3,0.3v0.8
	C14.1,39.9,14.2,40,14.4,40z"
          />
          <path fill={p4Tokens.colorBrandMenuBackground1} d="M12.4,20.1h9.9c1,0,1.9-0.8,1.9-1.8V9L12.4,20.1z" />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M42.4,34.8c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C51.2,38.7,47.3,34.8,42.4,34.8z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M39.5,39.1c1.4,0,2.4,1,2.4,2.5c0,1.5-1,2.5-2.4,2.5c-1.4,0-2.4-1-2.4-2.5C37.1,40.1,38.1,39.1,39.5,39.1z
		 M39.5,43.2c0.6,0,0.8-0.5,0.8-1.7c0-1.1-0.2-1.7-0.8-1.7s-0.8,0.5-0.8,1.7C38.7,42.7,38.9,43.2,39.5,43.2z M44.6,39.1h1.1L40.2,48
		h-1.1L44.6,39.1z M45.4,43.1c1.4,0,2.4,1,2.4,2.5c0,1.5-1,2.5-2.4,2.5c-1.4,0-2.4-1-2.4-2.5C43,44.1,44,43.1,45.4,43.1z M45.4,47.2
		c0.6,0,0.8-0.5,0.8-1.7c0-1.1-0.2-1.7-0.8-1.7c-0.6,0-0.8,0.5-0.8,1.7C44.6,46.7,44.8,47.2,45.4,47.2z"
            />
          </g>
        </g>
      );
    case 'warehouse':
      return (
        <g>
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                stroke={p4Tokens.colorBrandMenuForeground1}
                strokeWidth="1.418"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                d="
			M39,50.2c0-2.1,0-4.2,0-6.4c-2.7,0-5.5,0-8.6,0c0,2.3,0,4.5,0,6.7"
              />

              <path
                fill="none"
                stroke={p4Tokens.colorBrandMenuForeground2}
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                d="
			M42.9,50.2c0-7.4,0-14.8,0-22.4c-9.3,0-18.3,0-27.6,0c0,7.4,0,14.9,0,22.4"
              />

              <path
                fill="none"
                stroke={p4Tokens.colorBrandMenuForeground2}
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                d="
			M29.1,5.7C21.7,8.8,14.3,12,6.9,15.1c0,2,0,4.1,0,6.3c1.4,0.2,2.7,0.4,4.4,0.7c0,9.6,0,19,0,28.6c12,0,23.7,0,35.7,0
			c0-9.6,0-19,0-28.6c1.5-0.2,2.8-0.4,4.2-0.6c0-2.2,0-4.3,0-6.4C44.1,12,36.4,8.7,29.1,5.7"
              />

              <path
                fill="none"
                stroke={p4Tokens.colorBrandMenuForeground2}
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                d="
			M26.9,50.2c0-4.5,0-9,0-13.6c-2.5,0-4.7,0-7.2,0c0,4.5,0,9.2,0,13.9"
              />

              <path
                fill="none"
                stroke={p4Tokens.colorBrandMenuForeground2}
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                d="
			M16.6,21.6c-0.4,0.3-1,0.5-1.2,1c-0.2,0.4,0,1,0,1.7c2.5,0,4.7,0,7.1,0c0-0.9,0-1.6,0-2.7c-1.7,0-3.6,0-5.5,0"
              />

              <path
                fill="none"
                stroke={p4Tokens.colorBrandMenuForeground2}
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                d="
			M26.6,21.6c-0.5,0.7-1,1.5-1.9,2.7c3.2,0,5.5,0,8,0c0-0.7,0-1.5,0-2.7c-2,0-3.9,0-5.8,0"
              />

              <path
                fill="none"
                stroke={p4Tokens.colorBrandMenuForeground2}
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                d="
			M36.7,21.6c-0.4,0.7-0.8,1.5-1.4,2.7c3,0,5.2,0,7.5,0c0-0.7,0-1.5,0-2.7c-2,0-3.9,0-5.8,0"
              />

              <line
                fill="none"
                stroke={p4Tokens.colorBrandMenuForeground2}
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                x1="19.7"
                y1="40"
                x2="26.9"
                y2="40"
              />

              <line
                fill="none"
                stroke={p4Tokens.colorBrandMenuForeground2}
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                x1="19.7"
                y1="43.7"
                x2="26.9"
                y2="43.7"
              />

              <line
                fill="none"
                stroke={p4Tokens.colorBrandMenuForeground2}
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                x1="19.7"
                y1="47.5"
                x2="26.9"
                y2="47.5"
              />
            </g>
          </g>
        </g>
      );
    case 'warehouse_detail':
      return (
        <g>
          <g transform="matrix(1, 0, 0, 1, -25.146872, -20.438944)">
            <g transform="matrix(1, 0, 0, 1, 22.996801, 18.876017)">
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                stroke={p4Tokens.colorBrandMenuForeground1}
                strokeWidth="1.418"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                d=" M39,50.2c0-2.1,0-4.2,0-6.4c-2.7,0-5.5,0-8.6,0c0,2.3,0,4.5,0,6.7"
              />
              <path
                fill="none"
                stroke={p4Tokens.colorBrandMenuForeground2}
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                d=" M42.9,50.2c0-7.4,0-14.8,0-22.4c-9.3,0-18.3,0-27.6,0c0,7.4,0,14.9,0,22.4"
              />
              <path
                fill="none"
                stroke={p4Tokens.colorBrandMenuForeground2}
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                d=" M29.1,5.7C21.7,8.8,14.3,12,6.9,15.1c0,2,0,4.1,0,6.3c1.4,0.2,2.7,0.4,4.4,0.7c0,9.6,0,19,0,28.6c12,0,23.7,0,35.7,0 c0-9.6,0-19,0-28.6c1.5-0.2,2.8-0.4,4.2-0.6c0-2.2,0-4.3,0-6.4C44.1,12,36.4,8.7,29.1,5.7"
              />
              <path
                fill="none"
                stroke={p4Tokens.colorBrandMenuForeground2}
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                d=" M26.9,50.2c0-4.5,0-9,0-13.6c-2.5,0-4.7,0-7.2,0c0,4.5,0,9.2,0,13.9"
              />
              <path
                fill="none"
                stroke={p4Tokens.colorBrandMenuForeground2}
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                d=" M16.6,21.6c-0.4,0.3-1,0.5-1.2,1c-0.2,0.4,0,1,0,1.7c2.5,0,4.7,0,7.1,0c0-0.9,0-1.6,0-2.7c-1.7,0-3.6,0-5.5,0"
              />
              <path
                fill="none"
                stroke={p4Tokens.colorBrandMenuForeground2}
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                d=" M26.6,21.6c-0.5,0.7-1,1.5-1.9,2.7c3.2,0,5.5,0,8,0c0-0.7,0-1.5,0-2.7c-2,0-3.9,0-5.8,0"
              />
              <path
                fill="none"
                stroke={p4Tokens.colorBrandMenuForeground2}
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                d=" M36.7,21.6c-0.4,0.7-0.8,1.5-1.4,2.7c3,0,5.2,0,7.5,0c0-0.7,0-1.5,0-2.7c-2,0-3.9,0-5.8,0"
              />
              <line
                fill="none"
                stroke={p4Tokens.colorBrandMenuForeground2}
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                x1="19.7"
                y1="40"
                x2="26.9"
                y2="40"
              />
              <line
                fill="none"
                stroke={p4Tokens.colorBrandMenuForeground2}
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                x1="19.7"
                y1="43.7"
                x2="26.9"
                y2="43.7"
              />
              <line
                fill="none"
                stroke={p4Tokens.colorBrandMenuForeground2}
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                x1="19.7"
                y1="47.5"
                x2="26.9"
                y2="47.5"
              />
            </g>
            <path
              fill="#2C3279"
              d="M 69.005 58.551 C 64.205 58.551 60.305 62.451 60.305 67.251 C 60.305 72.051 64.205 75.951 69.005 75.951 C 73.805 75.951 77.705 72.051 77.705 67.251 C 77.805 62.451 73.905 58.551 69.005 58.551 Z"
            />
          </g>
          <g transform="matrix(1.083542, 0, 0, 1, -3.637407, 7.659297)">
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M 43.377 41.9 L 43.377 40.9 C 43.377 39.7 43.677 39.4 44.577 38.6 C 45.277 37.9 46.077 37.3 46.077 36.3 C 46.077 35.3 45.277 34.5 44.277 34.5 C 43.177 34.5 42.477 35.3 42.377 36.4 L 40.677 36.2 C 40.977 34.3 42.377 33.1 44.377 33.1 C 46.277 33.1 47.677 34.2 47.677 36.2 C 47.677 37.1 47.377 37.7 46.977 38.2 C 46.977 38.2 46.977 38.2 45.977 39.2 C 45.977 39.2 45.977 39.2 45.777 39.4 C 45.077 40.1 44.977 40.3 44.977 41.2 L 44.977 41.9 L 43.377 41.9 Z M 44.177 43.1 C 44.777 43.1 45.277 43.6 45.277 44.2 C 45.277 44.8 44.777 45.3 44.177 45.3 C 43.577 45.3 43.077 44.8 43.077 44.2 C 43.077 43.6 43.577 43.1 44.177 43.1 Z"
            />
          </g>
        </g>
      );
    case 'customer':
      return (
        <g>
          <circle
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.2"
            cx="14.4"
            cy="13.8"
            r="7.3"
          />
          <circle
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.2"
            strokeMiterlimit="10"
            cx="42"
            cy="13.8"
            r="7.3"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.2"
            d="M15.4,34.6l0.1-0.1c0.7-0.7,1.5-1.3,2.3-1.8c0.1,0,0.1-0.1,0.2-0.1
	c0.2-0.1,0.5-0.2,0.7-0.3c0.1,0,0.1,0,0.2-0.1c0.2-0.1,0.4-0.1,0.6-0.2c-1-1.5-1.5-3.4-1.5-5.3c0-1.5,0.3-2.9,0.9-4.2
	c-0.2,0.1-0.4,0.2-0.6,0.3c-0.1,0.1-0.2,0.1-0.4,0.1c-0.3,0.1-1.5,0.4-1.5,0.4c-0.7,0.1-1.3,0.2-2,0.2c-0.6,0-1.2-0.1-1.8-0.2
	s-1.2-0.3-1.7-0.5c-0.1-0.1-0.3-0.1-0.4-0.2c-0.8-0.3-1.5-0.8-2.1-1.3c-0.3-0.2-0.5-0.4-0.7-0.6C7.4,21,7.2,21,7,21.1H6.9
	c-0.2,0.1-0.4,0.2-0.6,0.3c0,0-0.1,0-0.1,0.1c-0.7,0.4-1.4,0.9-2,1.4L4.1,23c-1.1,1.2-1.8,2.9-1.9,4.7c0,0.1,0,2.8,0,2.9l0.1,4
	c0,0.2,0,1.3,0.2,3.1h11.2C14,36.5,14.6,35.5,15.4,34.6z"
          />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground1}
              strokeWidth="2"
              strokeMiterlimit="10"
              d="M40.1,42.2v7.6c0,0.2,0,0.3-0.2,2.1h-24
		c-0.1-1.8-0.2-1.9-0.2-2.1v-7.6c0-0.1,0-0.2,0-0.4c0.1-1.8,0.8-3.4,1.9-4.7l0.1-0.1c0.6-0.6,1.2-1.1,2-1.4c0,0,0.1,0,0.1-0.1
		c0.2-0.1,0.4-0.2,0.6-0.3h0.1c0.2-0.1,0.4-0.1,0.6-0.2c0.2,0.2,0.5,0.4,0.7,0.6c0.7,0.5,1.4,0.9,2.1,1.3c0.1,0.1,0.3,0.1,0.4,0.2
		c0.6,0.2,1.1,0.4,1.7,0.5s1.2,0.2,1.8,0.2c0.7,0,1.3-0.1,2-0.2c0.1,0,1.2-0.3,1.5-0.4c0.1,0,0.2-0.1,0.4-0.1c0.6-0.3,1.8-1,1.9-1.1
		c0.3-0.3,0.7-0.6,1-0.9c3,0.7,5.3,3.4,5.4,6.7C40.1,42,40.1,42.1,40.1,42.2z"
            />
          </g>
          <circle
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground1}
            strokeWidth="2"
            strokeMiterlimit="10"
            cx="27.9"
            cy="26.8"
            r="7.3"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.2"
            strokeMiterlimit="10"
            d="M48.8,20.9c-0.3,0.3-2.3,1.7-2.9,1.9
	c-0.1,0.1-0.8,0.4-1.1,0.5c-0.6,0.1-0.9,0.2-1.5,0.3c-0.5,0.1-1,0-1.3,0c-0.6,0-1.2-0.1-1.8-0.2s-1.2-0.3-1.7-0.5
	c-0.1-0.1-0.3-0.1-0.4-0.2c-0.5-0.2-0.9-0.5-1.4-0.7c0.7,1.4,1.2,3,1.2,4.7c0,2-0.6,3.9-1.6,5.4c2.6,0.8,4.6,2.9,5.5,5.5H54
	c0.2-1.1,0.2-1.4,0.2-2.1v-7.6c0-0.1,0-0.2,0-0.4C54,24.4,51.8,21.6,48.8,20.9z"
          />
        </g>
      );
    case 'customer_inverted':
      return (
        <g>
          <circle
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground1}
            strokeWidth="1.2"
            cx="14.4"
            cy="13.8"
            r="7.3"
          />
          <circle
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground1}
            strokeWidth="1.2"
            strokeMiterlimit="10"
            cx="42"
            cy="13.8"
            r="7.3"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground1}
            strokeWidth="1.2"
            d="M15.4,34.6l0.1-0.1c0.7-0.7,1.5-1.3,2.3-1.8c0.1,0,0.1-0.1,0.2-0.1
	c0.2-0.1,0.5-0.2,0.7-0.3c0.1,0,0.1,0,0.2-0.1c0.2-0.1,0.4-0.1,0.6-0.2c-1-1.5-1.5-3.4-1.5-5.3c0-1.5,0.3-2.9,0.9-4.2
	c-0.2,0.1-0.4,0.2-0.6,0.3c-0.1,0.1-0.2,0.1-0.4,0.1c-0.3,0.1-1.5,0.4-1.5,0.4c-0.7,0.1-1.3,0.2-2,0.2c-0.6,0-1.2-0.1-1.8-0.2
	s-1.2-0.3-1.7-0.5c-0.1-0.1-0.3-0.1-0.4-0.2c-0.8-0.3-1.5-0.8-2.1-1.3c-0.3-0.2-0.5-0.4-0.7-0.6C7.4,21,7.2,21,7,21.1H6.9
	c-0.2,0.1-0.4,0.2-0.6,0.3c0,0-0.1,0-0.1,0.1c-0.7,0.4-1.4,0.9-2,1.4L4.1,23c-1.1,1.2-1.8,2.9-1.9,4.7c0,0.1,0,2.8,0,2.9l0.1,4
	c0,0.2,0,1.3,0.2,3.1h11.2C14,36.5,14.6,35.5,15.4,34.6z"
          />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="2"
              strokeMiterlimit="10"
              d="M40.1,42.2v7.6c0,0.2,0,0.3-0.2,2.1h-24
		c-0.1-1.8-0.2-1.9-0.2-2.1v-7.6c0-0.1,0-0.2,0-0.4c0.1-1.8,0.8-3.4,1.9-4.7l0.1-0.1c0.6-0.6,1.2-1.1,2-1.4c0,0,0.1,0,0.1-0.1
		c0.2-0.1,0.4-0.2,0.6-0.3h0.1c0.2-0.1,0.4-0.1,0.6-0.2c0.2,0.2,0.5,0.4,0.7,0.6c0.7,0.5,1.4,0.9,2.1,1.3c0.1,0.1,0.3,0.1,0.4,0.2
		c0.6,0.2,1.1,0.4,1.7,0.5s1.2,0.2,1.8,0.2c0.7,0,1.3-0.1,2-0.2c0.1,0,1.2-0.3,1.5-0.4c0.1,0,0.2-0.1,0.4-0.1c0.6-0.3,1.8-1,1.9-1.1
		c0.3-0.3,0.7-0.6,1-0.9c3,0.7,5.3,3.4,5.4,6.7C40.1,42,40.1,42.1,40.1,42.2z"
            />
          </g>
          <circle
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="2"
            strokeMiterlimit="10"
            cx="27.9"
            cy="26.8"
            r="7.3"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground1}
            strokeWidth="1.2"
            strokeMiterlimit="10"
            d="M48.8,20.9c-0.3,0.3-2.3,1.7-2.9,1.9
	c-0.1,0.1-0.8,0.4-1.1,0.5c-0.6,0.1-0.9,0.2-1.5,0.3c-0.5,0.1-1,0-1.3,0c-0.6,0-1.2-0.1-1.8-0.2s-1.2-0.3-1.7-0.5
	c-0.1-0.1-0.3-0.1-0.4-0.2c-0.5-0.2-0.9-0.5-1.4-0.7c0.7,1.4,1.2,3,1.2,4.7c0,2-0.6,3.9-1.6,5.4c2.6,0.8,4.6,2.9,5.5,5.5H54
	c0.2-1.1,0.2-1.4,0.2-2.1v-7.6c0-0.1,0-0.2,0-0.4C54,24.4,51.8,21.6,48.8,20.9z"
          />
        </g>
      );
    case P4SVGIcon.CustomerGlobalContact:
      return (
        <g>
          <g id="g4">
            <circle
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground1}
              strokeWidth="1.2"
              cx="14.4"
              cy="13.8"
              r="7.3"
              id="circle1"
            />
            <circle
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground1}
              strokeWidth="1.2"
              strokeMiterlimit="10"
              cx="42"
              cy="13.8"
              r="7.3"
              id="circle2"
            />
            <path
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground1}
              strokeWidth="1.2"
              d="M15.4,34.6l0.1-0.1c0.7-0.7,1.5-1.3,2.3-1.8c0.1,0,0.1-0.1,0.2-0.1  c0.2-0.1,0.5-0.2,0.7-0.3c0.1,0,0.1,0,0.2-0.1c0.2-0.1,0.4-0.1,0.6-0.2c-1-1.5-1.5-3.4-1.5-5.3c0-1.5,0.3-2.9,0.9-4.2  c-0.2,0.1-0.4,0.2-0.6,0.3c-0.1,0.1-0.2,0.1-0.4,0.1c-0.3,0.1-1.5,0.4-1.5,0.4c-0.7,0.1-1.3,0.2-2,0.2c-0.6,0-1.2-0.1-1.8-0.2  s-1.2-0.3-1.7-0.5c-0.1-0.1-0.3-0.1-0.4-0.2c-0.8-0.3-1.5-0.8-2.1-1.3c-0.3-0.2-0.5-0.4-0.7-0.6C7.4,21,7.2,21,7,21.1H6.9  c-0.2,0.1-0.4,0.2-0.6,0.3c0,0-0.1,0-0.1,0.1c-0.7,0.4-1.4,0.9-2,1.4L4.1,23c-1.1,1.2-1.8,2.9-1.9,4.7c0,0.1,0,2.8,0,2.9l0.1,4  c0,0.2,0,1.3,0.2,3.1h11.2C14,36.5,14.6,35.5,15.4,34.6z"
              id="path2"
            />
            <g id="g3">
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                stroke={p4Tokens.colorBrandMenuForeground2}
                strokeWidth="2"
                strokeMiterlimit="10"
                d="M40.1,42.2v7.6c0,0.2,0,0.3-0.2,2.1h-24   c-0.1-1.8-0.2-1.9-0.2-2.1v-7.6c0-0.1,0-0.2,0-0.4c0.1-1.8,0.8-3.4,1.9-4.7l0.1-0.1c0.6-0.6,1.2-1.1,2-1.4c0,0,0.1,0,0.1-0.1   c0.2-0.1,0.4-0.2,0.6-0.3h0.1c0.2-0.1,0.4-0.1,0.6-0.2c0.2,0.2,0.5,0.4,0.7,0.6c0.7,0.5,1.4,0.9,2.1,1.3c0.1,0.1,0.3,0.1,0.4,0.2   c0.6,0.2,1.1,0.4,1.7,0.5s1.2,0.2,1.8,0.2c0.7,0,1.3-0.1,2-0.2c0.1,0,1.2-0.3,1.5-0.4c0.1,0,0.2-0.1,0.4-0.1c0.6-0.3,1.8-1,1.9-1.1   c0.3-0.3,0.7-0.6,1-0.9c3,0.7,5.3,3.4,5.4,6.7C40.1,42,40.1,42.1,40.1,42.2z"
                id="path3"
              />
            </g>
            <path
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground1}
              strokeWidth="1.2"
              strokeMiterlimit="10"
              d="M48.8,20.9c-0.3,0.3-2.3,1.7-2.9,1.9  c-0.1,0.1-0.8,0.4-1.1,0.5c-0.6,0.1-0.9,0.2-1.5,0.3c-0.5,0.1-1,0-1.3,0c-0.6,0-1.2-0.1-1.8-0.2s-1.2-0.3-1.7-0.5  c-0.1-0.1-0.3-0.1-0.4-0.2c-0.5-0.2-0.9-0.5-1.4-0.7c0.7,1.4,1.2,3,1.2,4.7c0,2-0.6,3.9-1.6,5.4c2.6,0.8,4.6,2.9,5.5,5.5H54  c0.2-1.1,0.2-1.4,0.2-2.1v-7.6c0-0.1,0-0.2,0-0.4C54,24.4,51.8,21.6,48.8,20.9z"
              id="path4"
            />
          </g>
          <g
            id="g5"
            transform="matrix(0.03324585,0,0,0.03324585,20.177366,18.938823)"
            style={{ fill: '#aaaaaa', fillOpacity: 1 }}
          >
            <g id="g1" style={{ fill: '#aaaaaa', fillOpacity: 1 }}>
              <path
                d="M 233.168,0 C 104.604,0 0,104.604 0,233.168 0,361.733 104.604,466.337 233.168,466.337 361.733,466.337 466.337,361.733 466.337,233.168 466.337,104.604 361.733,0 233.168,0 Z m -9.184,441.874 c -22.321,0 -46.405,-41.384 -59.045,-107.815 h 118.067 c -12.635,66.431 -36.69,107.815 -59.022,107.815 z m -62.87,-131.73 c -2.738,-19.991 -4.437,-41.781 -4.881,-65.018 H 291.74 c -0.443,23.237 -2.148,45.027 -4.869,65.018 z M 24.521,245.126 h 107.704 c 0.443,21.883 2.09,43.859 4.887,65.018 H 38.768 C 30.693,289.826 25.818,267.966 24.521,245.126 Z M 223.984,24.464 c 21.982,0 45.687,40.14 58.484,104.877 H 165.498 C 178.286,64.604 201.996,24.464 223.984,24.464 Z m 62.479,128.781 c 2.978,20.785 4.811,43.596 5.277,67.966 H 156.222 c 0.467,-24.37 2.295,-47.169 5.272,-67.966 z M 132.226,221.211 H 24.521 c 1.354,-23.926 6.568,-46.836 15.332,-67.966 h 97.656 c -3.047,22.075 -4.828,45.067 -5.283,67.966 z m 183.523,23.915 h 126.065 c -1.296,22.84 -6.188,44.7 -14.246,65.018 H 310.855 c 2.791,-21.159 4.45,-43.135 4.894,-65.018 z m 0,-23.915 c -0.468,-22.898 -2.254,-45.891 -5.29,-67.966 h 116.023 c 8.77,21.13 13.978,44.04 15.332,67.966 z M 414.596,129.33 H 306.617 C 298.723,87.263 285.89,50.486 268.422,27.108 330.952,37.799 384.06,76.205 414.596,129.33 Z M 176.073,32.036 c -15.7,23.459 -27.348,58.1 -34.699,97.305 H 51.741 C 78.657,82.505 123.064,47.1 176.073,32.036 Z M 49.96,334.058 h 90.895 c 7.311,40.403 19.133,76.205 35.219,100.26 -54.13,-15.414 -99.402,-51.94 -126.114,-100.26 z m 218.45,105.164 c 17.865,-23.938 30.874,-61.889 38.697,-105.164 H 416.381 C 386.15,388.743 332.12,428.339 268.41,439.222 Z"
                id="path1"
                style={{ fill: '#808183', fillOpacity: 1 }}
              />
            </g>
          </g>
        </g>
      );
    case 'customeraudit':
      return (
        <g>
          <g>
            <g>
              <ellipse fill={p4Tokens.colorBrandMenuForeground1} cx="33.5" cy="33.1" rx="3.9" ry="3.9" />
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M37.2,37c-0.9,1-2.2,1.6-3.7,1.6c-1.5,0-2.8-0.6-3.7-1.6c-0.1,0-0.2,0-0.2,0.1c0,0,0,0-0.1,0
			c-0.1,0-0.2,0.1-0.3,0.1c0,0,0,0-0.1,0c-0.4,0.2-0.7,0.5-1,0.8c0,0,0,0,0,0.1c-0.6,0.7-1,1.6-1,2.5c0,0.1,0,0.1,0,0.2v4.1
			c0,0.1,0,0.2,0.1,0.2c0,0,3.5,1.3,6.4,1.3s6.3-1.3,6.3-1.3c0.1,0,0.1-0.1,0.1-0.2v-4.1c0-0.1,0-0.1,0-0.2
			C39.9,38.8,38.7,37.4,37.2,37z"
              />
            </g>
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.1049"
              strokeMiterlimit="10"
              d="M52.1,51.1l-7.1-6.8l-3.2,3.3l7.1,6.8
		c0.9,0.9,2.4,0.9,3.3-0.1C53.1,53.5,53.1,52,52.1,51.1z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M24.7,15.4h-9.1c-0.3,0-0.6-0.2-0.6-0.4v-0.4c0-0.2,0.3-0.4,0.6-0.4h9.1c0.3,0,0.6,0.2,0.6,0.4V15
		C25.3,15.2,25.1,15.4,24.7,15.4z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M24.7,20.3h-9.1c-0.3,0-0.6-0.2-0.6-0.4v-0.4c0-0.2,0.3-0.4,0.6-0.4h9.1c0.3,0,0.6,0.2,0.6,0.4v0.4
		C25.3,20.1,25.1,20.3,24.7,20.3z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M24.7,24.8h-9.1c-0.3,0-0.6-0.2-0.6-0.4V24c0-0.2,0.3-0.4,0.6-0.4h9.1c0.3,0,0.6,0.2,0.6,0.4v0.4
		C25.3,24.6,25.1,24.8,24.7,24.8z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M22.5,30.2h-7c-0.2,0-0.4-0.2-0.4-0.4v-0.4c0-0.2,0.2-0.4,0.4-0.4h7c0.2,0,0.4,0.2,0.4,0.4v0.4
		C22.9,30,22.7,30.2,22.5,30.2z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M14,13.7l-2.1,2.4c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2,0-0.3-0.1l-1.3-1c-0.2-0.2-0.3-0.5-0.1-0.7
		c0.2-0.2,0.5-0.3,0.7-0.1l0.9,0.7l1.8-2c0.2-0.2,0.5-0.2,0.7,0C14.2,13.2,14.2,13.5,14,13.7z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M14,18.8l-2.1,2.4c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2,0-0.3-0.1l-1.3-1c-0.2-0.2-0.3-0.5-0.1-0.7
		c0.2-0.2,0.5-0.3,0.7-0.1l0.9,0.7l1.8-2c0.2-0.2,0.5-0.2,0.7,0C14.2,18.2,14.2,18.6,14,18.8z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M14,23.6L11.9,26c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2,0-0.3-0.1l-1.3-1c-0.2-0.2-0.3-0.5-0.1-0.7
		c0.2-0.2,0.5-0.3,0.7-0.1l0.9,0.7l1.8-2c0.2-0.2,0.5-0.2,0.7,0C14.2,23.1,14.2,23.4,14,23.6z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M14,28.5l-2.1,2.4C11.8,31,11.7,31,11.5,31c-0.1,0-0.2,0-0.3-0.1l-1.3-1c-0.2-0.2-0.3-0.5-0.1-0.7
		c0.2-0.2,0.5-0.3,0.7-0.1l0.9,0.7l1.8-2c0.2-0.2,0.5-0.2,0.7,0C14.2,28,14.2,28.3,14,28.5z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M28.9,2.9H5.4C4.6,2.9,3.5,4,3.5,5.4V36c0,1.4,1.1,2.5,2.5,2.5h16c-0.4-1-0.4-1.5-0.5-2.7H6.2l0-27.3h23.4
		l0,16.4c0.9-0.2,0.9-0.3,1.9-0.4c0.2,0,0.4,0,0.6,0V5.4C32.1,4,31,2.9,28.9,2.9z M21.4,5.7c0,0.2-0.2,0.3-0.4,0.3h-6.6
		C14.2,6,14,5.9,14,5.7V5.4C14,5.2,14.2,5,14.4,5h6.6c0.2,0,0.4,0.1,0.4,0.3V5.7z"
            />
            <g>
              <g>
                <path
                  fill={p4Tokens.colorBrandMenuForeground2}
                  d="M25.3,28.6c-4.3,4.5-4.2,11.6,0.3,15.9c3.8,3.7,9.6,4.1,13.9,1.4l1.5,1.5l3.8-3.9l-1.6-1.5
				c2.4-4.3,1.7-9.9-2-13.5C36.7,24,29.6,24.1,25.3,28.6z M40.2,29.4c3.9,3.7,4,9.9,0.2,13.8c-3.7,3.9-9.9,4-13.8,0.2
				c-3.9-3.7-4-9.9-0.2-13.8C30.1,25.8,36.3,25.7,40.2,29.4z"
                />
              </g>
            </g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M39.9,45.4c0,0,0.9-0.8,1.5-1.4c0.6-0.6,1.3-1.7,1.3-1.7l1.1,1.1l-2.9,2.9L39.9,45.4z"
            />
          </g>
        </g>
      );

    case 'customerspecialprice':
    case 'promotionalprice': // TODO - Create Unique Icon and dont use customerspecialprice
      return (
        <g>
          <g>
            <circle
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3"
              strokeMiterlimit="10"
              cx="26.7"
              cy="16.7"
              r="9.1"
            />
            <path
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3"
              strokeMiterlimit="10"
              d="M41.7,34.4v9.4c0,0.2,0,0.2-0.2,0.2H11.9
		c-0.2,0-0.3,0-0.3-0.2v-9.4c0-0.2,0-0.3,0-0.5c0.1-2.2,1-4.3,2.4-5.8c0,0,0.1-0.1,0.1-0.1c0.7-0.7,1.5-1.3,2.4-1.8
		c0.1,0,0.1-0.1,0.2-0.1c0.2-0.1,0.5-0.2,0.8-0.3c0.1,0,0.1,0,0.2-0.1c0.2-0.1,0.5-0.1,0.7-0.2c0.3,0.3,0.6,0.6,0.9,0.8
		c0.8,0.6,1.7,1.2,2.7,1.6c0.2,0.1,0.4,0.2,0.5,0.2c0.7,0.3,1.4,0.5,2.1,0.6c0.9,0.2,1.6,0.2,2.2,0.2c0.6,0,1.2,0,2-0.1
		c1.4-0.2,2.5-0.8,2.8-0.9c0.7-0.3,1.4-0.8,2.1-1.3c0,0,0,0,0,0c0.1,0,1.1-0.8,1.5-1.1c3.7,0.9,6.4,4.2,6.6,8.3
		C41.7,34.1,41.7,34.3,41.7,34.4z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M41.7,35.2c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C50.4,39.1,46.5,35.2,41.7,35.2z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M38.1,49.4v-0.9c1.2-0.6,2-1.7,2-3c0-0.4,0-0.8-0.1-1.2h-1.8v-1.1h1.6c-0.1-0.5-0.2-1.2-0.2-1.9
		c0-2.1,1.4-3.4,3.3-3.4c0.9,0,1.5,0.2,1.9,0.4l-0.3,1.1c-0.3-0.2-0.8-0.3-1.6-0.3c-1.4,0-1.9,0.9-1.9,2.2c0,0.7,0.1,1.3,0.2,1.9
		h2.5v1.1h-2.4c0.1,0.7,0.1,1.3-0.1,1.9c-0.2,0.7-0.6,1.4-1.2,1.9v0h5.2v1.3H38.1z"
            />
          </g>
        </g>
      );

    case 'customerpricelist':
      return (
        <g>
          <g>
            <circle
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3"
              strokeMiterlimit="10"
              cx="26"
              cy="15.7"
              r="9.1"
            />
            <path
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3"
              strokeMiterlimit="10"
              d="M41,33.4v9.4c0,0.2,0,0.2-0.2,0.2H11.2
		c-0.2,0-0.3,0-0.3-0.2v-9.4c0-0.2,0-0.3,0-0.5c0.1-2.2,1-4.3,2.4-5.8c0,0,0.1-0.1,0.1-0.1c0.7-0.7,1.5-1.3,2.4-1.8
		c0.1,0,0.1-0.1,0.2-0.1c0.2-0.1,0.5-0.2,0.8-0.3c0.1,0,0.1,0,0.2-0.1c0.2-0.1,0.5-0.1,0.7-0.2c0.3,0.3,0.6,0.6,0.9,0.8
		c0.8,0.6,1.7,1.2,2.7,1.6c0.2,0.1,0.4,0.2,0.5,0.2c0.7,0.3,1.4,0.5,2.1,0.6C24.7,28,25.4,28,26,28c0.6,0,1.2,0,2-0.1
		c1.4-0.2,2.5-0.8,2.8-0.9c0.7-0.3,1.4-0.8,2.1-1.3c0,0,0,0,0,0c0.1,0,1.1-0.8,1.5-1.1c3.7,0.9,6.4,4.2,6.6,8.3
		C41,33.1,41,33.3,41,33.4z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M41,34.2c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C49.8,38.1,45.8,34.2,41,34.2z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M37.4,48.4v-0.9c1.2-0.6,2-1.7,2-3c0-0.4,0-0.8-0.1-1.2h-1.8v-1.1h1.6c-0.1-0.5-0.2-1.2-0.2-1.9
		c0-2.1,1.4-3.4,3.3-3.4c0.9,0,1.5,0.2,1.9,0.4l-0.3,1.1c-0.3-0.2-0.8-0.3-1.6-0.3c-1.4,0-1.9,0.9-1.9,2.2c0,0.7,0.1,1.3,0.2,1.9
		h2.5v1.1h-2.4c0.1,0.7,0.1,1.3-0.1,1.9c-0.2,0.7-0.6,1.4-1.2,1.9v0h5.2v1.3H37.4z"
            />
          </g>
        </g>
      );

    case 'vatrate':
      return (
        <g>
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3071"
            strokeMiterlimit="10"
            d="M15.4,46h25c1.1,0,2.1-0.9,2.1-2.1V7.9
	c0-1.1-0.9-2.1-2.1-2.1H28.1L13.3,20v23.9C13.3,45.1,14.3,46,15.4,46z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeMiterlimit="10"
            d="M15.1,19.8h11c1.1,0,2.1-0.9,2.1-2.1v-11L15.1,19.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M17.5,26.8h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H17.5c-0.2,0-0.3,0.1-0.3,0.3v0.7
	C17.2,26.7,17.4,26.8,17.5,26.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M17.5,32.8h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H17.5c-0.2,0-0.3,0.1-0.3,0.3v0.7
	C17.2,32.6,17.4,32.8,17.5,32.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M17.5,38.8h16.7c0.2,0,0.3-0.1,0.3-0.3v-0.8c0-0.2-0.1-0.3-0.3-0.3H17.5c-0.2,0-0.3,0.1-0.3,0.3v0.8
	C17.2,38.6,17.3,38.8,17.5,38.8z"
          />
          <path fill={p4Tokens.colorBrandMenuBackground1} d="M15.6,18.9h9.9c1,0,1.9-0.8,1.9-1.8V7.8L15.6,18.9z" />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M45.6,33.6c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C54.3,37.5,50.4,33.6,45.6,33.6z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M42.6,37.9c1.4,0,2.4,1,2.4,2.5c0,1.5-1,2.5-2.4,2.5c-1.4,0-2.4-1-2.4-2.5C40.3,38.9,41.2,37.9,42.6,37.9z
		 M42.6,42c0.6,0,0.8-0.5,0.8-1.7c0-1.1-0.2-1.7-0.8-1.7s-0.8,0.5-0.8,1.7C41.8,41.4,42,42,42.6,42z M47.8,37.9h1.1l-5.5,8.9h-1.1
		L47.8,37.9z M48.5,41.9c1.4,0,2.4,1,2.4,2.5c0,1.5-1,2.5-2.4,2.5c-1.4,0-2.4-1-2.4-2.5C46.2,42.9,47.1,41.9,48.5,41.9z M48.5,46
		c0.6,0,0.8-0.5,0.8-1.7c0-1.1-0.2-1.7-0.8-1.7c-0.6,0-0.8,0.5-0.8,1.7C47.7,45.5,48,46,48.5,46z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground1}
              strokeWidth="0.8742"
              strokeMiterlimit="10"
              d="M20.4,53.5H6.8c-1.1,0-2-0.9-2-2V32.9
		c0-1.1,0.9-2,2-2h13.7c1.1,0,2,0.9,2,2v18.6C22.4,52.6,21.5,53.5,20.4,53.5z"
            />
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M11.7,43.7l-4.2-4.2c-0.1-0.1-0.1-0.4,0-0.5l0.3-0.3c0.1-0.1,0.4-0.1,0.5,0l4.2,4.2c0.1,0.1,0.1,0.4,0,0.5
			l-0.3,0.3C12.1,43.8,11.9,43.8,11.7,43.7z"
              />
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M7.5,42.9l4.2-4.2c0.1-0.1,0.4-0.1,0.5,0l0.3,0.3c0.1,0.1,0.1,0.4,0,0.5l-4.2,4.2c-0.1,0.1-0.4,0.1-0.5,0
			l-0.3-0.3C7.4,43.3,7.4,43,7.5,42.9z"
              />
            </g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M10.4,46.2v2.3h2.3v1.1h-2.3v2.3H9.2v-2.3H7v-1.1h2.3v-2.3H10.4z"
              />
            </g>

            <line
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground1}
              strokeWidth="1.4818"
              strokeLinecap="round"
              strokeMiterlimit="10"
              x1="15.1"
              y1="40.5"
              x2="19.6"
              y2="40.5"
            />

            <line
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground1}
              strokeWidth="1.4818"
              strokeLinecap="round"
              strokeMiterlimit="10"
              x1="15.1"
              y1="43"
              x2="19.6"
              y2="43"
            />

            <line
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground1}
              strokeWidth="1.4818"
              strokeLinecap="round"
              strokeMiterlimit="10"
              x1="15.1"
              y1="49"
              x2="19.6"
              y2="49"
            />

            <line
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground1}
              strokeWidth="3.672"
              strokeLinecap="round"
              strokeMiterlimit="10"
              x1="8.5"
              y1="34.8"
              x2="18.8"
              y2="34.8"
            />
          </g>
        </g>
      );
    case 'company':
      return (
        <g>
          <circle fill={p4Tokens.colorBrandMenuForeground1} cx="41.7" cy="38.8" r="2.1" />
          <circle fill={p4Tokens.colorBrandMenuForeground1} cx="21.6" cy="23.2" r="3.4" />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.2"
            d="M36.5,17.1l-2-3.6c-0.3-0.5-0.9-0.5-1.4-0.3L31,14.5l0,0
	c-0.9-0.9-2-1.8-3.2-2.5l0.6-2.3c0.1-0.5-0.2-1-0.7-1.2l-4-1.1c-0.5-0.1-1,0.2-1.2,0.7L22,10.4l0,0c-1.3,0-2.5,0-3.9,0.5l-1.2-2.1
	c-0.3-0.5-0.9-0.6-1.4-0.4l-3.6,2c-0.5,0.3-0.4,0.8-0.1,1.2l1.2,2.1l0,0c-1.1,1-1.9,2-2.5,3.2l-2.4-0.6c-0.5-0.1-1,0.2-1.2,0.7
	l-1.1,4c-0.1,0.5,0.2,1,0.7,1.2l2.3,0.6l0,0c0,1.3,0,2.5,0.5,4l-2.1,1.2c-0.5,0.3-0.5,0.7-0.3,1.2l2,3.6c0.3,0.5,0.7,0.6,1.1,0.3
	l2.1-1.2l0,0c1,1.1,2,1.9,3.2,2.5l-0.6,2.3c-0.1,0.5,0.2,1,0.7,1.2l4,1.1c0.5,0.1,1-0.2,1.2-0.7l0.6-2.3l0.1,0
	c1.3,0,2.6-0.1,4.1-0.6l1.2,2.1c0.3,0.5,0.6,0.7,1.1,0.4l3.6-2c0.5-0.3,0.7-0.8,0.4-1.3l-1.2-2.1l0,0c1.1-1,1.8-1.9,2.4-3.1l2.3,0.6
	c0.5,0.1,1-0.2,1.2-0.7l1.1-4c0.1-0.5-0.2-1-0.7-1.2l-2.3-0.6l0,0c0-1.3-0.1-2.6-0.5-4l2.1-1.2C36.4,18.1,36.8,17.6,36.5,17.1z
	 M16.3,19c0.5-0.7,1.2-1.2,1.9-1.7c1-0.6,2-0.8,3-0.9c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0
	c0.1,0,0.1,0,0.2,0c0.2,0,0.4,0.1,0.6,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.1,0,0.2,0.1c0.1,0,0.2,0.1,0.3,0.1
	c0.1,0,0.1,0,0.2,0.1c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0.1,0.2,0.1c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.1,0.2,0.2,0.4,0.2
	c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.2,0.2,0.2,0.2c0.4,0.4,0.7,0.9,1,1.4
	c0.5,0.9,0.8,1.9,0.9,2.9c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.3-0.1,0.5-0.1,0.8c0,0.1,0,0.2-0.1,0.3
	c0,0.2-0.1,0.3-0.1,0.5c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.1-0.1,0.2c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.1-0.1,0.3-0.2,0.4
	c-0.1,0.1-0.1,0.2-0.2,0.3c-0.6,0.9-1.3,1.6-2.3,2.2c-0.8,0.5-1.7,0.7-2.6,0.9c-0.1,0-0.2,0-0.3,0c-0.3,0-0.7,0-1,0
	c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0c-0.2,0-0.3-0.1-0.5-0.1c-1.8-0.4-3.4-1.5-4.4-3.2c-0.5-0.8-0.8-1.7-0.9-2.6
	c0-0.4-0.1-0.8,0-1.1c0-0.1,0-0.3,0-0.4c0-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.2-0.6,0.3-0.9c0-0.1,0-0.1,0.1-0.2c0-0.1,0.1-0.2,0.1-0.3
	c0-0.1,0.1-0.2,0.2-0.3c0.1-0.2,0.2-0.4,0.3-0.6c0-0.1,0.1-0.1,0.1-0.2C16.2,19.1,16.3,19.1,16.3,19z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.2"
            strokeMiterlimit="10"
            d="M48.8,31.8l-2-1.6c-0.3-0.2-0.7-0.1-0.9,0.2
	L45,31.5l0,0c-0.7-0.3-1.6-0.6-2.4-0.7l-0.2-1.5c0-0.3-0.3-0.6-0.7-0.5l-2.6,0.3c-0.3,0-0.6,0.3-0.5,0.7l0.2,1.5l0,0
	c-0.8,0.3-1.4,0.6-2.2,1.2l-1.2-0.9c-0.3-0.2-0.7-0.2-0.9,0.1l-1.6,2c-0.2,0.3-0.1,0.5,0.2,0.8l1.2,0.9l0,0
	c-0.4,0.9-0.6,1.6-0.7,2.5l-1.5,0.2c-0.3,0-0.6,0.3-0.5,0.7l0.3,2.6c0,0.3,0.3,0.6,0.7,0.5l1.5-0.2l0,0c0.3,0.8,0.6,1.5,1.2,2.2
	l-0.9,1.2c-0.2,0.3-0.1,0.5,0.1,0.8l2,1.6c0.3,0.2,0.5,0.2,0.7-0.1l0.9-1.2l0,0c0.9,0.4,1.6,0.6,2.4,0.7l0.2,1.5
	c0,0.3,0.3,0.6,0.7,0.5l2.6-0.3c0.3,0,0.6-0.3,0.5-0.7l-0.2-1.5l0,0c0.8-0.3,1.5-0.7,2.2-1.3l1.2,0.9c0.3,0.2,0.5,0.3,0.7,0l1.6-2
	c0.2-0.3,0.2-0.6-0.1-0.8L49,42.1l0,0c0.4-0.9,0.6-1.6,0.7-2.4l1.5-0.2c0.3,0,0.6-0.3,0.5-0.7l-0.3-2.6c0-0.3-0.3-0.6-0.7-0.5
	L49.2,36l0,0c-0.3-0.8-0.6-1.5-1.3-2.2l0.9-1.2C49,32.3,49.1,32,48.8,31.8z M37.4,37.6c0.1-0.5,0.4-1,0.8-1.5c0.4-0.6,1-1,1.6-1.3
	c0.1,0,0.1-0.1,0.2-0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2-0.1c0.1,0,0.1,0,0.2-0.1c0,0,0.1,0,0.1,0c0.1,0,0.3-0.1,0.4-0.1
	c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0
	c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0.1c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.1,0.1,0.2,0.1
	c0.3,0.1,0.7,0.3,1,0.6c0.5,0.4,1,0.9,1.2,1.5c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0.1,0.2
	c0.1,0.2,0.1,0.3,0.1,0.5c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2
	c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.2c-0.1,0.7-0.4,1.3-0.8,1.9c-0.4,0.5-0.8,0.9-1.3,1.1c-0.1,0-0.1,0.1-0.2,0.1
	c-0.2,0.1-0.4,0.2-0.6,0.2c-0.1,0-0.1,0-0.2,0.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0.1c-1.2,0.2-2.4-0.1-3.4-0.9
	c-0.5-0.4-0.9-0.8-1.1-1.3c-0.1-0.2-0.2-0.4-0.3-0.7c0-0.1-0.1-0.2-0.1-0.2c-0.1-0.2-0.1-0.4-0.1-0.6c0-0.2,0-0.4,0-0.6
	c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2s0-0.1,0-0.2c0-0.1,0-0.3,0.1-0.4c0,0,0-0.1,0-0.1C37.4,37.7,37.4,37.7,37.4,37.6z"
          />
          <circle fill="none" stroke="#FFFFFB" strokeWidth="3" strokeMiterlimit="10" cx="21.6" cy="23.2" r="9.9" />
        </g>
      );
    case 'smtp':
      return (
        <g>
          <path
            fill={fillColor}
            d="M25.637 14.541c-3.386 0-6.14 2.753-6.14 6.14s2.753 6.14 6.14 6.14c3.386 0 6.14-2.753 6.14-6.14s-2.753-6.14-6.14-6.14v0zM25.637 25.703c-2.753 0-5.023-2.27-5.023-5.023s2.27-5.023 5.023-5.023c2.753 0 5.023 2.27 5.023 5.023s-2.27 5.023-5.023 5.023v0zM5.656 21.536c-2.27 0-4.13-1.86-4.13-4.13v-6.512c0-0.744 0.186-1.414 0.521-2.046l6.847 3.572-4.949 4.986c-0.298 0.298-0.298 0.744 0 1.042 0.149 0.149 0.335 0.223 0.521 0.223s0.372-0.074 0.521-0.223l5.321-5.284 3.535 1.823 3.535-1.823 2.791 2.791c0.335-0.372 0.67-0.707 1.079-1.005l-2.493-2.493 6.846-3.572c0.335 0.595 0.521 1.302 0.521 2.046v2.53c0.521 0.037 1.005 0.112 1.488 0.26v-2.791c0-3.088-2.53-5.619-5.619-5.619h-16.335c-3.088 0-5.619 2.53-5.619 5.619v6.512c0 3.088 2.53 5.619 5.619 5.619h13.098c-0.149-0.484-0.298-0.967-0.335-1.488h-12.763v-0.037zM5.656 6.764h16.298c1.005 0 1.898 0.372 2.642 0.93l-10.791 5.619-10.754-5.619c0.707-0.595 1.637-0.93 2.605-0.93v0zM27.498 17.517h-3.721c-0.521 0-0.93 0.409-0.93 0.93s0.409 0.93 0.93 0.93h3.721c0.521 0 0.93-0.409 0.93-0.93s-0.409-0.93-0.93-0.93v0zM23.814 18.559h-0.372v-0.186h0.372v0.186zM24.26 18.559h-0.372v-0.186h0.372v0.186zM24.707 18.559h-0.372v-0.186h0.372v0.186zM26.605 18.82c-0.223 0-0.372-0.149-0.372-0.372s0.149-0.372 0.372-0.372c0.223 0 0.372 0.149 0.372 0.372s-0.149 0.372-0.372 0.372v0zM27.498 18.82c-0.223 0-0.372-0.149-0.372-0.372s0.149-0.372 0.372-0.372c0.223 0 0.372 0.149 0.372 0.372s-0.186 0.372-0.372 0.372v0zM27.498 19.75h-3.721c-0.521 0-0.93 0.409-0.93 0.93s0.409 0.93 0.93 0.93h3.721c0.521 0 0.93-0.409 0.93-0.93s-0.409-0.93-0.93-0.93v0zM23.814 20.792h-0.372v-0.186h0.372v0.186zM24.26 20.792h-0.372v-0.186h0.372v0.186zM24.707 20.792h-0.372v-0.186h0.372v0.186zM26.605 21.052c-0.223 0-0.372-0.149-0.372-0.372s0.149-0.372 0.372-0.372c0.223 0 0.372 0.149 0.372 0.372s-0.149 0.372-0.372 0.372v0zM27.498 21.052c-0.223 0-0.372-0.149-0.372-0.372s0.149-0.372 0.372-0.372c0.223 0 0.372 0.149 0.372 0.372s-0.186 0.372-0.372 0.372v0zM27.498 21.982h-3.721c-0.521 0-0.93 0.409-0.93 0.93s0.409 0.93 0.93 0.93h3.721c0.521 0 0.93-0.409 0.93-0.93s-0.409-0.93-0.93-0.93v0zM23.814 23.024h-0.372v-0.186h0.372v0.186zM24.26 23.024h-0.372v-0.186h0.372v0.186zM24.707 23.024h-0.372v-0.186h0.372v0.186zM26.605 23.285c-0.223 0-0.372-0.149-0.372-0.372s0.149-0.372 0.372-0.372c0.223 0 0.372 0.149 0.372 0.372s-0.149 0.372-0.372 0.372v0zM27.498 23.285c-0.223 0-0.372-0.149-0.372-0.372s0.149-0.372 0.372-0.372c0.223 0 0.372 0.149 0.372 0.372s-0.186 0.372-0.372 0.372v0z"
          />
        </g>
      );
    case 'database':
      return (
        <g>
          <path
            fill={fillColor}
            d="M0 22.826v4.374c0 0.086 0.023 0.168 0.062 0.241 0.63 2.611 6.265 4.559 13.271 4.559 6.99 0 12.616-1.941 13.267-4.542 0.043-0.076 0.067-0.164 0.067-0.258v-4.373c-2.205 1.552-6.749 2.773-13.333 2.773s-11.129-1.221-13.333-2.774z"
          />
          <path
            fill={fillColor}
            d="M28.267 26.642c0 0.105-0.026 0.203-0.070 0.288-0.075 0.313-0.213 0.617-0.405 0.91 2.295-0.807 3.822-1.925 4.142-3.204 0.043-0.076 0.067-0.165 0.067-0.258v-4.373l-3.733 1.755v4.882z"
          />
          <path
            fill={fillColor}
            d="M14.723 19.178c-0.463 0.015-0.927 0.022-1.39 0.022-0.463 0-0.929-0.007-1.394-0.022-3.915-0.107-7.035-0.66-9.282-1.449-1.055-0.356-1.959-0.775-2.658-1.254v5.013c1.518 1.585 6.61 3.046 13.333 3.046s11.815-1.461 13.333-3.046v-5.013c-0.703 0.483-1.615 0.905-2.68 1.262-2.245 0.785-5.359 1.335-9.263 1.441z"
          />
          <path
            fill={fillColor}
            d="M27.733 15.467v5.198c2.066-0.55 3.559-1.26 4.267-1.998v-5.013c-0.703 0.483-1.615 0.905-2.68 1.262l-1.587 0.551z"
          />
          <path
            fill={fillColor}
            d="M0 10.122v5.013c1.407 1.469 5.884 2.832 11.886 3.023 0.062 0.002 0.125 0.003 0.187 0.004 0.173 0.005 0.347 0.010 0.523 0.013 0.244 0.004 0.49 0.006 0.738 0.006s0.494-0.002 0.738-0.006c0.176-0.003 0.35-0.008 0.523-0.013 0.062-0.002 0.125-0.003 0.187-0.004 6.002-0.191 10.479-1.555 11.886-3.023v-5.013c-2.596 1.783-8.083 2.726-13.333 2.726s-10.738-0.943-13.333-2.726z"
          />
          <path
            fill={fillColor}
            d="M13.333 2.821c-8.041 0-12.638 2.251-13.255 4.539-0.045 0.078-0.078 0.164-0.078 0.261v1.23c1.513 1.579 6.569 3.037 13.333 3.037s11.821-1.458 13.333-3.037v-1.23c0-0.090-0.030-0.17-0.072-0.244-0.598-2.294-5.2-4.556-13.261-4.556z"
          />
          <path
            fill={fillColor}
            d="M27.733 13.067v1.249c2.069-0.55 3.558-1.262 4.267-2.002v-5.013c-1.030 0.708-2.521 1.281-4.267 1.717v4.050z"
          />
          <path
            fill={fillColor}
            d="M31.928 4.556c-0.598-2.294-5.2-4.556-13.261-4.556-5.401 0-9.239 1.017-11.371 2.377 1.856-0.39 4.047-0.622 6.571-0.622 8.384 0 13.169 2.528 13.792 5.092 0.044 0.083 0.075 0.173 0.075 0.273v0.907c2.069-0.549 3.559-1.258 4.267-1.997v-1.23c0-0.090-0.030-0.17-0.072-0.244z"
          />
        </g>
      );
    case 'user':
      return (
        <g>
          <path
            fill={fillColor}
            d="M15.965 0.178c-8.756 0-15.824 7.068-15.824 15.824s7.068 15.824 15.824 15.824c8.756 0 15.824-7.068 15.824-15.824s-7.103-15.824-15.824-15.824v0zM25.108 26.2c-0.879-1.407-2.215-2.426-3.798-2.884l-2.040-0.598c-0.703-0.211-1.055-0.949-0.844-1.653 0.035-0.141 0.141-0.281 0.211-0.387l1.477-1.653c0.985-1.090 1.442-2.567 1.266-4.009l-0.246-2.004c-0.176-1.512-1.020-2.884-2.321-3.727h-0.035c-1.723-1.090-3.938-1.090-5.662 0.070v0c-1.196 0.809-1.969 2.040-2.18 3.446l-0.316 2.11c-0.246 1.512 0.211 3.059 1.231 4.22l1.407 1.547c0.105 0.105 0.176 0.246 0.211 0.387 0.246 0.668-0.141 1.442-0.844 1.653l-2.040 0.598c-1.582 0.457-2.919 1.512-3.798 2.884-2.813-2.497-4.571-6.154-4.571-10.198 0-7.56 6.154-13.714 13.714-13.714s13.714 6.154 13.714 13.714c0.035 4.044-1.758 7.701-4.536 10.198v0z"
          />
        </g>
      );
    case 'userrole':
      return (
        <g>
          <path
            fill={fillColor}
            d="M15.598 31.875c-8.145-2.861-13.995-10.602-13.995-19.701v-8.806c0-0.501 0.407-0.909 0.909-0.909 5.142-0.001 10.261-0.805 12.952-2.275 0.133-0.073 0.283-0.112 0.436-0.112h0.136c0.152 0 0.302 0.038 0.435 0.112 2.691 1.47 7.81 2.273 12.951 2.275 0.502 0 0.909 0.407 0.909 0.909v8.806c0 9.099-5.849 16.84-13.995 19.701-0.119 0.042-0.24 0.057-0.364 0.049l0.319-0.087c-0.21 0.101-0.458 0.122-0.695 0.038v0zM15.968 30.067l1.137-0.449c6.72-2.961 11.409-9.663 11.409-17.444l-0-7.914-1.054-0.020c-3.931-0.152-7.839-0.759-10.587-1.864l-0.905-0.423-0.905 0.423c-2.748 1.105-6.656 1.712-10.588 1.864l-1.053 0.020v7.914c0 7.781 4.689 14.482 11.409 17.444l1.137 0.449zM9.671 21.73v-0.909c0-1.774 0.741-3.103 1.972-3.951 1.183-0.816 2.736-1.134 4.324-1.134s3.141 0.318 4.324 1.134c1.231 0.849 1.972 2.177 1.972 3.951v0.909h-12.592zM20.336 19.912l-0.076-0.263c-0.2-0.559-0.55-0.972-1-1.282-0.768-0.529-1.907-0.813-3.292-0.813s-2.525 0.284-3.293 0.813c-0.449 0.31-0.8 0.723-1 1.282l-0.076 0.263h8.736zM12.333 11.017c0-2.006 1.628-3.634 3.634-3.634s3.634 1.628 3.634 3.634c0 2.006-1.629 3.634-3.634 3.634s-3.634-1.628-3.634-3.634v0zM17.784 11.017c0-1.002-0.815-1.816-1.816-1.816s-1.816 0.814-1.816 1.816c0 1.002 0.814 1.816 1.816 1.816s1.816-0.814 1.816-1.816v0z"
          />
        </g>
      );
    case 'sales':
      return (
        <g>
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground2}
                d="M48.2,12.6H7.6c-1.6,0-3,1.3-3,3v24.9c0,1.6,1.3,3,3,3h40.7c1.6,0,3-1.3,3-3V15.6
			C51.2,13.9,49.9,12.6,48.2,12.6z M50,39.4c0,1.5-1.2,2.8-2.8,2.8H8.6c-1.5,0-2.8-1.2-2.8-2.8V16.7c0-1.5,1.2-2.8,2.8-2.8h38.7
			c1.5,0,2.8,1.2,2.8,2.8V39.4z"
              />
              <path
                fill={p4Tokens.colorBrandMenuForeground2}
                d="M3.2,44.5c1,3.2,1.5,3.6,5.1,3.6c12.6,0,25.2,0,37.8,0c1.2,0,2.4,0,3.6-0.1c1.9-0.2,3-1.3,3.3-3.5
			C36.4,44.5,19.9,44.5,3.2,44.5z M33,46.6H22.7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H33c0.3,0,0.5,0.2,0.5,0.5
			S33.3,46.6,33,46.6z"
              />
            </g>

            <polyline
              fillRule="evenodd"
              clipRule="evenodd"
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground1}
              strokeWidth="2"
              strokeLinecap="round"
              strokeMiterlimit="10"
              points="
		12.8,36.4 22.8,29.7 26.5,30.8 29.2,28.4 32.7,29.1 39.5,23.4 	"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M36.7,21.3l4.3-0.9c0.6-0.1,1.1,0.4,1,1l-0.5,4.3
		c-0.1,0.7-0.9,1-1.5,0.5l-3.8-3.4C35.7,22.3,36,21.4,36.7,21.3z"
            />
          </g>
        </g>
      );
    case 'folder':
      return (
        <g>
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M11.649 5.396l2.455 2.626h14.712c0.869 0.004 1.573 0.708 1.577 1.577v15.62c-0.004 0.869-0.708 1.573-1.577 1.577h-25.698c-0.869-0.004-1.573-0.708-1.577-1.577v-18.253c0.008-0.866 0.711-1.565 1.577-1.569h8.531zM12.222 4.079h-9.104c-1.598 0-2.893 1.295-2.893 2.893v18.26c0 1.598 1.295 2.893 2.893 2.893h25.698c1.598 0 2.893-1.295 2.893-2.893v-15.62c0-1.598-1.295-2.893-2.893-2.893h-14.132l-2.447-2.648-0.015 0.007z"
          />
        </g>
      );
    case 'cashreceipt':
      return (
        <g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M17.1,47.2c-0.8-0.3-1.5-0.6-2.2-1c-0.7-0.3-1.4-0.3-2.1,0c-0.4,0.2-0.9,0.4-1.3,0.6
		c-1.3,0.6-2.3,0-2.3-1.4c0-9.7,0-19.4,0-29.2c0-2.7,0-5.5,0-8.2c0-1.4,0.9-2.2,2.3-2.2c9.5,0,19,0,28.5,0c1.4,0,2.3,0.8,2.3,2.2
		c0,12.5,0,25,0,37.4c0,1-0.5,1.6-1.3,1.6c-0.3,0-0.7-0.1-1-0.2c-0.4-0.2-0.8-0.4-1.2-0.6c-0.7-0.3-1.4-0.3-2.2,0
		c-0.7,0.3-1.5,0.7-2.2,1c-0.4,0-0.8,0-1.2,0c-0.7-0.3-1.5-0.6-2.2-1c-0.7-0.3-1.5-0.3-2.2,0c-0.7,0.3-1.5,0.6-2.3,1
		c-0.4,0-0.8,0-1.2,0c-0.8-0.3-1.5-0.6-2.3-1c-0.7-0.3-1.4-0.3-2.1,0c-0.8,0.3-1.5,0.7-2.3,1C17.9,47.2,17.5,47.2,17.1,47.2z
		 M40.7,45.8c0-0.2,0-0.4,0-0.5c0-12.4,0-24.7,0-37.1c0-0.7-0.2-0.9-1-0.9c-9.4,0-18.9,0-28.3,0c-0.7,0-1,0.2-1,0.9
		c0,12.4,0,24.7,0,37.1c0,0.1,0,0.3,0,0.5c0.5-0.2,0.9-0.4,1.3-0.6c1.3-0.7,2.6-0.7,3.9,0c0.1,0.1,0.3,0.1,0.4,0.2
		c1.1,0.7,2.1,0.6,3.2,0c0.2-0.1,0.5-0.3,0.7-0.4c1.1-0.5,2.2-0.5,3.3,0c0.4,0.2,0.8,0.4,1.3,0.6c0.7,0.3,1.4,0.3,2.1,0
		c0.4-0.2,0.8-0.4,1.2-0.6c1.1-0.5,2.2-0.5,3.4,0c0.4,0.2,0.8,0.4,1.1,0.6c0.8,0.4,1.5,0.4,2.3,0c0.4-0.2,0.8-0.4,1.2-0.6
		c0.4-0.2,0.9-0.3,1.3-0.3c0.8-0.1,1.5,0.1,2.2,0.5C39.8,45.4,40.2,45.5,40.7,45.8z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M20.8,35.5c2.4,0,4.8,0,7.1,0c0.8,0,1,0.2,1,1c0,1.3,0,2.5,0,3.8c0,0.7-0.2,0.9-0.9,0.9
		c-4.8,0-9.6,0-14.4,0c-0.6,0-0.9-0.3-0.9-0.9c0-1.3,0-2.6,0-3.8c0-0.7,0.3-0.9,0.9-0.9C16,35.5,18.4,35.5,20.8,35.5z M14.1,36.8
		c0,1,0,1.9,0,2.9c4.5,0,8.9,0,13.4,0c0-1,0-1.9,0-2.9C23,36.8,18.6,36.8,14.1,36.8z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M21.8,11.1c2.5,0,5,0,7.5,0c0.3,0,0.6,0,0.8,0.3c0.3,0.5-0.1,1-0.7,1c-1.2,0-2.4,0-3.6,0
		c-3.7,0-7.5,0-11.2,0c-0.2,0-0.4,0-0.6-0.1c-0.3-0.1-0.4-0.4-0.4-0.7c0-0.3,0.2-0.5,0.6-0.6c0.1,0,0.3,0,0.4,0
		C16.9,11.1,19.3,11.1,21.8,11.1z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M21.8,18.6c2.5,0,4.9,0,7.4,0c0.4,0,0.7,0.1,0.8,0.4c0.2,0.5-0.2,0.9-0.8,0.9c-1.3,0-2.5,0-3.8,0
		c-3.7,0-7.4,0-11,0c-0.2,0-0.4,0-0.5-0.1c-0.3-0.1-0.5-0.4-0.4-0.7c0-0.3,0.2-0.5,0.6-0.6c0.2,0,0.3,0,0.5,0
		C17,18.6,19.4,18.6,21.8,18.6z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M19,31.4c-1.5,0-3,0-4.5,0c-0.1,0-0.3,0-0.4,0c-0.4-0.1-0.6-0.3-0.7-0.7c0-0.4,0.2-0.6,0.7-0.7
		c0.1,0,0.3,0,0.4,0c3,0,6,0,9,0c0.7,0,1,0.2,1,0.7c0,0.5-0.3,0.7-1,0.7C22.1,31.4,20.5,31.4,19,31.4z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M19.1,14.8c1.6,0,3.1,0,4.7,0c0.6,0,0.9,0.4,0.8,0.8c-0.1,0.3-0.4,0.5-0.8,0.5c-1,0-2,0-2.9,0
		c-2.1,0-4.3,0-6.4,0c-0.2,0-0.4,0-0.5-0.1c-0.3-0.1-0.5-0.4-0.4-0.7c0-0.3,0.3-0.5,0.6-0.6c0.3,0,0.6,0,0.9,0
		C16.3,14.8,17.7,14.8,19.1,14.8C19.1,14.8,19.1,14.8,19.1,14.8z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M19.1,22.4c1.5,0,3.1,0,4.6,0c0.5,0,0.8,0.2,0.9,0.6c0.1,0.5-0.2,0.8-0.8,0.8c-0.7,0-1.3,0-2,0
		c-2.5,0-4.9,0-7.4,0c-0.1,0-0.3,0-0.4-0.1c-0.3-0.1-0.5-0.4-0.4-0.7c0-0.3,0.2-0.6,0.6-0.6c0.4,0,0.8,0,1.2,0
		C16.5,22.4,17.8,22.4,19.1,22.4C19.1,22.4,19.1,22.4,19.1,22.4z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M16.9,26.2c0.9,0,1.8,0,2.7,0c0.4,0,0.7,0.3,0.7,0.6c0,0.4-0.2,0.6-0.7,0.7c-0.1,0-0.3,0-0.4,0
		c-1.5,0-3,0-4.5,0c-0.3,0-0.5,0-0.8-0.1c-0.4-0.1-0.5-0.3-0.5-0.7c0-0.3,0.2-0.6,0.6-0.6c0.1,0,0.3,0,0.5,0
		C15.3,26.2,16.1,26.2,16.9,26.2C16.9,26.2,16.9,26.2,16.9,26.2z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M35.6,31.4c-0.5,0-0.9,0-1.4,0c-0.5,0-0.8-0.3-0.8-0.7c0-0.4,0.3-0.7,0.8-0.7c0.9,0,1.8,0,2.7,0
		c0.2,0,0.4,0,0.5,0.1c0.2,0.2,0.3,0.5,0.3,0.7c0,0.2-0.3,0.5-0.5,0.5C36.7,31.4,36.2,31.4,35.6,31.4C35.6,31.4,35.6,31.4,35.6,31.4
		z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M35.6,22.4c0.5,0,0.9,0,1.4,0c0.5,0,0.8,0.3,0.8,0.7c0,0.4-0.3,0.7-0.7,0.7c-1,0-1.9,0-2.9,0
		c-0.5,0-0.8-0.3-0.7-0.7c0-0.4,0.3-0.6,0.8-0.7C34.7,22.4,35.2,22.4,35.6,22.4C35.6,22.4,35.6,22.4,35.6,22.4z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M35.7,11.1c0.5,0,0.9,0,1.4,0c0.4,0,0.7,0.3,0.7,0.6c0,0.4-0.3,0.7-0.7,0.7c-1,0-2,0-2.9,0
		c-0.5,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.6,0.7-0.6C34.7,11,35.2,11.1,35.7,11.1C35.7,11.1,35.7,11.1,35.7,11.1z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M35.6,14.8c0.5,0,0.9,0,1.4,0c0.5,0,0.7,0.2,0.8,0.6c0,0.4-0.3,0.7-0.7,0.7c-1,0-2,0-3,0
		c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.6,0.7-0.7C34.7,14.8,35.2,14.8,35.6,14.8C35.6,14.8,35.6,14.8,35.6,14.8z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M35.6,20c-0.4,0-0.9,0-1.3,0c-0.5,0-0.8-0.3-0.8-0.7c0-0.4,0.3-0.7,0.8-0.7c0.9,0,1.8,0,2.8,0
		c0.5,0,0.8,0.3,0.8,0.7c0,0.4-0.3,0.7-0.8,0.7C36.6,20,36.1,20,35.6,20z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M35.6,26.2c0.5,0,0.9,0,1.4,0c0.5,0,0.8,0.3,0.8,0.7c0,0.4-0.3,0.7-0.8,0.7c-0.9,0-1.8,0-2.8,0
		c-0.5,0-0.8-0.3-0.8-0.7c0-0.4,0.3-0.6,0.8-0.7c0.2,0,0.5,0,0.7,0C35.2,26.2,35.4,26.2,35.6,26.2C35.6,26.2,35.6,26.2,35.6,26.2z"
            />
          </g>
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M42.6,34.6c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C51.3,38.5,47.4,34.6,42.6,34.6z
			"
              />
            </g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                d="M39,48.8v-0.9c1.2-0.6,2-1.7,2-3c0-0.4,0-0.8-0.1-1.2h-1.8v-1.1h1.6c-0.1-0.5-0.2-1.2-0.2-1.9
			c0-2.1,1.4-3.4,3.3-3.4c0.9,0,1.5,0.2,1.9,0.4l-0.3,1.1c-0.3-0.2-0.8-0.3-1.6-0.3c-1.4,0-1.9,0.9-1.9,2.2c0,0.7,0.1,1.3,0.2,1.9
			h2.5v1.1h-2.4c0.1,0.7,0.1,1.3-0.1,1.9C42,46.3,41.6,47,41,47.5v0h5.2v1.3H39z"
              />
            </g>
          </g>
        </g>
      );
    case 'cashrefund':
      return (
        <g>
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3071"
            strokeMiterlimit="10"
            d="M12.5,45.2h25c1.1,0,2.1-0.9,2.1-2.1V7
	c0-1.1-0.9-2.1-2.1-2.1H25.3L10.5,19.2v23.9C10.5,44.2,11.4,45.2,12.5,45.2z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeMiterlimit="10"
            d="M12.2,18.9h11c1.1,0,2.1-0.9,2.1-2.1v-11L12.2,18.9z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M14.7,26h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H14.7c-0.2,0-0.3,0.1-0.3,0.3v0.7
	C14.3,25.8,14.5,26,14.7,26z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M14.7,31.9h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H14.7c-0.2,0-0.3,0.1-0.3,0.3v0.7
	C14.3,31.8,14.5,31.9,14.7,31.9z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M14.6,37.9h16.7c0.2,0,0.3-0.1,0.3-0.3v-0.8c0-0.2-0.1-0.3-0.3-0.3H14.6c-0.2,0-0.3,0.1-0.3,0.3v0.8
	C14.3,37.8,14.5,37.9,14.6,37.9z"
          />
          <path fill={p4Tokens.colorBrandMenuBackground1} d="M12.7,18.1h9.9c1,0,1.9-0.8,1.9-1.8V6.9L12.7,18.1z" />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M42.7,32.8c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C51.5,36.7,47.5,32.8,42.7,32.8z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M39.1,47v-0.9c1.2-0.6,2-1.7,2-3c0-0.4,0-0.8-0.1-1.2h-1.8v-1.1h1.6c-0.1-0.5-0.2-1.2-0.2-1.9
		c0-2.1,1.4-3.4,3.3-3.4c0.9,0,1.5,0.2,1.9,0.4L45.5,37c-0.3-0.2-0.8-0.3-1.6-0.3c-1.4,0-1.9,0.9-1.9,2.2c0,0.7,0.1,1.3,0.2,1.9h2.5
		v1.1h-2.4c0.1,0.7,0.1,1.3-0.1,1.9c-0.2,0.7-0.6,1.4-1.2,1.9v0h5.2V47H39.1z"
            />
          </g>
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                stroke={p4Tokens.colorBrandMenuForeground1}
                strokeMiterlimit="10"
                d="M26.8,40.4c-4,0-7.3,3.3-7.3,7.3c0,4,3.3,7.3,7.3,7.3
			s7.3-3.3,7.3-7.3C34.2,43.7,30.9,40.4,26.8,40.4z"
              />
            </g>
          </g>
          <rect x="21.8" y="46.8" fill={p4Tokens.colorBrandMenuForeground1} width="9.5" height="2.4" />
        </g>
      );
    case 'openingbalance':
      return (
        <g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M16.4,13.6c0.5,1.5,1,2.9,1.5,4.3c1.7,4.6,3.4,9.3,5.1,13.9c0.1,0.3,0.5,0.6,0.7,0.9
		c0.2,0.3,0.3,0.7,0.3,1.1c-0.7,2.9-2.7,4.5-5.3,5.4c-3.8,1.2-8.1,0-10.2-3c-0.5-0.7-0.7-1.4-1-2.2c-0.2-0.6-0.3-1.1,0.5-1.4
		c0.2-0.1,0.3-0.3,0.3-0.5c2.2-6.1,4.4-12.2,6.7-18.4c-0.3-0.1-0.5-0.1-0.7-0.2c-0.9-0.2-1.3-0.7-1.2-1.5c0.1-0.8,0.7-1.2,1.4-1.2
		c1.5,0,3,0,4.5,0c1.5,0,3,0,4.4,0c0.6,0,0.9-0.1,1.2-0.7c0.7-1.4,2-2.2,3.6-2.2c1.7,0,2.9,0.7,3.7,2.2c0.3,0.5,0.6,0.6,1.1,0.6
		c3,0,5.9,0,8.9,0c0.5,0,1.1,0.4,1.5,0.8c0.2,0.2,0.2,1-0.1,1.3c-0.4,0.4-1,0.6-1.7,0.9c0.6,1.8,1.3,3.7,2,5.6
		c1.5,4.1,3,8.2,4.5,12.3c0.1,0.3,0.5,0.6,0.7,0.9c0.2,0.4,0.4,0.8,0.3,1.2c-0.5,2.2-2,3.7-4,4.7c-3.8,1.9-8.8,1-11.3-2.1
		c-0.5-0.6-0.8-1.3-1.1-2c-0.3-0.7-0.7-1.6,0.5-2c0.1,0,0.2-0.3,0.2-0.5c2.1-5.9,4.3-11.8,6.4-17.8c0.1-0.2,0.1-0.4,0.1-0.6
		c-2.5,0-4.9,0-7.3,0c-0.2,0-0.5,0.3-0.6,0.5c-1.9,3.1-5.6,3.1-7.5,0c-0.1-0.2-0.4-0.5-0.6-0.5C21.4,13.6,19,13.6,16.4,13.6z
		 M34.6,32.6c4.1,0,8.1,0,12.2,0c-2-5.8-4-11.5-6.1-17.5C38.6,21.1,36.7,26.8,34.6,32.6z M15.8,15.4c-0.1,0-0.1,0-0.2,0
		c-2,5.7-4,11.4-6,17.2c4.1,0,8.1,0,12.2,0C19.8,26.8,17.8,21.1,15.8,15.4z"
            />
          </g>
          <line
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="2"
            strokeLinecap="round"
            strokeMiterlimit="10"
            x1="28.1"
            y1="3"
            x2="28.1"
            y2="53.3"
          />
          <line
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="2"
            strokeLinecap="round"
            strokeMiterlimit="10"
            x1="37.1"
            y1="53.3"
            x2="19.2"
            y2="53.3"
          />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M15.7,27.2c-3,0-5.5,2.5-5.5,5.5c0,3,2.5,5.5,5.5,5.5s5.5-2.5,5.5-5.5C21.2,29.7,18.7,27.2,15.7,27.2z"
            />
          </g>
          <g>
            <path fill={p4Tokens.colorBrandMenuBackground1} d="M16.3,29V32h2.9v1.4h-2.9v3h-1.4v-3H12V32h2.9V29H16.3z" />
          </g>
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M40.7,27c-3,0-5.5,2.5-5.5,5.5c0,3,2.5,5.5,5.5,5.5c3,0,5.5-2.5,5.5-5.5C46.2,29.4,43.7,27,40.7,27z"
              />
            </g>
          </g>
          <rect x="37" y="31.8" fill={p4Tokens.colorBrandMenuBackground1} width="7.1" height="1.8" />
        </g>
      );
    case 'bank':
      return (
        <g>
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.2401"
            strokeMiterlimit="10"
            d="M38.2,45.8c0.1-1.2,0.1-2.3,0.2-3.4
	c0.2-4.5,0.5-9.1,0.7-13.6c0-0.3,0-0.6,0-0.8c0-0.5-0.3-0.9-0.8-1c-0.6-0.1-0.9-0.5-0.9-1c0-0.5,0.4-0.8,1-0.8c2.1,0,4.3,0,6.4,0
	c0.6,0,0.9,0.3,1,0.8c0,0.5-0.2,0.8-0.8,1c-0.5,0.1-0.9,0.5-0.8,1.1c0.2,2.9,0.3,5.8,0.5,8.7c0.1,2.6,0.3,5.2,0.4,7.7
	c0,0.4,0,0.8,0.1,1.3c0.3,0,0.7,0,1,0c1,0,1.7,0.6,1.7,1.6c0,0.9-0.7,1.6-1.7,1.6c-4.3,0-8.6,0-12.9,0c-7.7,0-15.4,0-23.1,0
	c-0.9,0-1.4-0.4-1.6-1.1c-0.3-1,0.4-2,1.4-2c0.4,0,0.8,0,1.2,0c0.1-0.8,0.1-1.6,0.1-2.3c0.2-3.1,0.3-6.2,0.5-9.3
	c0.1-2,0.2-4,0.3-5.9c0-0.8-0.2-1.2-0.9-1.3c-0.5-0.1-0.8-0.4-0.7-0.9c0-0.5,0.3-0.8,0.8-0.8c0.5,0,1,0,1.5,0c1.6,0,3.2,0,4.8,0
	c0.2,0,0.3,0,0.5,0c0.5,0,0.8,0.4,0.8,0.8c0,0.5-0.2,0.8-0.7,0.9c-0.7,0.2-1,0.5-0.9,1.3c0.2,3.7,0.4,7.4,0.6,11.2
	c0.1,2,0.2,4,0.3,5.9c0,0.4,0.1,0.5,0.5,0.5c1.9,0,3.8,0,5.7,0c0.4,0,0.5-0.1,0.5-0.5c0.3-5,0.5-10,0.8-15c0-0.7,0.1-1.5,0.1-2.2
	c0-0.7-0.2-1.1-0.9-1.2C24.2,26.8,24,26.5,24,26c0-0.4,0.4-0.8,0.9-0.8c2.2,0,4.4,0,6.6,0c0.5,0,0.8,0.4,0.9,0.8
	c0,0.5-0.2,0.8-0.8,1c-0.7,0.1-1,0.5-0.9,1.2c0.2,4.2,0.5,8.4,0.7,12.6c0.1,1.5,0.2,2.9,0.2,4.4c0,0.4,0.1,0.6,0.5,0.6
	c1.8,0,3.7,0,5.5,0C37.8,45.8,38,45.8,38.2,45.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M28.2,50.6c6.9,0,13.9,0,20.8,0c1.1,0,1.9,0.3,1.6,0.6c-0.2,0.2-0.8,0.4-1.6,0.4c-2.8,0-5.6,0-8.4,0
	c-11,0-22.1,0-33.1,0c-1,0-1.7-0.2-1.7-0.5c0-0.3,0.6-0.5,1.6-0.5c2.2,0,4.3,0,6.5,0C18.6,50.6,23.4,50.6,28.2,50.6z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M28.1,52.6c7.2,0,14.4,0,21.7,0c1.2,0,1.9,0.4,1.7,0.9c-0.2,0.3-0.8,0.5-1.7,0.5c-2.9,0-5.9,0-8.8,0
	c-11.5,0-23,0-34.5,0c-1.1,0-1.7-0.3-1.8-0.7c0-0.5,0.6-0.8,1.7-0.8c2.3,0,4.5,0,6.8,0C18.2,52.6,23.2,52.6,28.1,52.6z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.116"
            strokeMiterlimit="10"
            d="M49.5,19.6c-0.1,0-0.1-0.1-0.2-0.1
	c-4.1-2.1-8.2-4.2-12.3-6.3c-1,4.5-5,7.9-9.9,7.9c-4.5,0-8.3-2.9-9.6-6.9c-0.1,0.1-0.3,0.1-0.4,0.2c-3.4,1.7-6.8,3.5-10.3,5.2
	c-0.7,0.4-0.9,0.8-0.5,1.5c0.2,0.4,0.4,0.8,0.6,1.2c0.3,0.7,0.9,1.1,1.7,1.1c6.5,0,13,0,19.5,0c1.5,0,3,0,4.5,0c5,0,10,0,15,0
	c0.8,0,1.4-0.3,1.7-1.1c0.2-0.4,0.4-0.8,0.6-1.1C50.3,20.4,50.2,19.9,49.5,19.6z"
          />
          <g>
            <g>
              <g>
                <path
                  fill={p4Tokens.colorBrandMenuForeground1}
                  stroke={p4Tokens.colorBrandMenuForeground1}
                  strokeMiterlimit="10"
                  d="M27.1,3.4c-4,0-7.3,3.3-7.3,7.3c0,4,3.3,7.3,7.3,7.3
				s7.3-3.3,7.3-7.3C34.5,6.7,31.2,3.4,27.1,3.4z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  fill={p4Tokens.colorBrandMenuBackground1}
                  d="M24.2,15.3v-0.7c1-0.5,1.6-1.4,1.6-2.5c0-0.3,0-0.6-0.1-1h-1.5v-0.9h1.3c-0.1-0.4-0.2-1-0.2-1.5
				c0-1.7,1.2-2.8,2.7-2.8c0.7,0,1.3,0.2,1.6,0.4l-0.3,0.9c-0.3-0.1-0.7-0.3-1.3-0.3c-1.1,0-1.6,0.8-1.6,1.8c0,0.6,0.1,1.1,0.2,1.5
				h2.1v0.9h-1.9c0,0.5,0.1,1.1-0.1,1.6c-0.2,0.6-0.5,1.1-1,1.5v0h4.3v1H24.2z"
                />
              </g>
            </g>
          </g>
        </g>
      );
    case 'customerpricematrix':
      return (
        <g>
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M39.7,49.5h-23c-2.5,0-4.5-2-4.5-4.5V12.2
	c0-2.5,2-4.5,4.5-4.5h23c2.5,0,4.5,2,4.5,4.5V45C44.2,47.5,42.2,49.5,39.7,49.5z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M8.7,15v-0.2c0-0.7,0.6-1.3,1.3-1.3h3.3c0.7,0,1.3,0.6,1.3,1.3V15c0,0.7-0.6,1.3-1.3,1.3H10
	C9.2,16.3,8.7,15.7,8.7,15z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M8.7,23.6v-0.2c0-0.7,0.6-1.3,1.3-1.3h3.3c0.7,0,1.3,0.6,1.3,1.3v0.2c0,0.7-0.6,1.3-1.3,1.3H10
	C9.2,24.9,8.7,24.4,8.7,23.6z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M8.7,33.3v-0.2c0-0.7,0.6-1.3,1.3-1.3h3.3c0.7,0,1.3,0.6,1.3,1.3v0.2c0,0.7-0.6,1.3-1.3,1.3H10
	C9.2,34.6,8.7,34,8.7,33.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M8.7,41.9v-0.2c0-0.7,0.6-1.3,1.3-1.3h3.3c0.7,0,1.3,0.6,1.3,1.3v0.2c0,0.7-0.6,1.3-1.3,1.3H10
	C9.2,43.2,8.7,42.6,8.7,41.9z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M20.1,41.4h18.6c0.2,0,0.3,0.1,0.3,0.3v0.8c0,0.2-0.1,0.3-0.3,0.3H20.1c-0.2,0-0.3-0.1-0.3-0.3v-0.8
	C19.8,41.5,19.9,41.4,20.1,41.4z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M20.1,36.3h18.6c0.2,0,0.3,0.1,0.3,0.3v0.8c0,0.2-0.1,0.3-0.3,0.3H20.1c-0.2,0-0.3-0.1-0.3-0.3v-0.8
	C19.8,36.4,19.9,36.3,20.1,36.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M20.1,31.4h18.6c0.2,0,0.3,0.1,0.3,0.3v0.8c0,0.2-0.1,0.3-0.3,0.3H20.1c-0.2,0-0.3-0.1-0.3-0.3v-0.8
	C19.8,31.5,19.9,31.4,20.1,31.4z"
          />
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M29.4,12.4c-4.2,0-7.6,3.4-7.6,7.6c0,4.2,3.4,7.6,7.6,7.6S37,24.2,37,20C37,15.8,33.6,12.4,29.4,12.4z"
              />
            </g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                d="M26.3,24.7V24c1-0.5,1.7-1.5,1.7-2.6c0-0.4,0-0.7-0.1-1.1h-1.6v-1h1.4c-0.1-0.5-0.2-1-0.2-1.6
			c0-1.8,1.2-2.9,2.9-2.9c0.8,0,1.3,0.2,1.6,0.4l-0.3,1c-0.3-0.2-0.7-0.3-1.4-0.3c-1.2,0-1.6,0.8-1.6,1.9c0,0.7,0.1,1.1,0.2,1.6h2.2
			v1h-2.1c0,0.6,0.1,1.1-0.1,1.7c-0.2,0.6-0.5,1.2-1,1.6v0h4.5v1.1H26.3z"
              />
            </g>
          </g>
        </g>
      );
    case 'specialprice':
      return (
        <g>
          <g>
            <circle
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3"
              strokeMiterlimit="10"
              cx="26.7"
              cy="16.7"
              r="9.1"
            />
            <path
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3"
              strokeMiterlimit="10"
              d="M41.7,34.4v9.4c0,0.2,0,0.2-0.2,0.2H11.9
		c-0.2,0-0.3,0-0.3-0.2v-9.4c0-0.2,0-0.3,0-0.5c0.1-2.2,1-4.3,2.4-5.8c0,0,0.1-0.1,0.1-0.1c0.7-0.7,1.5-1.3,2.4-1.8
		c0.1,0,0.1-0.1,0.2-0.1c0.2-0.1,0.5-0.2,0.8-0.3c0.1,0,0.1,0,0.2-0.1c0.2-0.1,0.5-0.1,0.7-0.2c0.3,0.3,0.6,0.6,0.9,0.8
		c0.8,0.6,1.7,1.2,2.7,1.6c0.2,0.1,0.4,0.2,0.5,0.2c0.7,0.3,1.4,0.5,2.1,0.6c0.9,0.2,1.6,0.2,2.2,0.2c0.6,0,1.2,0,2-0.1
		c1.4-0.2,2.5-0.8,2.8-0.9c0.7-0.3,1.4-0.8,2.1-1.3c0,0,0,0,0,0c0.1,0,1.1-0.8,1.5-1.1c3.7,0.9,6.4,4.2,6.6,8.3
		C41.7,34.1,41.7,34.3,41.7,34.4z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M41.7,35.2c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C50.4,39.1,46.5,35.2,41.7,35.2z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M38.1,49.4v-0.9c1.2-0.6,2-1.7,2-3c0-0.4,0-0.8-0.1-1.2h-1.8v-1.1h1.6c-0.1-0.5-0.2-1.2-0.2-1.9
		c0-2.1,1.4-3.4,3.3-3.4c0.9,0,1.5,0.2,1.9,0.4l-0.3,1.1c-0.3-0.2-0.8-0.3-1.6-0.3c-1.4,0-1.9,0.9-1.9,2.2c0,0.7,0.1,1.3,0.2,1.9
		h2.5v1.1h-2.4c0.1,0.7,0.1,1.3-0.1,1.9c-0.2,0.7-0.6,1.4-1.2,1.9v0h5.2v1.3H38.1z"
            />
          </g>
        </g>
      );
    case 'salesallocation':
      return (
        <g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.2"
              strokeMiterlimit="10"
              d="M28.2,18.3c-5.5,0-9.9,4.4-9.9,9.9
		c0,5.5,4.4,9.9,9.9,9.9s9.9-4.4,9.9-9.9C38.1,22.7,33.7,18.3,28.2,18.3z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M23.8,33.9V33c1.3-0.6,2.1-1.9,2.1-3.3c0-0.5,0-0.8-0.1-1.3h-1.9v-1.2h1.8c-0.1-0.6-0.2-1.3-0.2-2
		c0-2.2,1.5-3.7,3.6-3.7c1,0,1.7,0.2,2.1,0.5l-0.4,1.2c-0.3-0.2-0.9-0.4-1.7-0.4c-1.5,0-2,1-2,2.4c0,0.8,0.1,1.4,0.2,2h2.7v1.2h-2.6
		c0.1,0.7,0.1,1.4-0.1,2.1c-0.2,0.8-0.7,1.5-1.3,2v0h5.6v1.4H23.8z"
            />
          </g>
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M19.4,19c0.5-0.5,0.6-1.1,0.4-1.4l0,0l0,0c0,0,0,0,0,0s0,0,0,0l-9.2-9.2c-0.1-0.1-0.1-0.4,0.2-0.6l0.6-0.6
	c0.3-0.3,0.3-0.6,0-0.7L6.4,5.5C6.1,5.4,5.6,5.9,5.7,6.2L6.8,11c0.1,0.2,0.4,0.2,0.7,0l0.7-0.7c0.2-0.2,0.5-0.3,0.6-0.2l9.2,9.2l0,0
	C18.3,19.7,18.9,19.5,19.4,19z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M36.8,19c-0.5-0.5-0.6-1.1-0.4-1.4l0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0l9.2-9.2c0.1-0.1,0.1-0.4-0.2-0.6L45,7.3
	c-0.3-0.3-0.3-0.6,0-0.7l4.8-1.1c0.3-0.1,0.8,0.4,0.7,0.7L49.4,11c-0.1,0.2-0.4,0.2-0.7,0l-0.7-0.7c-0.2-0.2-0.5-0.3-0.6-0.2
	l-9.2,9.2l0,0C37.9,19.7,37.3,19.5,36.8,19z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M36.9,37.3c-0.5,0.5-0.6,1.1-0.4,1.4l0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0l9.2,9.2c0.1,0.1,0.1,0.4-0.2,0.6
	L45.1,49c-0.3,0.3-0.3,0.6,0,0.7l4.8,1.1c0.3,0.1,0.8-0.4,0.7-0.7l-1.1-4.8c-0.1-0.2-0.4-0.2-0.7,0L48.2,46
	c-0.2,0.2-0.5,0.3-0.6,0.2l-9.2-9.2l0,0C38,36.6,37.4,36.8,36.9,37.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M19.5,37.3c0.5,0.5,0.6,1.1,0.4,1.4l0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0l-9.2,9.2c-0.1,0.1-0.1,0.4,0.2,0.6
	l0.6,0.6c0.3,0.3,0.3,0.6,0,0.7l-4.8,1.1c-0.3,0.1-0.8-0.4-0.7-0.7l1.1-4.8c0.1-0.2,0.4-0.2,0.7,0L8.2,46c0.2,0.2,0.5,0.3,0.6,0.2
	l9.2-9.2l0,0C18.4,36.6,19,36.8,19.5,37.3z"
          />
        </g>
      );
    case 'salesreconciliation':
      return (
        <g>
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M35.1,25.2h-9.9c-0.3,0-0.6-0.2-0.6-0.5v-0.5c0-0.3,0.3-0.5,0.6-0.5h9.9c0.3,0,0.6,0.2,0.6,0.5v0.5
	C35.7,25,35.5,25.2,35.1,25.2z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M35.1,19.8h-9.9c-0.3,0-0.6-0.2-0.6-0.5v-0.5c0-0.3,0.3-0.5,0.6-0.5h9.9c0.3,0,0.6,0.2,0.6,0.5v0.5
	C35.7,19.6,35.5,19.8,35.1,19.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M35.4,30.2h-9.9c-0.3,0-0.6-0.2-0.6-0.5v-0.5c0-0.3,0.3-0.5,0.6-0.5h9.9c0.3,0,0.6,0.2,0.6,0.5v0.5
	C36,30,35.7,30.2,35.4,30.2z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M33.5,35.8h-8.4c-0.3,0-0.5-0.2-0.5-0.5v-0.5c0-0.3,0.2-0.5,0.5-0.5h8.4c0.3,0,0.5,0.2,0.5,0.5v0.5
	C34.1,35.6,33.8,35.8,33.5,35.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M23.4,23.4L21.2,26c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0-0.3,0-0.4-0.1L19,24.9c-0.2-0.2-0.3-0.6-0.1-0.8
	c0.2-0.2,0.6-0.3,0.8-0.1l1,0.8l1.9-2.2c0.2-0.2,0.6-0.3,0.8,0C23.6,22.8,23.6,23.2,23.4,23.4z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M23.4,18.2l-2.3,2.6c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0-0.3,0-0.4-0.1L19,19.6c-0.2-0.2-0.3-0.6-0.1-0.8
	c0.2-0.2,0.6-0.3,0.8-0.1l1,0.8l1.9-2.2c0.2-0.2,0.6-0.3,0.8,0C23.6,17.6,23.6,17.9,23.4,18.2z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M23.7,28.9l-2.3,2.6c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0-0.3,0-0.4-0.1l-1.4-1.1c-0.2-0.2-0.3-0.6-0.1-0.8
	c0.2-0.2,0.6-0.3,0.8-0.1l1,0.8l1.9-2.2c0.2-0.2,0.6-0.3,0.8,0C23.9,28.4,23.9,28.7,23.7,28.9z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M23.4,33.9l-2.3,2.6c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0-0.3,0-0.4-0.1L19,35.4c-0.2-0.2-0.3-0.6-0.1-0.8
	c0.2-0.2,0.6-0.3,0.8-0.1l1,0.8l1.9-2.2c0.2-0.2,0.6-0.3,0.8,0C23.6,33.4,23.6,33.7,23.4,33.9z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M39.7,6.1H14.1c-0.8,0-2.1,1.2-2.1,2.8v33.2c0,1.5,1.2,2.8,2.8,2.8h17.4c-0.4-1.1-0.4-1.7-0.5-2.9H15l0-29.7
	h25.4l0,17.8c0.9-0.2,1-0.3,2-0.5c0.2,0,0.5,0,0.7,0V8.9C43.1,7.4,41.9,6.1,39.7,6.1z M31.4,9.2c0,0.2-0.2,0.4-0.4,0.4h-7.1
	c-0.2,0-0.4-0.2-0.4-0.4V8.8c0-0.2,0.2-0.4,0.4-0.4H31c0.2,0,0.4,0.2,0.4,0.4V9.2z"
          />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M41.9,31.4c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C50.6,35.3,46.7,31.4,41.9,31.4z"
            />
          </g>
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                stroke={p4Tokens.colorBrandMenuForeground1}
                strokeMiterlimit="10"
                d="M25.8,38.4c-4,0-7.3,3.3-7.3,7.3c0,4,3.3,7.3,7.3,7.3
			s7.3-3.3,7.3-7.3C33.2,41.7,29.9,38.4,25.8,38.4z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M22.6,50.3v-0.7c1-0.5,1.6-1.4,1.6-2.5c0-0.3,0-0.6-0.1-1h-1.5v-0.9H24c-0.1-0.4-0.2-1-0.2-1.5
			c0-1.7,1.2-2.8,2.7-2.8c0.7,0,1.3,0.2,1.6,0.4l-0.3,0.9c-0.3-0.1-0.7-0.3-1.3-0.3c-1.1,0-1.6,0.8-1.6,1.8c0,0.6,0.1,1.1,0.2,1.5
			h2.1v0.9h-1.9c0,0.5,0.1,1.1-0.1,1.6c-0.2,0.6-0.5,1.1-1,1.5v0h4.3v1H22.6z"
              />
            </g>
          </g>
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke="#FFFFFB"
            strokeWidth="0.5"
            strokeMiterlimit="10"
            d="M46.9,36.7l-6.8,7.6c-0.1,0.1-0.3,0.2-0.4,0.2
	c-0.1,0-0.3,0-0.4-0.1L37,42.6c-0.2-0.2-0.3-0.6-0.1-0.8c0.2-0.2,0.6-0.3,0.8-0.1l1.9,1.4l6.5-7.2c0.2-0.2,0.6-0.3,0.8,0
	C47.1,36.1,47.1,36.5,46.9,36.7z"
          />
        </g>
      );
    case 'printer':
      return (
        <g>
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M39.9,18.4H17.3c-0.7,0-1.2-0.5-1.2-1.2V8.3
	c0-0.7,0.5-1.2,1.2-1.2h22.7c0.7,0,1.2,0.5,1.2,1.2v8.8C41.1,17.8,40.6,18.4,39.9,18.4z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M47.1,40.8H10.3c-1.2,0-2.3-1-2.3-2.3V19.8
	c0-1.2,1-2.3,2.3-2.3h36.8c1.2,0,2.3,1,2.3,2.3v18.8C49.4,39.8,48.4,40.8,47.1,40.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M14.8,23.5c0,0.8-0.6,1.5-1.4,1.5c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.4,1.4-1.5
	C14.1,22,14.8,22.7,14.8,23.5z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M28.7,38.3c2,0,4,0,6,0c0.6,0,1,0.3,1,0.8c0,0.5-0.3,0.8-0.7,0.9c-0.2,0-0.3,0-0.5,0c-4,0-7.9,0-11.9,0
	c-0.7,0-1.2-0.5-1-1.1c0.1-0.3,0.4-0.5,0.7-0.6c0.1,0,0.2,0,0.3,0C24.6,38.3,26.6,38.3,28.7,38.3C28.7,38.3,28.7,38.3,28.7,38.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M28.6,35.1c-2.1,0-4.1,0-6.2,0c-0.4,0-0.7-0.2-0.8-0.6c-0.1-0.3-0.1-0.7,0.2-0.9c0.2-0.1,0.5-0.2,0.7-0.2
	c2.3,0,4.5,0,6.8,0c1.8,0,3.6,0,5.5,0c0.5,0,0.9,0.3,0.9,0.8c0,0.6-0.3,0.9-0.9,0.9C32.7,35.1,30.7,35.1,28.6,35.1z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M28.6,43.3c2,0,4.1,0,6.1,0c0.5,0,0.9,0.3,0.9,0.8c0,0.5-0.3,0.9-0.9,0.9c-0.9,0-1.8,0-2.7,0
	c-3.2,0-6.4,0-9.6,0c-0.7,0-1.1-0.6-0.9-1.2c0.1-0.3,0.4-0.5,0.9-0.5c1.8,0,3.6,0,5.4,0C28.2,43.3,28.4,43.3,28.6,43.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground1}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M39.5,50.3H18.2c-0.9,0-1.7-0.8-1.7-1.7V30.3
	c0-0.9,0.8-1.7,1.7-1.7h21.3c0.9,0,1.7,0.8,1.7,1.7v18.3C41.2,49.5,40.5,50.3,39.5,50.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M35,35H22.4c-0.4,0-0.8-0.3-0.8-0.8v0c0-0.4,0.3-0.8,0.8-0.8H35c0.4,0,0.8,0.3,0.8,0.8v0
	C35.8,34.6,35.5,35,35,35z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M35,40H22.4c-0.4,0-0.8-0.3-0.8-0.8v0c0-0.4,0.3-0.8,0.8-0.8H35c0.4,0,0.8,0.3,0.8,0.8v0
	C35.8,39.7,35.5,40,35,40z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M35,44.9H22.4c-0.4,0-0.8-0.3-0.8-0.8l0,0c0-0.4,0.3-0.8,0.8-0.8H35c0.4,0,0.8,0.3,0.8,0.8l0,0
	C35.8,44.6,35.5,44.9,35,44.9z"
          />
        </g>
      );
    case 'purchaseorder':
      return (
        <g>
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3071"
            strokeMiterlimit="10"
            d="M12.7,45.5h25c1.1,0,2.1-0.9,2.1-2.1V7.3
	c0-1.1-0.9-2.1-2.1-2.1H25.4L10.6,19.5v23.9C10.6,44.5,11.5,45.5,12.7,45.5z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeMiterlimit="10"
            d="M12.3,19.2h11c1.1,0,2.1-0.9,2.1-2.1v-11L12.3,19.2z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M14.8,26.3h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H14.8c-0.2,0-0.3,0.1-0.3,0.3v0.7
	C14.5,26.1,14.6,26.3,14.8,26.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M14.8,32.3h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H14.8c-0.2,0-0.3,0.1-0.3,0.3v0.7
	C14.5,32.1,14.6,32.3,14.8,32.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M14.8,38.2h16.7c0.2,0,0.3-0.1,0.3-0.3v-0.8c0-0.2-0.1-0.3-0.3-0.3H14.8c-0.2,0-0.3,0.1-0.3,0.3v0.8
	C14.5,38.1,14.6,38.2,14.8,38.2z"
          />
          <path fill={p4Tokens.colorBrandMenuBackground1} d="M12.8,18.4h9.9c1,0,1.9-0.8,1.9-1.8V7.2L12.8,18.4z" />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M42.8,33.1c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C51.6,37,47.7,33.1,42.8,33.1z"
            />
          </g>
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                stroke={p4Tokens.colorBrandMenuForeground1}
                strokeMiterlimit="10"
                d="M26.3,39.7c-4,0-7.3,3.3-7.3,7.3c0,4,3.3,7.3,7.3,7.3
			s7.3-3.3,7.3-7.3C33.6,43,30.3,39.7,26.3,39.7z"
              />
            </g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M27.1,42.1V46h3.8v1.8h-3.8v3.9h-1.9v-3.9h-3.8V46h3.8v-3.9H27.1z"
              />
            </g>
          </g>
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke="#FFFFFB"
            strokeWidth="0.5"
            strokeMiterlimit="10"
            d="M47.9,38.6l-6.8,7.6c-0.1,0.1-0.3,0.2-0.4,0.2
	c-0.1,0-0.3,0-0.4-0.1l-2.3-1.8c-0.2-0.2-0.3-0.6-0.1-0.8c0.2-0.2,0.6-0.3,0.8-0.1l1.9,1.4l6.5-7.2c0.2-0.2,0.6-0.3,0.8,0
	C48.1,38,48.1,38.3,47.9,38.6z"
          />
        </g>
      );
    case 'orderaudit':
      return (
        <g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.1049"
              strokeMiterlimit="10"
              d="M51.4,50.7l-7.1-6.8l-3.2,3.3l7.1,6.8
		c0.9,0.9,2.4,0.9,3.3-0.1C52.3,53.1,52.3,51.6,51.4,50.7z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M24,15h-9.1c-0.3,0-0.6-0.2-0.6-0.4v-0.4c0-0.2,0.3-0.4,0.6-0.4H24c0.3,0,0.6,0.2,0.6,0.4v0.4
		C24.5,14.8,24.3,15,24,15z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M24,19.9h-9.1c-0.3,0-0.6-0.2-0.6-0.4v-0.4c0-0.2,0.3-0.4,0.6-0.4H24c0.3,0,0.6,0.2,0.6,0.4v0.4
		C24.5,19.7,24.3,19.9,24,19.9z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M24,24.4h-9.1c-0.3,0-0.6-0.2-0.6-0.4v-0.4c0-0.2,0.3-0.4,0.6-0.4H24c0.3,0,0.6,0.2,0.6,0.4V24
		C24.5,24.2,24.3,24.4,24,24.4z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M21.7,29.8h-7c-0.2,0-0.4-0.2-0.4-0.4v-0.4c0-0.2,0.2-0.4,0.4-0.4h7c0.2,0,0.4,0.2,0.4,0.4v0.4
		C22.1,29.6,21.9,29.8,21.7,29.8z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M13.2,13.3l-2.1,2.4c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2,0-0.3-0.1l-1.3-1C8.9,14.5,8.8,14.2,9,14
		c0.2-0.2,0.5-0.3,0.7-0.1l0.9,0.7l1.8-2c0.2-0.2,0.5-0.2,0.7,0C13.4,12.8,13.4,13.1,13.2,13.3z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M13.2,18.4l-2.1,2.4c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2,0-0.3-0.1l-1.3-1C8.9,19.6,8.8,19.3,9,19
		c0.2-0.2,0.5-0.3,0.7-0.1l0.9,0.7l1.8-2c0.2-0.2,0.5-0.2,0.7,0C13.4,17.9,13.4,18.2,13.2,18.4z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M13.2,23.2l-2.1,2.4c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2,0-0.3-0.1l-1.3-1c-0.2-0.2-0.3-0.5-0.1-0.7
		c0.2-0.2,0.5-0.3,0.7-0.1l0.9,0.7l1.8-2c0.2-0.2,0.5-0.2,0.7,0C13.4,22.7,13.4,23,13.2,23.2z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M13.2,28.1l-2.1,2.4c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2,0-0.3-0.1l-1.3-1C8.9,29.3,8.8,29,9,28.7
		c0.2-0.2,0.5-0.3,0.7-0.1l0.9,0.7l1.8-2c0.2-0.2,0.5-0.2,0.7,0C13.4,27.6,13.4,27.9,13.2,28.1z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M28.2,2.5H4.6C3.8,2.5,2.7,3.6,2.7,5v30.6c0,1.4,1.1,2.5,2.5,2.5h16c-0.4-1-0.4-1.5-0.5-2.7H5.4l0-27.3
		h23.4l0,16.4c0.9-0.2,0.9-0.3,1.9-0.4c0.2,0,0.4,0,0.6,0V5C31.4,3.6,30.2,2.5,28.2,2.5z M20.6,5.3c0,0.2-0.2,0.3-0.4,0.3h-6.6
		c-0.2,0-0.4-0.1-0.4-0.3V5c0-0.2,0.2-0.3,0.4-0.3h6.6c0.2,0,0.4,0.1,0.4,0.3V5.3z"
            />
            <g>
              <g>
                <path
                  fill={p4Tokens.colorBrandMenuForeground2}
                  d="M24.6,28.2c-4.3,4.5-4.2,11.6,0.3,15.9c3.8,3.7,9.6,4.1,13.9,1.4l1.5,1.5L44,43l-1.6-1.5
				c2.4-4.3,1.7-9.9-2-13.5C36,23.6,28.9,23.7,24.6,28.2z M39.4,29c3.9,3.7,4,9.9,0.2,13.8c-3.7,3.9-9.9,4-13.8,0.2
				c-3.9-3.7-4-9.9-0.2-13.8C29.4,25.4,35.5,25.3,39.4,29z"
                />
              </g>
            </g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M39.1,45c0,0,0.9-0.8,1.5-1.4c0.6-0.6,1.3-1.7,1.3-1.7L43,43L40.2,46L39.1,45z"
            />
            <g>
              <g>
                <path
                  fill={p4Tokens.colorBrandMenuForeground1}
                  stroke={p4Tokens.colorBrandMenuForeground1}
                  strokeWidth="0.4316"
                  strokeMiterlimit="10"
                  d="M28.3,42.5v-1c1.3-0.7,2.2-2,2.2-3.5
				c0-0.5,0-0.9-0.1-1.4h-2v-1.2h1.8c-0.1-0.6-0.2-1.4-0.2-2.1c0-2.3,1.6-3.8,3.8-3.8c1,0,1.7,0.2,2.2,0.5l-0.4,1.3
				c-0.4-0.2-0.9-0.4-1.8-0.4c-1.5,0-2.1,1.1-2.1,2.5c0,0.8,0.1,1.5,0.2,2.1h2.8v1.2H32c0.1,0.7,0.1,1.5-0.1,2.2
				c-0.2,0.8-0.7,1.6-1.4,2.1v0h5.9v1.4H28.3z"
                />
              </g>
            </g>
          </g>
        </g>
      );
    case 'printpicking':
      return (
        <g>
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M35.1,18.7H12.4c-0.7,0-1.2-0.5-1.2-1.2V8.7
	c0-0.7,0.5-1.2,1.2-1.2h22.7c0.7,0,1.2,0.5,1.2,1.2v8.8C36.3,18.2,35.7,18.7,35.1,18.7z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M42.3,41.2H5.4c-1.2,0-2.3-1-2.3-2.3V20.1
	c0-1.2,1-2.3,2.3-2.3h36.8c1.2,0,2.3,1,2.3,2.3v18.8C44.5,40.2,43.5,41.2,42.3,41.2z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M9.9,23.8c0,0.8-0.6,1.5-1.4,1.5c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.4,1.4-1.5C9.2,22.4,9.9,23,9.9,23.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M23.8,38.7c2,0,4,0,6,0c0.6,0,1,0.3,1,0.8c0,0.5-0.3,0.8-0.7,0.9c-0.2,0-0.3,0-0.5,0c-4,0-7.9,0-11.9,0
	c-0.7,0-1.2-0.5-1-1.1c0.1-0.3,0.4-0.5,0.7-0.6c0.1,0,0.2,0,0.3,0C19.8,38.7,21.8,38.7,23.8,38.7C23.8,38.7,23.8,38.7,23.8,38.7z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M23.8,35.4c-2.1,0-4.1,0-6.2,0c-0.4,0-0.7-0.2-0.8-0.6c-0.1-0.3-0.1-0.7,0.2-0.9c0.2-0.1,0.5-0.2,0.7-0.2
	c2.3,0,4.5,0,6.8,0c1.8,0,3.6,0,5.5,0c0.5,0,0.9,0.3,0.9,0.8c0,0.6-0.3,0.9-0.9,0.9C27.9,35.4,25.8,35.4,23.8,35.4z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M23.8,43.6c2,0,4.1,0,6.1,0c0.5,0,0.9,0.3,0.9,0.8c0,0.5-0.3,0.9-0.9,0.9c-0.9,0-1.8,0-2.7,0
	c-3.2,0-6.4,0-9.6,0c-0.7,0-1.1-0.6-0.9-1.2c0.1-0.3,0.4-0.5,0.9-0.5c1.8,0,3.6,0,5.4,0C23.3,43.6,23.5,43.6,23.8,43.6z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M34.7,50.6H13.4c-0.9,0-1.7-0.8-1.7-1.7V30.7
	c0-0.9,0.8-1.7,1.7-1.7h21.3c0.9,0,1.7,0.8,1.7,1.7v18.3C36.4,49.9,35.6,50.6,34.7,50.6z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M30.2,35.3H17.5c-0.4,0-0.8-0.3-0.8-0.8l0,0c0-0.4,0.3-0.8,0.8-0.8h12.6c0.4,0,0.8,0.3,0.8,0.8l0,0
	C30.9,35,30.6,35.3,30.2,35.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M30.2,40.4H17.5c-0.4,0-0.8-0.3-0.8-0.8l0,0c0-0.4,0.3-0.8,0.8-0.8h12.6c0.4,0,0.8,0.3,0.8,0.8l0,0
	C30.9,40,30.6,40.4,30.2,40.4z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M30.2,45.3H17.5c-0.4,0-0.8-0.3-0.8-0.8v0c0-0.4,0.3-0.8,0.8-0.8h12.6c0.4,0,0.8,0.3,0.8,0.8v0
	C30.9,44.9,30.6,45.3,30.2,45.3z"
          />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M46.1,31.4c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C54.8,35.3,50.9,31.4,46.1,31.4z"
            />
          </g>
          <g>
            <g>
              <polygon fill={p4Tokens.colorBrandMenuBackground1} points="40.5,37.8 45.6,39.6 45.5,45.2 40.5,43.4 		" />
              <polygon fill={p4Tokens.colorBrandMenuBackground1} points="46.4,39.6 51.4,37.8 51.5,43.4 46.4,45.3 		" />
              <polygon fill={p4Tokens.colorBrandMenuBackground1} points="41.1,37 46,38.8 51,37 45.9,35.1 		" />
            </g>
          </g>
        </g>
      );
    case 'pickinghistory':
      return (
        <g>
          <path
            fill={fillColor}
            d="M21.376 5.146c-2.361-2.361-5.469-3.646-8.783-3.646-3.853 0-7.416 1.781-9.777 4.723v-1.616c0-0.331-0.29-0.621-0.621-0.621s-0.621 0.29-0.621 0.621v3.687c0 0.29 0.207 0.539 0.456 0.621 0.124 0.041 0.249 0.041 0.373 0v0l3.563-1.201c0.331-0.124 0.497-0.456 0.373-0.787s-0.456-0.497-0.787-0.373l-1.864 0.621c2.113-2.776 5.386-4.433 8.907-4.433 6.173 0 11.186 5.013 11.186 11.186s-5.013 11.186-11.186 11.186c-4.101 0-7.913-2.237-9.86-5.883-0.166-0.29-0.539-0.414-0.829-0.249s-0.414 0.539-0.249 0.829c2.154 4.019 6.38 6.546 10.937 6.546 3.314 0 6.421-1.284 8.783-3.646s3.646-5.469 3.646-8.783c0-3.314-1.284-6.421-3.646-8.783v0z"
          />
          <path
            fill={fillColor}
            d="M13.207 16.087c-0.114 0.049-0.207 0.043-0.299 0.037l-5.161-2.085c-0.332-0.039-0.592-0.334-0.553-0.666s0.334-0.592 0.666-0.553l4.791 2.062 3.883-7.499c0.202-0.266 0.578-0.335 0.882-0.149s0.335 0.578 0.149 0.882l-4.085 7.765c-0.060 0.070-0.158 0.157-0.273 0.206v0z"
          />
          <path fill="#fff" d="M14.955 14.757h19.471v15.743h-19.471v-15.743z" />
          <path
            fill="#3949AB"
            d="M28.95 15.955c-0.090-0.090-0.226-0.090-0.316-0.023l-3.073 2.531h-1.559l1.062-1.062c0.068-0.068 0.090-0.158 0.045-0.249s-0.113-0.136-0.203-0.136h-1.446v-2.034c0-0.136-0.090-0.226-0.226-0.226h-3.231c-0.136 0-0.226 0.090-0.226 0.226v2.034h-1.446c-0.090 0-0.181 0.045-0.203 0.136s-0.023 0.181 0.045 0.249l1.062 1.062h-1.582l-3.073-2.531c-0.090-0.068-0.226-0.068-0.316 0.023l-2.418 2.644c-0.045 0.045-0.068 0.113-0.068 0.158 0 0.068 0.023 0.113 0.090 0.158l3.48 2.892v7.864c0 0.136 0.090 0.226 0.226 0.226h12.022c0.136 0 0.226-0.090 0.226-0.226v-7.819l3.525-2.938c0.045-0.045 0.068-0.090 0.090-0.158 0-0.068-0.023-0.113-0.068-0.158l-2.418-2.644zM25.764 19.344l1.424 2.147h-1.424v-2.147zM20.002 17.469c0.136 0 0.226-0.090 0.226-0.226v-2.034h2.779v2.034c0 0.136 0.090 0.226 0.226 0.226h1.13l-2.757 2.734-2.734-2.734h1.13zM21.448 20.7c0.045 0.045 0.090 0.068 0.158 0.068s0.113-0.023 0.158-0.068l1.763-1.785h1.763v2.576h-7.434v-2.576h1.83l1.763 1.785zM22.487 29.4h-1.763v-7.457h1.763v7.457zM16.002 21.491l1.401-2.124v2.124h-1.401zM14.465 16.429l2.825 2.305-1.763 2.644-3.186-2.644 2.124-2.305zM15.799 21.943h5.491v7.502h-5.491v-7.502zM27.368 29.445h-6.079v-7.502h6.079v7.502zM27.662 21.401l-1.763-2.644 2.847-2.328 2.124 2.305-3.209 2.667z"
          />
          <path
            fill="#3949AB"
            d="M26.239 27.141h-2.056c-0.136 0-0.226 0.090-0.226 0.226v1.13c0 0.136 0.090 0.226 0.226 0.226h2.056c0.136 0 0.226-0.090 0.226-0.226v-1.13c0-0.113-0.090-0.226-0.226-0.226zM26.013 28.27h-1.604v-0.678h1.604v0.678z"
          />
        </g>
      );
    case 'ackhistory':
      return (
        <g>
          <path
            fill={fillColor}
            d="M23.673 4.009c-2.569-2.569-5.949-3.966-9.555-3.966-4.192 0-8.068 1.938-10.637 5.138v-1.758c0-0.361-0.316-0.676-0.676-0.676s-0.676 0.316-0.676 0.676v4.011c0 0.316 0.225 0.586 0.496 0.676 0.135 0.045 0.27 0.045 0.406 0v0l3.876-1.307c0.361-0.135 0.541-0.496 0.406-0.856s-0.496-0.541-0.856-0.406l-2.028 0.676c2.299-3.020 5.859-4.823 9.69-4.823 6.715 0 12.169 5.454 12.169 12.169s-5.454 12.169-12.169 12.169c-4.462 0-8.608-2.434-10.727-6.4-0.18-0.316-0.586-0.451-0.901-0.27s-0.451 0.586-0.27 0.901c2.344 4.372 6.941 7.121 11.899 7.121 3.606 0 6.986-1.397 9.555-3.966s3.966-5.949 3.966-9.555c0-3.606-1.397-6.986-3.966-9.555v0z"
          />
          <path
            fill={fillColor}
            d="M14.786 15.912c-0.124 0.053-0.225 0.047-0.326 0.040l-5.614-2.268c-0.361-0.043-0.644-0.363-0.601-0.724s0.363-0.644 0.724-0.601l5.212 2.243 4.224-8.158c0.22-0.289 0.629-0.365 0.959-0.162s0.365 0.629 0.162 0.959l-4.444 8.447c-0.065 0.077-0.172 0.171-0.297 0.224v0z"
          />
          <path fill="#fff" d="M16.687 14.465h21.183v17.127h-21.183v-17.127z" />
          <path
            fill={fillColor}
            d="M30.445 17.62v0c0-0.021-0.021-0.064-0.021-0.086v-0.021c-0.021-0.021-0.021-0.043-0.043-0.064v0l-4.722-4.7c-0.021-0.021-0.043-0.043-0.064-0.043 0 0 0 0-0.021 0-0.021-0.021-0.043-0.021-0.086-0.021v0h-7.426c-0.515 0-0.923 0.408-0.923 0.923v17.427c0 0.515 0.408 0.923 0.923 0.923h11.482c0.515 0 0.923-0.408 0.923-0.923v-13.328c-0.021-0.043-0.021-0.064-0.021-0.086v0zM25.723 13.757l3.627 3.606h-2.125c-0.837 0-1.502-0.665-1.502-1.502v-2.103zM29.522 31.292h-11.482c-0.172 0-0.279-0.15-0.279-0.279v-17.427c0-0.172 0.15-0.279 0.279-0.279h7.040v2.554c0 1.18 0.966 2.146 2.146 2.146h2.575v13.006c0 0.172-0.129 0.279-0.279 0.279v0z"
          />
          <path
            fill={fillColor}
            d="M28.556 19.638h-9.508c-0.172 0-0.322 0.15-0.322 0.322s0.15 0.322 0.322 0.322h9.508c0.172 0 0.322-0.15 0.322-0.322s-0.15-0.322-0.322-0.322v0z"
          />
          <path
            fill={fillColor}
            d="M28.556 21.205h-9.508c-0.172 0-0.322 0.15-0.322 0.322s0.15 0.322 0.322 0.322h9.508c0.172 0 0.322-0.15 0.322-0.322s-0.15-0.322-0.322-0.322v0z"
          />
          <path
            fill={fillColor}
            d="M28.556 22.75h-9.508c-0.172 0-0.322 0.15-0.322 0.322s0.15 0.322 0.322 0.322h9.508c0.172 0 0.322-0.15 0.322-0.322s-0.15-0.322-0.322-0.322v0z"
          />
          <path
            fill={fillColor}
            d="M28.556 24.317h-9.508c-0.172 0-0.322 0.15-0.322 0.322s0.15 0.322 0.322 0.322h9.508c0.172 0 0.322-0.15 0.322-0.322s-0.15-0.322-0.322-0.322v0z"
          />
          <path
            fill="#3949AB"
            d="M23.206 29.789h-0.638l-0.254-0.66h-1.161l-0.24 0.66h-0.622l1.131-2.904h0.62l1.163 2.904zM22.127 28.641l-0.4-1.077-0.392 1.077h0.792zM25.348 28.308l-0.549 0.099c-0.018-0.11-0.060-0.192-0.126-0.248s-0.15-0.083-0.255-0.083c-0.139 0-0.249 0.048-0.332 0.144s-0.124 0.256-0.124 0.48c0 0.25 0.042 0.426 0.126 0.529s0.196 0.154 0.338 0.154c0.106 0 0.192-0.030 0.259-0.090s0.115-0.163 0.143-0.31l0.547 0.093c-0.057 0.251-0.166 0.44-0.327 0.568s-0.377 0.192-0.648 0.192c-0.308 0-0.553-0.097-0.736-0.291s-0.274-0.463-0.274-0.806c0-0.347 0.092-0.618 0.275-0.811s0.432-0.29 0.745-0.29c0.256 0 0.46 0.055 0.611 0.165s0.26 0.278 0.326 0.504zM25.75 29.789v-2.904h0.557v1.541l0.652-0.741h0.685l-0.719 0.768 0.77 1.335h-0.6l-0.529-0.945-0.259 0.271v0.673h-0.557z"
          />
        </g>
      );
    case 'printack':
      return (
        <g>
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M34.7,19.1H12c-0.7,0-1.2-0.5-1.2-1.2V9.1
	c0-0.7,0.5-1.2,1.2-1.2h22.7c0.7,0,1.2,0.5,1.2,1.2v8.8C35.9,18.5,35.4,19.1,34.7,19.1z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M41.9,41.5H5.1c-1.2,0-2.3-1-2.3-2.3V20.5
	c0-1.2,1-2.3,2.3-2.3h36.8c1.2,0,2.3,1,2.3,2.3v18.8C44.2,40.5,43.1,41.5,41.9,41.5z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M9.5,24.2c0,0.8-0.6,1.5-1.4,1.5c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.4,1.4-1.5C8.9,22.7,9.5,23.4,9.5,24.2z
	"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M23.4,39c2,0,4,0,6,0c0.6,0,1,0.3,1,0.8c0,0.5-0.3,0.8-0.7,0.9c-0.2,0-0.3,0-0.5,0c-4,0-7.9,0-11.9,0
	c-0.7,0-1.2-0.5-1-1.1c0.1-0.3,0.4-0.5,0.7-0.6c0.1,0,0.2,0,0.3,0C19.4,39,21.4,39,23.4,39C23.4,39,23.4,39,23.4,39z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M23.4,35.8c-2.1,0-4.1,0-6.2,0c-0.4,0-0.7-0.2-0.8-0.6c-0.1-0.3-0.1-0.7,0.2-0.9c0.2-0.1,0.5-0.2,0.7-0.2
	c2.3,0,4.5,0,6.8,0c1.8,0,3.6,0,5.5,0c0.5,0,0.9,0.3,0.9,0.8c0,0.6-0.3,0.9-0.9,0.9C27.5,35.8,25.5,35.8,23.4,35.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M23.4,44c2,0,4.1,0,6.1,0c0.5,0,0.9,0.3,0.9,0.8c0,0.5-0.3,0.9-0.9,0.9c-0.9,0-1.8,0-2.7,0
	c-3.2,0-6.4,0-9.6,0c-0.7,0-1.1-0.6-0.9-1.2c0.1-0.3,0.4-0.5,0.9-0.5c1.8,0,3.6,0,5.4,0C22.9,44,23.2,44,23.4,44z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M34.3,51H13c-0.9,0-1.7-0.8-1.7-1.7V31.1
	c0-0.9,0.8-1.7,1.7-1.7h21.3c0.9,0,1.7,0.8,1.7,1.7v18.3C36,50.2,35.2,51,34.3,51z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M29.8,35.7H17.2c-0.4,0-0.8-0.3-0.8-0.8v0c0-0.4,0.3-0.8,0.8-0.8h12.6c0.4,0,0.8,0.3,0.8,0.8v0
	C30.6,35.4,30.2,35.7,29.8,35.7z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M29.8,40.7H17.2c-0.4,0-0.8-0.3-0.8-0.8v0c0-0.4,0.3-0.8,0.8-0.8h12.6c0.4,0,0.8,0.3,0.8,0.8v0
	C30.6,40.4,30.2,40.7,29.8,40.7z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M29.8,45.6H17.2c-0.4,0-0.8-0.3-0.8-0.8l0,0c0-0.4,0.3-0.8,0.8-0.8h12.6c0.4,0,0.8,0.3,0.8,0.8l0,0
	C30.6,45.3,30.2,45.6,29.8,45.6z"
          />
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M45.7,31.5c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C54.5,35.4,50.6,31.5,45.7,31.5z
			"
              />
            </g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke="#FFFFFB"
              strokeMiterlimit="10"
              d="M50.7,36.8l-6.8,7.6c-0.1,0.1-0.3,0.2-0.4,0.2
		c-0.1,0-0.3,0-0.4-0.1l-2.3-1.8c-0.2-0.2-0.3-0.6-0.1-0.8c0.2-0.2,0.6-0.3,0.8-0.1l1.9,1.4l6.5-7.2c0.2-0.2,0.6-0.3,0.8,0
		C50.9,36.2,51,36.5,50.7,36.8z"
            />
          </g>
        </g>
      );
    case 'dnhistory':
      return (
        <g>
          <path
            fill={fillColor}
            d="M18.231 6.497c-2.068-2.068-4.788-3.192-7.69-3.192-3.373 0-6.493 1.56-8.56 4.135v-1.415c0-0.29-0.254-0.544-0.544-0.544s-0.544 0.254-0.544 0.544v3.228c0 0.254 0.181 0.472 0.399 0.544 0.109 0.036 0.218 0.036 0.326 0v0l3.119-1.052c0.29-0.109 0.435-0.399 0.326-0.689s-0.399-0.435-0.689-0.326l-1.632 0.544c1.85-2.43 4.715-3.881 7.799-3.881 5.405 0 9.794 4.389 9.794 9.794s-4.389 9.794-9.794 9.794c-3.591 0-6.928-1.959-8.633-5.151-0.145-0.254-0.472-0.363-0.725-0.218s-0.363 0.472-0.218 0.725c1.886 3.518 5.586 5.731 9.576 5.731 2.902 0 5.622-1.124 7.69-3.192s3.192-4.788 3.192-7.69c0-2.902-1.124-5.622-3.192-7.69v0z"
          />
          <path
            fill={fillColor}
            d="M11.078 16.076c-0.1 0.043-0.181 0.037-0.262 0.032l-4.518-1.826c-0.29-0.034-0.518-0.292-0.484-0.583s0.292-0.518 0.583-0.484l4.195 1.805 3.4-6.566c0.177-0.233 0.506-0.294 0.772-0.131s0.294 0.506 0.131 0.772l-3.577 6.798c-0.053 0.062-0.139 0.138-0.239 0.18v0z"
          />
          <path fill="#fff" d="M12.609 14.912h17.048v13.784h-17.048v-13.784z" />
          <path
            fill="#3949AB"
            d="M31.108 20.344h-2.467l-1.054-2.513h-3.227v-2.556h-11.388v10.373h1.539c0.155 1.139 1.118 1.988 2.256 1.988s2.102-0.849 2.256-1.988h6.031c0.155 1.139 1.118 1.988 2.256 1.988s2.102-0.849 2.256-1.988h1.539v-5.304zM16.767 26.776c-0.59-0-1.122-0.36-1.346-0.912s-0.096-1.186 0.325-1.604c0.421-0.419 1.050-0.539 1.593-0.305s0.892 0.777 0.883 1.373c-0.012 0.803-0.66 1.448-1.455 1.448v0zM22.672 24.796h-3.669c-0.248-1.044-1.172-1.781-2.235-1.781s-1.988 0.736-2.235 1.781h-0.717v-8.669h9.701v8.669h-0.843zM27.312 26.776c-0.59-0-1.122-0.36-1.346-0.912s-0.096-1.186 0.325-1.604c0.421-0.419 1.050-0.539 1.593-0.305s0.892 0.777 0.883 1.373c-0.012 0.803-0.66 1.448-1.455 1.448zM30.264 24.796h-0.717c-0.248-1.044-1.172-1.781-2.235-1.781s-1.988 0.736-2.235 1.781h-0.717v-6.113h2.678l1.054 2.513h2.172v3.6z"
          />
        </g>
      );
    case 'carriagecosts':
      return (
        <g>
          <path
            fill="#FFFFFB"
            stroke="#808183"
            strokeWidth="1.0286"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
	M29.2,35.1H7.2c-1.6,0-2.9-1.3-2.9-2.9V17c0-1.6,1.3-2.9,2.9-2.9h21.9c1.6,0,2.9,1.3,2.9,2.9v15.2C32.1,33.7,30.8,35.1,29.2,35.1z"
          />
          <path
            fill="#FFFFFB"
            stroke="#808183"
            strokeWidth="0.9336"
            strokeMiterlimit="10"
            d="M52.2,30.3c0-0.2,0-0.4-0.2-0.4
	c0,0,0,0-0.1-0.1l-5.4-3.7c-0.1-0.1-0.2-0.1-0.4-0.2c-0.8-7.7-4.7-9.4-5.5-9.7c-1.7-0.5-6.6-0.3-6.6-0.3c-0.3,0-0.5,0.2-0.5,0.5
	v13.5c0,0,0,0,0,0c0,0,0,0,0,0l0.1,6.3c0,0.1-28.8,0-28.8,0c-0.3,0-0.5,0.2-0.5,0.5v4.4c0,0.3,0.2,0.5,0.5,0.5h4.9
	c0.5-2.4,2.7-4.3,5.3-4.3s4.8,1.8,5.3,4.3h17.2c0.5-2.4,2.7-4.3,5.3-4.3c2.6,0,4.8,1.8,5.3,4.3h3.7c0.3,0,0.5-0.2,0.5-0.5L52.2,30.3
	z M35.3,25.8v-8.2c0,0,3.6-0.1,4.8,0.3c0.7,0.2,3.1,2.2,3.9,7.9H35.3z"
          />
          <path
            fill="#FFFFFB"
            stroke="#808183"
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M19,42.7c0,2.2-1.8,3.9-4,3.9l0,0
	c-2.2,0-4-1.8-4-3.9l0,0c0-2.2,1.8-3.9,4-3.9l0,0C17.2,38.7,19,40.5,19,42.7L19,42.7z"
          />
          <path
            fill="#FFFFFB"
            stroke="#808183"
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M46.7,42.7c0,2.2-1.8,3.9-4,3.9l0,0
	c-2.2,0-4-1.8-4-3.9l0,0c0-2.2,1.8-3.9,4-3.9l0,0C45,38.7,46.7,40.5,46.7,42.7L46.7,42.7z"
          />
          <g transform="translate(-24, -19)">
            <g>
              <path
                fill="#1A237E"
                d="M42,35.2c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C50.7,39.1,46.8,35.2,42,35.2z"
              />
            </g>
            <g>
              <path
                fill="#FFFFFB"
                d="M38.4,49.4v-0.9c1.2-0.6,2-1.7,2-3c0-0.4,0-0.8-0.1-1.2h-1.8v-1.1h1.6c-0.1-0.5-0.2-1.2-0.2-1.9
				c0-2.1,1.4-3.4,3.3-3.4c0.9,0,1.5,0.2,1.9,0.4l-0.3,1.1c-0.3-0.2-0.8-0.3-1.6-0.3c-1.4,0-1.9,0.9-1.9,2.2c0,0.7,0.1,1.3,0.2,1.9
				H44v1.1h-2.4c0.1,0.7,0.1,1.3-0.1,1.9c-0.2,0.7-0.6,1.4-1.2,1.9v0h5.2v1.3H38.4z"
              />
            </g>
          </g>
        </g>
      );
    case 'printdn':
      return (
        <g>
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.0286"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
	M29.2,35.1H7.2c-1.6,0-2.9-1.3-2.9-2.9V17c0-1.6,1.3-2.9,2.9-2.9h21.9c1.6,0,2.9,1.3,2.9,2.9v15.2C32.1,33.7,30.8,35.1,29.2,35.1z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.9336"
            strokeMiterlimit="10"
            d="M52.2,30.3c0-0.2,0-0.4-0.2-0.4
	c0,0,0,0-0.1-0.1l-5.4-3.7c-0.1-0.1-0.2-0.1-0.4-0.2c-0.8-7.7-4.7-9.4-5.5-9.7c-1.7-0.5-6.6-0.3-6.6-0.3c-0.3,0-0.5,0.2-0.5,0.5
	v13.5c0,0,0,0,0,0c0,0,0,0,0,0l0.1,6.3c0,0.1-28.8,0-28.8,0c-0.3,0-0.5,0.2-0.5,0.5v4.4c0,0.3,0.2,0.5,0.5,0.5h4.9
	c0.5-2.4,2.7-4.3,5.3-4.3s4.8,1.8,5.3,4.3h17.2c0.5-2.4,2.7-4.3,5.3-4.3c2.6,0,4.8,1.8,5.3,4.3h3.7c0.3,0,0.5-0.2,0.5-0.5L52.2,30.3
	z M35.3,25.8v-8.2c0,0,3.6-0.1,4.8,0.3c0.7,0.2,3.1,2.2,3.9,7.9H35.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M19,42.7c0,2.2-1.8,3.9-4,3.9l0,0
	c-2.2,0-4-1.8-4-3.9l0,0c0-2.2,1.8-3.9,4-3.9l0,0C17.2,38.7,19,40.5,19,42.7L19,42.7z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M46.7,42.7c0,2.2-1.8,3.9-4,3.9l0,0
	c-2.2,0-4-1.8-4-3.9l0,0c0-2.2,1.8-3.9,4-3.9l0,0C45,38.7,46.7,40.5,46.7,42.7L46.7,42.7z"
          />
          <g>
            <g>
              <polygon fill={p4Tokens.colorBrandMenuForeground1} points="11.8,22 17.6,24 17.6,30.5 11.8,28.4 		" />
              <polygon fill={p4Tokens.colorBrandMenuForeground1} points="18.6,24.1 24.5,22 24.5,28.4 18.6,30.5 		" />
              <polygon fill={p4Tokens.colorBrandMenuForeground1} points="12.5,21.2 18.1,23.2 23.9,21.1 18.1,19 		" />
            </g>
          </g>
        </g>
      );
    case 'writeoff':
      return (
        <g>
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3071"
            strokeMiterlimit="10"
            d="M13.2,44.9h25c1.1,0,2.1-0.9,2.1-2.1V6.8
	c0-1.1-0.9-2.1-2.1-2.1H25.9L11.1,18.9v23.9C11.1,44,12,44.9,13.2,44.9z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeMiterlimit="10"
            d="M12.9,18.7h11c1.1,0,2.1-0.9,2.1-2.1v-11L12.9,18.7z"
          />
          <path fill={p4Tokens.colorBrandMenuBackground1} d="M13.4,17.8h9.9c1,0,1.9-0.8,1.9-1.8V6.6L13.4,17.8z" />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M43.4,32.5c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C52.1,36.4,48.2,32.5,43.4,32.5z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M39.8,46.7v-0.9c1.2-0.6,2-1.7,2-3c0-0.4,0-0.8-0.1-1.2h-1.8v-1.1h1.6c-0.1-0.5-0.2-1.2-0.2-1.9
		c0-2.1,1.4-3.4,3.3-3.4c0.9,0,1.5,0.2,1.9,0.4l-0.3,1.1c-0.3-0.2-0.8-0.3-1.6-0.3c-1.4,0-1.9,0.9-1.9,2.2c0,0.7,0.1,1.3,0.2,1.9
		h2.5v1.1h-2.4c0.1,0.7,0.1,1.3-0.1,1.9c-0.2,0.7-0.6,1.4-1.2,1.9v0H47v1.3H39.8z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M32.8,32.9v4.3c0,0.1,0,0.2-0.1,1.2H19.1c-0.1-1-0.1-1.1-0.1-1.2v-4.3c0-0.1,0-0.1,0-0.2c0-1,0.5-2,1.1-2.7
		c0,0,0,0,0.1-0.1c0.3-0.3,0.7-0.6,1.1-0.8c0,0,0,0,0.1,0c0.1-0.1,0.2-0.1,0.3-0.1c0,0,0.1,0,0.1,0c0.1,0,0.2-0.1,0.3-0.1
		c0.1,0.1,0.3,0.3,0.4,0.4c0.4,0.3,0.8,0.5,1.2,0.7c0.1,0,0.2,0.1,0.2,0.1c0.3,0.1,0.6,0.2,1,0.3c0.3,0.1,0.7,0.1,1,0.1
		c0.4,0,0.8-0.1,1.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0.2,0,0.4-0.1,0.5-0.2c0.1,0,0.1,0,0.2-0.1
		c0.3-0.1,0.7-0.3,1-0.5c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1c0.2-0.1,0.4-0.3,0.6-0.5c1.7,0.4,3,2,3.1,3.8
		C32.8,32.7,32.8,32.8,32.8,32.9z"
            />
          </g>
          <circle fill={p4Tokens.colorBrandMenuForeground2} cx="26" cy="24.8" r="4.1" />
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                stroke={p4Tokens.colorBrandMenuForeground1}
                strokeMiterlimit="10"
                d="M27.9,40.1c-4,0-7.3,3.3-7.3,7.3c0,4,3.3,7.3,7.3,7.3
			s7.3-3.3,7.3-7.3C35.2,43.4,31.9,40.1,27.9,40.1z"
              />
            </g>
          </g>
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M25.2,51.8c-0.1,0-0.2,0-0.2-0.1l-1.1-1.1c-0.1-0.1-0.1-0.2-0.1-0.2c0-0.1,0-0.2,0.1-0.2l2.5-2.5l-2.5-2.5
	c-0.1-0.1-0.1-0.4,0-0.5l1.1-1.1c0.1-0.1,0.2-0.1,0.2-0.1c0.1,0,0.2,0,0.2,0.1l2.5,2.5l2.5-2.5c0.1-0.1,0.2-0.1,0.2-0.1
	c0.1,0,0.2,0,0.2,0.1l1.1,1.1c0.1,0.1,0.1,0.2,0.1,0.2c0,0.1,0,0.2-0.1,0.2l-2.5,2.5l2.5,2.5c0.1,0.1,0.1,0.4,0,0.5l-1.1,1.1
	c-0.1,0.1-0.2,0.1-0.2,0.1c-0.1,0-0.2,0-0.2-0.1l-2.5-2.5l-2.5,2.5C25.3,51.8,25.3,51.8,25.2,51.8L25.2,51.8z"
          />
        </g>
      );
    case 'bankreceipt':
      return (
        <g>
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                stroke={p4Tokens.colorBrandMenuForeground1}
                strokeMiterlimit="10"
                d="M27.1,3.1c-4,0-7.3,3.3-7.3,7.3c0,4,3.3,7.3,7.3,7.3
			s7.3-3.3,7.3-7.3C34.5,6.4,31.2,3.1,27.1,3.1z"
              />
            </g>
          </g>
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            d="M24.7,4.5c-0.5,0-0.9,0.4-0.9,0.8l0,0l0,0c0,0,0,0,0,0s0,0,0,0l0,5.3c0,0.2-0.2,0.4-0.4,0.4l-0.6,0
	c-0.3,0-0.5,0.3-0.4,0.5l2,4.6c0.1,0.3,0.6,0.3,0.8,0l2-4.6c0.1-0.2-0.1-0.5-0.4-0.5L26,11c-0.2,0-0.4-0.2-0.4-0.4l0-5.3l0,0
	C25.7,4.9,25.2,4.5,24.7,4.5z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            d="M29.5,16.3c0.5,0,0.9-0.4,0.9-0.8l0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0l0-5.3c0-0.2,0.2-0.4,0.4-0.4l0.6,0
	c0.3,0,0.5-0.3,0.4-0.5l-2-4.6c-0.1-0.3-0.6-0.3-0.8,0l-2,4.6c-0.1,0.2,0.1,0.5,0.4,0.5l0.7,0c0.2,0,0.4,0.2,0.4,0.4l0,5.3l0,0
	C28.6,16,29,16.3,29.5,16.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.2401"
            strokeMiterlimit="10"
            d="M38.2,45.5c0.1-1.2,0.1-2.3,0.2-3.4
	c0.2-4.5,0.5-9.1,0.7-13.6c0-0.3,0-0.6,0-0.8c0-0.5-0.3-0.9-0.8-1c-0.6-0.1-0.9-0.5-0.9-1c0-0.5,0.4-0.8,1-0.8c2.1,0,4.3,0,6.4,0
	c0.6,0,0.9,0.3,1,0.8c0,0.5-0.2,0.8-0.8,1c-0.5,0.1-0.9,0.5-0.8,1.1c0.2,2.9,0.3,5.8,0.5,8.7c0.1,2.6,0.3,5.2,0.4,7.7
	c0,0.4,0,0.8,0.1,1.3c0.3,0,0.7,0,1,0c1,0,1.7,0.6,1.7,1.6c0,0.9-0.7,1.6-1.7,1.6c-4.3,0-8.6,0-12.9,0c-7.7,0-15.4,0-23.1,0
	c-0.9,0-1.4-0.4-1.6-1.1c-0.3-1,0.4-2,1.4-2c0.4,0,0.8,0,1.2,0c0.1-0.8,0.1-1.6,0.1-2.3c0.2-3.1,0.3-6.2,0.5-9.3
	c0.1-2,0.2-4,0.3-5.9c0-0.8-0.2-1.2-0.9-1.3c-0.5-0.1-0.8-0.4-0.7-0.9c0-0.5,0.3-0.8,0.8-0.8c0.5,0,1,0,1.5,0c1.6,0,3.2,0,4.8,0
	c0.2,0,0.3,0,0.5,0c0.5,0,0.8,0.4,0.8,0.8c0,0.5-0.2,0.8-0.7,0.9c-0.7,0.2-1,0.5-0.9,1.3c0.2,3.7,0.4,7.4,0.6,11.2
	c0.1,2,0.2,4,0.3,5.9c0,0.4,0.1,0.5,0.5,0.5c1.9,0,3.8,0,5.7,0c0.4,0,0.5-0.1,0.5-0.5c0.3-5,0.5-10,0.8-15c0-0.7,0.1-1.5,0.1-2.2
	c0-0.7-0.2-1.1-0.9-1.2c-0.5-0.1-0.8-0.5-0.8-0.9c0-0.4,0.4-0.8,0.9-0.8c2.2,0,4.4,0,6.6,0c0.5,0,0.8,0.4,0.9,0.8
	c0,0.5-0.2,0.8-0.8,1c-0.7,0.1-1,0.5-0.9,1.2c0.2,4.2,0.5,8.4,0.7,12.6c0.1,1.5,0.2,2.9,0.2,4.4c0,0.4,0.1,0.6,0.5,0.6
	c1.8,0,3.7,0,5.5,0C37.8,45.5,38,45.5,38.2,45.5z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M28.2,50.3c6.9,0,13.9,0,20.8,0c1.1,0,1.9,0.3,1.6,0.6c-0.2,0.2-0.8,0.4-1.6,0.4c-2.8,0-5.6,0-8.4,0
	c-11,0-22.1,0-33.1,0c-1,0-1.7-0.2-1.7-0.5c0-0.3,0.6-0.5,1.6-0.5c2.2,0,4.3,0,6.5,0C18.6,50.3,23.4,50.3,28.2,50.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M28.1,52.3c7.2,0,14.4,0,21.7,0c1.2,0,1.9,0.4,1.7,0.9c-0.2,0.3-0.8,0.5-1.7,0.5c-2.9,0-5.9,0-8.8,0
	c-11.5,0-23,0-34.5,0c-1.1,0-1.7-0.3-1.8-0.7c0-0.5,0.6-0.8,1.7-0.8c2.3,0,4.5,0,6.8,0C18.2,52.3,23.2,52.3,28.1,52.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.116"
            strokeMiterlimit="10"
            d="M49.5,19.3c-0.1,0-0.1-0.1-0.2-0.1
	c-4.1-2.1-8.2-4.2-12.3-6.3c-1,4.5-5,7.9-9.9,7.9c-4.5,0-8.3-2.9-9.6-6.9c-0.1,0.1-0.3,0.1-0.4,0.2c-3.4,1.7-6.8,3.5-10.3,5.2
	c-0.7,0.4-0.9,0.8-0.5,1.5c0.2,0.4,0.4,0.8,0.6,1.2C7.3,22.7,7.9,23,8.7,23c6.5,0,13,0,19.5,0c1.5,0,3,0,4.5,0c5,0,10,0,15,0
	c0.8,0,1.4-0.3,1.7-1.1c0.2-0.4,0.4-0.8,0.6-1.1C50.3,20.1,50.2,19.6,49.5,19.3z"
          />
        </g>
      );
    case 'accrual':
      return (
        <g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              stroke="#FFFFFF"
              strokeWidth="0.1826"
              strokeMiterlimit="10"
              d="M17,13.1c-8.8,4.4-9.8,17.3-4.8,23.4
		c0.1-0.1,0.1-0.2,0.2-0.2c0.2-0.1,0.4-0.3,0.6-0.4c0.8-0.4,1.3-0.1,1.6,0.2c0.2,0.2,0.3,0.4,0.3,0.7c0.2,1.5,0.6,4.5-0.2,4.9
		c-1,0.5-3.5-0.7-5-1.4c-0.7-0.3-1.2-0.8-0.9-1.5c0.2-0.4,0.7-0.6,1.2-0.9c-0.5-1.2-1-1.8-1.6-3.2C5.8,29,6.7,24.1,9.5,19.2
		c1.1-2,2.8-3.8,5-5C15.3,13.8,16.1,13.5,17,13.1z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              stroke="#FFFFFF"
              strokeWidth="0.1826"
              strokeMiterlimit="10"
              d="M19.4,45.3c7.2,6.7,19.6,3.1,23.6-3.7
		c-0.1,0-0.2,0-0.3-0.1c-0.2-0.1-0.4-0.2-0.6-0.4c-0.7-0.6-0.6-1.2-0.3-1.5c0.1-0.2,0.3-0.4,0.5-0.5c1.3-0.7,4-2.1,4.7-1.5
		c0.9,0.8,0.6,3.5,0.5,5.1c-0.1,0.8-0.4,1.4-1.1,1.4c-0.4,0-0.8-0.5-1.3-0.8c-1,0.9-1.3,1.6-2.4,2.6c-4.5,4.3-9.4,5.1-15,4.2
		c-2.3-0.4-4.5-1.3-6.4-2.9C20.6,46.6,20,46,19.4,45.3z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              stroke="#FFFFFF"
              strokeWidth="0.1826"
              strokeMiterlimit="10"
              d="M48.7,28.5c1.9-9.7-7.8-18.2-15.7-18.1
		c0,0.1,0.1,0.2,0.1,0.3c0,0.2,0,0.5,0,0.7c-0.1,0.9-0.7,1.1-1.1,1.1c-0.3,0-0.5-0.1-0.7-0.2c-1.3-0.7-3.9-2.2-3.8-3.2
		c0.2-1.1,2.7-2.4,4.1-3.1c0.7-0.4,1.4-0.4,1.7,0.2c0.2,0.3,0,0.9,0,1.5c1.3,0.4,2,0.3,3.5,0.7c6,1.5,9.3,5.2,11.5,10.4
		c0.9,2.1,1.3,4.5,0.9,6.9C49.2,26.7,48.9,27.6,48.7,28.5z"
            />
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                stroke={p4Tokens.colorBrandMenuForeground2}
                strokeWidth="1.3"
                strokeMiterlimit="10"
                d="M29.6,16.8c-6.7,0-12.2,5.5-12.2,12.2
			c0,6.7,5.5,12.2,12.2,12.2s12.2-5.5,12.2-12.2C41.7,22.2,36.3,16.8,29.6,16.8z"
              />
            </g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground2}
                d="M23.7,36v-1.2c1.6-0.8,2.8-2.4,2.8-4.2c0-0.6,0-1.1-0.1-1.7h-2.5v-1.5h2.3c-0.1-0.7-0.3-1.7-0.3-2.6
			c0-2.9,2-4.7,4.6-4.7c1.3,0,2.1,0.3,2.6,0.6l-0.5,1.6c-0.4-0.2-1.2-0.5-2.2-0.5c-1.9,0-2.6,1.3-2.6,3c0,1,0.1,1.8,0.3,2.6h3.5v1.5
			h-3.3c0.1,0.9,0.1,1.8-0.1,2.7c-0.3,1-0.8,1.9-1.7,2.6v0h7.2V36H23.7z"
              />
            </g>
          </g>
        </g>
      );
    case 'journal':
      return (
        <g>
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M39.7,49.5h-23c-2.5,0-4.5-2-4.5-4.5V12.2
	c0-2.5,2-4.5,4.5-4.5h23c2.5,0,4.5,2,4.5,4.5V45C44.2,47.5,42.2,49.5,39.7,49.5z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M8.7,15v-0.2c0-0.7,0.6-1.3,1.3-1.3h3.3c0.7,0,1.3,0.6,1.3,1.3V15c0,0.7-0.6,1.3-1.3,1.3H10
	C9.2,16.3,8.7,15.7,8.7,15z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M8.7,23.6v-0.2c0-0.7,0.6-1.3,1.3-1.3h3.3c0.7,0,1.3,0.6,1.3,1.3v0.2c0,0.7-0.6,1.3-1.3,1.3H10
	C9.2,24.9,8.7,24.4,8.7,23.6z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M8.7,33.3v-0.2c0-0.7,0.6-1.3,1.3-1.3h3.3c0.7,0,1.3,0.6,1.3,1.3v0.2c0,0.7-0.6,1.3-1.3,1.3H10
	C9.2,34.6,8.7,34,8.7,33.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M8.7,41.9v-0.2c0-0.7,0.6-1.3,1.3-1.3h3.3c0.7,0,1.3,0.6,1.3,1.3v0.2c0,0.7-0.6,1.3-1.3,1.3H10
	C9.2,43.2,8.7,42.6,8.7,41.9z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M20.1,41.4h18.6c0.2,0,0.3,0.1,0.3,0.3v0.8c0,0.2-0.1,0.3-0.3,0.3H20.1c-0.2,0-0.3-0.1-0.3-0.3v-0.8
	C19.8,41.5,19.9,41.4,20.1,41.4z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M20.1,36.3h18.6c0.2,0,0.3,0.1,0.3,0.3v0.8c0,0.2-0.1,0.3-0.3,0.3H20.1c-0.2,0-0.3-0.1-0.3-0.3v-0.8
	C19.8,36.4,19.9,36.3,20.1,36.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M20.1,31.4h18.6c0.2,0,0.3,0.1,0.3,0.3v0.8c0,0.2-0.1,0.3-0.3,0.3H20.1c-0.2,0-0.3-0.1-0.3-0.3v-0.8
	C19.8,31.5,19.9,31.4,20.1,31.4z"
          />
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M29.4,12.4c-4.2,0-7.6,3.4-7.6,7.6c0,4.2,3.4,7.6,7.6,7.6S37,24.2,37,20C37,15.8,33.6,12.4,29.4,12.4z"
              />
            </g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                d="M26.3,24.7V24c1-0.5,1.7-1.5,1.7-2.6c0-0.4,0-0.7-0.1-1.1h-1.6v-1h1.4c-0.1-0.5-0.2-1-0.2-1.6
			c0-1.8,1.2-2.9,2.9-2.9c0.8,0,1.3,0.2,1.6,0.4l-0.3,1c-0.3-0.2-0.7-0.3-1.4-0.3c-1.2,0-1.6,0.8-1.6,1.9c0,0.7,0.1,1.1,0.2,1.6h2.2
			v1h-2.1c0,0.6,0.1,1.1-0.1,1.7c-0.2,0.6-0.5,1.2-1,1.6v0h4.5v1.1H26.3z"
              />
            </g>
          </g>
        </g>
      );
    case 'template':
      return (
        <g>
          <g>
            <path
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3071"
              strokeMiterlimit="10"
              d="M31.9,3.5h-25c-1.1,0-2.1,0.9-2.1,2.1v36.1
		c0,1.1,0.9,2.1,2.1,2.1h12.3L34,29.5V5.5C34,4.4,33.1,3.5,31.9,3.5z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M29.8,35H9.4c-0.2,0-0.3,0.1-0.3,0.3v0.7c0,0.2,0.1,0.3,0.3,0.3h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7
		C30.1,35.2,30,35,29.8,35z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M29.8,29H9.4c-0.2,0-0.3,0.1-0.3,0.3v0.7c0,0.2,0.1,0.3,0.3,0.3h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7
		C30.1,29.2,30,29,29.8,29z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M29.8,23H9.4c-0.2,0-0.3,0.1-0.3,0.3v0.7c0,0.2,0.1,0.3,0.3,0.3h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7
		C30.1,23.2,30,23,29.8,23z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M29.8,17H9.4c-0.2,0-0.3,0.1-0.3,0.3v0.7c0,0.2,0.1,0.3,0.3,0.3h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7
		C30.1,17.2,30,17,29.8,17z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M29.8,11H9.4c-0.2,0-0.3,0.1-0.3,0.3V12c0,0.2,0.1,0.3,0.3,0.3h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7
		C30.1,11.1,30,11,29.8,11z"
            />
          </g>
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3071"
            strokeMiterlimit="10"
            d="M39,8.6h-25c-1.1,0-2.1,0.9-2.1,2.1v36.1
	c0,1.1,0.9,2.1,2.1,2.1h12.3l14.8-14.2V10.7C41.1,9.6,40.1,8.6,39,8.6z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M36.8,40.2H16.4c-0.2,0-0.3,0.1-0.3,0.3v0.7c0,0.2,0.1,0.3,0.3,0.3h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7
	C37.2,40.4,37,40.2,36.8,40.2z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M36.8,34.2H16.4c-0.2,0-0.3,0.1-0.3,0.3v0.7c0,0.2,0.1,0.3,0.3,0.3h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7
	C37.2,34.4,37,34.2,36.8,34.2z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M36.8,28.2H16.4c-0.2,0-0.3,0.1-0.3,0.3v0.7c0,0.2,0.1,0.3,0.3,0.3h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7
	C37.2,28.3,37,28.2,36.8,28.2z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M36.8,22.2H16.4c-0.2,0-0.3,0.1-0.3,0.3v0.7c0,0.2,0.1,0.3,0.3,0.3h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7
	C37.2,22.3,37,22.2,36.8,22.2z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M36.8,16.2H16.4c-0.2,0-0.3,0.1-0.3,0.3v0.7c0,0.2,0.1,0.3,0.3,0.3h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7
	C37.2,16.3,37,16.2,36.8,16.2z"
          />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground1}
              strokeWidth="1.3071"
              strokeMiterlimit="10"
              d="M23.3,54h25c1.1,0,2.1-0.9,2.1-2.1V15.8
		c0-1.1-0.9-2.1-2.1-2.1H36L21.2,28v23.9C21.2,53,22.1,54,23.3,54z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              stroke={p4Tokens.colorBrandMenuForeground1}
              strokeMiterlimit="10"
              d="M23,27.8h11c1.1,0,2.1-0.9,2.1-2.1v-11L23,27.8z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M25.4,34.8h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H25.4c-0.2,0-0.3,0.1-0.3,0.3v0.7
		C25.1,34.6,25.2,34.8,25.4,34.8z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M25.4,40.8h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H25.4c-0.2,0-0.3,0.1-0.3,0.3v0.7
		C25.1,40.6,25.2,40.8,25.4,40.8z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M25.4,46.7h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H25.4c-0.2,0-0.3,0.1-0.3,0.3v0.7
		C25.1,46.6,25.2,46.7,25.4,46.7z"
            />
            <path fill={p4Tokens.colorBrandMenuBackground1} d="M23.5,26.9h9.9c1,0,1.9-0.8,1.9-1.8v-9.4L23.5,26.9z" />
          </g>
        </g>
      );
    case 'vatreturn':
      return (
        <g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3"
              strokeMiterlimit="10"
              d="M39.7,46.6H18.1c-1.8,0-3.2-1.4-3.2-3.2V14
		c0-1.8,1.4-3.2,3.2-3.2h21.6c1.8,0,3.2,1.4,3.2,3.2v29.4C42.9,45.1,41.5,46.6,39.7,46.6z"
            />
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M25.9,31.1l-6.7-6.7c-0.2-0.2-0.2-0.6,0-0.8l0.4-0.4c0.2-0.2,0.6-0.2,0.8,0l6.7,6.7c0.2,0.2,0.2,0.6,0,0.8
			l-0.4,0.4C26.5,31.3,26.1,31.3,25.9,31.1z"
              />
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M19.2,29.9l6.7-6.7c0.2-0.2,0.6-0.2,0.8,0l0.4,0.4c0.2,0.2,0.2,0.6,0,0.8l-6.7,6.7c-0.2,0.2-0.6,0.2-0.8,0
			l-0.4-0.4C19,30.5,19,30.1,19.2,29.9z"
              />
            </g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M23.8,35v3.7h3.6v1.7h-3.6v3.7H22v-3.7h-3.6v-1.7H22V35H23.8z"
              />
            </g>

            <line
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground1}
              strokeWidth="2.3423"
              strokeLinecap="round"
              strokeMiterlimit="10"
              x1="31.2"
              y1="26.1"
              x2="38.4"
              y2="26.1"
            />

            <line
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground1}
              strokeWidth="2.3423"
              strokeLinecap="round"
              strokeMiterlimit="10"
              x1="31.2"
              y1="30"
              x2="38.4"
              y2="30"
            />

            <line
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground1}
              strokeWidth="2.3423"
              strokeLinecap="round"
              strokeMiterlimit="10"
              x1="31.2"
              y1="39.6"
              x2="38.4"
              y2="39.6"
            />

            <line
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="5.8043"
              strokeLinecap="round"
              strokeMiterlimit="10"
              x1="20.9"
              y1="17.1"
              x2="37.2"
              y2="17.1"
            />
          </g>
        </g>
      );
    case 'bankfeedrule':
      return (
        <g>
          <circle fill={p4Tokens.colorBrandMenuForeground1} cx="41.2" cy="39.8" r="2.1" />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            d="M36,18l-2-3.6C33.7,14,33,14,32.6,14.2l-2.1,1.2l0,0c-0.9-0.9-2-1.8-3.2-2.5l0.6-2.3
	c0.1-0.5-0.2-1-0.7-1.2l-4-1.1c-0.5-0.1-1,0.2-1.2,0.7l-0.6,2.3l0,0c-1.3,0-2.5,0-3.9,0.5l-1.2-2.1c-0.3-0.5-0.9-0.6-1.4-0.4l-3.6,2
	c-0.5,0.3-0.4,0.8-0.1,1.2l1.2,2.1l0,0c-1.1,1-1.9,2-2.5,3.2l-2.4-0.6c-0.5-0.1-1,0.2-1.2,0.7l-1.1,4c-0.1,0.5,0.2,1,0.7,1.2
	l2.3,0.6l0,0c0,1.3,0,2.5,0.5,4L6.8,29c-0.5,0.3-0.5,0.7-0.3,1.2l2,3.6c0.3,0.5,0.7,0.6,1.1,0.3l2.1-1.2l0,0c1,1.1,2,1.9,3.2,2.5
	l-0.6,2.3c-0.1,0.5,0.2,1,0.7,1.2l4,1.1c0.5,0.1,1-0.2,1.2-0.7l0.6-2.3l0.1,0c1.3,0,2.6-0.1,4.1-0.6l1.2,2.1
	c0.3,0.5,0.6,0.7,1.1,0.4l3.6-2c0.5-0.3,0.7-0.8,0.4-1.3l-1.2-2.1l0,0c1.1-1,1.8-1.9,2.4-3.1l2.3,0.6c0.5,0.1,1-0.2,1.2-0.7l1.1-4
	c0.1-0.5-0.2-1-0.7-1.2L34,24.5l0,0c0-1.3-0.1-2.6-0.5-4l2.1-1.2C36,19,36.3,18.5,36,18z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.2"
            strokeMiterlimit="10"
            d="M48.4,32.7l-2-1.6c-0.3-0.2-0.7-0.1-0.9,0.2
	l-0.9,1.2l0,0c-0.7-0.3-1.6-0.6-2.4-0.7l-0.2-1.5c0-0.3-0.3-0.6-0.7-0.5l-2.6,0.3c-0.3,0-0.6,0.3-0.5,0.7l0.2,1.5l0,0
	c-0.8,0.3-1.4,0.6-2.2,1.2L35,32.6c-0.3-0.2-0.7-0.2-0.9,0.1l-1.6,2c-0.2,0.3-0.1,0.5,0.2,0.8l1.2,0.9l0,0c-0.4,0.9-0.6,1.6-0.7,2.5
	l-1.5,0.2c-0.3,0-0.6,0.3-0.5,0.7l0.3,2.6c0,0.3,0.3,0.6,0.7,0.5l1.5-0.2l0,0c0.3,0.8,0.6,1.5,1.2,2.2L34,46
	c-0.2,0.3-0.1,0.5,0.1,0.8l2,1.6c0.3,0.2,0.5,0.2,0.7-0.1l0.9-1.2l0,0c0.9,0.4,1.6,0.6,2.4,0.7l0.2,1.5c0,0.3,0.3,0.6,0.7,0.5
	l2.6-0.3c0.3,0,0.6-0.3,0.5-0.7l-0.2-1.5l0,0c0.8-0.3,1.5-0.7,2.2-1.3l1.2,0.9c0.3,0.2,0.5,0.3,0.7,0l1.6-2c0.2-0.3,0.2-0.6-0.1-0.8
	l-1.2-0.9l0,0c0.4-0.9,0.6-1.6,0.7-2.4l1.5-0.2c0.3,0,0.6-0.3,0.5-0.7l-0.3-2.6c0-0.3-0.3-0.6-0.7-0.5l-1.5,0.2l0,0
	c-0.3-0.8-0.6-1.5-1.3-2.2l0.9-1.2C48.6,33.3,48.6,32.9,48.4,32.7z M37,38.6c0.1-0.5,0.4-1,0.8-1.5c0.4-0.6,1-1,1.6-1.3
	c0.1,0,0.1-0.1,0.2-0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2-0.1c0.1,0,0.1,0,0.2-0.1c0,0,0.1,0,0.1,0c0.1,0,0.3-0.1,0.4-0.1
	c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0
	c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0.1c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.1,0.1,0.2,0.1
	c0.3,0.1,0.7,0.3,1,0.6c0.5,0.4,1,0.9,1.2,1.5c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0.1,0.2
	c0.1,0.2,0.1,0.3,0.1,0.5c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2
	c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.2c-0.1,0.7-0.4,1.3-0.8,1.9c-0.4,0.5-0.8,0.9-1.3,1.1c-0.1,0-0.1,0.1-0.2,0.1
	c-0.2,0.1-0.4,0.2-0.6,0.2c-0.1,0-0.1,0-0.2,0.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0.1c-1.2,0.2-2.4-0.1-3.4-0.9
	c-0.5-0.4-0.9-0.8-1.1-1.3c-0.1-0.2-0.2-0.4-0.3-0.7c0-0.1-0.1-0.2-0.1-0.2c-0.1-0.2-0.1-0.4-0.1-0.6c0-0.2,0-0.4,0-0.6
	c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.3,0.1-0.4c0,0,0-0.1,0-0.1C36.9,38.7,37,38.6,37,38.6z"
          />
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                stroke={p4Tokens.colorBrandMenuForeground1}
                strokeWidth="1.2"
                strokeMiterlimit="10"
                d="M21.2,15.3c-4.8,0-8.7,3.9-8.7,8.7
			c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C29.9,19.2,26,15.3,21.2,15.3z"
              />
            </g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M17.6,29.5v-0.9c1.2-0.6,2-1.7,2-3c0-0.4,0-0.8-0.1-1.2h-1.8v-1.1h1.6c-0.1-0.5-0.2-1.2-0.2-1.9
			c0-2.1,1.4-3.4,3.3-3.4c0.9,0,1.5,0.2,1.9,0.4L24,19.5c-0.3-0.2-0.8-0.3-1.6-0.3c-1.4,0-1.9,0.9-1.9,2.2c0,0.7,0.1,1.3,0.2,1.9
			h2.5v1.1h-2.4c0.1,0.7,0.1,1.3-0.1,1.9c-0.2,0.7-0.6,1.4-1.2,1.9v0h5.2v1.3H17.6z"
              />
            </g>
          </g>
        </g>
      );
    case 'supplierpayment':
      return (
        <g>
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M45.7,44.9H10c-3.2,0-5.8-2.6-5.8-5.7v-19c0-3.2,2.6-5.7,5.8-5.7h35.6c3.2,0,5.8,2.6,5.8,5.7v19
	C51.5,42.4,48.9,44.9,45.7,44.9z M10,16c-2.3,0-4.2,1.9-4.2,4.2v19c0,2.3,1.9,4.2,4.2,4.2h35.6c2.3,0,4.2-1.9,4.2-4.2v-19
	c0-2.3-1.9-4.2-4.2-4.2H10z"
          />
          <rect x="5.8" y="19.6" fill={p4Tokens.colorBrandMenuForeground1} width="44.1" height="5.1" />
          <line
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="2"
            strokeLinecap="round"
            x1="32.3"
            y1="35.8"
            x2="44.5"
            y2="35.8"
          />
          <line
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="2"
            strokeLinecap="round"
            x1="12"
            y1="30.1"
            x2="44.5"
            y2="30.1"
          />
          <circle fill={p4Tokens.colorBrandMenuForeground1} cx="12" cy="37.4" r="2.7" />
          <circle fill={p4Tokens.colorBrandMenuForeground1} cx="16" cy="37.4" r="2.7" />
        </g>
      );
    case 'supplierrefund':
      return (
        <g>
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3071"
            strokeMiterlimit="10"
            d="M12.5,45.2h25c1.1,0,2.1-0.9,2.1-2.1V7
	c0-1.1-0.9-2.1-2.1-2.1H25.3L10.5,19.2v23.9C10.5,44.2,11.4,45.2,12.5,45.2z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeMiterlimit="10"
            d="M12.2,18.9h11c1.1,0,2.1-0.9,2.1-2.1v-11L12.2,18.9z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M14.7,26h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H14.7c-0.2,0-0.3,0.1-0.3,0.3v0.7
	C14.3,25.8,14.5,26,14.7,26z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M14.7,31.9h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H14.7c-0.2,0-0.3,0.1-0.3,0.3v0.7
	C14.3,31.8,14.5,31.9,14.7,31.9z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M14.6,37.9h16.7c0.2,0,0.3-0.1,0.3-0.3v-0.8c0-0.2-0.1-0.3-0.3-0.3H14.6c-0.2,0-0.3,0.1-0.3,0.3v0.8
	C14.3,37.8,14.5,37.9,14.6,37.9z"
          />
          <path fill={p4Tokens.colorBrandMenuBackground1} d="M12.7,18.1h9.9c1,0,1.9-0.8,1.9-1.8V6.9L12.7,18.1z" />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M42.7,32.8c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C51.5,36.7,47.5,32.8,42.7,32.8z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M39.1,47v-0.9c1.2-0.6,2-1.7,2-3c0-0.4,0-0.8-0.1-1.2h-1.8v-1.1h1.6c-0.1-0.5-0.2-1.2-0.2-1.9
		c0-2.1,1.4-3.4,3.3-3.4c0.9,0,1.5,0.2,1.9,0.4L45.5,37c-0.3-0.2-0.8-0.3-1.6-0.3c-1.4,0-1.9,0.9-1.9,2.2c0,0.7,0.1,1.3,0.2,1.9h2.5
		v1.1h-2.4c0.1,0.7,0.1,1.3-0.1,1.9c-0.2,0.7-0.6,1.4-1.2,1.9v0h5.2V47H39.1z"
            />
          </g>
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                stroke={p4Tokens.colorBrandMenuForeground1}
                strokeMiterlimit="10"
                d="M26.8,40.4c-4,0-7.3,3.3-7.3,7.3c0,4,3.3,7.3,7.3,7.3
			s7.3-3.3,7.3-7.3C34.2,43.7,30.9,40.4,26.8,40.4z"
              />
            </g>
          </g>
          <rect x="21.8" y="46.8" fill={p4Tokens.colorBrandMenuForeground1} width="9.5" height="2.4" />
        </g>
      );
    case 'banktransfer':
      return (
        <g>
          <g>
            <g>
              <g>
                <path
                  fill={p4Tokens.colorBrandMenuBackground1}
                  stroke={p4Tokens.colorBrandMenuForeground2}
                  strokeWidth="1.2"
                  strokeMiterlimit="10"
                  d="M28.2,9.3c-4.8,0-8.7,3.9-8.7,8.7
				c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C36.9,13.2,33,9.3,28.2,9.3z"
                />
              </g>
              <g>
                <path
                  fill={p4Tokens.colorBrandMenuForeground2}
                  d="M24.5,23.4v-0.9c1.2-0.6,2-1.7,2-3c0-0.4,0-0.8-0.1-1.2h-1.8v-1.1h1.6c-0.1-0.5-0.2-1.2-0.2-1.9
				c0-2.1,1.4-3.4,3.3-3.4c0.9,0,1.5,0.2,1.9,0.4L31,13.5c-0.3-0.2-0.8-0.3-1.6-0.3c-1.4,0-1.9,0.9-1.9,2.2c0,0.7,0.1,1.3,0.2,1.9
				h2.5v1.1h-2.4c0.1,0.7,0.1,1.3-0.1,1.9c-0.2,0.7-0.6,1.4-1.2,1.9v0h5.2v1.3H24.5z"
                />
              </g>
            </g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M9.1,46.3c0,0.8,0.7,1.5,1.5,1.6v0h0c0,0,0,0,0,0c0,0,0,0,0,0h26.2c0.4,0,0.7,0.3,0.7,0.7v1
		c0,0.5,0.5,0.8,0.9,0.6l8.5-3.3c0.6-0.2,0.6-1.1,0-1.3l-8.5-3.3c-0.4-0.2-0.9,0.2-0.9,0.6V44c0,0.4-0.3,0.7-0.7,0.7H10.5v0
		C9.7,44.7,9.1,45.4,9.1,46.3z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M47.2,35.4c0-0.8-0.7-1.5-1.5-1.6v0h0c0,0,0,0,0,0c0,0,0,0,0,0H19.5c-0.4,0-0.7-0.3-0.7-0.7v-1
		c0-0.5-0.5-0.8-0.9-0.6l-8.5,3.3c-0.6,0.2-0.6,1.1,0,1.3l8.5,3.3c0.4,0.2,0.9-0.2,0.9-0.6v-1.2c0-0.4,0.3-0.7,0.7-0.7h26.3v0
		C46.6,37,47.2,36.3,47.2,35.4z"
            />
          </g>
        </g>
      );
    case 'quickinvoice':
      return (
        <g>
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3071"
            strokeMiterlimit="10"
            d="M13.2,44h25c1.1,0,2.1-0.9,2.1-2.1V5.9
	c0-1.1-0.9-2.1-2.1-2.1H25.9L11.1,18v23.9C11.1,43.1,12,44,13.2,44z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeMiterlimit="10"
            d="M12.8,17.8h11c1.1,0,2.1-0.9,2.1-2.1v-11L12.8,17.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M15.3,24.8h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H15.3c-0.2,0-0.3,0.1-0.3,0.3v0.7
	C15,24.7,15.1,24.8,15.3,24.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M15.3,30.8h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H15.3c-0.2,0-0.3,0.1-0.3,0.3v0.7
	C15,30.6,15.1,30.8,15.3,30.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M15.3,36.1H32c0.2,0,0.3-0.1,0.3-0.3V35c0-0.2-0.1-0.3-0.3-0.3H15.3c-0.2,0-0.3,0.1-0.3,0.3v0.8
	C15,36,15.1,36.1,15.3,36.1z"
          />
          <path fill={p4Tokens.colorBrandMenuBackground1} d="M13.3,16.9h9.9c1,0,1.9-0.8,1.9-1.8V5.8L13.3,16.9z" />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M43.4,32.3c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C52.1,36.3,48.2,32.3,43.4,32.3z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M39.7,46.5v-0.9c1.2-0.6,2-1.7,2-3c0-0.4,0-0.8-0.1-1.2h-1.8v-1.1h1.6c-0.1-0.5-0.2-1.2-0.2-1.9
		c0-2.1,1.4-3.4,3.3-3.4c0.9,0,1.5,0.2,1.9,0.4l-0.3,1.1c-0.3-0.2-0.8-0.3-1.6-0.3c-1.4,0-1.9,0.9-1.9,2.2c0,0.7,0.1,1.3,0.2,1.9
		h2.5v1.1h-2.4c0.1,0.7,0.1,1.3-0.1,1.9c-0.2,0.7-0.6,1.4-1.2,1.9v0H47v1.3H39.7z"
            />
          </g>
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground1}
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeMiterlimit="10"
            d="M18.9,46.6
	c-0.5,0.1-1.1,0.1-1.7,0.1h-3.9"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground1}
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeMiterlimit="10"
            d="M18.4,49
	c-0.5,0.1-1.1,0.1-1.7,0.1h-3.9"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground1}
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeMiterlimit="10"
            d="M19.4,51.8
	c-0.4,0.1-0.9,0.1-1.3,0.1H15"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M29,40v-1.2h1.8c0.3,0,0.6-0.2,0.6-0.6v-0.7c0-0.3-0.2-0.6-0.6-0.6h-4.9c-0.3,0-0.6,0.2-0.6,0.6v0.7
	c0,0.3,0.2,0.6,0.6,0.6h1.8V40c-3.7,0.3-6.7,3.5-6.7,7.3c0,4,3.3,7.3,7.3,7.3s7.3-3.3,7.3-7.3C35.7,43.5,32.8,40.3,29,40z"
          />
          <circle fill={p4Tokens.colorBrandMenuBackground1} cx="28.4" cy="47.3" r="6.2" />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M29.2,46.7l-0.8-4.1l-0.8,4.1c-0.6,0.3-1.1,0.9-1.1,1.7c0,1,0.8,1.9,1.9,1.9s1.9-0.8,1.9-1.9
	C30.3,47.6,29.8,47,29.2,46.7z"
          />
        </g>
      );
    case 'suppliertransactions':
      return (
        <g>
          <g>
            <path
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3071"
              strokeMiterlimit="10"
              d="M13.2,45.1h25c1.1,0,2.1-0.9,2.1-2.1V7
		c0-1.1-0.9-2.1-2.1-2.1H25.9L11.1,19.1V43C11.1,44.2,12,45.1,13.2,45.1z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeMiterlimit="10"
              d="M12.9,18.9h11c1.1,0,2.1-0.9,2.1-2.1v-11L12.9,18.9z"
            />
            <path fill={p4Tokens.colorBrandMenuBackground1} d="M13.4,18h9.9c1,0,1.9-0.8,1.9-1.8V6.9L13.4,18z" />
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M43.4,32.7c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C52.1,36.6,48.2,32.7,43.4,32.7z
			"
              />
            </g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                d="M39.8,46.9V46c1.2-0.6,2-1.7,2-3c0-0.4,0-0.8-0.1-1.2h-1.8v-1.1h1.6c-0.1-0.5-0.2-1.2-0.2-1.9
			c0-2.1,1.4-3.4,3.3-3.4c0.9,0,1.5,0.2,1.9,0.4L46.2,37c-0.3-0.2-0.8-0.3-1.6-0.3c-1.4,0-1.9,0.9-1.9,2.2c0,0.7,0.1,1.3,0.2,1.9
			h2.5v1.1h-2.4c0.1,0.7,0.1,1.3-0.1,1.9c-0.2,0.7-0.6,1.4-1.2,1.9v0H47v1.3H39.8z"
              />
            </g>
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M17.1,31c0,0.4,0.3,0.8,0.7,0.8v0h0c0,0,0,0,0,0s0,0,0,0h13c0.2,0,0.3,0.2,0.3,0.3v0.5
		c0,0.2,0.2,0.4,0.4,0.3l4.2-1.7c0.3-0.1,0.3-0.5,0-0.6l-4.2-1.7c-0.2-0.1-0.4,0.1-0.4,0.3v0.6c0,0.2-0.1,0.3-0.3,0.3H17.8v0
		C17.4,30.2,17.1,30.5,17.1,31z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M36.1,24.5c0-0.4-0.3-0.8-0.7-0.8v0h0c0,0,0,0,0,0c0,0,0,0,0,0h-13c-0.2,0-0.3-0.2-0.3-0.3v-0.5
		c0-0.2-0.2-0.4-0.4-0.3l-4.2,1.7c-0.3,0.1-0.3,0.5,0,0.6l4.2,1.7c0.2,0.1,0.4-0.1,0.4-0.3v-0.6c0-0.2,0.1-0.3,0.3-0.3h13.1v0
		C35.8,25.3,36.1,25,36.1,24.5z"
            />
            <g>
              <circle fill={p4Tokens.colorBrandMenuForeground1} cx="25.5" cy="45" r="8.2" />
              <circle fill={p4Tokens.colorBrandMenuBackground1} cx="25.5" cy="45" r="6.5" />
              <polygon fill={p4Tokens.colorBrandMenuForeground1} points="26.2,45 29.7,41.6 25.6,44.3 		" />
              <polygon fill={p4Tokens.colorBrandMenuForeground1} points="24.7,45.2 22.5,43.3 25.2,44.4 		" />
              <rect x="25.4" y="38.5" fill={p4Tokens.colorBrandMenuForeground1} width="0.3" height="0.7" />

              <rect
                x="28.5"
                y="39.3"
                transform="matrix(0.8656 0.5007 -0.5007 0.8656 23.6207 -8.9833)"
                fill={p4Tokens.colorBrandMenuForeground1}
                width="0.1"
                height="0.5"
              />

              <rect
                x="19.9"
                y="41.7"
                transform="matrix(0.5074 -0.8617 0.8617 0.5074 -26.2518 37.8478)"
                fill={p4Tokens.colorBrandMenuForeground1}
                width="0.1"
                height="0.5"
              />

              <rect
                x="22.2"
                y="39.3"
                transform="matrix(0.8707 -0.4918 0.4918 0.8707 -16.5777 16.0748)"
                fill={p4Tokens.colorBrandMenuForeground1}
                width="0.1"
                height="0.5"
              />

              <rect
                x="19.1"
                y="44.7"
                transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 64.2741 25.7537)"
                fill={p4Tokens.colorBrandMenuForeground1}
                width="0.3"
                height="0.7"
              />
              <circle fill={p4Tokens.colorBrandMenuForeground1} cx="25.5" cy="45" r="0.8" />
              <circle
                fill={p4Tokens.colorBrandMenuForeground1}
                stroke={p4Tokens.colorBrandMenuForeground1}
                strokeMiterlimit="10"
                cx="25.5"
                cy="45"
                r="0.5"
              />
            </g>
          </g>
        </g>
      );
    case 'companyaudit':
      return (
        <g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M33.5,41.5c-2.4,0-4.8-0.8-6.9-2.4c-1-0.7-1.8-1.5-2.6-2.4c-0.1-0.1-0.1-0.2,0-0.4c1.5-1.8,3.4-3.2,5.6-4.1
		c2.4-0.9,4.8-1,7.2-0.3c2,0.5,3.7,1.5,5.2,2.9c0.5,0.5,1,1,1.5,1.5c0.1,0.1,0.1,0.3,0,0.4c-1.4,1.6-3.1,3-5.1,3.8
		C36.9,41.1,35.3,41.5,33.5,41.5z M34.4,40.2c3-0.2,5.5-1.5,7.5-3.7c-2.1-2.1-4.6-3.5-7.6-3.7c2.1,0.5,3.1,2.2,3.1,3.7
		C37.4,38.2,36.3,39.7,34.4,40.2z M33,40.2c-0.8-0.2-1.5-0.6-2.1-1.3c-0.6-0.7-0.9-1.4-0.9-2.3c0-2,1.1-3.2,2.9-3.8
		c-3,0.3-5.4,1.6-7.5,3.7C27.5,38.6,30,40,33,40.2z M35.4,36.5c0-0.9-0.7-1.7-1.7-1.7c-0.9,0-1.7,0.7-1.7,1.7c0,0.9,0.7,1.7,1.7,1.7
		C34.6,38.2,35.4,37.5,35.4,36.5z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.1049"
              strokeMiterlimit="10"
              d="M52.6,51l-7.1-6.8l-3.2,3.3l7.1,6.8
		c0.9,0.9,2.4,0.9,3.3-0.1C53.5,53.4,53.5,51.9,52.6,51z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M25.2,15.3h-9.1c-0.3,0-0.6-0.2-0.6-0.4v-0.4c0-0.2,0.3-0.4,0.6-0.4h9.1c0.3,0,0.6,0.2,0.6,0.4v0.4
		C25.7,15.1,25.5,15.3,25.2,15.3z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M25.2,20.2h-9.1c-0.3,0-0.6-0.2-0.6-0.4v-0.4c0-0.2,0.3-0.4,0.6-0.4h9.1c0.3,0,0.6,0.2,0.6,0.4v0.4
		C25.7,20.1,25.5,20.2,25.2,20.2z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M25.2,24.7h-9.1c-0.3,0-0.6-0.2-0.6-0.4v-0.4c0-0.2,0.3-0.4,0.6-0.4h9.1c0.3,0,0.6,0.2,0.6,0.4v0.4
		C25.7,24.5,25.5,24.7,25.2,24.7z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M22.9,30.1h-7c-0.2,0-0.4-0.2-0.4-0.4v-0.4c0-0.2,0.2-0.4,0.4-0.4h7c0.2,0,0.4,0.2,0.4,0.4v0.4
		C23.3,29.9,23.1,30.1,22.9,30.1z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M14.4,13.7L12.3,16c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2,0-0.3-0.1l-1.3-1c-0.2-0.2-0.3-0.5-0.1-0.7
		c0.2-0.2,0.5-0.3,0.7-0.1l0.9,0.7l1.8-2c0.2-0.2,0.5-0.2,0.7,0C14.6,13.1,14.6,13.4,14.4,13.7z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M14.4,18.7l-2.1,2.4c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2,0-0.3-0.1l-1.3-1c-0.2-0.2-0.3-0.5-0.1-0.7
		c0.2-0.2,0.5-0.3,0.7-0.1l0.9,0.7l1.8-2c0.2-0.2,0.5-0.2,0.7,0C14.6,18.2,14.6,18.5,14.4,18.7z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M14.4,23.5l-2.1,2.4c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2,0-0.3-0.1l-1.3-1c-0.2-0.2-0.3-0.5-0.1-0.7
		c0.2-0.2,0.5-0.3,0.7-0.1l0.9,0.7l1.8-2c0.2-0.2,0.5-0.2,0.7,0C14.6,23,14.6,23.3,14.4,23.5z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M14.4,28.4l-2.1,2.4c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2,0-0.3-0.1l-1.3-1c-0.2-0.2-0.3-0.5-0.1-0.7
		c0.2-0.2,0.5-0.3,0.7-0.1l0.9,0.7l1.8-2c0.2-0.2,0.5-0.2,0.7,0C14.6,27.9,14.6,28.2,14.4,28.4z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M29.4,2.8H5.8C5,2.8,3.9,3.9,3.9,5.4v30.6c0,1.4,1.1,2.5,2.5,2.5h16c-0.4-1-0.4-1.5-0.5-2.7H6.6l0-27.3H30
		l0,16.4c0.9-0.2,0.9-0.3,1.9-0.4c0.2,0,0.4,0,0.6,0V5.4C32.6,3.9,31.4,2.8,29.4,2.8z M21.8,5.6c0,0.2-0.2,0.3-0.4,0.3h-6.6
		c-0.2,0-0.4-0.1-0.4-0.3V5.3c0-0.2,0.2-0.3,0.4-0.3h6.6c0.2,0,0.4,0.1,0.4,0.3V5.6z"
            />
            <g>
              <g>
                <path
                  fill={p4Tokens.colorBrandMenuForeground2}
                  d="M25.8,28.5C21.5,33,21.6,40.1,26,44.4c3.8,3.7,9.6,4.1,13.9,1.4l1.5,1.5l3.8-3.9l-1.6-1.5
				c2.4-4.3,1.7-9.9-2-13.5C37.2,23.9,30.1,24.1,25.8,28.5z M40.6,29.3c3.9,3.7,4,9.9,0.2,13.8c-3.7,3.9-9.9,4-13.8,0.2
				c-3.9-3.7-4-9.9-0.2-13.8C30.6,25.7,36.7,25.6,40.6,29.3z"
                />
              </g>
            </g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M40.3,45.3c0,0,0.9-0.8,1.5-1.4c0.6-0.6,1.3-1.7,1.3-1.7l1.1,1.1l-2.9,2.9L40.3,45.3z"
            />
          </g>
        </g>
      );
    case 'companydocs':
      return (
        <g>
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M39.3,18.4H16.7c-0.7,0-1.2-0.5-1.2-1.2V8.4
	c0-0.7,0.5-1.2,1.2-1.2h22.7c0.7,0,1.2,0.5,1.2,1.2v8.8C40.6,17.8,40,18.4,39.3,18.4z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M46.6,40.8H9.7c-1.2,0-2.3-1-2.3-2.3V19.8
	c0-1.2,1-2.3,2.3-2.3h36.8c1.2,0,2.3,1,2.3,2.3v18.8C48.8,39.8,47.8,40.8,46.6,40.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M14.2,23.5c0,0.8-0.6,1.5-1.4,1.5c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.4,1.4-1.5
	C13.5,22,14.2,22.7,14.2,23.5z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M28.1,38.3c2,0,4,0,6,0c0.6,0,1,0.3,1,0.8c0,0.5-0.3,0.8-0.7,0.9c-0.2,0-0.3,0-0.5,0c-4,0-7.9,0-11.9,0
	c-0.7,0-1.2-0.5-1-1.1c0.1-0.3,0.4-0.5,0.7-0.6c0.1,0,0.2,0,0.3,0C24,38.3,26.1,38.3,28.1,38.3C28.1,38.3,28.1,38.3,28.1,38.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M28.1,35.1c-2.1,0-4.1,0-6.2,0c-0.4,0-0.7-0.2-0.8-0.6c-0.1-0.3-0.1-0.7,0.2-0.9c0.2-0.1,0.5-0.2,0.7-0.2
	c2.3,0,4.5,0,6.8,0c1.8,0,3.6,0,5.5,0c0.5,0,0.9,0.3,0.9,0.8c0,0.6-0.3,0.9-0.9,0.9C32.2,35.1,30.1,35.1,28.1,35.1z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M28.1,43.3c2,0,4.1,0,6.1,0c0.5,0,0.9,0.3,0.9,0.8c0,0.5-0.3,0.9-0.9,0.9c-0.9,0-1.8,0-2.7,0
	c-3.2,0-6.4,0-9.6,0c-0.7,0-1.1-0.6-0.9-1.2c0.1-0.3,0.4-0.5,0.9-0.5c1.8,0,3.6,0,5.4,0C27.6,43.3,27.8,43.3,28.1,43.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground1}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M39,50.3H17.6c-0.9,0-1.7-0.8-1.7-1.7V30.4
	c0-0.9,0.8-1.7,1.7-1.7H39c0.9,0,1.7,0.8,1.7,1.7v18.3C40.6,49.5,39.9,50.3,39,50.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M34.4,35H21.8c-0.4,0-0.8-0.3-0.8-0.8v0c0-0.4,0.3-0.8,0.8-0.8h12.6c0.4,0,0.8,0.3,0.8,0.8v0
	C35.2,34.7,34.9,35,34.4,35z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M34.4,40H21.8c-0.4,0-0.8-0.3-0.8-0.8v0c0-0.4,0.3-0.8,0.8-0.8h12.6c0.4,0,0.8,0.3,0.8,0.8v0
	C35.2,39.7,34.9,40,34.4,40z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M34.4,44.9H21.8c-0.4,0-0.8-0.3-0.8-0.8l0,0c0-0.4,0.3-0.8,0.8-0.8h12.6c0.4,0,0.8,0.3,0.8,0.8l0,0
	C35.2,44.6,34.9,44.9,34.4,44.9z"
          />
        </g>
      );
    case 'stockval':
      return (
        <g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.2"
              strokeMiterlimit="10"
              d="M25.5,8.9c-4.8,0-8.7,3.9-8.7,8.7
		c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C34.2,12.8,30.3,8.9,25.5,8.9z"
            />
          </g>
          <polyline
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground1}
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeMiterlimit="10"
            points="5.1,38.8
	14.6,27.7 25.2,47.4 35.3,30.3 50.6,20.5 "
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M50.1,25.6l2.6-5.6c0.3-0.8-0.3-1.6-1.1-1.5L45.4,19c-0.8,0.1-1.3,1-0.8,1.7l3.6,5
	C48.7,26.4,49.7,26.3,50.1,25.6z"
          />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M22.1,23v-0.8c1.1-0.5,1.8-1.6,1.8-2.8c0-0.4,0-0.7-0.1-1.1h-1.7v-1h1.5c-0.1-0.5-0.2-1.1-0.2-1.7
		c0-1.9,1.3-3.1,3.1-3.1c0.8,0,1.4,0.2,1.8,0.4l-0.3,1.1c-0.3-0.2-0.8-0.3-1.5-0.3c-1.3,0-1.8,0.9-1.8,2c0,0.7,0.1,1.2,0.2,1.7h2.3
		v1h-2.2c0,0.6,0.1,1.2-0.1,1.8c-0.2,0.7-0.6,1.3-1.1,1.7v0h4.8V23H22.1z"
            />
          </g>
        </g>
      );
    case 'customertransenq':
      return (
        <g>
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M47.1,43.5l-9.2-8.8l-4.2,4.3l9.2,8.8
	c1.2,1.1,3.1,1.1,4.3-0.1C48.3,46.5,48.3,44.6,47.1,43.5z"
          />
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground2}
                d="M12.3,14.3c-5.6,5.8-5.4,14.9,0.4,20.5c4.9,4.8,12.4,5.3,17.9,1.8l2,1.9l4.9-5.1l-2.1-2
			c3.1-5.6,2.2-12.8-2.6-17.5C27.1,8.4,17.9,8.6,12.3,14.3z M31.7,15.1c5.1,5,5.3,13.2,0.3,18.3c-5,5.1-13.2,5.3-18.3,0.3
			c-5.1-5-5.3-13.2-0.3-18.3C18.4,10.3,26.6,10.1,31.7,15.1z"
              />
            </g>
          </g>
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            d="M31.1,35.9c0,0,1.2-1.1,2-1.9c0.8-0.8,1.7-2.2,1.7-2.2l1.5,1.5l-3.8,3.9L31.1,35.9z"
          />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              stroke={p4Tokens.colorBrandMenuForeground1}
              strokeWidth="0.8563"
              strokeMiterlimit="10"
              d="M21.3,28.8v-1.4c0-1.7,0.4-2.1,1.7-3.3
		c1-1,2.1-1.9,2.1-3.3c0-1.4-1.1-2.5-2.5-2.5c-1.5,0-2.5,1.1-2.7,2.6l-2.4-0.2c0.4-2.7,2.4-4.4,5.2-4.4c2.6,0,4.7,1.6,4.7,4.4
		c0,1.2-0.4,2.1-1,2.8c0,0,0,0-1.4,1.5c0,0,0,0-0.2,0.2c-1,0.9-1.2,1.2-1.2,2.5v1H21.3z M22.4,30.5c0.8,0,1.6,0.7,1.6,1.6
		s-0.7,1.6-1.6,1.6c-0.8,0-1.6-0.7-1.6-1.6S21.6,30.5,22.4,30.5z"
            />
          </g>
        </g>
      );
    case 'customervatonly':
      return (
        <g>
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3071"
            strokeMiterlimit="10"
            d="M13.2,45.1h25c1.1,0,2.1-0.9,2.1-2.1V7
	c0-1.1-0.9-2.1-2.1-2.1H25.9L11.1,19.1V43C11.1,44.2,12,45.1,13.2,45.1z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeMiterlimit="10"
            d="M12.9,18.9h11c1.1,0,2.1-0.9,2.1-2.1v-11L12.9,18.9z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M15.3,25.9h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H15.3c-0.2,0-0.3,0.1-0.3,0.3v0.7
	C15,25.8,15.1,25.9,15.3,25.9z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M15.3,31.9h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H15.3c-0.2,0-0.3,0.1-0.3,0.3v0.7
	C15,31.7,15.1,31.9,15.3,31.9z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M15.3,37.9H32c0.2,0,0.3-0.1,0.3-0.3v-0.8c0-0.2-0.1-0.3-0.3-0.3H15.3c-0.2,0-0.3,0.1-0.3,0.3v0.8
	C15,37.7,15.1,37.9,15.3,37.9z"
          />
          <path fill={p4Tokens.colorBrandMenuBackground1} d="M13.4,18h9.9c1,0,1.9-0.8,1.9-1.8V6.9L13.4,18z" />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M43.4,32.7c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C52.1,36.6,48.2,32.7,43.4,32.7z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M40.4,37c1.4,0,2.4,1,2.4,2.5c0,1.5-1,2.5-2.4,2.5c-1.4,0-2.4-1-2.4-2.5C38,37.9,39,37,40.4,37z M40.4,41.1
		c0.6,0,0.8-0.5,0.8-1.7c0-1.1-0.2-1.7-0.8-1.7s-0.8,0.5-0.8,1.7C39.6,40.5,39.8,41.1,40.4,41.1z M45.6,37h1.1l-5.5,8.9H40L45.6,37z
		 M46.3,41c1.4,0,2.4,1,2.4,2.5c0,1.5-1,2.5-2.4,2.5c-1.4,0-2.4-1-2.4-2.5C43.9,42,44.9,41,46.3,41z M46.3,45.1
		c0.6,0,0.8-0.5,0.8-1.7c0-1.1-0.2-1.7-0.8-1.7c-0.6,0-0.8,0.5-0.8,1.7C45.5,44.6,45.7,45.1,46.3,45.1z"
            />
          </g>
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                stroke={p4Tokens.colorBrandMenuForeground1}
                strokeMiterlimit="10"
                d="M27.8,40.1c-4,0-7.3,3.3-7.3,7.3c0,4,3.3,7.3,7.3,7.3
			s7.3-3.3,7.3-7.3C35.2,43.4,31.9,40.1,27.8,40.1z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M24.6,52v-0.7c1-0.5,1.6-1.4,1.6-2.5c0-0.3,0-0.6-0.1-1h-1.5v-0.9h1.3c-0.1-0.4-0.2-1-0.2-1.5
			c0-1.7,1.2-2.8,2.7-2.8c0.7,0,1.3,0.2,1.6,0.4l-0.3,0.9c-0.3-0.1-0.7-0.3-1.3-0.3c-1.1,0-1.6,0.8-1.6,1.8c0,0.6,0.1,1.1,0.2,1.5
			h2.1v0.9h-1.9c0,0.5,0.1,1.1-0.1,1.6c-0.2,0.6-0.5,1.1-1,1.5v0h4.3v1H24.6z"
              />
            </g>
          </g>
        </g>
      );
    case 'customersales':
      return (
        <g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M36.3,14.9c0,0-0.1-0.1-0.1-0.1c-0.3-0.4-0.8-0.4-1.2-0.2c-0.6,0.4-1.3,0.9-1.9,1.3c-3,2-16,6.7-19.5,7.4
		c-1.1,0.2-1.9-0.2-2.1-1.1c-0.2-0.8,0.4-1.5,1.4-1.8c3.8-0.8,16.9-5.9,20.1-8.1c0.4-0.3,0.5-0.9,0.2-1.4c0,0,0,0,0,0
		c-0.4-0.6-0.1-1.4,0.6-1.5C35.4,9.3,37,9,38.6,8.7c0.7-0.1,1.3,0.6,1,1.2c-0.6,1.5-1.1,3.1-1.7,4.6C37.7,15.3,36.8,15.4,36.3,14.9z
		"
            />
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.346"
              strokeMiterlimit="10"
              d="M47.7,31.6c0,3.6,0,7.3,0,10.9
		c0,2.5-0.9,3.4-3.4,3.5c-0.5,0-1.1,0-1.6,0c-1.7-0.1-2.7-1-2.8-2.8c0-7.7,0-15.4,0-23.1c0-1.7,1-2.7,2.8-2.8c0.6,0,1.3,0,2,0
		c2.1,0.1,3.1,1,3.1,3.1C47.8,24.1,47.7,27.8,47.7,31.6z"
            />
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.346"
              strokeMiterlimit="10"
              d="M37.3,34.3c0,2.8,0,5.6,0,8.5
		c0,2.2-1,3.2-3.2,3.2c-0.7,0-1.3,0-2,0c-1.6-0.1-2.7-1.1-2.7-2.7c0-6,0-12.1,0-18.1c0-1.6,1-2.6,2.7-2.7c0.7,0,1.4,0,2.1,0
		c2,0.1,3,1,3,3C37.3,28.4,37.3,31.4,37.3,34.3z"
            />
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.346"
              strokeMiterlimit="10"
              d="M19,36.7c0-2,0-4,0-6c0-2,1-3,3-3
		c0.7,0,1.4,0,2.1,0c1.6,0.1,2.7,1,2.7,2.7c0.1,4.3,0.1,8.6,0,12.9c0,1.7-1,2.6-2.7,2.7c-0.8,0.1-1.5,0-2.3,0
		c-1.8-0.1-2.8-1-2.9-2.9C19,41,19,38.9,19,36.7z"
            />
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.346"
              strokeMiterlimit="10"
              d="M8.6,39.3c0-1.2,0-2.4,0-3.6
		c0.1-1.8,1-2.8,2.9-2.8c0.7,0,1.4,0,2.1,0c1.8,0.1,2.8,1,2.8,2.7c0.1,2.5,0.1,5.1,0,7.6c0,1.6-1,2.6-2.7,2.7
		c-0.8,0.1-1.6,0.1-2.4,0c-1.6-0.1-2.6-1.1-2.7-2.7C8.5,41.9,8.6,40.6,8.6,39.3z"
            />
          </g>
        </g>
      );
    case 'customercontrol':
      return (
        <g>
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M14.8,55.7L14.8,55.7c-0.6,0-1.1-0.5-1.1-1.1V1.7c0-0.6,0.5-1.1,1.1-1.1h0c0.6,0,1.1,0.5,1.1,1.1v52.9
	C15.9,55.2,15.4,55.7,14.8,55.7z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M28.1,55.7L28.1,55.7c-0.6,0-1.1-0.5-1.1-1.1V1.7c0-0.6,0.5-1.1,1.1-1.1h0c0.6,0,1.1,0.5,1.1,1.1v52.9
	C29.2,55.2,28.7,55.7,28.1,55.7z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M41.3,55.7L41.3,55.7c-0.6,0-1.1-0.5-1.1-1.1V1.7c0-0.6,0.5-1.1,1.1-1.1l0,0c0.6,0,1.1,0.5,1.1,1.1v52.9
	C42.4,55.2,41.9,55.7,41.3,55.7z"
          />
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                stroke={p4Tokens.colorBrandMenuForeground1}
                strokeWidth="1.2"
                strokeMiterlimit="10"
                d="M28.4,7.8c-4.8,0-8.7,3.9-8.7,8.7
			c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C37.1,11.7,33.2,7.8,28.4,7.8z"
              />
            </g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M24.8,22v-0.9c1.2-0.6,2-1.7,2-3c0-0.4,0-0.8-0.1-1.2h-1.8v-1.1h1.6c-0.1-0.5-0.2-1.2-0.2-1.9
			c0-2.1,1.4-3.4,3.3-3.4c0.9,0,1.5,0.2,1.9,0.4l-0.3,1.1c-0.3-0.2-0.8-0.3-1.6-0.3c-1.4,0-1.9,0.9-1.9,2.2c0,0.7,0.1,1.3,0.2,1.9
			h2.5v1.1h-2.4c0.1,0.7,0.1,1.3-0.1,1.9c-0.2,0.7-0.6,1.4-1.2,1.9v0H32V22H24.8z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                stroke={p4Tokens.colorBrandMenuForeground1}
                strokeWidth="1.2"
                strokeMiterlimit="10"
                d="M15,29.1c-4.8,0-8.7,3.9-8.7,8.7
			c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C23.7,33.1,19.8,29.1,15,29.1z"
              />
            </g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M11.3,43.3v-0.9c1.2-0.6,2-1.7,2-3c0-0.4,0-0.8-0.1-1.2h-1.8v-1.1h1.6c-0.1-0.5-0.2-1.2-0.2-1.9
			c0-2.1,1.4-3.4,3.3-3.4c0.9,0,1.5,0.2,1.9,0.4l-0.3,1.1c-0.3-0.2-0.8-0.3-1.6-0.3c-1.4,0-1.9,0.9-1.9,2.2c0,0.7,0.1,1.3,0.2,1.9
			H17v1.1h-2.4c0.1,0.7,0.1,1.3-0.1,1.9c-0.2,0.7-0.6,1.4-1.2,1.9v0h5.2v1.3H11.3z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                stroke={p4Tokens.colorBrandMenuForeground1}
                strokeWidth="1.2"
                strokeMiterlimit="10"
                d="M41.3,34.1c-4.8,0-8.7,3.9-8.7,8.7
			c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C50.1,38,46.2,34.1,41.3,34.1z"
              />
            </g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M37.7,48.3v-0.9c1.2-0.6,2-1.7,2-3c0-0.4,0-0.8-0.1-1.2h-1.8v-1.1h1.6c-0.1-0.5-0.2-1.2-0.2-1.9
			c0-2.1,1.4-3.4,3.3-3.4c0.9,0,1.5,0.2,1.9,0.4l-0.3,1.1c-0.3-0.2-0.8-0.3-1.6-0.3c-1.4,0-1.9,0.9-1.9,2.2c0,0.7,0.1,1.3,0.2,1.9
			h2.5v1.1H41c0.1,0.7,0.1,1.3-0.1,1.9c-0.2,0.7-0.6,1.4-1.2,1.9v0H45v1.3H37.7z"
              />
            </g>
          </g>
        </g>
      );
    case 'bankrec':
      return (
        <g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M16.9,13.2c0.5,1.5,1,2.9,1.5,4.3c1.7,4.6,3.4,9.3,5.1,13.9c0.1,0.3,0.5,0.6,0.7,0.9
		c0.2,0.3,0.3,0.7,0.3,1.1c-0.7,2.9-2.7,4.5-5.3,5.4c-3.8,1.2-8.1,0-10.2-3c-0.5-0.7-0.7-1.4-1-2.2c-0.2-0.6-0.3-1.1,0.5-1.4
		c0.2-0.1,0.3-0.3,0.3-0.5c2.2-6.1,4.4-12.2,6.7-18.4c-0.3-0.1-0.5-0.1-0.7-0.2c-0.9-0.2-1.3-0.7-1.2-1.5c0.1-0.8,0.7-1.2,1.4-1.2
		c1.5,0,3,0,4.5,0c1.5,0,3,0,4.4,0c0.6,0,0.9-0.1,1.2-0.7c0.7-1.4,2-2.2,3.6-2.2c1.7,0,2.9,0.7,3.7,2.2c0.3,0.5,0.6,0.6,1.1,0.6
		c3,0,5.9,0,8.9,0c0.5,0,1.1,0.4,1.5,0.8c0.2,0.2,0.2,1-0.1,1.3c-0.4,0.4-1,0.6-1.7,0.9c0.6,1.8,1.3,3.7,2,5.6
		c1.5,4.1,3,8.2,4.5,12.3c0.1,0.3,0.5,0.6,0.7,0.9c0.2,0.4,0.4,0.8,0.3,1.2c-0.5,2.2-2,3.7-4,4.7c-3.8,1.9-8.8,1-11.3-2.1
		c-0.5-0.6-0.8-1.3-1.1-2c-0.3-0.7-0.7-1.6,0.5-2c0.1,0,0.2-0.3,0.2-0.5c2.1-5.9,4.3-11.8,6.4-17.8c0.1-0.2,0.1-0.4,0.1-0.6
		c-2.5,0-4.9,0-7.3,0c-0.2,0-0.5,0.3-0.6,0.5c-1.9,3.1-5.6,3.1-7.5,0c-0.1-0.2-0.4-0.5-0.6-0.5C21.9,13.2,19.5,13.2,16.9,13.2z
		 M35.1,32.2c4.1,0,8.1,0,12.2,0c-2-5.8-4-11.5-6.1-17.5C39.1,20.6,37.1,26.3,35.1,32.2z M16.3,15c-0.1,0-0.1,0-0.2,0
		c-2,5.7-4,11.4-6,17.2c4.1,0,8.1,0,12.2,0C20.2,26.4,18.3,20.7,16.3,15z"
            />
          </g>
          <line
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="2"
            strokeLinecap="round"
            strokeMiterlimit="10"
            x1="28.6"
            y1="2.6"
            x2="28.6"
            y2="52.8"
          />
          <line
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="2"
            strokeLinecap="round"
            strokeMiterlimit="10"
            x1="37.6"
            y1="53.3"
            x2="19.7"
            y2="53.3"
          />
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M16.2,23.5c-4,0-7.3,3.3-7.3,7.3c0,4,3.3,7.3,7.3,7.3s7.3-3.3,7.3-7.3C23.5,26.7,20.2,23.5,16.2,23.5z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                d="M13,35.4v-0.7c1-0.5,1.6-1.4,1.6-2.5c0-0.3,0-0.6-0.1-1h-1.5v-0.9h1.3c-0.1-0.4-0.2-1-0.2-1.5
			c0-1.7,1.2-2.8,2.7-2.8c0.7,0,1.3,0.2,1.6,0.4l-0.3,0.9c-0.3-0.1-0.7-0.3-1.3-0.3c-1.1,0-1.6,0.8-1.6,1.8c0,0.6,0.1,1.1,0.2,1.5
			h2.1v0.9h-1.9c0,0.5,0.1,1.1-0.1,1.6c-0.2,0.6-0.5,1.1-1,1.5v0h4.3v1H13z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M41.7,23.5c-4,0-7.3,3.3-7.3,7.3c0,4,3.3,7.3,7.3,7.3s7.3-3.3,7.3-7.3C49,26.7,45.7,23.5,41.7,23.5z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                d="M38.5,35.4v-0.7c1-0.5,1.6-1.4,1.6-2.5c0-0.3,0-0.6-0.1-1h-1.5v-0.9h1.3c-0.1-0.4-0.2-1-0.2-1.5
			c0-1.7,1.2-2.8,2.7-2.8c0.7,0,1.3,0.2,1.6,0.4l-0.3,0.9c-0.3-0.1-0.7-0.3-1.3-0.3c-1.1,0-1.6,0.8-1.6,1.8c0,0.6,0.1,1.1,0.2,1.5
			h2.1v0.9h-1.9c0,0.5,0.1,1.1-0.1,1.6c-0.2,0.6-0.5,1.1-1,1.5v0h4.3v1H38.5z"
              />
            </g>
          </g>
        </g>
      );
    case 'bankrevalue':
      return (
        <g>
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M35.1,25.2h-9.9c-0.3,0-0.6-0.2-0.6-0.5v-0.5c0-0.3,0.3-0.5,0.6-0.5h9.9c0.3,0,0.6,0.2,0.6,0.5v0.5
	C35.7,25,35.5,25.2,35.1,25.2z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M35.1,19.8h-9.9c-0.3,0-0.6-0.2-0.6-0.5v-0.5c0-0.3,0.3-0.5,0.6-0.5h9.9c0.3,0,0.6,0.2,0.6,0.5v0.5
	C35.7,19.6,35.5,19.8,35.1,19.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M35.4,30.2h-9.9c-0.3,0-0.6-0.2-0.6-0.5v-0.5c0-0.3,0.3-0.5,0.6-0.5h9.9c0.3,0,0.6,0.2,0.6,0.5v0.5
	C36,30,35.7,30.2,35.4,30.2z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M33.5,35.8h-8.4c-0.3,0-0.5-0.2-0.5-0.5v-0.5c0-0.3,0.2-0.5,0.5-0.5h8.4c0.3,0,0.5,0.2,0.5,0.5v0.5
	C34.1,35.6,33.8,35.8,33.5,35.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M23.4,23.4L21.2,26c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0-0.3,0-0.4-0.1L19,24.9c-0.2-0.2-0.3-0.6-0.1-0.8
	c0.2-0.2,0.6-0.3,0.8-0.1l1,0.8l1.9-2.2c0.2-0.2,0.6-0.3,0.8,0C23.6,22.8,23.6,23.2,23.4,23.4z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M23.4,18.2l-2.3,2.6c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0-0.3,0-0.4-0.1L19,19.6c-0.2-0.2-0.3-0.6-0.1-0.8
	c0.2-0.2,0.6-0.3,0.8-0.1l1,0.8l1.9-2.2c0.2-0.2,0.6-0.3,0.8,0C23.6,17.6,23.6,17.9,23.4,18.2z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M23.7,28.9l-2.3,2.6c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0-0.3,0-0.4-0.1l-1.4-1.1c-0.2-0.2-0.3-0.6-0.1-0.8
	c0.2-0.2,0.6-0.3,0.8-0.1l1,0.8l1.9-2.2c0.2-0.2,0.6-0.3,0.8,0C23.9,28.4,23.9,28.7,23.7,28.9z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M23.4,33.9l-2.3,2.6c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0-0.3,0-0.4-0.1L19,35.4c-0.2-0.2-0.3-0.6-0.1-0.8
	c0.2-0.2,0.6-0.3,0.8-0.1l1,0.8l1.9-2.2c0.2-0.2,0.6-0.3,0.8,0C23.6,33.4,23.6,33.7,23.4,33.9z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M39.7,6.1H14.1c-0.8,0-2.1,1.2-2.1,2.8v33.2c0,1.5,1.2,2.8,2.8,2.8h17.4c-0.4-1.1-0.4-1.7-0.5-2.9H15l0-29.7
	h25.4l0,17.8c0.9-0.2,1-0.3,2-0.5c0.2,0,0.5,0,0.7,0V8.9C43.1,7.4,41.9,6.1,39.7,6.1z M31.4,9.2c0,0.2-0.2,0.4-0.4,0.4h-7.1
	c-0.2,0-0.4-0.2-0.4-0.4V8.8c0-0.2,0.2-0.4,0.4-0.4H31c0.2,0,0.4,0.2,0.4,0.4V9.2z"
          />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M41.9,31.4c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C50.6,35.3,46.7,31.4,41.9,31.4z"
            />
          </g>
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                stroke={p4Tokens.colorBrandMenuForeground1}
                strokeMiterlimit="10"
                d="M25.8,38.4c-4,0-7.3,3.3-7.3,7.3c0,4,3.3,7.3,7.3,7.3
			s7.3-3.3,7.3-7.3C33.2,41.7,29.9,38.4,25.8,38.4z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M22.6,50.3v-0.7c1-0.5,1.6-1.4,1.6-2.5c0-0.3,0-0.6-0.1-1h-1.5v-0.9H24c-0.1-0.4-0.2-1-0.2-1.5
			c0-1.7,1.2-2.8,2.7-2.8c0.7,0,1.3,0.2,1.6,0.4l-0.3,0.9c-0.3-0.1-0.7-0.3-1.3-0.3c-1.1,0-1.6,0.8-1.6,1.8c0,0.6,0.1,1.1,0.2,1.5
			h2.1v0.9h-1.9c0,0.5,0.1,1.1-0.1,1.6c-0.2,0.6-0.5,1.1-1,1.5v0h4.3v1H22.6z"
              />
            </g>
          </g>
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke="#FFFFFB"
            strokeWidth="0.5"
            strokeMiterlimit="10"
            d="M46.9,36.7l-6.8,7.6c-0.1,0.1-0.3,0.2-0.4,0.2
	c-0.1,0-0.3,0-0.4-0.1L37,42.6c-0.2-0.2-0.3-0.6-0.1-0.8c0.2-0.2,0.6-0.3,0.8-0.1l1.9,1.4l6.5-7.2c0.2-0.2,0.6-0.3,0.8,0
	C47.1,36.1,47.1,36.5,46.9,36.7z"
          />
        </g>
      );
    case 'vatrec':
      return (
        <g>
          <circle fill={p4Tokens.colorBrandMenuForeground1} cx="40.3" cy="40.6" r="2.1" />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            d="M35.2,18.8l-2-3.6c-0.3-0.5-0.9-0.5-1.4-0.3l-2.1,1.2l0,0c-0.9-0.9-2-1.8-3.2-2.5l0.6-2.3
	c0.1-0.5-0.2-1-0.7-1.2l-4-1.1c-0.5-0.1-1,0.2-1.2,0.7l-0.6,2.3l0,0c-1.3,0-2.5,0-3.9,0.5l-1.2-2.1c-0.3-0.5-0.9-0.6-1.4-0.4l-3.6,2
	c-0.5,0.3-0.4,0.8-0.1,1.2l1.2,2.1l0,0c-1.1,1-1.9,2-2.5,3.2l-2.4-0.6c-0.5-0.1-1,0.2-1.2,0.7l-1.1,4c-0.1,0.5,0.2,1,0.7,1.2
	l2.3,0.6l0,0c0,1.3,0,2.5,0.5,4l-2.1,1.2c-0.5,0.3-0.5,0.7-0.3,1.2l2,3.6C8,35,8.4,35.1,8.9,34.9l2.1-1.2l0,0c1,1.1,2,1.9,3.2,2.5
	l-0.6,2.3c-0.1,0.5,0.2,1,0.7,1.2l4,1.1c0.5,0.1,1-0.2,1.2-0.7l0.6-2.3l0.1,0c1.3,0,2.6-0.1,4.1-0.6l1.2,2.1
	c0.3,0.5,0.6,0.7,1.1,0.4l3.6-2c0.5-0.3,0.7-0.8,0.4-1.3l-1.2-2.1l0,0c1.1-1,1.8-1.9,2.4-3.1l2.3,0.6c0.5,0.1,1-0.2,1.2-0.7l1.1-4
	c0.1-0.5-0.2-1-0.7-1.2l-2.3-0.6l0,0c0-1.3-0.1-2.6-0.5-4l2.1-1.2C35.1,19.8,35.4,19.3,35.2,18.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.2"
            strokeMiterlimit="10"
            d="M47.5,33.5l-2-1.6c-0.3-0.2-0.7-0.1-0.9,0.2
	l-0.9,1.2l0,0c-0.7-0.3-1.6-0.6-2.4-0.7l-0.2-1.5c0-0.3-0.3-0.6-0.7-0.5l-2.6,0.3c-0.3,0-0.6,0.3-0.5,0.7l0.2,1.5l0,0
	c-0.8,0.3-1.4,0.6-2.2,1.2l-1.2-0.9c-0.3-0.2-0.7-0.2-0.9,0.1l-1.6,2c-0.2,0.3-0.1,0.5,0.2,0.8l1.2,0.9l0,0
	c-0.4,0.9-0.6,1.6-0.7,2.5l-1.5,0.2c-0.3,0-0.6,0.3-0.5,0.7l0.3,2.6c0,0.3,0.3,0.6,0.7,0.5l1.5-0.2l0,0c0.3,0.8,0.6,1.5,1.2,2.2
	l-0.9,1.2c-0.2,0.3-0.1,0.5,0.1,0.8l2,1.6c0.3,0.2,0.5,0.2,0.7-0.1l0.9-1.2l0,0c0.9,0.4,1.6,0.6,2.4,0.7l0.2,1.5
	c0,0.3,0.3,0.6,0.7,0.5l2.6-0.3c0.3,0,0.6-0.3,0.5-0.7l-0.2-1.5l0,0c0.8-0.3,1.5-0.7,2.2-1.3l1.2,0.9c0.3,0.2,0.5,0.3,0.7,0l1.6-2
	c0.2-0.3,0.2-0.6-0.1-0.8l-1.2-0.9l0,0c0.4-0.9,0.6-1.6,0.7-2.4l1.5-0.2c0.3,0,0.6-0.3,0.5-0.7L50,38.1c0-0.3-0.3-0.6-0.7-0.5
	l-1.5,0.2l0,0c-0.3-0.8-0.6-1.5-1.3-2.2l0.9-1.2C47.7,34.1,47.8,33.7,47.5,33.5z M36.1,39.4c0.1-0.5,0.4-1,0.8-1.5
	c0.4-0.6,1-1,1.6-1.3c0.1,0,0.1-0.1,0.2-0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2-0.1c0.1,0,0.1,0,0.2-0.1c0,0,0.1,0,0.1,0
	c0.1,0,0.3-0.1,0.4-0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0
	c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0.1c0.1,0,0.2,0.1,0.3,0.1
	c0.1,0,0.1,0.1,0.2,0.1c0.3,0.1,0.7,0.3,1,0.6c0.5,0.4,1,0.9,1.2,1.5c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0.1,0.1,0.1,0.2
	c0,0.1,0,0.1,0.1,0.2c0.1,0.2,0.1,0.3,0.1,0.5c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1
	c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.2c-0.1,0.7-0.4,1.3-0.8,1.9c-0.4,0.5-0.8,0.9-1.3,1.1c-0.1,0-0.1,0.1-0.2,0.1
	c-0.2,0.1-0.4,0.2-0.6,0.2c-0.1,0-0.1,0-0.2,0.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0.1c-1.2,0.2-2.4-0.1-3.4-0.9
	c-0.5-0.4-0.9-0.8-1.1-1.3c-0.1-0.2-0.2-0.4-0.3-0.7c0-0.1-0.1-0.2-0.1-0.2c-0.1-0.2-0.1-0.4-0.1-0.6c0-0.2,0-0.4,0-0.6
	c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.3,0.1-0.4c0,0,0-0.1,0-0.1C36.1,39.4,36.1,39.4,36.1,39.4z"
          />
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                stroke={p4Tokens.colorBrandMenuForeground1}
                strokeWidth="1.2"
                strokeMiterlimit="10"
                d="M20.3,16c-4.8,0-8.7,3.9-8.7,8.7
			c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C29,20,25.1,16,20.3,16z"
              />
            </g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M16.7,30.2v-0.9c1.2-0.6,2-1.7,2-3c0-0.4,0-0.8-0.1-1.2h-1.8V24h1.6c-0.1-0.5-0.2-1.2-0.2-1.9
			c0-2.1,1.4-3.4,3.3-3.4c0.9,0,1.5,0.2,1.9,0.4l-0.3,1.1c-0.3-0.2-0.8-0.3-1.6-0.3c-1.4,0-1.9,0.9-1.9,2.2c0,0.7,0.1,1.3,0.2,1.9
			h2.5v1.1H20c0.1,0.7,0.1,1.3-0.1,1.9c-0.2,0.7-0.6,1.4-1.2,1.9v0h5.2v1.3H16.7z"
              />
            </g>
          </g>
        </g>
      );
    case 'vatanalysis':
      return (
        <g>
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M25.2,8.9c-9.5,0-17.3,7.7-17.3,17.3c0,9.5,7.7,17.3,17.3,17.3c9.5,0,17.3-7.7,17.3-17.3
	C42.5,16.6,34.7,8.9,25.2,8.9z M25.2,41.7c-8.6,0-15.5-7-15.5-15.5c0-8.6,6.9-15.5,15.5-15.5s15.5,6.9,15.5,15.5
	C40.7,34.7,33.8,41.7,25.2,41.7z"
          />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M42.5,26.1c0,9.6-7.7,17.3-17.3,17.3c-9.5,0-17.3-7.7-17.3-17.3c0-9.6,7.7-17.3,17.3-17.3
		C34.7,8.8,42.5,16.6,42.5,26.1z"
            />
            <path
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="2.4214"
              strokeMiterlimit="10"
              strokeDasharray="0.617,0.617"
              d="M42.5,26.1
		c0,9.6-7.7,17.3-17.3,17.3c-9.5,0-17.3-7.7-17.3-17.3c0-9.6,7.7-17.3,17.3-17.3C34.7,8.8,42.5,16.6,42.5,26.1z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M19.6,34.6v-1.3c1.8-0.9,3.1-2.7,3.1-4.7c0-0.6,0-1.2-0.1-1.9h-2.8V25h2.5C22.1,24.2,22,23.1,22,22
		c0-3.2,2.2-5.3,5.2-5.3c1.4,0,2.4,0.3,2.9,0.7l-0.5,1.8c-0.5-0.3-1.3-0.5-2.4-0.5c-2.1,0-2.9,1.5-2.9,3.4c0,1.2,0.1,2,0.3,2.9h3.9
		v1.7h-3.7c0.1,1,0.1,2.1-0.1,3c-0.3,1.2-0.9,2.1-1.9,2.9v0.1h8v2H19.6z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M25.2,9.4C16,9.4,8.5,16.9,8.5,26.1S16,42.9,25.2,42.9c9.2,0,16.7-7.5,16.7-16.7S34.4,9.4,25.2,9.4z
		 M25.2,41.7c-8.6,0-15.5-7-15.5-15.5c0-8.6,7-15.5,15.5-15.5c8.6,0,15.5,7,15.5,15.5C40.7,34.7,33.8,41.7,25.2,41.7z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M40.7,32.9c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C49.5,36.9,45.5,32.9,40.7,32.9z"
            />
          </g>
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke="#FFFFFB"
            strokeWidth="0.5"
            strokeMiterlimit="10"
            d="M45.7,38.2l-6.8,7.6C38.8,46,38.6,46,38.5,46
	c-0.1,0-0.3,0-0.4-0.1l-2.3-1.8c-0.2-0.2-0.3-0.6-0.1-0.8c0.2-0.2,0.6-0.3,0.8-0.1l1.9,1.4l6.5-7.2c0.2-0.2,0.6-0.3,0.8,0
	C45.9,37.7,45.9,38,45.7,38.2z"
          />
        </g>
      );
    case 'nominalanalytics':
      return (
        <g>
          <path
            fill="#FFFFFF"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M32.2,51c-7,2.2-16.7-1.5-21.8-8.2
		c-5.8-7.7-6.3-18-1.1-26C14.5,9,24,5,33,7.2c-0.2,0.6-0.3,1.2-0.5,1.8c-1.7,6-3.5,11.9-5.1,17.9c-0.4,1.4-0.4,3-0.1,4.4
		c1.4,6,2.9,11.9,4.4,17.9C31.9,49.8,32.1,50.4,32.2,51z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M35,50.6c-1.6-6.5-3.2-12.8-4.8-19.3c6.5,1.9,12.7,3.6,19.1,5.5C46.8,43.6,42,48.1,35,50.6z"
          />
          <path
            fill="#FFFFFF"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M35.8,8c10.2,3,17,15.2,14.3,25.8
		C43.5,31.9,36.8,30,30.1,28C32,21.3,33.9,14.7,35.8,8z"
          />
        </g>
      );
    case 'nominalcost':
      return (
        <g>
          <circle fill={p4Tokens.colorBrandMenuForeground1} cx="18.8" cy="23.7" r="3.4" />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.2"
            d="M33.6,17.6l-2-3.6c-0.3-0.5-0.9-0.5-1.4-0.3l-2.1,1.2l0,0
	c-0.9-0.9-2-1.8-3.2-2.5l0.6-2.3c0.1-0.5-0.2-1-0.7-1.2l-4-1.1c-0.5-0.1-1,0.2-1.2,0.7l-0.6,2.3l0,0c-1.3,0-2.5,0-3.9,0.5L14,9.3
	c-0.3-0.5-0.9-0.6-1.4-0.4l-3.6,2c-0.5,0.3-0.4,0.8-0.1,1.2l1.2,2.1l0,0c-1.1,1-1.9,2-2.5,3.2l-2.4-0.6c-0.5-0.1-1,0.2-1.2,0.7
	l-1.1,4c-0.1,0.5,0.2,1,0.7,1.2L6,23.4l0,0c0,1.3,0,2.5,0.5,4l-2.1,1.2c-0.5,0.3-0.5,0.7-0.3,1.2l2,3.6c0.3,0.5,0.7,0.6,1.1,0.3
	l2.1-1.2l0,0c1,1.1,2,1.9,3.2,2.5L12,37.3c-0.1,0.5,0.2,1,0.7,1.2l4,1.1c0.5,0.1,1-0.2,1.2-0.7l0.6-2.3l0.1,0c1.3,0,2.6-0.1,4.1-0.6
	l1.2,2.1c0.3,0.5,0.6,0.7,1.1,0.4l3.6-2c0.5-0.3,0.7-0.8,0.4-1.3L27.7,33l0,0c1.1-1,1.8-1.9,2.4-3.1l2.3,0.6c0.5,0.1,1-0.2,1.2-0.7
	l1.1-4c0.1-0.5-0.2-1-0.7-1.2L31.6,24l0,0c0-1.3-0.1-2.6-0.5-4l2.1-1.2C33.6,18.5,33.9,18,33.6,17.6z M13.5,19.5
	c0.5-0.7,1.2-1.2,1.9-1.7c1-0.6,2-0.8,3-0.9c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0
	c0.1,0,0.1,0,0.2,0c0.2,0,0.4,0.1,0.6,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.1,0,0.2,0.1c0.1,0,0.2,0.1,0.3,0.1
	c0.1,0,0.1,0,0.2,0.1c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0.1,0.2,0.1c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.1,0.2,0.2,0.4,0.2
	c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.2,0.2,0.2,0.2c0.4,0.4,0.7,0.9,1,1.4
	c0.5,0.9,0.8,1.9,0.9,2.9c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.3-0.1,0.5-0.1,0.8c0,0.1,0,0.2-0.1,0.3
	c0,0.2-0.1,0.3-0.1,0.5c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.1-0.1,0.2c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.1-0.1,0.3-0.2,0.4
	c-0.1,0.1-0.1,0.2-0.2,0.3c-0.6,0.9-1.3,1.6-2.3,2.2c-0.8,0.5-1.7,0.7-2.6,0.9c-0.1,0-0.2,0-0.3,0c-0.3,0-0.7,0-1,0
	c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0c-0.2,0-0.3-0.1-0.5-0.1c-1.8-0.4-3.4-1.5-4.4-3.2c-0.5-0.8-0.8-1.7-0.9-2.6
	c0-0.4-0.1-0.8,0-1.1c0-0.1,0-0.3,0-0.4c0-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.2-0.6,0.3-0.9c0-0.1,0-0.1,0.1-0.2c0-0.1,0.1-0.2,0.1-0.3
	c0-0.1,0.1-0.2,0.2-0.3c0.1-0.2,0.2-0.4,0.3-0.6c0-0.1,0.1-0.1,0.1-0.2C13.4,19.6,13.4,19.6,13.5,19.5z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.2"
            strokeMiterlimit="10"
            d="M46,32.2l-2-1.6c-0.3-0.2-0.7-0.1-0.9,0.2
	L42.2,32l0,0c-0.7-0.3-1.6-0.6-2.4-0.7l-0.2-1.5c0-0.3-0.3-0.6-0.7-0.5l-2.6,0.3c-0.3,0-0.6,0.3-0.5,0.7l0.2,1.5l0,0
	c-0.8,0.3-1.4,0.6-2.2,1.2l-1.2-0.9c-0.3-0.2-0.7-0.2-0.9,0.1l-1.6,2c-0.2,0.3-0.1,0.5,0.2,0.8l1.2,0.9l0,0
	c-0.4,0.9-0.6,1.6-0.7,2.5l-1.5,0.2c-0.3,0-0.6,0.3-0.5,0.7l0.3,2.6c0,0.3,0.3,0.6,0.7,0.5l1.5-0.2l0,0c0.3,0.8,0.6,1.5,1.2,2.2
	l-0.9,1.2c-0.2,0.3-0.1,0.5,0.1,0.8l2,1.6c0.3,0.2,0.5,0.2,0.7-0.1l0.9-1.2l0,0c0.9,0.4,1.6,0.6,2.4,0.7l0.2,1.5
	c0,0.3,0.3,0.6,0.7,0.5l2.6-0.3c0.3,0,0.6-0.3,0.5-0.7l-0.2-1.5l0,0c0.8-0.3,1.5-0.7,2.2-1.3l1.2,0.9c0.3,0.2,0.5,0.3,0.7,0l1.6-2
	c0.2-0.3,0.2-0.6-0.1-0.8l-1.2-0.9l0,0c0.4-0.9,0.6-1.6,0.7-2.4l1.5-0.2c0.3,0,0.6-0.3,0.5-0.7l-0.3-2.6c0-0.3-0.3-0.6-0.7-0.5
	l-1.5,0.2l0,0C46,35.7,45.7,35,45,34.2l0.9-1.2C46.2,32.8,46.2,32.4,46,32.2z"
          />
          <circle fill="none" stroke="#FFFFFB" strokeWidth="3" strokeMiterlimit="10" cx="18.8" cy="23.7" r="9.9" />
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M38.8,31.4c-4.5,0-8.1,3.6-8.1,8.1c0,4.5,3.6,8.1,8.1,8.1s8.1-3.6,8.1-8.1C46.9,35,43.3,31.4,38.8,31.4z"
              />
            </g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                d="M35.5,44.5v-0.8c1.1-0.5,1.8-1.6,1.8-2.8c0-0.4,0-0.7-0.1-1.1h-1.7v-1h1.5c-0.1-0.5-0.2-1.1-0.2-1.7
			c0-1.9,1.3-3.1,3.1-3.1c0.8,0,1.4,0.2,1.8,0.4l-0.3,1.1C41.1,35.2,40.7,35,40,35c-1.3,0-1.8,0.9-1.8,2c0,0.7,0.1,1.2,0.2,1.7h2.3
			v1h-2.2c0,0.6,0.1,1.2-0.1,1.8c-0.2,0.7-0.6,1.3-1.1,1.7v0h4.8v1.2H35.5z"
              />
            </g>
          </g>
        </g>
      );
    case 'yearend':
      return (
        <g>
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M41.8,11.5H38v2.3c0,1.6-1.2,2.8-2.8,2.8
	c-1.6,0-2.8-1.3-2.8-2.8v-2.3H16.6v2.3c0,1.6-1.2,2.8-2.8,2.8s-2.8-1.3-2.8-2.8v-2.3H7.3c-2.2,0-3.9,1.6-3.9,3.7v25
	c0,2.2,1.8,4.1,3.9,4.1h34.5c2.2,0,3.9-1.9,3.9-4.1v-25C45.7,13,44,11.5,41.8,11.5z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M35.3,15L35.3,15c-0.8,0-1.3-0.6-1.3-1.3v-3.6c0-0.7,0.6-1.3,1.3-1.3h0c0.7,0,1.3,0.6,1.3,1.3v3.6
	C36.6,14.4,36,15,35.3,15z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M13.9,15L13.9,15c-0.8,0-1.3-0.6-1.3-1.3v-3.6c0-0.7,0.6-1.3,1.3-1.3h0c0.7,0,1.3,0.6,1.3,1.3v3.6
	C15.2,14.4,14.6,15,13.9,15z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M41.8,40.6H7c-0.6,0-1.1-0.5-1.1-1.1V22.3
	c0-0.6,0.5-1.1,1.1-1.1h34.7c0.6,0,1.1,0.5,1.1,1.1v17.2C42.9,40.1,42.4,40.6,41.8,40.6z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.6"
            d="M17.2,27.2h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8c0-0.4,0.3-0.8,0.8-0.8h2.8
	c0.4,0,0.8,0.3,0.8,0.8v2.8C18,26.8,17.7,27.2,17.2,27.2z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.6"
            d="M17.2,32.8h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8c0-0.4,0.3-0.8,0.8-0.8h2.8
	c0.4,0,0.8,0.3,0.8,0.8V32C18,32.4,17.7,32.8,17.2,32.8z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.6"
            d="M17.2,38.6h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8c0-0.4,0.3-0.8,0.8-0.8h2.8
	c0.4,0,0.8,0.3,0.8,0.8v2.8C18,38.2,17.7,38.6,17.2,38.6z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.6"
            d="M23.1,27.2h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8c0-0.4,0.3-0.8,0.8-0.8h2.8
	c0.4,0,0.8,0.3,0.8,0.8v2.8C23.8,26.8,23.5,27.2,23.1,27.2z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.6"
            d="M23.1,32.8h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8c0-0.4,0.3-0.8,0.8-0.8h2.8
	c0.4,0,0.8,0.3,0.8,0.8V32C23.8,32.4,23.5,32.8,23.1,32.8z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.6"
            d="M23.1,38.6h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8c0-0.4,0.3-0.8,0.8-0.8h2.8
	c0.4,0,0.8,0.3,0.8,0.8v2.8C23.8,38.2,23.5,38.6,23.1,38.6z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.6"
            d="M28.9,27.2h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8c0-0.4,0.3-0.8,0.8-0.8h2.8
	c0.4,0,0.8,0.3,0.8,0.8v2.8C29.6,26.8,29.3,27.2,28.9,27.2z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.6"
            d="M28.9,32.8h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8c0-0.4,0.3-0.8,0.8-0.8h2.8
	c0.4,0,0.8,0.3,0.8,0.8V32C29.6,32.4,29.3,32.8,28.9,32.8z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.6"
            d="M28.9,38.6h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8c0-0.4,0.3-0.8,0.8-0.8h2.8
	c0.4,0,0.8,0.3,0.8,0.8v2.8C29.6,38.2,29.3,38.6,28.9,38.6z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.6"
            d="M34.7,27.2h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8c0-0.4,0.3-0.8,0.8-0.8h2.8
	c0.4,0,0.8,0.3,0.8,0.8v2.8C35.4,26.8,35.1,27.2,34.7,27.2z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.6"
            d="M34.7,32.8h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8c0-0.4,0.3-0.8,0.8-0.8h2.8
	c0.4,0,0.8,0.3,0.8,0.8V32C35.4,32.4,35.1,32.8,34.7,32.8z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.6"
            d="M34.7,38.6h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8c0-0.4,0.3-0.8,0.8-0.8h2.8
	c0.4,0,0.8,0.3,0.8,0.8v2.8C35.4,38.2,35.1,38.6,34.7,38.6z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.6"
            d="M40.5,27.2h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8c0-0.4,0.3-0.8,0.8-0.8h2.8
	c0.4,0,0.8,0.3,0.8,0.8v2.8C41.3,26.8,40.9,27.2,40.5,27.2z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.6"
            d="M40.5,32.8h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8c0-0.4,0.3-0.8,0.8-0.8h2.8
	c0.4,0,0.8,0.3,0.8,0.8V32C41.3,32.4,40.9,32.8,40.5,32.8z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.6"
            d="M11.5,32.8H8.7C8.3,32.8,8,32.4,8,32v-2.8c0-0.4,0.3-0.8,0.8-0.8h2.8
	c0.4,0,0.8,0.3,0.8,0.8V32C12.3,32.4,11.9,32.8,11.5,32.8z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.6"
            d="M11.5,38.6H8.7c-0.4,0-0.8-0.3-0.8-0.8v-2.8c0-0.4,0.3-0.8,0.8-0.8h2.8
	c0.4,0,0.8,0.3,0.8,0.8v2.8C12.3,38.2,11.9,38.6,11.5,38.6z"
          />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M45.8,33.5c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C54.6,37.5,50.6,33.5,45.8,33.5z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M42.2,47.7v-0.9c1.2-0.6,2-1.7,2-3c0-0.4,0-0.8-0.1-1.2h-1.8v-1.1h1.6c-0.1-0.5-0.2-1.2-0.2-1.9
		c0-2.1,1.4-3.4,3.3-3.4c0.9,0,1.5,0.2,1.9,0.4l-0.3,1.1c-0.3-0.2-0.8-0.3-1.6-0.3c-1.4,0-1.9,0.9-1.9,2.2c0,0.7,0.1,1.3,0.2,1.9
		h2.5v1.1h-2.4c0.1,0.7,0.1,1.3-0.1,1.9c-0.2,0.7-0.6,1.4-1.2,1.9v0h5.2v1.3H42.2z"
            />
          </g>
        </g>
      );
    case 'nominalreports':
      return (
        <g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3071"
              strokeMiterlimit="10"
              d="M11.4,47.2h25c1.1,0,2.1-0.9,2.1-2.1V9
		c0-1.1-0.9-2.1-2.1-2.1H24.2L9.4,21.2v23.9C9.4,46.2,10.3,47.2,11.4,47.2z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeMiterlimit="10"
              d="M11.1,21h11c1.1,0,2.1-0.9,2.1-2.1v-11L11.1,21z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M13.6,28H34c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H13.6c-0.2,0-0.3,0.1-0.3,0.3v0.7
		C13.3,27.8,13.4,28,13.6,28z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M13.6,34H34c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H13.6c-0.2,0-0.3,0.1-0.3,0.3v0.7
		C13.3,33.8,13.4,34,13.6,34z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M13.6,39.9H34c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H13.6c-0.2,0-0.3,0.1-0.3,0.3v0.7
		C13.3,39.8,13.4,39.9,13.6,39.9z"
            />
            <path fill={p4Tokens.colorBrandMenuBackground1} d="M11.6,20.1h9.9c1,0,1.9-0.8,1.9-1.8V8.9L11.6,20.1z" />
          </g>
          <ellipse fill={p4Tokens.colorBrandMenuBackground1} cx="38.3" cy="18.3" rx="4" ry="6.9" />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M47.5,11.9c-0.6-0.5-1.2-1-1.7-1.5c-0.2,0.1-6.3,5.5-9.2,8.1c-0.2,0.2-0.4,0.4-0.6,0.6
		c-0.3,0.5-0.3,0.9,0.1,1.3c0.4,0.4,0.9,0.4,1.5,0.2c0.2-0.1,0.3-0.2,0.5-0.3C41.2,17.5,47.4,12,47.5,11.9z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M44.9,7.9c0,0,3.6,3.2,5.4,4.7c0.4-0.4,0.8-0.7,1.2-1.2c0.6-0.8,0.4-1.8-0.3-2.6c-0.5-0.5-1.1-1-1.6-1.5
		c-1.2-1-2.7-1.1-3.9-0.1C45.4,7.5,44.9,7.9,44.9,7.9z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M49.3,13.5c0,0-0.6-0.5-0.8-0.8c-0.2,0.2-0.4,0.4-0.6,0.5c-2.9,2.5-5.8,5.1-8.6,7.6
		c-0.2,0.1-0.5,0.4-0.5,0.5c-0.1,0.2,0,0.4,0.2,0.6c0.1,0.1,0.4,0.2,0.6,0.1c0.2,0,0.4-0.2,0.5-0.3c3-2.7,6-5.4,9.1-8
		C49.1,13.6,49.3,13.5,49.3,13.5z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M45,9.6c0,0-0.6-0.5-0.8-0.8c-0.2,0.2-0.4,0.4-0.6,0.5c-2.9,2.5-5.8,5.1-8.6,7.6c-0.2,0.1-0.5,0.4-0.5,0.5
		c-0.1,0.2,0,0.4,0.2,0.6c0.1,0.1,0.4,0.2,0.6,0.1c0.2,0,0.4-0.2,0.5-0.3c3-2.7,6-5.4,9.1-8C44.8,9.8,45,9.6,45,9.6z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M37.9,22.8c-0.2-0.7-0.6-1-1.4-1.1c-1-0.1-1.6-0.8-1.8-1.9c-0.1-0.3-0.3-0.6-0.6-0.7
		c-0.2-0.1-0.3-0.1-0.5-0.2c-0.5,1.7-1,3.4-1.5,5.2C34,23.7,35.9,23.3,37.9,22.8z"
            />
          </g>
        </g>
      );
    case 'polines':
      return (
        <g>
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3071"
            strokeMiterlimit="10"
            d="M15.6,48.2h25c1.1,0,2.1-0.9,2.1-2.1V10
	c0-1.1-0.9-2.1-2.1-2.1H28.3L13.5,22.2v23.9C13.5,47.2,14.4,48.2,15.6,48.2z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeMiterlimit="10"
            d="M15.2,22h11c1.1,0,2.1-0.9,2.1-2.1v-11L15.2,22z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M24.7,28.3h13.5c0.1,0,0.3-0.1,0.3-0.3v-0.8c0-0.1-0.1-0.3-0.3-0.3H24.7c-0.1,0-0.3,0.1-0.3,0.3V28
	C24.4,28.2,24.5,28.3,24.7,28.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M24.7,35h13.5c0.1,0,0.3-0.1,0.3-0.3v-0.8c0-0.1-0.1-0.3-0.3-0.3H24.7c-0.1,0-0.3,0.1-0.3,0.3v0.8
	C24.4,34.8,24.5,35,24.7,35z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M24.7,41.6h13.5c0.1,0,0.3-0.1,0.3-0.3v-0.8c0-0.1-0.1-0.3-0.3-0.3H24.7c-0.1,0-0.3,0.1-0.3,0.3v0.8
	C24.4,41.5,24.5,41.6,24.7,41.6z"
          />
          <path fill={p4Tokens.colorBrandMenuBackground1} d="M15.7,21.1h9.9c1,0,1.9-0.8,1.9-1.8V9.9L15.7,21.1z" />
          <rect x="17.1" y="24.8" fill={p4Tokens.colorBrandMenuForeground1} width="4.7" height="4.7" />
          <rect x="17.1" y="31.9" fill={p4Tokens.colorBrandMenuForeground1} width="4.7" height="4.7" />
          <rect x="17.1" y="38.8" fill={p4Tokens.colorBrandMenuForeground1} width="4.7" height="4.7" />
        </g>
      );
    case 'shortages':
      return (
        <g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.2035"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              d="
		M25,25.1c0,0-17.7-8-18-7.5C6.7,18,7.1,40.2,7.1,40.2l17.7,7.6L25,25.1z"
            />

            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              d="
		M7.2,17.3c2.1-1,16-6.3,16.8-6.4c1,0,18.7,6.2,18.2,6.5c-0.4,0.3-15.9,7.2-17.1,7.5C24.1,25.3,7.3,17.3,7.2,17.3"
            />

            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              d="
		M25.2,25c0,0,17.2-8.1,17.2-7.5c0,10.2,0.2,22-0.2,22.3c-0.7,0.4-16.9,8.5-17.1,8S25.2,25,25.2,25z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M29.8,13.3l-16.3,7v9.9c0,0,3.8,2,3.9,1.2c0.2-3.1,0.2-9.6,0.2-9.3l16.5-7.3L29.8,13.3z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M44.9,27c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C53.7,31,49.7,27,44.9,27z"
            />
          </g>
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            d="M44.9,29.9c-0.5,0-0.9,0.4-1,0.8l0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0l-0.1,5.4c0,0.2-0.2,0.4-0.4,0.4l-0.6,0
	c-0.3,0-0.5,0.3-0.4,0.5l2,4.7c0.1,0.3,0.7,0.3,0.8,0l2.1-4.7c0.1-0.2-0.1-0.5-0.4-0.5l-0.7,0c-0.2,0-0.4-0.2-0.4-0.4l0.1-5.5l0,0
	C45.9,30.2,45.4,29.9,44.9,29.9z"
          />
        </g>
      );
    case 'printpo':
      return (
        <g>
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M35.3,19.3H12.7c-0.7,0-1.2-0.5-1.2-1.2V9.3
	c0-0.7,0.5-1.2,1.2-1.2h22.7c0.7,0,1.2,0.5,1.2,1.2v8.8C36.6,18.8,36,19.3,35.3,19.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M42.6,41.8H5.7c-1.2,0-2.3-1-2.3-2.3V20.7
	c0-1.2,1-2.3,2.3-2.3h36.8c1.2,0,2.3,1,2.3,2.3v18.8C44.8,40.8,43.8,41.8,42.6,41.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M10.2,24.5c0,0.8-0.6,1.5-1.4,1.5c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.4,1.4-1.5C9.5,23,10.2,23.7,10.2,24.5
	z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M24.1,39.3c2,0,4,0,6,0c0.6,0,1,0.3,1,0.8c0,0.5-0.3,0.8-0.7,0.9c-0.2,0-0.3,0-0.5,0c-4,0-7.9,0-11.9,0
	c-0.7,0-1.2-0.5-1-1.1c0.1-0.3,0.4-0.5,0.7-0.6c0.1,0,0.2,0,0.3,0C20,39.3,22.1,39.3,24.1,39.3C24.1,39.3,24.1,39.3,24.1,39.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M24.1,36.1c-2.1,0-4.1,0-6.2,0c-0.4,0-0.7-0.2-0.8-0.6c-0.1-0.3-0.1-0.7,0.2-0.9c0.2-0.1,0.5-0.2,0.7-0.2
	c2.3,0,4.5,0,6.8,0c1.8,0,3.6,0,5.5,0c0.5,0,0.9,0.3,0.9,0.8c0,0.6-0.3,0.9-0.9,0.9C28.2,36.1,26.1,36.1,24.1,36.1z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M24.1,44.3c2,0,4.1,0,6.1,0c0.5,0,0.9,0.3,0.9,0.8c0,0.5-0.3,0.9-0.9,0.9c-0.9,0-1.8,0-2.7,0
	c-3.2,0-6.4,0-9.6,0c-0.7,0-1.1-0.6-0.9-1.2c0.1-0.3,0.4-0.5,0.9-0.5c1.8,0,3.6,0,5.4,0C23.6,44.3,23.8,44.3,24.1,44.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M35,51.2H13.6c-0.9,0-1.7-0.8-1.7-1.7V31.3
	c0-0.9,0.8-1.7,1.7-1.7H35c0.9,0,1.7,0.8,1.7,1.7v18.3C36.6,50.5,35.9,51.2,35,51.2z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M30.4,35.9H17.8c-0.4,0-0.8-0.3-0.8-0.8l0,0c0-0.4,0.3-0.8,0.8-0.8h12.6c0.4,0,0.8,0.3,0.8,0.8l0,0
	C31.2,35.6,30.9,35.9,30.4,35.9z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M30.4,41H17.8c-0.4,0-0.8-0.3-0.8-0.8l0,0c0-0.4,0.3-0.8,0.8-0.8h12.6c0.4,0,0.8,0.3,0.8,0.8l0,0
	C31.2,40.7,30.9,41,30.4,41z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M30.4,45.9H17.8c-0.4,0-0.8-0.3-0.8-0.8l0,0c0-0.4,0.3-0.8,0.8-0.8h12.6c0.4,0,0.8,0.3,0.8,0.8l0,0
	C31.2,45.5,30.9,45.9,30.4,45.9z"
          />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M46.8,31.9c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C55.5,35.8,51.6,31.9,46.8,31.9z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M51.5,41.7H41.4c-0.3,0-0.6-0.3-0.6-0.6v-0.6c0-0.3,0.3-0.6,0.6-0.6h10.1c0.3,0,0.6,0.3,0.6,0.6v0.6
		C52.1,41.4,51.8,41.7,51.5,41.7z"
            />
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M45.5,45.8V35.7c0-0.3,0.3-0.6,0.6-0.6h0.6c0.3,0,0.6,0.3,0.6,0.6v10.1c0,0.3-0.3,0.6-0.6,0.6h-0.6
		C45.8,46.4,45.5,46.1,45.5,45.8z"
            />
          </g>
        </g>
      );
    case 'supplierpricing':
      return (
        <g>
          <g>
            <circle
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3"
              strokeMiterlimit="10"
              cx="25.5"
              cy="15.9"
              r="9.1"
            />
            <path
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3"
              strokeMiterlimit="10"
              d="M40.5,33.7v9.4c0,0.2,0,0.2-0.2,0.2H10.6
		c-0.2,0-0.3,0-0.3-0.2v-9.4c0-0.2,0-0.3,0-0.5c0.1-2.2,1-4.3,2.4-5.8c0,0,0.1-0.1,0.1-0.1c0.7-0.7,1.5-1.3,2.4-1.8
		c0.1,0,0.1-0.1,0.2-0.1c0.2-0.1,0.5-0.2,0.8-0.3c0.1,0,0.1,0,0.2-0.1c0.2-0.1,0.5-0.1,0.7-0.2c0.3,0.3,0.6,0.6,0.9,0.8
		c0.8,0.6,1.7,1.2,2.7,1.6c0.2,0.1,0.4,0.2,0.5,0.2c0.7,0.3,1.4,0.5,2.1,0.6c0.9,0.2,1.6,0.2,2.2,0.2c0.6,0,1.2,0,2-0.1
		c1.4-0.2,2.5-0.8,2.8-0.9c0.7-0.3,1.4-0.8,2.1-1.3c0,0,0,0,0,0c0.1,0,1.1-0.8,1.5-1.1c3.7,0.9,6.4,4.2,6.6,8.3
		C40.4,33.3,40.5,33.5,40.5,33.7z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M40.5,34.5c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C49.2,38.4,45.3,34.5,40.5,34.5z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M36.9,48.7v-0.9c1.2-0.6,2-1.7,2-3c0-0.4,0-0.8-0.1-1.2H37v-1.1h1.6c-0.1-0.5-0.2-1.2-0.2-1.9
		c0-2.1,1.4-3.4,3.3-3.4c0.9,0,1.5,0.2,1.9,0.4l-0.3,1.1c-0.3-0.2-0.8-0.3-1.6-0.3c-1.4,0-1.9,0.9-1.9,2.2c0,0.7,0.1,1.3,0.2,1.9
		h2.5v1.1h-2.4c0.1,0.7,0.1,1.3-0.1,1.9c-0.2,0.7-0.6,1.4-1.2,1.9v0h5.2v1.3H36.9z"
            />
          </g>
        </g>
      );
    case 'supplierbank':
      return (
        <g>
          <circle fill={p4Tokens.colorBrandMenuForeground1} cx="27.3" cy="10.7" r="8.1" />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.2401"
            strokeMiterlimit="10"
            d="M38.5,45.7c0.1-1.2,0.1-2.3,0.2-3.4
	c0.2-4.5,0.5-9.1,0.7-13.6c0-0.3,0-0.6,0-0.8c0-0.5-0.3-0.9-0.8-1c-0.6-0.1-0.9-0.5-0.9-1c0-0.5,0.4-0.8,1-0.8c2.1,0,4.3,0,6.4,0
	c0.6,0,0.9,0.3,1,0.8c0,0.5-0.2,0.8-0.8,1c-0.5,0.1-0.9,0.5-0.8,1.1c0.2,2.9,0.3,5.8,0.5,8.7c0.1,2.6,0.3,5.2,0.4,7.7
	c0,0.4,0,0.8,0.1,1.3c0.3,0,0.7,0,1,0c1,0,1.7,0.6,1.7,1.6c0,0.9-0.7,1.6-1.7,1.6c-4.3,0-8.6,0-12.9,0c-7.7,0-15.4,0-23.1,0
	c-0.9,0-1.4-0.4-1.6-1.1c-0.3-1,0.4-2,1.4-2c0.4,0,0.8,0,1.2,0c0.1-0.8,0.1-1.6,0.1-2.3c0.2-3.1,0.3-6.2,0.5-9.3
	c0.1-2,0.2-4,0.3-5.9c0-0.8-0.2-1.2-0.9-1.3c-0.5-0.1-0.8-0.4-0.7-0.9c0-0.5,0.3-0.8,0.8-0.8c0.5,0,1,0,1.5,0c1.6,0,3.2,0,4.8,0
	c0.2,0,0.3,0,0.5,0c0.5,0,0.8,0.4,0.8,0.8c0,0.5-0.2,0.8-0.7,0.9c-0.7,0.2-1,0.5-0.9,1.3c0.2,3.7,0.4,7.4,0.6,11.2
	c0.1,2,0.2,4,0.3,5.9c0,0.4,0.1,0.5,0.5,0.5c1.9,0,3.8,0,5.7,0c0.4,0,0.5-0.1,0.5-0.5c0.3-5,0.5-10,0.8-15c0-0.7,0.1-1.5,0.1-2.2
	c0-0.7-0.2-1.1-0.9-1.2c-0.5-0.1-0.8-0.5-0.8-0.9c0-0.4,0.4-0.8,0.9-0.8c2.2,0,4.4,0,6.6,0c0.5,0,0.8,0.4,0.9,0.8
	c0,0.5-0.2,0.8-0.8,1c-0.7,0.1-1,0.5-0.9,1.2c0.2,4.2,0.5,8.4,0.7,12.6c0.1,1.5,0.2,2.9,0.2,4.4c0,0.4,0.1,0.6,0.5,0.6
	c1.8,0,3.7,0,5.5,0C38.1,45.7,38.3,45.7,38.5,45.7z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M28.5,50.6c6.9,0,13.9,0,20.8,0c1.1,0,1.9,0.3,1.6,0.6c-0.2,0.2-0.8,0.4-1.6,0.4c-2.8,0-5.6,0-8.4,0
	c-11,0-22.1,0-33.1,0c-1,0-1.7-0.2-1.7-0.5c0-0.3,0.6-0.5,1.6-0.5c2.2,0,4.3,0,6.5,0C18.9,50.6,23.7,50.6,28.5,50.6z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M28.5,52.5c7.2,0,14.4,0,21.7,0c1.2,0,1.9,0.4,1.7,0.9C51.6,53.8,51,54,50.1,54c-2.9,0-5.9,0-8.8,0
	c-11.5,0-23,0-34.5,0c-1.1,0-1.7-0.3-1.8-0.7c0-0.5,0.6-0.8,1.7-0.8c2.3,0,4.5,0,6.8,0C18.5,52.5,23.5,52.5,28.5,52.5z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.116"
            strokeMiterlimit="10"
            d="M49.8,19.5c-0.1,0-0.1-0.1-0.2-0.1
	c-4.1-2.1-8.2-4.2-12.3-6.3c-1,4.5-5,7.9-9.9,7.9c-4.5,0-8.3-2.9-9.6-6.9c-0.1,0.1-0.3,0.1-0.4,0.2c-3.4,1.7-6.8,3.5-10.3,5.2
	c-0.7,0.4-0.9,0.8-0.5,1.5c0.2,0.4,0.4,0.8,0.6,1.2C7.6,23,8.2,23.3,9,23.3c6.5,0,13,0,19.5,0c1.5,0,3,0,4.5,0c5,0,10,0,15,0
	c0.8,0,1.4-0.3,1.7-1.1c0.2-0.4,0.4-0.8,0.6-1.1C50.6,20.4,50.5,19.9,49.8,19.5z"
          />
          <g>
            <g>
              <circle fill={p4Tokens.colorBrandMenuBackground1} cx="27.3" cy="8.4" r="3" />
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                d="M30.1,11.3c-0.7,0.7-1.7,1.2-2.8,1.2c-1.1,0-2.1-0.5-2.8-1.2c-0.1,0-0.1,0-0.2,0.1c0,0,0,0-0.1,0
			c-0.1,0-0.2,0.1-0.2,0.1c0,0,0,0-0.1,0c-0.3,0.1-0.6,0.3-0.8,0.6c0,0,0,0,0,0c-0.5,0.5-0.7,1.2-0.8,1.9c0,0,0,0.1,0,0.1v3.1
			c0,0.1,0,0.1,0.1,0.1c0,0,2.7,1,4.9,1s4.8-1,4.8-1c0.1,0,0.1-0.1,0.1-0.1v-3.1c0,0,0-0.1,0-0.1C32.2,12.7,31.3,11.6,30.1,11.3z"
              />
            </g>
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M27.3,2.1c-4.7,0-8.6,3.9-8.6,8.6s3.9,8.6,8.6,8.6c4.7,0,8.6-3.9,8.6-8.6S32,2.1,27.3,2.1z M27.3,18.2
		c-4.2,0-7.5-3.4-7.5-7.5c0-4.2,3.4-7.5,7.5-7.5c4.2,0,7.5,3.4,7.5,7.5C34.8,14.9,31.5,18.2,27.3,18.2z"
            />
          </g>
        </g>
      );
    case 'suggestedpayments':
      return (
        <g>
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M44.5,42.9H8.9c-3.2,0-5.8-2.6-5.8-5.7v-19c0-3.2,2.6-5.7,5.8-5.7h35.6c3.2,0,5.8,2.6,5.8,5.7v19
	C50.4,40.3,47.7,42.9,44.5,42.9z M8.9,14c-2.3,0-4.2,1.9-4.2,4.2v19c0,2.3,1.9,4.2,4.2,4.2h35.6c2.3,0,4.2-1.9,4.2-4.2v-19
	c0-2.3-1.9-4.2-4.2-4.2H8.9z"
          />
          <rect x="4.7" y="17.6" fill={p4Tokens.colorBrandMenuForeground1} width="44.1" height="5.1" />
          <line
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="2"
            strokeLinecap="round"
            x1="31.2"
            y1="33.8"
            x2="43.4"
            y2="33.8"
          />
          <line
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="2"
            strokeLinecap="round"
            x1="10.8"
            y1="28.1"
            x2="43.4"
            y2="28.1"
          />
          <circle fill={p4Tokens.colorBrandMenuForeground1} cx="10.8" cy="35.4" r="2.7" />
          <circle fill={p4Tokens.colorBrandMenuForeground1} cx="14.8" cy="35.4" r="2.7" />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M46.4,32.7c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C55.1,36.6,51.2,32.7,46.4,32.7z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M50.2,38.4c0-1.9-1.8-3.4-3.9-3.4c-2.2,0-3.9,1.5-3.9,3.4c0,0.7,0.2,1.3,0.6,1.9l0,0
		c0.2,0.3,0.3,0.5,0.6,0.9c0.2,0.3,0.3,0.5,0.5,0.9c0.2,0.4,0.4,1,0.4,2.1H48c0-1.1,0.3-1.7,0.5-2.1c0.2-0.5,0.3-0.6,0.5-0.9
		c0.2-0.4,0.4-0.7,0.6-0.9l0,0C49.9,39.6,50.2,39,50.2,38.4z"
            />
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M48.2,44.9c0,0.1-0.1,0.1-0.2,0.1h-3.6c-0.1,0-0.2-0.1-0.2-0.1l0,0c0-0.1,0.1-0.1,0.2-0.1H48
		C48.1,44.7,48.2,44.8,48.2,44.9L48.2,44.9z"
            />
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M48.2,45.5c0,0.1-0.1,0.1-0.2,0.1h-3.6c-0.1,0-0.2-0.1-0.2-0.1l0,0c0-0.1,0.1-0.1,0.2-0.1H48
		C48.1,45.4,48.2,45.5,48.2,45.5L48.2,45.5z"
            />
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M48.2,46.3c0,0.1-0.1,0.1-0.2,0.1h-3.6c-0.1,0-0.2-0.1-0.2-0.1l0,0c0-0.1,0.1-0.1,0.2-0.1H48
		C48.1,46.1,48.2,46.2,48.2,46.3L48.2,46.3z"
            />
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M47.6,47.5c0,0.4-0.4,0.7-0.8,0.7h-1.2c-0.4,0-0.8-0.3-0.8-0.7l0,0c0-0.4,0.4-0.7,0.8-0.7h1.2
		C47.3,46.7,47.6,47.1,47.6,47.5L47.6,47.5z"
            />
          </g>
        </g>
      );
    case 'certificate':
      return (
        <g>
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3071"
            strokeMiterlimit="10"
            d="M12.9,44.9h25c1.1,0,2.1-0.9,2.1-2.1V6.7
	c0-1.1-0.9-2.1-2.1-2.1H25.6L10.8,18.9v23.9C10.8,43.9,11.7,44.9,12.9,44.9z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeMiterlimit="10"
            d="M12.6,18.6h11c1.1,0,2.1-0.9,2.1-2.1v-11L12.6,18.6z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M15,25.7h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H15c-0.2,0-0.3,0.1-0.3,0.3v0.7
	C14.7,25.5,14.8,25.7,15,25.7z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M15,31.6h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H15c-0.2,0-0.3,0.1-0.3,0.3v0.7
	C14.7,31.5,14.8,31.6,15,31.6z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M15,37.6h16.7c0.2,0,0.3-0.1,0.3-0.3v-0.8c0-0.2-0.1-0.3-0.3-0.3H15c-0.2,0-0.3,0.1-0.3,0.3v0.8
	C14.7,37.5,14.8,37.6,15,37.6z"
          />
          <path fill={p4Tokens.colorBrandMenuBackground1} d="M13.1,17.8H23c1,0,1.9-0.8,1.9-1.8V6.6L13.1,17.8z" />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M48.3,40.8c0,0.4-0.2,0.8-0.4,1.1c-0.1,0.1-0.2,0.3-0.3,0.4c-0.4,0.5-0.5,1.1-0.5,1.7
		c0,0.3-0.1,0.5-0.1,0.8C47,45.5,46.6,46,46,46.2c-0.3,0.1-0.5,0.2-0.8,0.3c-0.5,0.2-0.9,0.5-1.2,0.9c-0.2,0.2-0.4,0.5-0.7,0.7
		c-0.4,0.4-0.8,0.6-1.3,0.5c-0.3,0-0.6-0.1-0.9-0.2c-0.4-0.1-0.8-0.2-1.3-0.1c-0.3,0-0.6,0.1-0.9,0.2c-0.3,0.1-0.6,0.1-1,0.1
		c-0.5,0-0.9-0.3-1.3-0.7c-0.2-0.2-0.4-0.4-0.6-0.7c-0.3-0.4-0.7-0.6-1.2-0.8c-0.3-0.1-0.6-0.2-0.8-0.4c-0.5-0.3-0.9-0.7-0.9-1.3
		c-0.1-0.4-0.1-0.8-0.1-1.1c0-0.4-0.2-0.8-0.4-1.2c-0.2-0.3-0.4-0.6-0.5-1c-0.3-0.5-0.3-1,0-1.6c0.2-0.3,0.3-0.6,0.5-0.9
		c0.3-0.4,0.4-0.8,0.4-1.3c0-0.4,0.1-0.7,0.1-1.1c0.1-0.6,0.4-1,0.9-1.2c0.3-0.1,0.7-0.3,1-0.4c0.4-0.2,0.8-0.5,1.1-0.8
		c0.2-0.2,0.4-0.5,0.6-0.7c0.5-0.5,1-0.7,1.7-0.5c0.3,0.1,0.6,0.1,1,0.2c0.5,0.1,0.9,0.1,1.3,0c0.4-0.1,0.7-0.2,1.1-0.2
		c0.5-0.1,1,0.1,1.4,0.5c0.2,0.2,0.4,0.4,0.6,0.7c0.4,0.5,0.8,0.8,1.4,1c0.3,0.1,0.5,0.2,0.7,0.3c0.6,0.3,0.9,0.7,1,1.3
		c0.1,0.4,0.1,0.8,0.1,1.2c0,0.4,0.2,0.8,0.4,1.2c0.2,0.3,0.3,0.5,0.5,0.8C48.2,40.3,48.3,40.5,48.3,40.8z M46,40.9
		C46,40.9,46,40.9,46,40.9c0-0.2,0-0.4,0-0.6c0-0.3,0-0.5-0.1-0.8c-0.4-1.7-1.4-3-3-3.9c-0.5-0.3-1.1-0.5-1.7-0.6
		c-0.4-0.1-0.9,0-1.4-0.1c-0.4,0-0.8,0-1.1,0.1c-1.3,0.3-2.3,1-3.1,2c-1.1,1.3-1.5,2.9-1.2,4.6c0.2,1.5,1,2.7,2.1,3.7
		c1,0.8,2.2,1.3,3.5,1.3c0.5,0,0.9,0,1.4-0.1c1.3-0.3,2.4-1,3.3-2c0.6-0.7,1-1.5,1.2-2.5C45.9,41.7,45.9,41.3,46,40.9z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M39.9,49.6c-0.6,1.9-1.3,3.7-1.9,5.5c0,0-0.1-0.1-0.1-0.1c-0.5-0.5-1-1-1.5-1.5c-0.1-0.1-0.1-0.1-0.2-0.1
		c-0.7,0.1-1.5,0.3-2.2,0.4c-0.1,0-0.1,0-0.2,0c0.6-1.9,1.3-3.7,1.9-5.5c0.1,0.1,0.2,0.1,0.2,0.1c0.5,0.3,1.1,0.6,1.6,0.8
		c0.3,0.1,0.7,0.1,1,0.2c0.4,0.1,0.7,0.1,1.1,0.1C39.8,49.5,39.8,49.6,39.9,49.6z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M44.5,48.4c0.6,1.8,1.3,3.6,1.9,5.5c-0.2,0-0.4-0.1-0.6-0.1c-0.6-0.1-1.2-0.2-1.9-0.3c-0.1,0-0.1,0-0.2,0.1
		c-0.4,0.4-0.8,0.8-1.2,1.3c-0.1,0.1-0.2,0.2-0.3,0.3c-0.7-1.8-1.3-3.7-1.9-5.5c0.2,0,0.3,0,0.4-0.1c0.5-0.1,1-0.1,1.5-0.2
		c0.4-0.1,0.8-0.2,1.2-0.4c0.3-0.2,0.6-0.3,0.9-0.5C44.4,48.4,44.4,48.4,44.5,48.4z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M44.9,40.9c0.1,1.8-1.3,3.8-3,4.5c-1.8,0.7-3.9,0.3-5.2-1.2c-1.1-1.2-1.5-2.6-1.3-4.2c0.3-1.7,1.3-3,3-3.6
		c2.4-1,5.4,0.2,6.3,2.9C44.9,39.8,44.9,40.3,44.9,40.9z"
            />
          </g>
          <circle
            fill={p4Tokens.colorBrandMenuForeground1}
            stroke="#FFFFFB"
            strokeWidth="0.9857"
            strokeMiterlimit="10"
            cx="40"
            cy="40.9"
            r="6.1"
          />
        </g>
      );
    case 'usage':
      return (
        <g>
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M14.8,30.3c0,3.7,0,7.3,0,11
		c0,2.6-0.9,3.5-3.5,3.5c-0.5,0-1.1,0-1.6,0C8,44.7,6.9,43.8,6.9,42c0-7.8,0-15.6,0-23.3c0-1.8,1-2.7,2.8-2.8c0.7,0,1.3,0,2,0
		c2.1,0.1,3.1,1,3.1,3.2C14.8,22.8,14.8,26.6,14.8,30.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            stroke={p4Tokens.colorBrandMenuForeground1}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M26.3,33.1c0,2.8,0,5.7,0,8.5
		c0,2.2-1,3.2-3.2,3.2c-0.7,0-1.3,0-2,0c-1.7-0.1-2.7-1.1-2.7-2.7c0-6.1,0-12.2,0-18.2c0-1.7,1-2.6,2.7-2.7c0.7-0.1,1.4,0,2.1,0
		c2,0.1,3,1,3,3.1C26.4,27.1,26.3,30.1,26.3,33.1z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M41.5,35.5c0-2,0-4.1,0-6.1c0-2,1-3,3-3.1
		c0.7,0,1.4,0,2.1,0c1.7,0.1,2.7,1.1,2.7,2.7c0.1,4.3,0.1,8.6,0,13c0,1.7-1,2.6-2.7,2.7c-0.8,0.1-1.5,0-2.3,0
		c-1.8-0.1-2.8-1-2.9-2.9C41.4,39.8,41.5,37.7,41.5,35.5z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M30,38.1c0-1.2,0-2.4,0-3.6
		c0.1-1.8,1.1-2.8,2.9-2.9c0.7,0,1.4,0,2.1,0c1.8,0.1,2.8,1,2.8,2.7c0.1,2.6,0.1,5.1,0,7.7c0,1.7-1.1,2.6-2.7,2.7
		c-0.8,0.1-1.6,0.1-2.5,0c-1.6-0.1-2.6-1.1-2.7-2.7C29.9,40.8,30,39.4,30,38.1z"
          />
        </g>
      );
    case 'deadstock':
      return (
        <g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.2035"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              d="
		M24.1,24.7c0,0-17.7-8-18-7.5c-0.3,0.4,0.1,22.6,0.1,22.6l17.7,7.6L24.1,24.7z"
            />

            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              d="
		M6.3,16.9c2.1-1,16-6.3,16.8-6.4c1,0,18.7,6.2,18.2,6.5c-0.4,0.3-15.9,7.2-17.1,7.5C23.1,24.9,6.4,16.9,6.3,16.9"
            />

            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              d="
		M24.3,24.6c0,0,17.2-8.1,17.2-7.5c0,10.2,0.2,22-0.2,22.3c-0.7,0.4-16.9,8.5-17.1,8C24,47,24.3,24.6,24.3,24.6z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M28.9,12.9l-16.3,7v9.9c0,0,3.8,2,3.9,1.2c0.2-3.1,0.2-9.6,0.2-9.3l16.5-7.3L28.9,12.9z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M42.7,32.8c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C51.4,36.7,47.5,32.8,42.7,32.8z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M45.6,46.3l-7.1-7.1c-0.2-0.2-0.2-0.6,0-0.9l0.5-0.5c0.2-0.2,0.6-0.2,0.9,0l7.1,7.1c0.2,0.2,0.2,0.6,0,0.9
		l-0.5,0.5C46.2,46.5,45.8,46.5,45.6,46.3z"
            />
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M38.5,45l7.1-7.1c0.2-0.2,0.6-0.2,0.9,0l0.5,0.5c0.2,0.2,0.2,0.6,0,0.9l-7.1,7.1c-0.2,0.2-0.6,0.2-0.9,0
		l-0.5-0.5C38.2,45.6,38.2,45.2,38.5,45z"
            />
          </g>
        </g>
      );
    case 'minmax':
      return (
        <g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M14.2,29.6h0.7l0.6,1.5c0.1,0.2,0.1,0.4,0.2,0.6h0c0.1-0.2,0.1-0.4,0.2-0.6l0.6-1.5h0.7v3.1h-0.6v-1.4
		c0-0.3,0-0.7,0.1-1h0L16.5,31L16,32.4h-0.4L15,31l-0.3-0.7h0c0,0.3,0.1,0.7,0.1,1v1.4h-0.6V29.6z"
            />
            <path fill={p4Tokens.colorBrandMenuForeground2} d="M18.2,29.6h0.6v3.1h-0.6V29.6z" />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M19.8,29.6h0.6l1.1,1.7l0.4,0.7h0c0-0.3-0.1-0.7-0.1-1.1v-1.3h0.6v3.1h-0.6L20.7,31l-0.4-0.7h0
		c0,0.3,0.1,0.7,0.1,1v1.4h-0.6V29.6z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M36.1,29.6h0.7l0.6,1.5c0.1,0.2,0.1,0.4,0.2,0.6h0c0.1-0.2,0.1-0.4,0.2-0.6l0.6-1.5h0.7v3.1h-0.6v-1.4
		c0-0.3,0-0.7,0.1-1h0L38.4,31l-0.6,1.4h-0.4L36.9,31l-0.3-0.7h0c0,0.3,0.1,0.7,0.1,1v1.4h-0.6V29.6z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M40.8,29.6h0.7l1.1,3.1H42l-0.5-1.6c-0.1-0.3-0.2-0.7-0.3-1h0c-0.1,0.3-0.2,0.7-0.3,1l-0.5,1.6h-0.6
		L40.8,29.6z M40.3,31.4H42v0.4h-1.7V31.4z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M43.7,31.1l-0.9-1.5h0.7l0.4,0.7c0.1,0.1,0.2,0.3,0.3,0.5h0c0.1-0.2,0.2-0.3,0.2-0.5l0.4-0.7h0.7l-0.9,1.5
		l1,1.6h-0.7L44.4,32c-0.1-0.2-0.2-0.3-0.3-0.5h0c-0.1,0.2-0.2,0.3-0.3,0.5l-0.4,0.7h-0.7L43.7,31.1z"
            />
          </g>
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M25.7,40.1c-0.6,0-1.1,0-1.7,0c-0.1-0.1-0.2-0.1-0.3-0.2c0-1.2,0-2.4,0-3.7c0.1-0.1,0.2-0.1,0.3-0.2
	c0.6,0,1.1,0,1.7,0c0.1,0.1,0.2,0.1,0.2,0.2c0,1.2,0,2.5,0,3.7C25.9,40,25.8,40,25.7,40.1z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M34.6,40.1c-0.6,0-1.1,0-1.7,0c-0.1-0.1-0.2-0.1-0.3-0.2c0-1.2,0-2.4,0-3.7c0.1-0.1,0.2-0.1,0.3-0.2
	c0.6,0,1.1,0,1.7,0c0.1,0.1,0.2,0.1,0.2,0.2c0,1.2,0,2.5,0,3.7C34.8,40,34.7,40,34.6,40.1z"
          />
          <circle fill={p4Tokens.colorBrandMenuForeground2} cx="20.4" cy="38" r="1.7" />
          <circle fill={p4Tokens.colorBrandMenuForeground2} cx="38.3" cy="38" r="1.7" />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M28.8,5.2c-12.7,0-23,10.3-23,23c0,12.7,10.3,23,23,23s23-10.3,23-23C51.7,15.5,41.5,5.2,28.8,5.2z
		 M28.8,49.3c-11.7,0-21.1-9.5-21.1-21.1C7.6,16.5,17.1,7,28.8,7s21.1,9.5,21.1,21.1C49.9,39.8,40.4,49.3,28.8,49.3z"
            />
            <rect x="28.1" y="7" fill={p4Tokens.colorBrandMenuForeground2} width="1" height="2.5" />

            <rect
              x="39.8"
              y="10.3"
              transform="matrix(0.8656 0.5007 -0.5007 0.8656 10.9803 -18.5269)"
              fill={p4Tokens.colorBrandMenuForeground2}
              width="0.4"
              height="1.7"
            />

            <rect
              x="10.3"
              y="18.3"
              transform="matrix(0.5074 -0.8617 0.8617 0.5074 -11.2759 18.5134)"
              fill={p4Tokens.colorBrandMenuForeground2}
              width="0.4"
              height="1.7"
            />

            <rect
              x="46.8"
              y="18.3"
              transform="matrix(-0.5074 -0.8617 0.8617 -0.5074 54.4442 69.3611)"
              fill={p4Tokens.colorBrandMenuForeground2}
              width="0.4"
              height="1.7"
            />

            <rect
              x="17.2"
              y="10.3"
              transform="matrix(0.8707 -0.4918 0.4918 0.8707 -3.2471 10.0302)"
              fill={p4Tokens.colorBrandMenuForeground2}
              width="0.4"
              height="1.7"
            />

            <rect
              x="8.2"
              y="27"
              transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 37.0509 19.6462)"
              fill={p4Tokens.colorBrandMenuForeground2}
              width="1"
              height="2.8"
            />

            <rect
              x="48.4"
              y="26.8"
              transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 77.2265 -20.5294)"
              fill={p4Tokens.colorBrandMenuForeground2}
              width="1"
              height="3"
            />
          </g>
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M30.1,17.4c0-1.3,0-2.6,0-3.9c0-0.4,0-0.6,0.5-0.6c2.8,0.3,5.4,1.1,7.8,2.7c0.6,0.4,0.6,0.6,0.1,1.2
	c-1.9,1.8-3.7,3.7-5.6,5.6c-0.4,0.4-0.8,0.8-1.4,0.5c-1.1-0.7-1.5-0.6-1.5-1.7C30.2,19.9,30.1,18.6,30.1,17.4z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M40.1,23.3c0.1,0,0.4,0,0.5,0.1c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.3,0.3-0.5,0.4c-3,2.1-5.9,4.2-9,6.3
	c-1,0.7-2,0.8-3,0.2c-1-0.5-1.4-1.4-1.4-2.5c0-1.2,0.7-2.2,1.9-2.5"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M28.6,20.8c0,0.1-0.1,0.2-0.2,0.2c-1.5-0.5-2.9-0.8-4.4-0.7c-0.3,0-2.8-2.6-3.9-3.6
	c-0.5-0.4-0.4-0.7,0.1-0.9c1.7-1,4.7-2.3,7.8-2.8c0.4,0,0.6-0.1,0.6,0.4C28.6,15.8,28.6,18.2,28.6,20.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M21.6,20.3c0.1,0.1,0.1,0.2,0,0.3c-0.8,0.3-3.9,1.3-7.2,5.4c-0.2,0.2-0.3,0.4-0.5,0.6
	c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2-0.1-0.2-0.3-0.1-0.5c0.7-3.3,2.1-6.2,4.5-8.6c0.4-0.4,0.7-0.4,1.2,0C19.8,18.6,20.7,19.4,21.6,20.3z
	"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M35.2,22.3c1.7-1.7,3.1-3.1,4.5-4.6c0.4-0.4,0.6-0.3,1-0.1c1,0.8,1.7,1.8,2.4,2.9c0.3,0.4,0.2,0.6-0.2,0.6
	c-2.7,0.2-3.1,0.4-5.6,0.8C36.7,22,35.3,22.3,35.2,22.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M39.9,26.8c0.7-0.5,1.9-1.4,2.6-2c0.7-0.6,1.5-1.1,1.6-2.1c0-0.1,0.1-0.1,0.1,0c0.7,1.2,1.1,2.6,1.2,4
	c0,0.3-0.2,0.2-0.4,0.2c-1.7,0-3.1,0-4.8,0C39.9,26.9,39.9,27,39.9,26.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M28.5,40.1c-0.4,0-0.9,0-1.3,0C27.1,40,27,40,27,39.9c0-1.2,0-2.4,0-3.7c0.1-0.1,0.1-0.1,0.2-0.2
	c0.4,0,0.9,0,1.3,0c0.1,0.1,0.1,0.1,0.2,0.2c0,1.2,0,2.5,0,3.7C28.6,40,28.5,40,28.5,40.1z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M31.6,36.2c0,1.2,0,2.4,0,3.7c-0.1,0.1-0.1,0.1-0.2,0.2c-0.4,0-0.9,0-1.3,0C30.1,40,30,40,29.9,39.9
	c0-1.2,0-2.5,0-3.7c0.1-0.1,0.1-0.1,0.2-0.2c0.4,0,0.9,0,1.3,0C31.5,36.1,31.6,36.2,31.6,36.2z"
          />
        </g>
      );
    case 'imageimp':
      return (
        <g>
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            d="M38.1,17.2h-6v-2.3c0-1.2-1-2.2-2.2-2.2H18.1c-1.2,0-2.2,1-2.2,2.2v2.3
	h-6c-3,0-5.4,2.4-5.4,5.4v14.1c0,3,2.4,5.4,5.4,5.4h28.2c3,0,5.4-2.4,5.4-5.4V22.6C43.5,19.6,41.1,17.2,38.1,17.2z"
          />
          <circle
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            cx="24"
            cy="30.1"
            r="7.3"
          />
          <circle fill={p4Tokens.colorBrandMenuForeground1} cx="10.9" cy="22.7" r="2.1" />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M45,31.4c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C53.7,35.4,49.8,31.4,45,31.4z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M49.7,41.3H39.7c-0.3,0-0.6-0.3-0.6-0.6V40c0-0.3,0.3-0.6,0.6-0.6h10.1c0.3,0,0.6,0.3,0.6,0.6v0.6
		C50.4,41,50.1,41.3,49.7,41.3z"
            />
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M43.8,45.4V35.3c0-0.3,0.3-0.6,0.6-0.6H45c0.3,0,0.6,0.3,0.6,0.6v10.1c0,0.3-0.3,0.6-0.6,0.6h-0.6
		C44,46,43.8,45.7,43.8,45.4z"
            />
          </g>
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M48.4,14c-0.5,0-1,0.4-1,1l0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0l-0.1,6.6c0,0.2-0.2,0.5-0.4,0.5l-0.6,0
	c-0.3,0-0.5,0.3-0.4,0.6l2.1,5.8c0.1,0.4,0.7,0.4,0.8,0l2.1-5.8c0.1-0.3-0.1-0.6-0.4-0.6l-0.7,0c-0.2,0-0.4-0.2-0.4-0.5l0.1-6.7l0,0
	C49.4,14.5,48.9,14,48.4,14z"
          />
        </g>
      );
    case 'productpricemat':
      return (
        <g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.2035"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              d="
		M21.5,23.3c0,0-17.7-8-18-7.5s0.1,22.6,0.1,22.6L21.3,46L21.5,23.3z"
            />

            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              d="
		M3.7,15.5c2.1-1,16-6.3,16.8-6.4c1,0,18.7,6.2,18.2,6.5s-15.9,7.2-17.1,7.5C20.5,23.4,3.8,15.4,3.7,15.5"
            />

            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              d="
		M21.7,23.1c0,0,17.2-8.1,17.2-7.5c0,10.2,0.2,22-0.2,22.3c-0.7,0.4-16.9,8.5-17.1,8C21.4,45.6,21.7,23.1,21.7,23.1z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M26.3,11.5l-16.3,7v9.9c0,0,3.8,2,3.9,1.2c0.2-3.1,0.2-9.6,0.2-9.3L30.5,13L26.3,11.5z"
            />
          </g>
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M49.5,28.8h-1.2v1.1h1.2c0.9,0,1.7,0.5,1.7,1.1V48c0,0.6-0.8,1.1-1.7,1.1h-1.2v1.1h1.2c1.8,0,3.3-1,3.3-2.2
	V31C52.7,29.8,51.3,28.8,49.5,28.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            d="M31,43.2l-4.1,2c-0.6,0.3-1.4,0.1-1.8-0.6L25,44.3c-0.3-0.6-0.1-1.4,0.6-1.8l4.1-2c0.6-0.3,1.4-0.1,1.8,0.6
	l0.1,0.3C31.9,42.1,31.6,42.8,31,43.2z"
          />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M40.1,31.3c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C48.8,35.3,44.9,31.3,40.1,31.3z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M36.5,45.5v-0.9c1.2-0.6,2-1.7,2-3c0-0.4,0-0.8-0.1-1.2h-1.8v-1.1h1.6c-0.1-0.5-0.2-1.2-0.2-1.9
		c0-2.1,1.4-3.4,3.3-3.4c0.9,0,1.5,0.2,1.9,0.4l-0.3,1.1c-0.3-0.2-0.8-0.3-1.6-0.3c-1.4,0-1.9,0.9-1.9,2.2c0,0.7,0.1,1.3,0.2,1.9
		h2.5v1.1h-2.4c0.1,0.7,0.1,1.3-0.1,1.9c-0.2,0.7-0.6,1.4-1.2,1.9v0h5.2v1.3H36.5z"
            />
          </g>
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M29.9,50.2h1.2v-1h-1.2c-0.9,0-1.7-0.5-1.7-1V32c0-0.6,0.8-1,1.7-1h1.2v-1h-1.2c-1.8,0-3.3,0.9-3.3,2.1v16.2
	C26.6,49.3,28.1,50.2,29.9,50.2z"
          />
        </g>
      );
    case 'promomessage':
      return (
        <g>
          <path
            fill="#FFFFFF"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            d="M49.3,27.2c0-8.9-9.2-16.1-20.5-16.1c-11.3,0-20.5,7.2-20.5,16.1
	c0,8.6,8.5,15.6,19.3,16.1l8.8,8l-4.6-8.1C41.6,42,49.3,35.3,49.3,27.2z"
          />
          <circle
            fill={p4Tokens.colorBrandMenuForeground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.75"
            cx="19.1"
            cy="27.1"
            r="2.9"
          />
          <circle
            fill={p4Tokens.colorBrandMenuForeground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.75"
            cx="28.3"
            cy="27.1"
            r="2.9"
          />
          <circle
            fill={p4Tokens.colorBrandMenuForeground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="0.75"
            cx="37.4"
            cy="27.1"
            r="2.9"
          />
        </g>
      );
    case 'goodsinreport':
      return (
        <g>
          <g>
            <path
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3071"
              strokeMiterlimit="10"
              d="M12.7,47.8h25c1.1,0,2.1-0.9,2.1-2.1V9.6
		c0-1.1-0.9-2.1-2.1-2.1H25.4L10.6,21.8v23.9C10.6,46.8,11.5,47.8,12.7,47.8z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeMiterlimit="10"
              d="M12.4,21.5h11c1.1,0,2.1-0.9,2.1-2.1v-11L12.4,21.5z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M14.8,28.6h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H14.8c-0.2,0-0.3,0.1-0.3,0.3v0.7
		C14.5,28.4,14.6,28.6,14.8,28.6z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M14.8,34.5h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H14.8c-0.2,0-0.3,0.1-0.3,0.3v0.7
		C14.5,34.4,14.6,34.5,14.8,34.5z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M14.8,40.5h16.7c0.2,0,0.3-0.1,0.3-0.3v-0.8c0-0.2-0.1-0.3-0.3-0.3H14.8c-0.2,0-0.3,0.1-0.3,0.3v0.8
		C14.5,40.4,14.6,40.5,14.8,40.5z"
            />
            <path fill={p4Tokens.colorBrandMenuBackground1} d="M12.9,20.7h9.9c1,0,1.9-0.8,1.9-1.8V9.5L12.9,20.7z" />
            <g>
              <g>
                <path
                  fill={p4Tokens.colorBrandMenuForeground1}
                  d="M41.6,35.2c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C50.4,39.1,46.5,35.2,41.6,35.2
				z"
                />
              </g>
            </g>
          </g>
          <g>
            <g>
              <polygon fill={p4Tokens.colorBrandMenuBackground1} points="36.2,41.6 41.2,43.4 41.2,49 36.2,47.2 		" />
              <polygon fill={p4Tokens.colorBrandMenuBackground1} points="42,43.4 47.1,41.6 47.1,47.2 42.1,49.1 		" />
              <polygon fill={p4Tokens.colorBrandMenuBackground1} points="36.8,40.8 41.6,42.6 46.6,40.8 41.6,38.9 		" />
            </g>
          </g>
        </g>
      );
    case 'stocktakedirect':
      return (
        <g>
          <rect x="17.6" y="29.7" fill="none" stroke={p4Tokens.colorBrandMenuForeground1} width="4.7" height="4.7" />
          <rect x="17.6" y="23.7" fill="none" stroke={p4Tokens.colorBrandMenuForeground1} width="4.7" height="4.7" />
          <rect x="17.6" y="17.7" fill="none" stroke={p4Tokens.colorBrandMenuForeground1} width="4.7" height="4.7" />
          <rect x="17.6" y="35.7" fill="none" stroke={p4Tokens.colorBrandMenuForeground1} width="4.7" height="4.7" />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M34.9,27.3H25c-0.3,0-0.6-0.2-0.6-0.5v-0.5c0-0.3,0.3-0.5,0.6-0.5h9.9c0.3,0,0.6,0.2,0.6,0.5v0.5
	C35.5,27.1,35.2,27.3,34.9,27.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M34.9,21.9H25c-0.3,0-0.6-0.2-0.6-0.5v-0.5c0-0.3,0.3-0.5,0.6-0.5h9.9c0.3,0,0.6,0.2,0.6,0.5v0.5
	C35.5,21.7,35.2,21.9,34.9,21.9z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M35.2,32.3h-9.9c-0.3,0-0.6-0.2-0.6-0.5v-0.5c0-0.3,0.3-0.5,0.6-0.5h9.9c0.3,0,0.6,0.2,0.6,0.5v0.5
	C35.8,32.1,35.5,32.3,35.2,32.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M33.3,37.8h-8.4c-0.3,0-0.5-0.2-0.5-0.5v-0.5c0-0.3,0.2-0.5,0.5-0.5h8.4c0.3,0,0.5,0.2,0.5,0.5v0.5
	C33.8,37.6,33.6,37.8,33.3,37.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M23.2,18.7l-2.3,2.6c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0-0.3,0-0.4-0.1l-1.4-1.1c-0.2-0.2-0.3-0.6-0.1-0.8
	c0.2-0.2,0.6-0.3,0.8-0.1l1,0.8l1.9-2.2c0.2-0.2,0.6-0.3,0.8,0C23.4,18.1,23.4,18.4,23.2,18.7z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M23.2,24.7l-2.3,2.6c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0-0.3,0-0.4-0.1l-1.4-1.1c-0.2-0.2-0.3-0.6-0.1-0.8
	c0.2-0.2,0.6-0.3,0.8-0.1l1,0.8l1.9-2.2c0.2-0.2,0.6-0.3,0.8,0C23.4,24.1,23.4,24.4,23.2,24.7z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M39.4,8.2H13.8c-0.8,0-2.1,1.2-2.1,2.8v33.2c0,1.5,1.2,2.8,2.8,2.8H32c-0.4-1.1-0.4-1.7-0.5-2.9H14.7l0-29.7
	h25.4l0,17.8c0.9-0.2,1-0.3,2-0.5c0.2,0,0.5,0,0.7,0V10.9C42.9,9.4,41.7,8.2,39.4,8.2z M31.2,11.2c0,0.2-0.2,0.4-0.4,0.4h-7.1
	c-0.2,0-0.4-0.2-0.4-0.4v-0.4c0-0.2,0.2-0.4,0.4-0.4h7.1c0.2,0,0.4,0.2,0.4,0.4V11.2z"
          />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M41.7,33.4c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C50.4,37.4,46.5,33.4,41.7,33.4z"
            />
          </g>
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke="#FFFFFB"
            strokeWidth="0.5"
            strokeMiterlimit="10"
            d="M46.7,38.8l-6.8,7.6c-0.1,0.1-0.3,0.2-0.4,0.2
	c-0.1,0-0.3,0-0.4-0.1l-2.3-1.8c-0.2-0.2-0.3-0.6-0.1-0.8c0.2-0.2,0.6-0.3,0.8-0.1l1.9,1.4l6.5-7.2c0.2-0.2,0.6-0.3,0.8,0
	C46.9,38.2,46.9,38.5,46.7,38.8z"
          />
        </g>
      );
    case 'stocktakeprog':
      return (
        <g>
          <rect x="17.7" y="29.7" fill="none" stroke={p4Tokens.colorBrandMenuForeground1} width="4.7" height="4.7" />
          <rect x="17.7" y="23.7" fill="none" stroke={p4Tokens.colorBrandMenuForeground1} width="4.7" height="4.7" />
          <rect x="17.7" y="17.7" fill="none" stroke={p4Tokens.colorBrandMenuForeground1} width="4.7" height="4.7" />
          <rect x="17.7" y="35.7" fill="none" stroke={p4Tokens.colorBrandMenuForeground1} width="4.7" height="4.7" />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M34.9,27.3h-9.9c-0.3,0-0.6-0.2-0.6-0.5v-0.5c0-0.3,0.3-0.5,0.6-0.5h9.9c0.3,0,0.6,0.2,0.6,0.5v0.5
	C35.6,27.1,35.3,27.3,34.9,27.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M34.9,21.9h-9.9c-0.3,0-0.6-0.2-0.6-0.5v-0.5c0-0.3,0.3-0.5,0.6-0.5h9.9c0.3,0,0.6,0.2,0.6,0.5v0.5
	C35.6,21.7,35.3,21.9,34.9,21.9z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M35.2,32.3h-9.9c-0.3,0-0.6-0.2-0.6-0.5v-0.5c0-0.3,0.3-0.5,0.6-0.5h9.9c0.3,0,0.6,0.2,0.6,0.5v0.5
	C35.8,32.1,35.6,32.3,35.2,32.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M33.4,37.8H25c-0.3,0-0.5-0.2-0.5-0.5v-0.5c0-0.3,0.2-0.5,0.5-0.5h8.4c0.3,0,0.5,0.2,0.5,0.5v0.5
	C33.9,37.6,33.7,37.8,33.4,37.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M23.3,18.7L21,21.2c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0-0.3,0-0.4-0.1l-1.4-1.1c-0.2-0.2-0.3-0.6-0.1-0.8
	c0.2-0.2,0.6-0.3,0.8-0.1l1,0.8l1.9-2.2c0.2-0.2,0.6-0.3,0.8,0C23.4,18.1,23.5,18.4,23.3,18.7z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M23.3,24.7L21,27.2c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0-0.3,0-0.4-0.1l-1.4-1.1c-0.2-0.2-0.3-0.6-0.1-0.8
	c0.2-0.2,0.6-0.3,0.8-0.1l1,0.8l1.9-2.2c0.2-0.2,0.6-0.3,0.8,0C23.4,24.1,23.5,24.4,23.3,24.7z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M39.5,8.2H13.9c-0.8,0-2.1,1.2-2.1,2.8v33.2c0,1.5,1.2,2.8,2.8,2.8H32c-0.4-1.1-0.4-1.7-0.5-2.9H14.8l0-29.7
	h25.4l0,17.8c0.9-0.2,1-0.3,2-0.5c0.2,0,0.5,0,0.7,0V10.9C43,9.4,41.7,8.2,39.5,8.2z M31.3,11.2c0,0.2-0.2,0.4-0.4,0.4h-7.1
	c-0.2,0-0.4-0.2-0.4-0.4v-0.4c0-0.2,0.2-0.4,0.4-0.4h7.1c0.2,0,0.4,0.2,0.4,0.4V11.2z"
          />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              d="M41.7,33.4c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C50.5,37.4,46.5,33.4,41.7,33.4z"
            />
          </g>
          <g>
            <circle fill={p4Tokens.colorBrandMenuForeground1} cx="41.7" cy="42" r="8.2" />
            <circle fill={p4Tokens.colorBrandMenuBackground1} cx="41.7" cy="42" r="6.5" />
            <polygon fill={p4Tokens.colorBrandMenuForeground1} points="42.4,42 46,38.6 41.9,41.4 	" />
            <polygon fill={p4Tokens.colorBrandMenuForeground1} points="41,42.2 38.8,40.3 41.5,41.4 	" />
            <rect x="41.6" y="35.5" fill={p4Tokens.colorBrandMenuForeground1} width="0.3" height="0.7" />

            <rect
              x="44.7"
              y="36.3"
              transform="matrix(0.8656 0.5007 -0.5007 0.8656 24.3129 -17.5265)"
              fill={p4Tokens.colorBrandMenuForeground1}
              width="0.1"
              height="0.5"
            />

            <rect
              x="36.2"
              y="38.7"
              transform="matrix(0.5074 -0.8617 0.8617 0.5074 -15.6729 50.3904)"
              fill={p4Tokens.colorBrandMenuForeground1}
              width="0.1"
              height="0.5"
            />

            <rect
              x="38.5"
              y="36.4"
              transform="matrix(0.8707 -0.4918 0.4918 0.8707 -13.0088 23.6861)"
              fill={p4Tokens.colorBrandMenuForeground1}
              width="0.1"
              height="0.5"
            />

            <rect
              x="35.4"
              y="41.7"
              transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 77.5526 6.5111)"
              fill={p4Tokens.colorBrandMenuForeground1}
              width="0.3"
              height="0.7"
            />
            <circle fill={p4Tokens.colorBrandMenuForeground1} cx="41.7" cy="42" r="0.8" />
            <circle
              fill={p4Tokens.colorBrandMenuForeground1}
              stroke={p4Tokens.colorBrandMenuForeground1}
              strokeMiterlimit="10"
              cx="41.7"
              cy="42"
              r="0.5"
            />
          </g>
        </g>
      );
    case 'receiptlabel':
      return (
        <g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M19.6,49c-0.8-0.3-1.5-0.6-2.2-1c-0.7-0.3-1.4-0.3-2.1,0c-0.4,0.2-0.9,0.4-1.3,0.6c-1.3,0.6-2.3,0-2.3-1.4
		c0-9.7,0-19.4,0-29.2c0-2.7,0-5.5,0-8.2c0-1.4,0.9-2.2,2.3-2.2c9.5,0,19,0,28.5,0c1.4,0,2.3,0.8,2.3,2.2c0,12.5,0,25,0,37.4
		c0,1-0.5,1.6-1.3,1.6c-0.3,0-0.7-0.1-1-0.2c-0.4-0.2-0.8-0.4-1.2-0.6c-0.7-0.3-1.4-0.3-2.2,0c-0.7,0.3-1.5,0.7-2.2,1
		c-0.4,0-0.8,0-1.2,0c-0.7-0.3-1.5-0.6-2.2-1c-0.7-0.3-1.5-0.3-2.2,0c-0.7,0.3-1.5,0.6-2.3,1c-0.4,0-0.8,0-1.2,0
		c-0.8-0.3-1.5-0.6-2.3-1c-0.7-0.3-1.4-0.3-2.1,0c-0.8,0.3-1.5,0.7-2.3,1C20.4,49,20,49,19.6,49z M43.3,47.6c0-0.2,0-0.4,0-0.5
		c0-12.4,0-24.7,0-37.1c0-0.7-0.2-0.9-1-0.9c-9.4,0-18.9,0-28.3,0c-0.7,0-1,0.2-1,0.9c0,12.4,0,24.7,0,37.1c0,0.1,0,0.3,0,0.5
		c0.5-0.2,0.9-0.4,1.3-0.6c1.3-0.7,2.6-0.7,3.9,0c0.1,0.1,0.3,0.1,0.4,0.2c1.1,0.7,2.1,0.6,3.2,0c0.2-0.1,0.5-0.3,0.7-0.4
		c1.1-0.5,2.2-0.5,3.3,0c0.4,0.2,0.8,0.4,1.3,0.6c0.7,0.3,1.4,0.3,2.1,0c0.4-0.2,0.8-0.4,1.2-0.6c1.1-0.5,2.2-0.5,3.4,0
		c0.4,0.2,0.8,0.4,1.1,0.6c0.8,0.4,1.5,0.4,2.3,0c0.4-0.2,0.8-0.4,1.2-0.6c0.4-0.2,0.9-0.3,1.3-0.3c0.8-0.1,1.5,0.1,2.2,0.5
		C42.3,47.2,42.8,47.3,43.3,47.6z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M24.3,12.9c2.5,0,5,0,7.5,0c0.3,0,0.6,0,0.8,0.3c0.3,0.5-0.1,1-0.7,1c-1.2,0-2.4,0-3.6,0
		c-3.7,0-7.5,0-11.2,0c-0.2,0-0.4,0-0.6-0.1C16.1,14,16,13.8,16,13.4c0-0.3,0.2-0.5,0.6-0.6c0.1,0,0.3,0,0.4,0
		C19.4,12.9,21.9,12.9,24.3,12.9z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M24.3,20.4c2.5,0,4.9,0,7.4,0c0.4,0,0.7,0.1,0.8,0.4c0.2,0.5-0.2,0.9-0.8,0.9c-1.3,0-2.5,0-3.8,0
		c-3.7,0-7.4,0-11,0c-0.2,0-0.4,0-0.5-0.1C16.1,21.6,16,21.4,16,21c0-0.3,0.2-0.5,0.6-0.6c0.2,0,0.3,0,0.5,0
		C19.5,20.4,21.9,20.4,24.3,20.4z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M21.6,16.6c1.6,0,3.1,0,4.7,0c0.6,0,0.9,0.4,0.8,0.8c-0.1,0.3-0.4,0.5-0.8,0.5c-1,0-2,0-2.9,0
		c-2.1,0-4.3,0-6.4,0c-0.2,0-0.4,0-0.5-0.1c-0.3-0.1-0.5-0.4-0.4-0.7c0-0.3,0.3-0.5,0.6-0.6c0.3,0,0.6,0,0.9,0
		C18.9,16.6,20.3,16.6,21.6,16.6C21.6,16.6,21.6,16.6,21.6,16.6z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M38.2,12.9c0.5,0,0.9,0,1.4,0c0.4,0,0.7,0.3,0.7,0.6c0,0.4-0.3,0.7-0.7,0.7c-1,0-2,0-2.9,0
		c-0.5,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.6,0.7-0.6C37.2,12.8,37.7,12.8,38.2,12.9C38.2,12.8,38.2,12.9,38.2,12.9z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M38.2,16.6c0.5,0,0.9,0,1.4,0c0.5,0,0.7,0.2,0.8,0.6c0,0.4-0.3,0.7-0.7,0.7c-1,0-2,0-3,0
		c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.6,0.7-0.7C37.2,16.6,37.7,16.6,38.2,16.6C38.2,16.6,38.2,16.6,38.2,16.6z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M38.1,21.8c-0.4,0-0.9,0-1.3,0c-0.5,0-0.8-0.3-0.8-0.7c0-0.4,0.3-0.7,0.8-0.7c0.9,0,1.8,0,2.8,0
		c0.5,0,0.8,0.3,0.8,0.7c0,0.4-0.3,0.7-0.8,0.7C39.1,21.8,38.6,21.8,38.1,21.8z"
            />
          </g>
          <rect
            x="16.1"
            y="28"
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground1}
            width="24.3"
            height="12.8"
          />
          <rect x="18" y="30.1" fill={p4Tokens.colorBrandMenuForeground1} width="20.7" height="8.7" />
        </g>
      );
    case 'amazonorders':
      return (
        <g>
          <g>
            <polyline
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.5948"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              points="
		10.6,12.1 22.1,43.2 40.2,43.2 	"
            />

            <polyline
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3821"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              points="
		19.1,34.2 42.2,34.2 45.7,20.1 14.1,20.1 	"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              stroke={p4Tokens.colorBrandMenuForeground1}
              strokeWidth="1.3821"
              strokeMiterlimit="10"
              d="M28.2,48.9c0,1.5-1.2,2.8-2.8,2.8
		c-1.5,0-2.8-1.2-2.8-2.8c0-1.5,1.2-2.8,2.8-2.8C26.9,46.2,28.2,47.4,28.2,48.9z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              stroke={p4Tokens.colorBrandMenuForeground1}
              strokeWidth="1.3821"
              strokeMiterlimit="10"
              d="M40.4,48.9c0,1.5-1.2,2.8-2.8,2.8
		s-2.8-1.2-2.8-2.8c0-1.5,1.2-2.8,2.8-2.8S40.4,47.4,40.4,48.9z"
            />
            <line
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="0.172"
              strokeMiterlimit="10"
              x1="22.1"
              y1="20.6"
              x2="22.1"
              y2="33.7"
            />
            <line
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="0.6511"
              strokeMiterlimit="10"
              x1="29.7"
              y1="20.6"
              x2="29.7"
              y2="33.7"
            />
            <line
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="0.6511"
              strokeMiterlimit="10"
              x1="22.1"
              y1="20.6"
              x2="22.1"
              y2="33.7"
            />
            <line
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="0.6511"
              strokeMiterlimit="10"
              x1="37.2"
              y1="20.1"
              x2="37.2"
              y2="33.7"
            />
            <line
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="0.6511"
              strokeMiterlimit="10"
              x1="16.1"
              y1="27.2"
              x2="43.2"
              y2="27.2"
            />
          </g>
          <g>
            <g>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                fill="#F7981D"
                d="M35.1,14.6c-2,1.5-5,2.3-7.6,2.3c-3.6,0-6.8-1.3-9.2-3.5
			c-0.2-0.2,0-0.4,0.2-0.3c2.6,1.5,5.9,2.5,9.3,2.5c2.3,0,4.8-0.5,7.1-1.4C35.2,13.9,35.4,14.3,35.1,14.6z"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                fill="#F7981D"
                d="M36,13.6c-0.3-0.3-1.7-0.2-2.4-0.1c-0.2,0-0.2-0.2-0.1-0.3
			c1.2-0.8,3.1-0.6,3.3-0.3c0.2,0.3-0.1,2.2-1.2,3.1c-0.2,0.1-0.3,0.1-0.3-0.1C35.7,15.3,36.2,13.9,36,13.6z"
              />
            </g>
            <g>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M33.6,7.4V6.6c0-0.1,0.1-0.2,0.2-0.2l3.6,0c0.1,0,0.2,0.1,0.2,0.2v0.7
			c0,0.1-0.1,0.3-0.3,0.5l-1.9,2.7c0.7,0,1.4,0.1,2,0.4c0.1,0.1,0.2,0.2,0.2,0.3v0.9c0,0.1-0.1,0.3-0.3,0.2c-1.1-0.6-2.6-0.6-3.8,0
			c-0.1,0.1-0.3-0.1-0.3-0.2v-0.8c0-0.1,0-0.4,0.1-0.5l2.2-3.1l-1.9,0C33.7,7.6,33.6,7.5,33.6,7.4z"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.5,12.4h-1.1c-0.1,0-0.2-0.1-0.2-0.2l0-5.6c0-0.1,0.1-0.2,0.2-0.2l1,0
			c0.1,0,0.2,0.1,0.2,0.2v0.7h0c0.3-0.7,0.8-1,1.4-1c0.7,0,1.1,0.3,1.4,1c0.3-0.7,0.9-1,1.5-1c0.5,0,1,0.2,1.3,0.6
			c0.3,0.5,0.3,1.2,0.3,1.8l0,3.5c0,0.1-0.1,0.2-0.2,0.2h-1.1c-0.1,0-0.2-0.1-0.2-0.2l0-3c0-0.2,0-0.8,0-1c-0.1-0.4-0.3-0.5-0.6-0.5
			c-0.3,0-0.5,0.2-0.7,0.5c-0.1,0.3-0.1,0.8-0.1,1.1v3c0,0.1-0.1,0.2-0.2,0.2h-1.1c-0.1,0-0.2-0.1-0.2-0.2l0-3
			c0-0.6,0.1-1.5-0.7-1.5c-0.8,0-0.8,0.9-0.8,1.5l0,3C20.8,12.3,20.7,12.4,20.5,12.4z"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M40.7,6.3c1.6,0,2.5,1.4,2.5,3.2c0,1.7-1,3.1-2.5,3.1c-1.6,0-2.5-1.4-2.5-3.1
			C38.2,7.7,39.1,6.3,40.7,6.3z M40.7,7.5c-0.8,0-0.9,1.1-0.9,1.8c0,0.7,0,2.1,0.8,2.1c0.8,0,0.9-1.2,0.9-1.9c0-0.5,0-1-0.2-1.5
			C41.3,7.6,41.1,7.5,40.7,7.5z"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M45.3,12.4h-1.1c-0.1,0-0.2-0.1-0.2-0.2l0-5.6c0-0.1,0.1-0.2,0.2-0.2l1,0
			c0.1,0,0.2,0.1,0.2,0.2v0.9h0c0.3-0.8,0.7-1.1,1.5-1.1c0.5,0,1,0.2,1.3,0.7c0.3,0.4,0.3,1.2,0.3,1.7v3.5c0,0.1-0.1,0.2-0.2,0.2
			h-1.1c-0.1,0-0.2-0.1-0.2-0.2v-3c0-0.6,0.1-1.5-0.7-1.5c-0.3,0-0.5,0.2-0.6,0.4c-0.2,0.3-0.2,0.7-0.2,1.1v3
			C45.5,12.3,45.4,12.4,45.3,12.4z"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M30.8,9.7c0,0.4,0,0.8-0.2,1.2c-0.2,0.3-0.4,0.5-0.8,0.5c-0.4,0-0.7-0.3-0.7-0.8
			c0-0.9,0.8-1.1,1.6-1.1V9.7z M31.9,12.4c-0.1,0.1-0.2,0.1-0.3,0c-0.4-0.3-0.4-0.4-0.6-0.7c-0.6,0.6-1,0.8-1.8,0.8
			c-0.9,0-1.6-0.6-1.6-1.7c0-0.9,0.5-1.5,1.2-1.8c0.6-0.3,1.4-0.3,2-0.4V8.5c0-0.3,0-0.6-0.1-0.8c-0.1-0.2-0.4-0.3-0.6-0.3
			c-0.4,0-0.8,0.2-0.9,0.7c0,0.1-0.1,0.2-0.2,0.2l-1.1-0.1c-0.1,0-0.2-0.1-0.2-0.2c0.2-1.3,1.4-1.7,2.4-1.7c0.5,0,1.2,0.1,1.6,0.5
			c0.5,0.5,0.5,1.2,0.5,1.9v1.7c0,0.5,0.2,0.7,0.4,1c0.1,0.1,0.1,0.2,0,0.3C32.5,11.9,32.1,12.2,31.9,12.4L31.9,12.4z"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.5,9.7c0,0.4,0,0.8-0.2,1.2c-0.2,0.3-0.4,0.5-0.8,0.5c-0.4,0-0.7-0.3-0.7-0.8
			c0-0.9,0.8-1.1,1.6-1.1V9.7z M17.6,12.4c-0.1,0.1-0.2,0.1-0.3,0c-0.4-0.3-0.4-0.4-0.6-0.7c-0.6,0.6-1,0.8-1.8,0.8
			c-0.9,0-1.6-0.6-1.6-1.7c0-0.9,0.5-1.5,1.2-1.8c0.6-0.3,1.4-0.3,2-0.4V8.5c0-0.3,0-0.6-0.1-0.8c-0.1-0.2-0.4-0.3-0.6-0.3
			c-0.4,0-0.8,0.2-0.9,0.7c0,0.1-0.1,0.2-0.2,0.2l-1.1-0.1c-0.1,0-0.2-0.1-0.2-0.2c0.2-1.3,1.4-1.7,2.4-1.7c0.5,0,1.2,0.1,1.6,0.5
			C18.1,7.3,18,8,18,8.7v1.7c0,0.5,0.2,0.7,0.4,1c0.1,0.1,0.1,0.2,0,0.3C18.2,11.9,17.8,12.2,17.6,12.4L17.6,12.4z"
              />
            </g>
          </g>
        </g>
      );
    case 'ebayorders':
      return (
        <g>
          <g>
            <polyline
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.5948"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              points="
		10.6,12.1 22.1,43.2 40.2,43.2 	"
            />

            <polyline
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3821"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              points="
		19.1,34.2 42.2,34.2 45.7,20.1 14.1,20.1 	"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              stroke={p4Tokens.colorBrandMenuForeground1}
              strokeWidth="1.3821"
              strokeMiterlimit="10"
              d="M28.2,48.9c0,1.5-1.2,2.8-2.8,2.8
		c-1.5,0-2.8-1.2-2.8-2.8c0-1.5,1.2-2.8,2.8-2.8C26.9,46.2,28.2,47.4,28.2,48.9z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground1}
              stroke={p4Tokens.colorBrandMenuForeground1}
              strokeWidth="1.3821"
              strokeMiterlimit="10"
              d="M40.4,48.9c0,1.5-1.2,2.8-2.8,2.8
		s-2.8-1.2-2.8-2.8c0-1.5,1.2-2.8,2.8-2.8S40.4,47.4,40.4,48.9z"
            />
            <line
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="0.172"
              strokeMiterlimit="10"
              x1="22.1"
              y1="20.6"
              x2="22.1"
              y2="33.7"
            />
            <line
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="0.6511"
              strokeMiterlimit="10"
              x1="29.7"
              y1="20.6"
              x2="29.7"
              y2="33.7"
            />
            <line
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="0.6511"
              strokeMiterlimit="10"
              x1="22.1"
              y1="20.6"
              x2="22.1"
              y2="33.7"
            />
            <line
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="0.6511"
              strokeMiterlimit="10"
              x1="37.2"
              y1="20.1"
              x2="37.2"
              y2="33.7"
            />
            <line
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="0.6511"
              strokeMiterlimit="10"
              x1="16.1"
              y1="27.2"
              x2="43.2"
              y2="27.2"
            />
          </g>
          <g>
            <g>
              <g>
                <path
                  fill="#EE3A3F"
                  d="M19,8.6c-3.8,0-4,3-4,3.8c0,0-0.2,3.5,3.9,3.5c3.5,0,3.6-2.2,3.6-2.2l-1.6,0c0,0-0.3,1.2-2,1.2
				c-2.2,0-2.3-2.2-2.3-2.2h6.2C22.8,12.6,23.3,8.6,19,8.6z M16.7,11.6c0,0,0.1-1.9,2.3-2c2.2,0,2.2,2,2.2,2H16.7z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  fill="#0067B2"
                  d="M27.1,8.6c-1.9,0-2.8,1.1-2.8,1.1V5.9h-1.5l0,8.1c0,0,0,0.9-0.1,1.6h1.5l0.1-0.9c0,0,0.7,1.1,2.7,1.1
				c2,0,3.7-1.3,3.7-3.6C30.8,9.9,29,8.6,27.1,8.6z M26.7,14.8c-2.4,0-2.4-2.6-2.4-2.6s-0.1-2.5,2.4-2.6c2.5-0.1,2.4,2.6,2.4,2.6
				S29.2,14.7,26.7,14.8z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  fill="#FAAC18"
                  d="M37.9,14c0-1.1,0-2,0-2.7c0-0.8,0-2.6-3.3-2.8c0,0-3.2-0.3-3.5,2.1h1.6c0,0,0.1-1.1,1.8-1.1
				c1.6,0,1.8,0.8,1.8,1.7c0,0-1.3,0-1.8,0c-0.8,0-3.6,0.1-3.9,1.8c-0.3,2,1.5,2.7,2.9,2.7c1.4,0,2.2-0.4,2.8-1.2l0.1,1l1.4,0
				C37.9,15.6,37.9,15,37.9,14z M33.8,14.8c0,0-1.5,0-1.6-1.2c-0.1-1.3,2.4-1.2,2.4-1.2l1.7,0C36.3,12.4,36.6,14.9,33.8,14.8z"
                />
              </g>
            </g>
            <polygon
              fill="#6AB845"
              points="37,8.8 38.8,8.8 41.4,14.1 44.1,8.8 45.7,8.8 40.9,18.1 39.2,18.1 40.6,15.6 	"
            />
            <g>
              <path
                fill="#231F20"
                d="M46.3,9.2V9h-0.1V9h0.1V8.9h0.1V9h0.1V9h-0.1v0.2c0,0,0,0,0.1,0c0,0,0,0,0.1,0v0.1c0,0-0.1,0-0.1,0
			C46.3,9.3,46.3,9.3,46.3,9.2z"
              />
              <path
                fill="#231F20"
                d="M46.6,9h0.1V9c0,0,0.1-0.1,0.1-0.1C46.9,8.9,47,9,47,9c0,0,0.1-0.1,0.2-0.1c0.1,0,0.2,0.1,0.2,0.1v0.2
			h-0.1V9.1c0-0.1,0-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1v0.2h-0.1V9.1c0-0.1,0-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1v0.2h-0.1V9z"
              />
            </g>
          </g>
        </g>
      );
    case 'quote':
      return (
        <g>
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3071"
            strokeMiterlimit="10"
            d="M11.7,47.4h25c1.1,0,2.1-0.9,2.1-2.1V9.3
		c0-1.1-0.9-2.1-2.1-2.1H24.4L9.6,21.4v23.9C9.6,46.5,10.5,47.4,11.7,47.4z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeMiterlimit="10"
            d="M11.4,21.2h11c1.1,0,2.1-0.9,2.1-2.1v-11L11.4,21.2z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M13.8,28.2h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H13.8c-0.2,0-0.3,0.1-0.3,0.3v0.7
		C13.5,28.1,13.6,28.2,13.8,28.2z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M13.8,34.2h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H13.8c-0.2,0-0.3,0.1-0.3,0.3v0.7
		C13.5,34.1,13.6,34.2,13.8,34.2z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M13.8,40.2h16.7c0.2,0,0.3-0.1,0.3-0.3v-0.8c0-0.2-0.1-0.3-0.3-0.3H13.8c-0.2,0-0.3,0.1-0.3,0.3v0.8
		C13.5,40.1,13.6,40.2,13.8,40.2z"
          />
          <path fill={p4Tokens.colorBrandMenuBackground1} d="M11.9,20.3h9.9c1,0,1.9-0.8,1.9-1.8V9.2L11.9,20.3z" />
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M41.8,34.9c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C50.5,38.8,46.6,34.9,41.8,34.9
				z"
              />
            </g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                d="M41,46.7v-1c0-1.2,0.3-1.5,1.2-2.3c0.7-0.7,1.5-1.3,1.5-2.3c0-1-0.8-1.8-1.8-1.8c-1.1,0-1.8,0.8-1.9,1.9
				L38.3,41c0.3-1.9,1.7-3.1,3.7-3.1c1.9,0,3.3,1.1,3.3,3.1c0,0.9-0.3,1.5-0.7,2c0,0,0,0-1,1c0,0,0,0-0.2,0.2
				c-0.7,0.7-0.8,0.9-0.8,1.8v0.7H41z M41.7,47.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1
				C40.6,48.4,41.1,47.9,41.7,47.9z"
              />
            </g>
          </g>
        </g>
      );
    case 'orderquote':
      return (
        <g>
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3071"
            strokeMiterlimit="10"
            d="M29.6,2.2h-25c-1.1,0-2.1,0.9-2.1,2.1v36.1
	c0,1.1,0.9,2.1,2.1,2.1h12.3l14.8-14.2V4.3C31.6,3.1,30.7,2.2,29.6,2.2z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M27.4,33.8H7c-0.2,0-0.3,0.1-0.3,0.3v0.7c0,0.2,0.1,0.3,0.3,0.3h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7
	C27.8,33.9,27.6,33.8,27.4,33.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M27.4,27.8H7c-0.2,0-0.3,0.1-0.3,0.3v0.7c0,0.2,0.1,0.3,0.3,0.3h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7
	C27.8,27.9,27.6,27.8,27.4,27.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M27.4,21.8H7c-0.2,0-0.3,0.1-0.3,0.3v0.7c0,0.2,0.1,0.3,0.3,0.3h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7
	C27.8,21.9,27.6,21.8,27.4,21.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M27.4,15.8H7c-0.2,0-0.3,0.1-0.3,0.3v0.7c0,0.2,0.1,0.3,0.3,0.3h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7
	C27.8,15.9,27.6,15.8,27.4,15.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M27.4,9.7H7c-0.2,0-0.3,0.1-0.3,0.3v0.7c0,0.2,0.1,0.3,0.3,0.3h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7
	C27.8,9.9,27.6,9.7,27.4,9.7z"
          />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3071"
              strokeMiterlimit="10"
              d="M15.9,47.5h25c1.1,0,2.1-0.9,2.1-2.1V9.4
		c0-1.1-0.9-2.1-2.1-2.1H28.6L13.8,21.5v23.9C13.8,46.6,14.7,47.5,15.9,47.5z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeMiterlimit="10"
              d="M15.5,21.3h11c1.1,0,2.1-0.9,2.1-2.1v-11L15.5,21.3z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M18,28.3h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H18c-0.2,0-0.3,0.1-0.3,0.3V28
		C17.7,28.2,17.8,28.3,18,28.3z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M18,34.3h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H18c-0.2,0-0.3,0.1-0.3,0.3V34
		C17.7,34.2,17.8,34.3,18,34.3z"
            />
            <path
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M18,40.3h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H18c-0.2,0-0.3,0.1-0.3,0.3V40
		C17.7,40.2,17.8,40.3,18,40.3z"
            />
            <path fill={p4Tokens.colorBrandMenuBackground1} d="M16,20.4h9.9c1,0,1.9-0.8,1.9-1.8V9.3L16,20.4z" />
          </g>
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M45.1,35.8c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C53.8,39.7,49.9,35.8,45.1,35.8z
			"
              />
            </g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                d="M44.3,47.6v-1c0-1.2,0.3-1.5,1.2-2.3c0.7-0.7,1.5-1.3,1.5-2.3c0-1-0.8-1.8-1.8-1.8c-1.1,0-1.8,0.8-1.9,1.9
			l-1.7-0.2c0.3-1.9,1.7-3.1,3.7-3.1c1.9,0,3.3,1.1,3.3,3.1c0,0.9-0.3,1.5-0.7,2c0,0,0,0-1,1c0,0,0,0-0.2,0.2
			c-0.7,0.7-0.8,0.9-0.8,1.8v0.7H44.3z M45.1,48.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1
			C44,49.3,44.5,48.8,45.1,48.8z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                stroke={p4Tokens.colorBrandMenuForeground1}
                strokeMiterlimit="10"
                d="M28.9,39.7c-4,0-7.3,3.3-7.3,7.3c0,4,3.3,7.3,7.3,7.3
			s7.3-3.3,7.3-7.3C36.3,43,33,39.7,28.9,39.7z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M25.7,51.6v-0.7c1-0.5,1.6-1.4,1.6-2.5c0-0.3,0-0.6-0.1-1h-1.5v-0.9h1.3c-0.1-0.4-0.2-1-0.2-1.5
			c0-1.7,1.2-2.8,2.7-2.8c0.7,0,1.3,0.2,1.6,0.4L31,43.4c-0.3-0.1-0.7-0.3-1.3-0.3c-1.1,0-1.6,0.8-1.6,1.8c0,0.6,0.1,1.1,0.2,1.5
			h2.1v0.9h-1.9c0,0.5,0.1,1.1-0.1,1.6c-0.2,0.6-0.5,1.1-1,1.5v0h4.3v1H25.7z"
              />
            </g>
          </g>
        </g>
      );
    case 'tradecounter':
      return (
        <g>
          <g>
            <circle
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3"
              strokeMiterlimit="10"
              cx="28.3"
              cy="12.3"
              r="7.1"
            />
            <path
              fill="none"
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3"
              strokeMiterlimit="10"
              d="M40,26.1v7.3c0,0.2,0,0.2-0.1,0.2H16.7
		c-0.1,0-0.3,0-0.3-0.2v-7.3c0-0.1,0-0.2,0-0.4c0.1-1.7,0.8-3.3,1.9-4.5c0,0,0.1-0.1,0.1-0.1c0.5-0.6,1.2-1,1.9-1.4
		c0,0,0.1,0,0.1-0.1c0.2-0.1,0.4-0.2,0.6-0.2c0,0,0.1,0,0.1,0c0.2-0.1,0.4-0.1,0.6-0.2c0.2,0.2,0.5,0.4,0.7,0.6
		c0.6,0.5,1.3,0.9,2.1,1.2c0.1,0.1,0.3,0.1,0.4,0.2c0.5,0.2,1.1,0.4,1.7,0.5c0.7,0.1,1.2,0.1,1.7,0.2c0.4,0,0.9,0,1.6-0.1
		c1.1-0.1,2-0.6,2.2-0.7c0.6-0.3,1.1-0.6,1.6-1c0,0,0,0,0,0c0.1,0,0.8-0.6,1.1-0.9c2.9,0.7,5,3.3,5.2,6.5C40,25.8,40,26,40,26.1z"
            />
          </g>
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M50.3,41H6.1c-1,0-1.9-0.8-1.9-1.9v-1.5c0-1,0.8-1.9,1.9-1.9h44.2c1,0,1.9,0.8,1.9,1.9v1.5
	C52.2,40.1,51.4,41,50.3,41z"
          />
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                stroke={p4Tokens.colorBrandMenuForeground1}
                strokeWidth="1.2"
                strokeMiterlimit="10"
                d="M43.3,37.5c-4,0-7.3,3.3-7.3,7.3
			c0,4,3.3,7.3,7.3,7.3s7.3-3.3,7.3-7.3C50.6,40.8,47.3,37.5,43.3,37.5z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M40.1,49.4v-0.7c1-0.5,1.6-1.4,1.6-2.5c0-0.3,0-0.6-0.1-1h-1.5v-0.9h1.3c-0.1-0.4-0.2-1-0.2-1.5
			c0-1.7,1.2-2.8,2.7-2.8c0.7,0,1.3,0.2,1.6,0.4l-0.3,0.9c-0.3-0.1-0.7-0.3-1.3-0.3c-1.1,0-1.6,0.8-1.6,1.8c0,0.6,0.1,1.1,0.2,1.5
			h2.1v0.9h-1.9c0,0.5,0.1,1.1-0.1,1.6c-0.2,0.6-0.5,1.1-1,1.5v0H46v1H40.1z"
              />
            </g>
          </g>
        </g>
      );
    case 'orderlines':
      return (
        <g>
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3071"
            strokeMiterlimit="10"
            d="M16.1,48.9h25c1.1,0,2.1-0.9,2.1-2.1V10.7
	c0-1.1-0.9-2.1-2.1-2.1H28.8L14,22.9v23.9C14,47.9,14.9,48.9,16.1,48.9z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeMiterlimit="10"
            d="M15.8,22.6h11c1.1,0,2.1-0.9,2.1-2.1v-11L15.8,22.6z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M25.2,29h13.5c0.1,0,0.3-0.1,0.3-0.3v-0.8c0-0.1-0.1-0.3-0.3-0.3H25.2c-0.1,0-0.3,0.1-0.3,0.3v0.8
	C24.9,28.9,25,29,25.2,29z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M25.2,35.6h13.5c0.1,0,0.3-0.1,0.3-0.3v-0.8c0-0.1-0.1-0.3-0.3-0.3H25.2c-0.1,0-0.3,0.1-0.3,0.3v0.8
	C24.9,35.5,25,35.6,25.2,35.6z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M25.2,42.3h13.5c0.1,0,0.3-0.1,0.3-0.3v-0.8c0-0.1-0.1-0.3-0.3-0.3H25.2c-0.1,0-0.3,0.1-0.3,0.3v0.8
	C24.9,42.2,25,42.3,25.2,42.3z"
          />
          <path fill={p4Tokens.colorBrandMenuBackground1} d="M16.3,21.8h9.9c1,0,1.9-0.8,1.9-1.8v-9.4L16.3,21.8z" />
          <rect x="17.6" y="25.5" fill={p4Tokens.colorBrandMenuForeground1} width="4.7" height="4.7" />
          <rect x="17.6" y="32.6" fill={p4Tokens.colorBrandMenuForeground1} width="4.7" height="4.7" />
          <rect x="17.6" y="39.5" fill={p4Tokens.colorBrandMenuForeground1} width="4.7" height="4.7" />
        </g>
      );
    case 'printquote':
      return (
        <g>
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M35.2,18.5H12.5c-0.7,0-1.2-0.5-1.2-1.2V8.5
	c0-0.7,0.5-1.2,1.2-1.2h22.7c0.7,0,1.2,0.5,1.2,1.2v8.8C36.4,17.9,35.8,18.5,35.2,18.5z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M42.4,40.9H5.5c-1.2,0-2.3-1-2.3-2.3V19.9
	c0-1.2,1-2.3,2.3-2.3h36.8c1.2,0,2.3,1,2.3,2.3v18.8C44.6,39.9,43.6,40.9,42.4,40.9z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M10,23.6c0,0.8-0.6,1.5-1.4,1.5c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.4,1.4-1.5C9.3,22.2,10,22.8,10,23.6z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M23.9,38.5c2,0,4,0,6,0c0.6,0,1,0.3,1,0.8c0,0.5-0.3,0.8-0.7,0.9c-0.2,0-0.3,0-0.5,0c-4,0-7.9,0-11.9,0
	c-0.7,0-1.2-0.5-1-1.1c0.1-0.3,0.4-0.5,0.7-0.6c0.1,0,0.2,0,0.3,0C19.9,38.5,21.9,38.5,23.9,38.5C23.9,38.5,23.9,38.5,23.9,38.5z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M23.9,35.2c-2.1,0-4.1,0-6.2,0c-0.4,0-0.7-0.2-0.8-0.6c-0.1-0.3-0.1-0.7,0.2-0.9c0.2-0.1,0.5-0.2,0.7-0.2
	c2.3,0,4.5,0,6.8,0c1.8,0,3.6,0,5.5,0c0.5,0,0.9,0.3,0.9,0.8c0,0.6-0.3,0.9-0.9,0.9C28,35.2,25.9,35.2,23.9,35.2z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M23.9,43.4c2,0,4.1,0,6.1,0c0.5,0,0.9,0.3,0.9,0.8c0,0.5-0.3,0.9-0.9,0.9c-0.9,0-1.8,0-2.7,0
	c-3.2,0-6.4,0-9.6,0c-0.7,0-1.1-0.6-0.9-1.2c0.1-0.3,0.4-0.5,0.9-0.5c1.8,0,3.6,0,5.4,0C23.4,43.4,23.6,43.4,23.9,43.4z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M34.8,50.4H13.5c-0.9,0-1.7-0.8-1.7-1.7V30.5
	c0-0.9,0.8-1.7,1.7-1.7h21.3c0.9,0,1.7,0.8,1.7,1.7v18.3C36.5,49.7,35.7,50.4,34.8,50.4z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M30.3,35.1H17.6c-0.4,0-0.8-0.3-0.8-0.8v0c0-0.4,0.3-0.8,0.8-0.8h12.6c0.4,0,0.8,0.3,0.8,0.8v0
	C31,34.8,30.7,35.1,30.3,35.1z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M30.3,40.2H17.6c-0.4,0-0.8-0.3-0.8-0.8v0c0-0.4,0.3-0.8,0.8-0.8h12.6c0.4,0,0.8,0.3,0.8,0.8v0
	C31,39.8,30.7,40.2,30.3,40.2z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M30.3,45H17.6c-0.4,0-0.8-0.3-0.8-0.8l0,0c0-0.4,0.3-0.8,0.8-0.8h12.6c0.4,0,0.8,0.3,0.8,0.8l0,0
	C31,44.7,30.7,45,30.3,45z"
          />
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M46,30.9c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C54.8,34.8,50.8,30.9,46,30.9z"
              />
            </g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                d="M45.2,42.7v-1c0-1.2,0.3-1.5,1.2-2.3c0.7-0.7,1.5-1.3,1.5-2.3c0-1-0.8-1.8-1.8-1.8c-1.1,0-1.8,0.8-1.9,1.9
			L42.5,37c0.3-1.9,1.7-3.1,3.7-3.1c1.9,0,3.3,1.1,3.3,3.1c0,0.9-0.3,1.5-0.7,2c0,0,0,0-1,1c0,0,0,0-0.2,0.2
			c-0.7,0.7-0.8,0.9-0.8,1.8v0.7H45.2z M46,43.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1
			C44.9,44.4,45.4,43.9,46,43.9z"
              />
            </g>
          </g>
        </g>
      );
    case 'printproforma':
      return (
        <g>
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M34.5,19H11.8c-0.7,0-1.2-0.5-1.2-1.2V8.9
	c0-0.7,0.5-1.2,1.2-1.2h22.7c0.7,0,1.2,0.5,1.2,1.2v8.8C35.7,18.4,35.1,19,34.5,19z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M41.7,41.4H4.9c-1.2,0-2.3-1-2.3-2.3V20.4
	c0-1.2,1-2.3,2.3-2.3h36.8c1.2,0,2.3,1,2.3,2.3v18.8C43.9,40.4,42.9,41.4,41.7,41.4z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M9.3,24.1c0,0.8-0.6,1.5-1.4,1.5c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.4,1.4-1.5C8.6,22.6,9.3,23.3,9.3,24.1z
	"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M23.2,38.9c2,0,4,0,6,0c0.6,0,1,0.3,1,0.8c0,0.5-0.3,0.8-0.7,0.9c-0.2,0-0.3,0-0.5,0c-4,0-7.9,0-11.9,0
	c-0.7,0-1.2-0.5-1-1.1c0.1-0.3,0.4-0.5,0.7-0.6c0.1,0,0.2,0,0.3,0C19.2,38.9,21.2,38.9,23.2,38.9C23.2,38.9,23.2,38.9,23.2,38.9z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M23.2,35.7c-2.1,0-4.1,0-6.2,0c-0.4,0-0.7-0.2-0.8-0.6c-0.1-0.3-0.1-0.7,0.2-0.9c0.2-0.1,0.5-0.2,0.7-0.2
	c2.3,0,4.5,0,6.8,0c1.8,0,3.6,0,5.5,0c0.5,0,0.9,0.3,0.9,0.8c0,0.6-0.3,0.9-0.9,0.9C27.3,35.7,25.2,35.7,23.2,35.7z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M23.2,43.9c2,0,4.1,0,6.1,0c0.5,0,0.9,0.3,0.9,0.8c0,0.5-0.3,0.9-0.9,0.9c-0.9,0-1.8,0-2.7,0
	c-3.2,0-6.4,0-9.6,0c-0.7,0-1.1-0.6-0.9-1.2c0.1-0.3,0.4-0.5,0.9-0.5c1.8,0,3.6,0,5.4,0C22.7,43.9,22.9,43.9,23.2,43.9z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M34.1,50.9H12.8c-0.9,0-1.7-0.8-1.7-1.7V30.9
	c0-0.9,0.8-1.7,1.7-1.7h21.3c0.9,0,1.7,0.8,1.7,1.7v18.3C35.8,50.1,35,50.9,34.1,50.9z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M29.6,35.6H16.9c-0.4,0-0.8-0.3-0.8-0.8l0,0c0-0.4,0.3-0.8,0.8-0.8h12.6c0.4,0,0.8,0.3,0.8,0.8l0,0
	C30.3,35.2,30,35.6,29.6,35.6z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M29.6,40.6H16.9c-0.4,0-0.8-0.3-0.8-0.8l0,0c0-0.4,0.3-0.8,0.8-0.8h12.6c0.4,0,0.8,0.3,0.8,0.8l0,0
	C30.3,40.3,30,40.6,29.6,40.6z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground2}
            d="M29.6,45.5H16.9c-0.4,0-0.8-0.3-0.8-0.8v0c0-0.4,0.3-0.8,0.8-0.8h12.6c0.4,0,0.8,0.3,0.8,0.8v0
	C30.3,45.2,30,45.5,29.6,45.5z"
          />
          <g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuForeground1}
                d="M45.8,30.8c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C54.6,34.7,50.6,30.8,45.8,30.8z
			"
              />
            </g>
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                d="M42.2,45v-0.9c1.2-0.6,2-1.7,2-3c0-0.4,0-0.8-0.1-1.2h-1.8v-1.1h1.6c-0.1-0.5-0.2-1.2-0.2-1.9
			c0-2.1,1.4-3.4,3.3-3.4c0.9,0,1.5,0.2,1.9,0.4l-0.3,1.1c-0.3-0.2-0.8-0.3-1.6-0.3c-1.4,0-1.9,0.9-1.9,2.2c0,0.7,0.1,1.3,0.2,1.9
			h2.5v1.1h-2.4c0.1,0.7,0.1,1.3-0.1,1.9c-0.2,0.7-0.6,1.4-1.2,1.9v0h5.2V45H42.2z"
              />
            </g>
          </g>
        </g>
      );
    case 'printdatasheet':
      return (
        <g>
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M39.9,18.4H17.3c-0.7,0-1.2-0.5-1.2-1.2V8.3
	c0-0.7,0.5-1.2,1.2-1.2h22.7c0.7,0,1.2,0.5,1.2,1.2v8.8C41.1,17.8,40.6,18.4,39.9,18.4z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground2}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M47.1,40.8H10.3c-1.2,0-2.3-1-2.3-2.3V19.8
	c0-1.2,1-2.3,2.3-2.3h36.8c1.2,0,2.3,1,2.3,2.3v18.8C49.4,39.8,48.4,40.8,47.1,40.8z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M14.8,23.5c0,0.8-0.6,1.5-1.4,1.5c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.4,1.4-1.5
	C14.1,22,14.8,22.7,14.8,23.5z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M28.7,38.3c2,0,4,0,6,0c0.6,0,1,0.3,1,0.8c0,0.5-0.3,0.8-0.7,0.9c-0.2,0-0.3,0-0.5,0c-4,0-7.9,0-11.9,0
	c-0.7,0-1.2-0.5-1-1.1c0.1-0.3,0.4-0.5,0.7-0.6c0.1,0,0.2,0,0.3,0C24.6,38.3,26.6,38.3,28.7,38.3C28.7,38.3,28.7,38.3,28.7,38.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M28.6,35.1c-2.1,0-4.1,0-6.2,0c-0.4,0-0.7-0.2-0.8-0.6c-0.1-0.3-0.1-0.7,0.2-0.9c0.2-0.1,0.5-0.2,0.7-0.2
	c2.3,0,4.5,0,6.8,0c1.8,0,3.6,0,5.5,0c0.5,0,0.9,0.3,0.9,0.8c0,0.6-0.3,0.9-0.9,0.9C32.7,35.1,30.7,35.1,28.6,35.1z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M28.6,43.3c2,0,4.1,0,6.1,0c0.5,0,0.9,0.3,0.9,0.8c0,0.5-0.3,0.9-0.9,0.9c-0.9,0-1.8,0-2.7,0
	c-3.2,0-6.4,0-9.6,0c-0.7,0-1.1-0.6-0.9-1.2c0.1-0.3,0.4-0.5,0.9-0.5c1.8,0,3.6,0,5.4,0C28.2,43.3,28.4,43.3,28.6,43.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={p4Tokens.colorBrandMenuForeground1}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M39.5,50.3H18.2c-0.9,0-1.7-0.8-1.7-1.7V30.3
	c0-0.9,0.8-1.7,1.7-1.7h21.3c0.9,0,1.7,0.8,1.7,1.7v18.3C41.2,49.5,40.5,50.3,39.5,50.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M35,35H22.4c-0.4,0-0.8-0.3-0.8-0.8v0c0-0.4,0.3-0.8,0.8-0.8H35c0.4,0,0.8,0.3,0.8,0.8v0
	C35.8,34.6,35.5,35,35,35z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M35,40H22.4c-0.4,0-0.8-0.3-0.8-0.8v0c0-0.4,0.3-0.8,0.8-0.8H35c0.4,0,0.8,0.3,0.8,0.8v0
	C35.8,39.7,35.5,40,35,40z"
          />
          <path
            fill={p4Tokens.colorBrandMenuForeground1}
            d="M35,44.9H22.4c-0.4,0-0.8-0.3-0.8-0.8l0,0c0-0.4,0.3-0.8,0.8-0.8H35c0.4,0,0.8,0.3,0.8,0.8l0,0
	C35.8,44.6,35.5,44.9,35,44.9z"
          />
        </g>
      );
    case 'purchasingmodule':
      return (
        <g>
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="1.3071"
            strokeMiterlimit="10"
            d="M11.5,47.5h25c1.1,0,2.1-0.9,2.1-2.1V9.4
	c0-1.1-0.9-2.1-2.1-2.1H24.2L9.4,21.5v23.9C9.4,46.6,10.3,47.5,11.5,47.5z"
          />
          <path
            fill={fillColor}
            stroke={fillColor}
            strokeMiterlimit="10"
            d="M11.2,21.3h11c1.1,0,2.1-0.9,2.1-2.1v-11L11.2,21.3z"
          />
          <path
            fill={fillColor}
            d="M13.6,28.3H34c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H13.6c-0.2,0-0.3,0.1-0.3,0.3V28
	C13.3,28.2,13.4,28.3,13.6,28.3z"
          />
          <path
            fill={fillColor}
            d="M13.6,34.3H34c0.2,0,0.3-0.1,0.3-0.3v-0.7c0-0.2-0.1-0.3-0.3-0.3H13.6c-0.2,0-0.3,0.1-0.3,0.3V34
	C13.3,34.1,13.4,34.3,13.6,34.3z"
          />
          <path
            fill={fillColor}
            d="M13.6,40.3h16.7c0.2,0,0.3-0.1,0.3-0.3v-0.8c0-0.2-0.1-0.3-0.3-0.3H13.6c-0.2,0-0.3,0.1-0.3,0.3V40
	C13.3,40.1,13.4,40.3,13.6,40.3z"
          />
          <path fill={p4Tokens.colorBrandMenuBackground1} d="M11.7,20.4h9.9c1,0,1.9-0.8,1.9-1.8V9.3L11.7,20.4z" />
          <g>
            <path
              fill="#949596"
              d="M41.7,35.1c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C50.4,39,46.5,35.1,41.7,35.1z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M46.5,44.8H36.5c-0.3,0-0.6-0.3-0.6-0.6v-0.6c0-0.3,0.3-0.6,0.6-0.6h10.1c0.3,0,0.6,0.3,0.6,0.6v0.6
		C47.2,44.5,46.9,44.8,46.5,44.8z"
            />
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M40.6,48.9V38.8c0-0.3,0.3-0.6,0.6-0.6h0.6c0.3,0,0.6,0.3,0.6,0.6v10.1c0,0.3-0.3,0.6-0.6,0.6h-0.6
		C40.8,49.5,40.6,49.2,40.6,48.9z"
            />
          </g>
        </g>
      );
    case 'vatmodule':
      return (
        <g>
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="1.3071"
            strokeMiterlimit="10"
            d="M12.3,47.2h25c1.1,0,2.1-0.9,2.1-2.1V9.1
	C39.4,8,38.5,7,37.3,7H25L10.2,21.2v23.9C10.2,46.3,11.1,47.2,12.3,47.2z"
          />
          <path
            fill={fillColor}
            stroke={fillColor}
            strokeMiterlimit="10"
            d="M11.9,21h11c1.1,0,2.1-0.9,2.1-2.1v-11L11.9,21z"
          />
          <path
            fill={fillColor}
            d="M14.4,28h20.4c0.2,0,0.3-0.1,0.3-0.3V27c0-0.2-0.1-0.3-0.3-0.3H14.4c-0.2,0-0.3,0.1-0.3,0.3v0.7
	C14.1,27.9,14.2,28,14.4,28z"
          />
          <path
            fill={fillColor}
            d="M14.4,34h20.4c0.2,0,0.3-0.1,0.3-0.3V33c0-0.2-0.1-0.3-0.3-0.3H14.4c-0.2,0-0.3,0.1-0.3,0.3v0.7
	C14.1,33.9,14.2,34,14.4,34z"
          />
          <path
            fill={fillColor}
            d="M14.4,40h16.7c0.2,0,0.3-0.1,0.3-0.3v-0.8c0-0.2-0.1-0.3-0.3-0.3H14.4c-0.2,0-0.3,0.1-0.3,0.3v0.8
	C14.1,39.9,14.2,40,14.4,40z"
          />
          <path fill={p4Tokens.colorBrandMenuBackground1} d="M12.4,20.1h9.9c1,0,1.9-0.8,1.9-1.8V9L12.4,20.1z" />
          <g>
            <path
              fill="#949596"
              d="M42.4,34.8c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7C51.2,38.7,47.3,34.8,42.4,34.8z"
            />
          </g>
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              d="M39.5,39.1c1.4,0,2.4,1,2.4,2.5c0,1.5-1,2.5-2.4,2.5c-1.4,0-2.4-1-2.4-2.5C37.1,40.1,38.1,39.1,39.5,39.1z
		 M39.5,43.2c0.6,0,0.8-0.5,0.8-1.7c0-1.1-0.2-1.7-0.8-1.7s-0.8,0.5-0.8,1.7C38.7,42.7,38.9,43.2,39.5,43.2z M44.6,39.1h1.1L40.2,48
		h-1.1L44.6,39.1z M45.4,43.1c1.4,0,2.4,1,2.4,2.5c0,1.5-1,2.5-2.4,2.5c-1.4,0-2.4-1-2.4-2.5C43,44.1,44,43.1,45.4,43.1z M45.4,47.2
		c0.6,0,0.8-0.5,0.8-1.7c0-1.1-0.2-1.7-0.8-1.7c-0.6,0-0.8,0.5-0.8,1.7C44.6,46.7,44.8,47.2,45.4,47.2z"
            />
          </g>
        </g>
      );
    case 'nominalmodule':
      return (
        <g>
          <g>
            <path
              fill={fillColor}
              d="M28.1,10.9c-9.5,0-17.3,7.7-17.3,17.3c0,9.5,7.7,17.3,17.3,17.3c9.5,0,17.3-7.7,17.3-17.3
		C45.4,18.6,37.7,10.9,28.1,10.9z M28.1,43.7c-8.6,0-15.5-7-15.5-15.5c0-8.6,6.9-15.5,15.5-15.5s15.5,6.9,15.5,15.5
		C43.7,36.7,36.7,43.7,28.1,43.7z"
            />
            <g>
              <path
                fill={p4Tokens.colorBrandMenuBackground1}
                d="M45.4,28.1c0,9.6-7.7,17.3-17.3,17.3c-9.5,0-17.3-7.7-17.3-17.3c0-9.6,7.7-17.3,17.3-17.3
			C37.7,10.8,45.4,18.6,45.4,28.1z"
              />
              <path
                fill="none"
                stroke={fillColor}
                strokeWidth="2.4214"
                strokeMiterlimit="10"
                strokeDasharray="0.617,0.617"
                d="M45.4,28.1
			c0,9.6-7.7,17.3-17.3,17.3c-9.5,0-17.3-7.7-17.3-17.3c0-9.6,7.7-17.3,17.3-17.3C37.7,10.8,45.4,18.6,45.4,28.1z"
              />
            </g>
            <g>
              <path
                fill={fillColor}
                d="M22.6,36.6v-1.3c1.8-0.9,3.1-2.7,3.1-4.7c0-0.6,0-1.2-0.1-1.9h-2.8V27h2.5c-0.1-0.8-0.3-1.9-0.3-2.9
			c0-3.2,2.2-5.3,5.2-5.3c1.4,0,2.4,0.3,2.9,0.7l-0.5,1.8c-0.5-0.3-1.3-0.5-2.4-0.5c-2.1,0-2.9,1.5-2.9,3.4c0,1.2,0.1,2,0.3,2.9h3.9
			v1.7h-3.7c0.1,1,0.1,2.1-0.1,3c-0.3,1.2-0.9,2.1-1.9,2.9v0.1h8v2H22.6z"
              />
            </g>
            <g>
              <path
                fill={fillColor}
                d="M28.2,11.4c-9.2,0-16.7,7.5-16.7,16.7s7.5,16.7,16.7,16.7c9.2,0,16.7-7.5,16.7-16.7S37.4,11.4,28.2,11.4z
			 M28.2,43.7c-8.6,0-15.5-7-15.5-15.5c0-8.6,7-15.5,15.5-15.5c8.6,0,15.5,7,15.5,15.5C43.7,36.7,36.7,43.7,28.2,43.7z"
              />
            </g>
          </g>
        </g>
      );
    case 'eventmodule':
      return (
        <g>
          <path
            fill="none"
            stroke="#949596"
            strokeMiterlimit="10"
            d="M45.5,43.2H10.8c-0.6,0-1.1-0.5-1.1-1.1V24.9c0-0.6,0.5-1.1,1.1-1.1
	h34.7c0.6,0,1.1,0.5,1.1,1.1v17.2C46.6,42.7,46.1,43.2,45.5,43.2z"
          />
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M45.5,14h-3.8v2.3c0,1.6-1.2,2.8-2.8,2.8
	s-2.8-1.3-2.8-2.8V14H20.4v2.3c0,1.6-1.2,2.8-2.8,2.8s-2.8-1.3-2.8-2.8V14H11c-2.2,0-3.9,1.6-3.9,3.7v25c0,2.2,1.8,4.1,3.9,4.1h34.5
	c2.2,0,3.9-1.9,3.9-4.1v-25C49.4,15.6,47.7,14,45.5,14z"
          />
          <path
            fill="#949596"
            d="M39,17.6L39,17.6c-0.8,0-1.3-0.6-1.3-1.3v-3.6c0-0.7,0.6-1.3,1.3-1.3l0,0c0.7,0,1.3,0.6,1.3,1.3v3.6
	C40.3,17,39.8,17.6,39,17.6z"
          />
          <path
            fill="#949596"
            d="M17.6,17.6L17.6,17.6c-0.8,0-1.3-0.6-1.3-1.3v-3.6c0-0.7,0.6-1.3,1.3-1.3l0,0c0.7,0,1.3,0.6,1.3,1.3v3.6
	C18.9,17,18.3,17.6,17.6,17.6z"
          />
          <path
            fill="#949596"
            stroke="#949596"
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M21,29.7h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8H21c0.4,0,0.8,0.3,0.8,0.8V29C21.8,29.4,21.4,29.7,21,29.7z"
          />
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M21,35.3h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8H21c0.4,0,0.8,0.3,0.8,0.8v2.8C21.8,35,21.4,35.3,21,35.3z"
          />
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M21,41.1h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8H21c0.4,0,0.8,0.3,0.8,0.8v2.8C21.8,40.8,21.4,41.1,21,41.1z"
          />
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M26.8,29.7H24c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8h2.8c0.4,0,0.8,0.3,0.8,0.8V29C27.6,29.4,27.2,29.7,26.8,29.7z"
          />
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M26.8,35.3H24c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8h2.8c0.4,0,0.8,0.3,0.8,0.8v2.8C27.6,35,27.2,35.3,26.8,35.3z"
          />
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M26.8,41.1H24c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8h2.8c0.4,0,0.8,0.3,0.8,0.8v2.8C27.6,40.8,27.2,41.1,26.8,41.1z"
          />
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M32.6,29.7h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8h2.8c0.4,0,0.8,0.3,0.8,0.8V29C33.4,29.4,33,29.7,32.6,29.7z"
          />
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M32.6,35.3h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8h2.8c0.4,0,0.8,0.3,0.8,0.8v2.8C33.4,35,33,35.3,32.6,35.3z"
          />
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M32.6,41.1h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8h2.8c0.4,0,0.8,0.3,0.8,0.8v2.8C33.4,40.8,33,41.1,32.6,41.1z"
          />
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M38.4,29.7h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8h2.8c0.4,0,0.8,0.3,0.8,0.8V29C39.2,29.4,38.8,29.7,38.4,29.7z"
          />
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M38.4,35.3h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8h2.8c0.4,0,0.8,0.3,0.8,0.8v2.8C39.2,35,38.8,35.3,38.4,35.3z"
          />
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M38.4,41.1h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8h2.8c0.4,0,0.8,0.3,0.8,0.8v2.8C39.2,40.8,38.8,41.1,38.4,41.1z"
          />
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M44.2,29.7h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8h2.8c0.4,0,0.8,0.3,0.8,0.8V29C45,29.4,44.7,29.7,44.2,29.7z"
          />
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M44.2,35.3h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8h2.8c0.4,0,0.8,0.3,0.8,0.8v2.8C45,35,44.7,35.3,44.2,35.3z"
          />
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M15.2,35.3h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8h2.8c0.4,0,0.8,0.3,0.8,0.8v2.8C16,35,15.7,35.3,15.2,35.3z"
          />
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M15.2,41.1h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8
	c0-0.4,0.3-0.8,0.8-0.8h2.8c0.4,0,0.8,0.3,0.8,0.8v2.8C16,40.8,15.7,41.1,15.2,41.1z"
          />
        </g>
      );
    case 'productmodule':
      return (
        <g>
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="1.2035"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
		M28.5,25.8c0,0-17.7-8-18-7.5s0.1,22.6,0.1,22.6l17.7,7.6L28.5,25.8z"
          />
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
		M10.7,18c2.1-1,16-6.3,16.8-6.4c1,0,18.7,6.2,18.2,6.5c-0.4,0.3-15.9,7.2-17.1,7.5C27.6,25.9,10.8,17.9,10.7,18"
          />
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
		M28.7,25.7c0,0,17.2-8.1,17.2-7.5c0,10.2,0.2,22-0.2,22.3c-0.7,0.4-16.9,8.5-17.1,8S28.7,25.7,28.7,25.7z"
          />
          <path fill="#949596" d="M33.3,14L17,21v9.9c0,0,3.8,2,3.9,1.2c0.2-3.1,0.2-9.6,0.2-9.3l16.5-7.3L33.3,14z" />
        </g>
      );
    case 'suppliermodule':
      return (
        <g>
          <g>
            <circle
              fill="none"
              stroke={fillColor}
              strokeWidth="1.3"
              strokeMiterlimit="10"
              cx="43.4"
              cy="34.1"
              r="5.1"
            />
            <path
              fill="none"
              stroke={fillColor}
              strokeWidth="1.3"
              strokeMiterlimit="10"
              d="M51.8,44.6v5.2c0,0.1,0,0.1-0.1,0.1H35.2
		c-0.1,0-0.2,0-0.2-0.1v-5.2c0-0.1,0-0.2,0-0.3c0.1-1.2,0.6-2.4,1.3-3.2c0,0,0,0,0.1-0.1c0.4-0.4,0.8-0.7,1.3-1c0,0,0.1,0,0.1,0
		c0.1-0.1,0.3-0.1,0.4-0.2c0,0,0.1,0,0.1,0c0.1,0,0.3-0.1,0.4-0.1c0.2,0.2,0.3,0.3,0.5,0.4c0.5,0.4,1,0.7,1.5,0.9
		c0.1,0,0.2,0.1,0.3,0.1c0.4,0.1,0.8,0.3,1.2,0.3c0.5,0.1,0.9,0.1,1.2,0.1c0.3,0,0.7,0,1.1,0c0.8-0.1,1.4-0.4,1.6-0.5
		c0.4-0.2,0.8-0.4,1.2-0.7c0,0,0,0,0,0c0,0,0.6-0.4,0.8-0.6c2.1,0.5,3.6,2.3,3.7,4.6C51.8,44.4,51.8,44.5,51.8,44.6z"
            />
          </g>
          <g>
            <circle fill="none" stroke={fillColor} strokeWidth="1.3" strokeMiterlimit="10" cx="28.7" cy="11" r="5.1" />
            <path
              fill="none"
              stroke={fillColor}
              strokeWidth="1.3"
              strokeMiterlimit="10"
              d="M37,21.5v5.2c0,0.1,0,0.1-0.1,0.1H20.4
		c-0.1,0-0.2,0-0.2-0.1v-5.2c0-0.1,0-0.2,0-0.3c0.1-1.2,0.6-2.4,1.3-3.2c0,0,0,0,0.1-0.1c0.4-0.4,0.8-0.7,1.3-1c0,0,0.1,0,0.1,0
		c0.1-0.1,0.3-0.1,0.4-0.2c0,0,0.1,0,0.1,0c0.1,0,0.3-0.1,0.4-0.1c0.2,0.2,0.3,0.3,0.5,0.4c0.5,0.4,1,0.7,1.5,0.9
		c0.1,0,0.2,0.1,0.3,0.1c0.4,0.1,0.8,0.3,1.2,0.3c0.5,0.1,0.9,0.1,1.2,0.1c0.3,0,0.7,0,1.1,0c0.8-0.1,1.4-0.4,1.6-0.5
		c0.4-0.2,0.8-0.4,1.2-0.7c0,0,0,0,0,0c0,0,0.6-0.4,0.8-0.6c2.1,0.5,3.6,2.3,3.7,4.6C37,21.3,37,21.4,37,21.5z"
            />
          </g>
          <g>
            <circle
              fill="none"
              stroke={fillColor}
              strokeWidth="1.3"
              strokeMiterlimit="10"
              cx="13.3"
              cy="34.1"
              r="5.1"
            />
            <path
              fill="none"
              stroke={fillColor}
              strokeWidth="1.3"
              strokeMiterlimit="10"
              d="M21.7,44.6v5.2c0,0.1,0,0.1-0.1,0.1H5
		c-0.1,0-0.2,0-0.2-0.1v-5.2c0-0.1,0-0.2,0-0.3c0.1-1.2,0.6-2.4,1.3-3.2c0,0,0,0,0.1-0.1c0.4-0.4,0.8-0.7,1.3-1c0,0,0.1,0,0.1,0
		c0.1-0.1,0.3-0.1,0.4-0.2c0,0,0.1,0,0.1,0c0.1,0,0.3-0.1,0.4-0.1c0.2,0.2,0.3,0.3,0.5,0.4c0.5,0.4,1,0.7,1.5,0.9
		c0.1,0,0.2,0.1,0.3,0.1c0.4,0.1,0.8,0.3,1.2,0.3c0.5,0.1,0.9,0.1,1.2,0.1c0.3,0,0.7,0,1.1,0c0.8-0.1,1.4-0.4,1.6-0.5
		c0.4-0.2,0.8-0.4,1.2-0.7c0,0,0,0,0,0c0,0,0.6-0.4,0.8-0.6c2.1,0.5,3.6,2.3,3.7,4.6C21.6,44.4,21.7,44.5,21.7,44.6z"
            />
          </g>
          <path
            fill="#949596"
            stroke="#949596"
            strokeWidth="1.4"
            strokeMiterlimit="10"
            d="M28.3,29.6L28.3,29.6c-0.3,0-0.6,0.3-0.6,0.6v6
	c0,0.3,0.3,0.6,0.6,0.6l0,0c0.3,0,0.6-0.3,0.6-0.6v-6C28.8,29.9,28.6,29.6,28.3,29.6z"
          />
          <path
            fill="#949596"
            stroke="#949596"
            strokeWidth="1.4"
            strokeMiterlimit="10"
            d="M27.9,35.8L27.9,35.8c-0.2,0.2-0.2,0.6,0.1,0.8
	l5,4c0.2,0.2,0.6,0.2,0.8-0.1l0,0c0.2-0.2,0.2-0.6-0.1-0.8l-5-4C28.5,35.5,28.1,35.5,27.9,35.8z"
          />
          <path
            fill="#949596"
            stroke="#949596"
            strokeWidth="1.4"
            strokeMiterlimit="10"
            d="M22.8,40.4L22.8,40.4c-0.2-0.2-0.2-0.6,0.1-0.8
	l4.8-3.8c0.2-0.2,0.6-0.2,0.8,0.1l0,0c0.2,0.2,0.2,0.6-0.1,0.8l-4.8,3.8C23.4,40.7,23,40.6,22.8,40.4z"
          />
        </g>
      );
    case 'customermodule':
      return (
        <g>
          <circle fill="none" stroke={fillColor} strokeWidth="1.2" cx="14.4" cy="13.8" r="7.3" />
          <circle fill="none" stroke={fillColor} strokeWidth="1.2" strokeMiterlimit="10" cx="42" cy="13.8" r="7.3" />
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="1.2"
            d="M15.4,34.6l0.1-0.1c0.7-0.7,1.5-1.3,2.3-1.8c0.1,0,0.1-0.1,0.2-0.1
	c0.2-0.1,0.5-0.2,0.7-0.3c0.1,0,0.1,0,0.2-0.1c0.2-0.1,0.4-0.1,0.6-0.2c-1-1.5-1.5-3.4-1.5-5.3c0-1.5,0.3-2.9,0.9-4.2
	c-0.2,0.1-0.4,0.2-0.6,0.3c-0.1,0.1-0.2,0.1-0.4,0.1c-0.3,0.1-1.5,0.4-1.5,0.4c-0.7,0.1-1.3,0.2-2,0.2c-0.6,0-1.2-0.1-1.8-0.2
	s-1.2-0.3-1.7-0.5c-0.1-0.1-0.3-0.1-0.4-0.2c-0.8-0.3-1.5-0.8-2.1-1.3c-0.3-0.2-0.5-0.4-0.7-0.6C7.4,21,7.2,21,7,21.1H6.9
	c-0.2,0.1-0.4,0.2-0.6,0.3c0,0-0.1,0-0.1,0.1c-0.7,0.4-1.4,0.9-2,1.4L4.1,23c-1.1,1.2-1.8,2.9-1.9,4.7c0,0.1,0,2.8,0,2.9l0.1,4
	c0,0.2,0,1.3,0.2,3.1h11.2C14,36.5,14.6,35.5,15.4,34.6z"
          />
          <g>
            <path
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke="#949596"
              strokeWidth="2"
              strokeMiterlimit="10"
              d="M40.1,42.2v7.6c0,0.2,0,0.3-0.2,2.1h-24
		c-0.1-1.8-0.2-1.9-0.2-2.1v-7.6c0-0.1,0-0.2,0-0.4c0.1-1.8,0.8-3.4,1.9-4.7l0.1-0.1c0.6-0.6,1.2-1.1,2-1.4c0,0,0.1,0,0.1-0.1
		c0.2-0.1,0.4-0.2,0.6-0.3h0.1c0.2-0.1,0.4-0.1,0.6-0.2c0.2,0.2,0.5,0.4,0.7,0.6c0.7,0.5,1.4,0.9,2.1,1.3c0.1,0.1,0.3,0.1,0.4,0.2
		c0.6,0.2,1.1,0.4,1.7,0.5s1.2,0.2,1.8,0.2c0.7,0,1.3-0.1,2-0.2c0.1,0,1.2-0.3,1.5-0.4c0.1,0,0.2-0.1,0.4-0.1c0.6-0.3,1.8-1,1.9-1.1
		c0.3-0.3,0.7-0.6,1-0.9c3,0.7,5.3,3.4,5.4,6.7C40.1,42,40.1,42.1,40.1,42.2z"
            />
          </g>
          <circle fill="#949596" stroke="949596" strokeWidth="2" strokeMiterlimit="10" cx="27.9" cy="26.8" r="7.3" />
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="1.2"
            strokeMiterlimit="10"
            d="M48.8,20.9c-0.3,0.3-2.3,1.7-2.9,1.9
	c-0.1,0.1-0.8,0.4-1.1,0.5c-0.6,0.1-0.9,0.2-1.5,0.3c-0.5,0.1-1,0-1.3,0c-0.6,0-1.2-0.1-1.8-0.2s-1.2-0.3-1.7-0.5
	c-0.1-0.1-0.3-0.1-0.4-0.2c-0.5-0.2-0.9-0.5-1.4-0.7c0.7,1.4,1.2,3,1.2,4.7c0,2-0.6,3.9-1.6,5.4c2.6,0.8,4.6,2.9,5.5,5.5H54
	c0.2-1.1,0.2-1.4,0.2-2.1v-7.6c0-0.1,0-0.2,0-0.4C54,24.4,51.8,21.6,48.8,20.9z"
          />
        </g>
      );
    case 'salesmodule':
      return (
        <g>
          <g>
            <g>
              <path
                fill={fillColor}
                d="M48.2,12.6H7.6c-1.6,0-3,1.3-3,3v24.9c0,1.6,1.3,3,3,3h40.7c1.6,0,3-1.3,3-3V15.6
			C51.2,13.9,49.9,12.6,48.2,12.6z M50,39.4c0,1.5-1.2,2.8-2.8,2.8H8.6c-1.5,0-2.8-1.2-2.8-2.8V16.7c0-1.5,1.2-2.8,2.8-2.8h38.7
			c1.5,0,2.8,1.2,2.8,2.8V39.4z"
              />
              <path
                fill={fillColor}
                d="M3.2,44.5c1,3.2,1.5,3.6,5.1,3.6c12.6,0,25.2,0,37.8,0c1.2,0,2.4,0,3.6-0.1c1.9-0.2,3-1.3,3.3-3.5
			C36.4,44.5,19.9,44.5,3.2,44.5z M33,46.6H22.7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H33c0.3,0,0.5,0.2,0.5,0.5
			S33.3,46.6,33,46.6z"
              />
            </g>

            <polyline
              fillRule="evenodd"
              clipRule="evenodd"
              fill="none"
              stroke="#949596"
              strokeWidth="2"
              strokeLinecap="round"
              strokeMiterlimit="10"
              points="
		12.8,36.4 22.8,29.7 26.5,30.8 29.2,28.4 32.7,29.1 39.5,23.4 	"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              fill="#949596"
              d="M36.7,21.3l4.3-0.9c0.6-0.1,1.1,0.4,1,1l-0.5,4.3
		c-0.1,0.7-0.9,1-1.5,0.5l-3.8-3.4C35.7,22.3,36,21.4,36.7,21.3z"
            />
          </g>
        </g>
      );
    case 'bankmodule':
      return (
        <g>
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="1.2401"
            strokeMiterlimit="10"
            d="M38.2,45.8c0.1-1.2,0.1-2.3,0.2-3.4
	c0.2-4.5,0.5-9.1,0.7-13.6c0-0.3,0-0.6,0-0.8c0-0.5-0.3-0.9-0.8-1c-0.6-0.1-0.9-0.5-0.9-1c0-0.5,0.4-0.8,1-0.8c2.1,0,4.3,0,6.4,0
	c0.6,0,0.9,0.3,1,0.8c0,0.5-0.2,0.8-0.8,1c-0.5,0.1-0.9,0.5-0.8,1.1c0.2,2.9,0.3,5.8,0.5,8.7c0.1,2.6,0.3,5.2,0.4,7.7
	c0,0.4,0,0.8,0.1,1.3c0.3,0,0.7,0,1,0c1,0,1.7,0.6,1.7,1.6c0,0.9-0.7,1.6-1.7,1.6c-4.3,0-8.6,0-12.9,0c-7.7,0-15.4,0-23.1,0
	c-0.9,0-1.4-0.4-1.6-1.1c-0.3-1,0.4-2,1.4-2c0.4,0,0.8,0,1.2,0c0.1-0.8,0.1-1.6,0.1-2.3c0.2-3.1,0.3-6.2,0.5-9.3
	c0.1-2,0.2-4,0.3-5.9c0-0.8-0.2-1.2-0.9-1.3c-0.5-0.1-0.8-0.4-0.7-0.9c0-0.5,0.3-0.8,0.8-0.8c0.5,0,1,0,1.5,0c1.6,0,3.2,0,4.8,0
	c0.2,0,0.3,0,0.5,0c0.5,0,0.8,0.4,0.8,0.8c0,0.5-0.2,0.8-0.7,0.9c-0.7,0.2-1,0.5-0.9,1.3c0.2,3.7,0.4,7.4,0.6,11.2
	c0.1,2,0.2,4,0.3,5.9c0,0.4,0.1,0.5,0.5,0.5c1.9,0,3.8,0,5.7,0c0.4,0,0.5-0.1,0.5-0.5c0.3-5,0.5-10,0.8-15c0-0.7,0.1-1.5,0.1-2.2
	c0-0.7-0.2-1.1-0.9-1.2C24.2,26.8,24,26.5,24,26c0-0.4,0.4-0.8,0.9-0.8c2.2,0,4.4,0,6.6,0c0.5,0,0.8,0.4,0.9,0.8
	c0,0.5-0.2,0.8-0.8,1c-0.7,0.1-1,0.5-0.9,1.2c0.2,4.2,0.5,8.4,0.7,12.6c0.1,1.5,0.2,2.9,0.2,4.4c0,0.4,0.1,0.6,0.5,0.6
	c1.8,0,3.7,0,5.5,0C37.8,45.8,38,45.8,38.2,45.8z"
          />
          <path
            fill={fillColor}
            d="M28.2,50.6c6.9,0,13.9,0,20.8,0c1.1,0,1.9,0.3,1.6,0.6c-0.2,0.2-0.8,0.4-1.6,0.4c-2.8,0-5.6,0-8.4,0
	c-11,0-22.1,0-33.1,0c-1,0-1.7-0.2-1.7-0.5c0-0.3,0.6-0.5,1.6-0.5c2.2,0,4.3,0,6.5,0C18.6,50.6,23.4,50.6,28.2,50.6z"
          />
          <path
            fill={fillColor}
            d="M28.1,52.6c7.2,0,14.4,0,21.7,0c1.2,0,1.9,0.4,1.7,0.9c-0.2,0.3-0.8,0.5-1.7,0.5c-2.9,0-5.9,0-8.8,0
	c-11.5,0-23,0-34.5,0c-1.1,0-1.7-0.3-1.8-0.7c0-0.5,0.6-0.8,1.7-0.8c2.3,0,4.5,0,6.8,0C18.2,52.6,23.2,52.6,28.1,52.6z"
          />
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="1.116"
            strokeMiterlimit="10"
            d="M49.5,19.6c-0.1,0-0.1-0.1-0.2-0.1
	c-4.1-2.1-8.2-4.2-12.3-6.3c-1,4.5-5,7.9-9.9,7.9c-4.5,0-8.3-2.9-9.6-6.9c-0.1,0.1-0.3,0.1-0.4,0.2c-3.4,1.7-6.8,3.5-10.3,5.2
	c-0.7,0.4-0.9,0.8-0.5,1.5c0.2,0.4,0.4,0.8,0.6,1.2c0.3,0.7,0.9,1.1,1.7,1.1c6.5,0,13,0,19.5,0c1.5,0,3,0,4.5,0c5,0,10,0,15,0
	c0.8,0,1.4-0.3,1.7-1.1c0.2-0.4,0.4-0.8,0.6-1.1C50.3,20.4,50.2,19.9,49.5,19.6z"
          />
          <g>
            <g>
              <g>
                <path
                  fill="#949596"
                  stroke="#949596"
                  strokeMiterlimit="10"
                  d="M27.1,3.4c-4,0-7.3,3.3-7.3,7.3c0,4,3.3,7.3,7.3,7.3
				s7.3-3.3,7.3-7.3C34.5,6.7,31.2,3.4,27.1,3.4z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  fill={p4Tokens.colorBrandMenuBackground1}
                  d="M24.2,15.3v-0.7c1-0.5,1.6-1.4,1.6-2.5c0-0.3,0-0.6-0.1-1h-1.5v-0.9h1.3c-0.1-0.4-0.2-1-0.2-1.5
				c0-1.7,1.2-2.8,2.7-2.8c0.7,0,1.3,0.2,1.6,0.4l-0.3,0.9c-0.3-0.1-0.7-0.3-1.3-0.3c-1.1,0-1.6,0.8-1.6,1.8c0,0.6,0.1,1.1,0.2,1.5
				h2.1v0.9h-1.9c0,0.5,0.1,1.1-0.1,1.6c-0.2,0.6-0.5,1.1-1,1.5v0h4.3v1H24.2z"
                />
              </g>
            </g>
          </g>
        </g>
      );
    case 'reportsmodule':
      return (
        <g>
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={fillColor}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M39.3,18.4H16.7c-0.7,0-1.2-0.5-1.2-1.2V8.4
	c0-0.7,0.5-1.2,1.2-1.2h22.7c0.7,0,1.2,0.5,1.2,1.2v8.8C40.6,17.8,40,18.4,39.3,18.4z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={fillColor}
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M46.6,40.8H9.7c-1.2,0-2.3-1-2.3-2.3V19.8
	c0-1.2,1-2.3,2.3-2.3h36.8c1.2,0,2.3,1,2.3,2.3v18.8C48.8,39.8,47.8,40.8,46.6,40.8z"
          />
          <path
            fill="#949596"
            d="M14.2,23.5c0,0.8-0.6,1.5-1.4,1.5c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.4,1.4-1.5
	C13.5,22,14.2,22.7,14.2,23.5z"
          />
          <path
            fill="#949596"
            d="M28.1,38.3c2,0,4,0,6,0c0.6,0,1,0.3,1,0.8c0,0.5-0.3,0.8-0.7,0.9c-0.2,0-0.3,0-0.5,0c-4,0-7.9,0-11.9,0
	c-0.7,0-1.2-0.5-1-1.1c0.1-0.3,0.4-0.5,0.7-0.6c0.1,0,0.2,0,0.3,0C24,38.3,26.1,38.3,28.1,38.3C28.1,38.3,28.1,38.3,28.1,38.3z"
          />
          <path
            fill="#949596"
            d="M28.1,35.1c-2.1,0-4.1,0-6.2,0c-0.4,0-0.7-0.2-0.8-0.6c-0.1-0.3-0.1-0.7,0.2-0.9c0.2-0.1,0.5-0.2,0.7-0.2
	c2.3,0,4.5,0,6.8,0c1.8,0,3.6,0,5.5,0c0.5,0,0.9,0.3,0.9,0.8c0,0.6-0.3,0.9-0.9,0.9C32.2,35.1,30.1,35.1,28.1,35.1z"
          />
          <path
            fill="#949596"
            d="M28.1,43.3c2,0,4.1,0,6.1,0c0.5,0,0.9,0.3,0.9,0.8c0,0.5-0.3,0.9-0.9,0.9c-0.9,0-1.8,0-2.7,0
	c-3.2,0-6.4,0-9.6,0c-0.7,0-1.1-0.6-0.9-1.2c0.1-0.3,0.4-0.5,0.9-0.5c1.8,0,3.6,0,5.4,0C27.6,43.3,27.8,43.3,28.1,43.3z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke="#949596"
            strokeWidth="1.3"
            strokeMiterlimit="10"
            d="M39,50.3H17.6c-0.9,0-1.7-0.8-1.7-1.7V30.4
	c0-0.9,0.8-1.7,1.7-1.7H39c0.9,0,1.7,0.8,1.7,1.7v18.3C40.6,49.5,39.9,50.3,39,50.3z"
          />
          <path
            fill="#949596"
            d="M34.4,35H21.8c-0.4,0-0.8-0.3-0.8-0.8v0c0-0.4,0.3-0.8,0.8-0.8h12.6c0.4,0,0.8,0.3,0.8,0.8v0
	C35.2,34.7,34.9,35,34.4,35z"
          />
          <path
            fill="#949596"
            d="M34.4,40H21.8c-0.4,0-0.8-0.3-0.8-0.8v0c0-0.4,0.3-0.8,0.8-0.8h12.6c0.4,0,0.8,0.3,0.8,0.8v0
	C35.2,39.7,34.9,40,34.4,40z"
          />
          <path
            fill="#949596"
            d="M34.4,44.9H21.8c-0.4,0-0.8-0.3-0.8-0.8l0,0c0-0.4,0.3-0.8,0.8-0.8h12.6c0.4,0,0.8,0.3,0.8,0.8l0,0
	C35.2,44.6,34.9,44.9,34.4,44.9z"
          />
        </g>
      );
    case 'companymodule':
      return (
        <g>
          <path
            fill="none"
            stroke="#949596"
            strokeWidth="1.3"
            d="M33.1,51.1H7.9c-0.7,0-1.3-0.6-1.3-1.3V7.6c0-0.7,0.6-1.3,1.3-1.3h25.2
	c0.7,0,1.3,0.6,1.3,1.3v42.3C34.3,50.6,33.8,51.1,33.1,51.1z"
          />
          <path
            fill="none"
            stroke="#949596"
            strokeWidth="1.3"
            d="M48.9,51.1H35.3c-0.4,0-0.8-0.3-0.8-0.8V28.9c0-0.4,0.3-0.8,0.8-0.8h13.6
	c0.4,0,0.8,0.3,0.8,0.8v21.5C49.7,50.8,49.3,51.1,48.9,51.1z"
          />
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="0.8"
            d="M40.6,48.4h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8c0-0.4,0.3-0.8,0.8-0.8h2.8
	c0.4,0,0.8,0.3,0.8,0.8v2.8C41.4,48.1,41,48.4,40.6,48.4z"
          />
          <path
            fill="none"
            stroke={fillColor}
            d="M13.9,48.7H11c-0.6,0-1.1-0.5-1.1-1.1v-5.4c0-0.6,0.5-1.1,1.1-1.1h2.9c0.6,0,1.1,0.5,1.1,1.1
	v5.4C15,48.2,14.5,48.7,13.9,48.7z"
          />
          <path
            fill="none"
            stroke={fillColor}
            d="M30.3,48.7h-2.9c-0.6,0-1.1-0.5-1.1-1.1v-5.4c0-0.6,0.5-1.1,1.1-1.1h2.9
	c0.6,0,1.1,0.5,1.1,1.1v5.4C31.5,48.2,31,48.7,30.3,48.7z"
          />
          <path
            fill="#949596"
            d="M24.1,51.1h-6.8c-0.2,0-0.3-0.1-0.3-0.3V41c0-0.2,0.1-0.3,0.3-0.3h6.8c0.2,0,0.3,0.1,0.3,0.3v9.9
	C24.4,51,24.3,51.1,24.1,51.1z"
          />
          <path
            fill="none"
            stroke={fillColor}
            d="M30.5,38.4h-3.3c-0.5,0-0.9-0.4-0.9-0.9v-3.2c0-0.5,0.4-0.9,0.9-0.9h3.3
	c0.5,0,0.9,0.4,0.9,0.9v3.2C31.5,38,31.1,38.4,30.5,38.4z"
          />
          <path
            fill="none"
            stroke={fillColor}
            d="M30.5,30.5h-3.3c-0.5,0-0.9-0.4-0.9-0.9v-3.2c0-0.5,0.4-0.9,0.9-0.9h3.3
	c0.5,0,0.9,0.4,0.9,0.9v3.2C31.5,30.1,31.1,30.5,30.5,30.5z"
          />
          <path
            fill="none"
            stroke={fillColor}
            d="M30.5,22.7h-3.3c-0.5,0-0.9-0.4-0.9-0.9v-3.2c0-0.5,0.4-0.9,0.9-0.9h3.3
	c0.5,0,0.9,0.4,0.9,0.9v3.2C31.5,22.3,31.1,22.7,30.5,22.7z"
          />
          <path
            fill="none"
            stroke={fillColor}
            d="M30.5,14.9h-3.3c-0.5,0-0.9-0.4-0.9-0.9v-3.2c0-0.5,0.4-0.9,0.9-0.9h3.3
	c0.5,0,0.9,0.4,0.9,0.9V14C31.5,14.5,31.1,14.9,30.5,14.9z"
          />
          <path
            fill="none"
            stroke={p4Tokens.colorBrandMenuForeground2}
            d="M22.3,38.4H19c-0.5,0-0.9-0.4-0.9-0.9v-3.2c0-0.5,0.4-0.9,0.9-0.9h3.3c0.5,0,0.9,0.4,0.9,0.9
	v3.2C23.2,38,22.8,38.4,22.3,38.4z"
          />
          <path
            fill="none"
            stroke={fillColor}
            d="M22.3,30.5H19c-0.5,0-0.9-0.4-0.9-0.9v-3.2c0-0.5,0.4-0.9,0.9-0.9h3.3c0.5,0,0.9,0.4,0.9,0.9
	v3.2C23.2,30.1,22.8,30.5,22.3,30.5z"
          />
          <path
            fill="none"
            stroke={fillColor}
            d="M22.3,22.7H19c-0.5,0-0.9-0.4-0.9-0.9v-3.2c0-0.5,0.4-0.9,0.9-0.9h3.3c0.5,0,0.9,0.4,0.9,0.9
	v3.2C23.2,22.3,22.8,22.7,22.3,22.7z"
          />
          <path
            fill="none"
            stroke={fillColor}
            d="M22.3,14.9H19c-0.5,0-0.9-0.4-0.9-0.9v-3.2c0-0.5,0.4-0.9,0.9-0.9h3.3c0.5,0,0.9,0.4,0.9,0.9
	V14C23.2,14.5,22.8,14.9,22.3,14.9z"
          />
          <path
            fill="none"
            stroke={fillColor}
            d="M14.1,38.4h-3.3c-0.5,0-0.9-0.4-0.9-0.9v-3.2c0-0.5,0.4-0.9,0.9-0.9h3.3
	c0.5,0,0.9,0.4,0.9,0.9v3.2C15,38,14.6,38.4,14.1,38.4z"
          />
          <path
            fill="none"
            stroke={fillColor}
            d="M14.1,30.5h-3.3c-0.5,0-0.9-0.4-0.9-0.9v-3.2c0-0.5,0.4-0.9,0.9-0.9h3.3
	c0.5,0,0.9,0.4,0.9,0.9v3.2C15,30.1,14.6,30.5,14.1,30.5z"
          />
          <path
            fill="none"
            stroke={fillColor}
            d="M14.1,22.7h-3.3c-0.5,0-0.9-0.4-0.9-0.9v-3.2c0-0.5,0.4-0.9,0.9-0.9h3.3
	c0.5,0,0.9,0.4,0.9,0.9v3.2C15,22.3,14.6,22.7,14.1,22.7z"
          />
          <path
            fill="none"
            stroke={fillColor}
            d="M14.1,14.9h-3.3c-0.5,0-0.9-0.4-0.9-0.9v-3.2c0-0.5,0.4-0.9,0.9-0.9h3.3
	c0.5,0,0.9,0.4,0.9,0.9V14C15,14.5,14.6,14.9,14.1,14.9z"
          />
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="0.8"
            d="M46.5,48.4h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8c0-0.4,0.3-0.8,0.8-0.8h2.8
	c0.4,0,0.8,0.3,0.8,0.8v2.8C47.2,48.1,46.9,48.4,46.5,48.4z"
          />
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="0.8"
            d="M40.6,41.9h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8c0-0.4,0.3-0.8,0.8-0.8h2.8
	c0.4,0,0.8,0.3,0.8,0.8v2.8C41.4,41.5,41,41.9,40.6,41.9z"
          />
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="0.8"
            d="M46.5,41.9h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8c0-0.4,0.3-0.8,0.8-0.8h2.8
	c0.4,0,0.8,0.3,0.8,0.8v2.8C47.2,41.5,46.9,41.9,46.5,41.9z"
          />
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="0.8"
            d="M40.6,35.3h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8c0-0.4,0.3-0.8,0.8-0.8h2.8
	c0.4,0,0.8,0.3,0.8,0.8v2.8C41.4,34.9,41,35.3,40.6,35.3z"
          />
          <path
            fill="none"
            stroke={fillColor}
            strokeWidth="0.8"
            d="M46.5,35.3h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-2.8c0-0.4,0.3-0.8,0.8-0.8h2.8
	c0.4,0,0.8,0.3,0.8,0.8v2.8C47.2,34.9,46.9,35.3,46.5,35.3z"
          />
        </g>
      );
    case 'configurationmodule':
      return (
        <g>
          <circle fill={fillColor} cx="41.7" cy="38.8" r="2.1" />
          <circle fill={fillColor} cx="21.6" cy="23.2" r="3.4" />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={fillColor}
            strokeWidth="1.2"
            d="M36.5,17.1l-2-3.6c-0.3-0.5-0.9-0.5-1.4-0.3L31,14.5l0,0
	c-0.9-0.9-2-1.8-3.2-2.5l0.6-2.3c0.1-0.5-0.2-1-0.7-1.2l-4-1.1c-0.5-0.1-1,0.2-1.2,0.7L22,10.4l0,0c-1.3,0-2.5,0-3.9,0.5l-1.2-2.1
	c-0.3-0.5-0.9-0.6-1.4-0.4l-3.6,2c-0.5,0.3-0.4,0.8-0.1,1.2l1.2,2.1l0,0c-1.1,1-1.9,2-2.5,3.2l-2.4-0.6c-0.5-0.1-1,0.2-1.2,0.7
	l-1.1,4c-0.1,0.5,0.2,1,0.7,1.2l2.3,0.6l0,0c0,1.3,0,2.5,0.5,4l-2.1,1.2c-0.5,0.3-0.5,0.7-0.3,1.2l2,3.6c0.3,0.5,0.7,0.6,1.1,0.3
	l2.1-1.2l0,0c1,1.1,2,1.9,3.2,2.5l-0.6,2.3c-0.1,0.5,0.2,1,0.7,1.2l4,1.1c0.5,0.1,1-0.2,1.2-0.7l0.6-2.3l0.1,0
	c1.3,0,2.6-0.1,4.1-0.6l1.2,2.1c0.3,0.5,0.6,0.7,1.1,0.4l3.6-2c0.5-0.3,0.7-0.8,0.4-1.3l-1.2-2.1l0,0c1.1-1,1.8-1.9,2.4-3.1l2.3,0.6
	c0.5,0.1,1-0.2,1.2-0.7l1.1-4c0.1-0.5-0.2-1-0.7-1.2l-2.3-0.6l0,0c0-1.3-0.1-2.6-0.5-4l2.1-1.2C36.4,18.1,36.8,17.6,36.5,17.1z
	 M16.3,19c0.5-0.7,1.2-1.2,1.9-1.7c1-0.6,2-0.8,3-0.9c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0
	c0.1,0,0.1,0,0.2,0c0.2,0,0.4,0.1,0.6,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.1,0,0.2,0.1c0.1,0,0.2,0.1,0.3,0.1
	c0.1,0,0.1,0,0.2,0.1c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0.1,0.2,0.1c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.1,0.2,0.2,0.4,0.2
	c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.2,0.2,0.2,0.2c0.4,0.4,0.7,0.9,1,1.4
	c0.5,0.9,0.8,1.9,0.9,2.9c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.3-0.1,0.5-0.1,0.8c0,0.1,0,0.2-0.1,0.3
	c0,0.2-0.1,0.3-0.1,0.5c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.1-0.1,0.2c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.1-0.1,0.3-0.2,0.4
	c-0.1,0.1-0.1,0.2-0.2,0.3c-0.6,0.9-1.3,1.6-2.3,2.2c-0.8,0.5-1.7,0.7-2.6,0.9c-0.1,0-0.2,0-0.3,0c-0.3,0-0.7,0-1,0
	c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0c-0.2,0-0.3-0.1-0.5-0.1c-1.8-0.4-3.4-1.5-4.4-3.2c-0.5-0.8-0.8-1.7-0.9-2.6
	c0-0.4-0.1-0.8,0-1.1c0-0.1,0-0.3,0-0.4c0-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.2-0.6,0.3-0.9c0-0.1,0-0.1,0.1-0.2c0-0.1,0.1-0.2,0.1-0.3
	c0-0.1,0.1-0.2,0.2-0.3c0.1-0.2,0.2-0.4,0.3-0.6c0-0.1,0.1-0.1,0.1-0.2C16.2,19.1,16.3,19.1,16.3,19z"
          />
          <path
            fill={p4Tokens.colorBrandMenuBackground1}
            stroke={fillColor}
            strokeWidth="1.2"
            strokeMiterlimit="10"
            d="M48.8,31.8l-2-1.6c-0.3-0.2-0.7-0.1-0.9,0.2
	L45,31.5l0,0c-0.7-0.3-1.6-0.6-2.4-0.7l-0.2-1.5c0-0.3-0.3-0.6-0.7-0.5l-2.6,0.3c-0.3,0-0.6,0.3-0.5,0.7l0.2,1.5l0,0
	c-0.8,0.3-1.4,0.6-2.2,1.2l-1.2-0.9c-0.3-0.2-0.7-0.2-0.9,0.1l-1.6,2c-0.2,0.3-0.1,0.5,0.2,0.8l1.2,0.9l0,0
	c-0.4,0.9-0.6,1.6-0.7,2.5l-1.5,0.2c-0.3,0-0.6,0.3-0.5,0.7l0.3,2.6c0,0.3,0.3,0.6,0.7,0.5l1.5-0.2l0,0c0.3,0.8,0.6,1.5,1.2,2.2
	l-0.9,1.2c-0.2,0.3-0.1,0.5,0.1,0.8l2,1.6c0.3,0.2,0.5,0.2,0.7-0.1l0.9-1.2l0,0c0.9,0.4,1.6,0.6,2.4,0.7l0.2,1.5
	c0,0.3,0.3,0.6,0.7,0.5l2.6-0.3c0.3,0,0.6-0.3,0.5-0.7l-0.2-1.5l0,0c0.8-0.3,1.5-0.7,2.2-1.3l1.2,0.9c0.3,0.2,0.5,0.3,0.7,0l1.6-2
	c0.2-0.3,0.2-0.6-0.1-0.8L49,42.1l0,0c0.4-0.9,0.6-1.6,0.7-2.4l1.5-0.2c0.3,0,0.6-0.3,0.5-0.7l-0.3-2.6c0-0.3-0.3-0.6-0.7-0.5
	L49.2,36l0,0c-0.3-0.8-0.6-1.5-1.3-2.2l0.9-1.2C49,32.3,49.1,32,48.8,31.8z M37.4,37.6c0.1-0.5,0.4-1,0.8-1.5c0.4-0.6,1-1,1.6-1.3
	c0.1,0,0.1-0.1,0.2-0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2-0.1c0.1,0,0.1,0,0.2-0.1c0,0,0.1,0,0.1,0c0.1,0,0.3-0.1,0.4-0.1
	c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0
	c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0.1c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.1,0.1,0.2,0.1
	c0.3,0.1,0.7,0.3,1,0.6c0.5,0.4,1,0.9,1.2,1.5c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0.1,0.2
	c0.1,0.2,0.1,0.3,0.1,0.5c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2
	c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.2c-0.1,0.7-0.4,1.3-0.8,1.9c-0.4,0.5-0.8,0.9-1.3,1.1c-0.1,0-0.1,0.1-0.2,0.1
	c-0.2,0.1-0.4,0.2-0.6,0.2c-0.1,0-0.1,0-0.2,0.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0.1c-1.2,0.2-2.4-0.1-3.4-0.9
	c-0.5-0.4-0.9-0.8-1.1-1.3c-0.1-0.2-0.2-0.4-0.3-0.7c0-0.1-0.1-0.2-0.1-0.2c-0.1-0.2-0.1-0.4-0.1-0.6c0-0.2,0-0.4,0-0.6
	c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2s0-0.1,0-0.2c0-0.1,0-0.3,0.1-0.4c0,0,0-0.1,0-0.1C37.4,37.7,37.4,37.7,37.4,37.6z"
          />
          <circle fill="none" stroke="#FFFFFB" strokeWidth="3" strokeMiterlimit="10" cx="21.6" cy="23.2" r="9.9" />
        </g>
      );
    case P4SVGIcon.TradeCounterStockAdjustPlus:
      return (
        <path
          fill="#263184"
          d="M42.2,28.4v-8.7h5.6v8.7c-0.9-0.1-1.9-0.3-2.8-0.3C44,28.1,43.1,28.3,42.2,28.4 M50.6,16.9H0.1V0.1h50.5V16.9
	 M45,5.7H5.7v5.6H45V5.7 M8.5,45V19.7H2.9v30.8h26.2c-0.6-1.8-1-3.6-1-5.6L8.5,45 M47.8,42.2v-8.4h-5.6v8.4h-8.4v5.6h8.4v8.4h5.6
	v-8.4h8.4v-5.6C56.2,42.2,47.8,42.2,47.8,42.2z"
        />
      );
    case P4SVGIcon.TradeCounterVoidLine:
      return (
        <path
          fill="#E2180A"
          d="M19,0.5v3.1H3.7v6.2h3.1v40c0,3.4,2.8,6.2,6.2,6.2h30.8c3.4,0,6.2-2.8,6.2-6.2v-40h3.1V3.5H37.5V0.5H19
	 M12.9,9.7h30.8v40H12.9V9.7 M19,15.8v27.7h6.2V15.8H19 M31.3,15.8v27.7h6.2V15.8H31.3z"
        />
      );
    case P4SVGIcon.TradeCounterBatchAllocation:
      return (
        <g>
          <g>
            <polygon
              fill="#263184"
              points="36.2,53.5 19.2,53.5 19.2,46.8 16.3,46.8 16.3,56.3 24.7,56.3 30.6,56.3 39.1,56.3 39.1,46.8
			36.2,46.8 		"
            />
            <path
              fill="#263184"
              d="M14.9,36.8l0,8.6l25.8,0l0-8.6L14.9,36.8z M37.8,42.5l-20.1,0l0-2.9l20.1,0L37.8,42.5z"
            />
          </g>
          <path
            fill="#263184"
            d="M30.4,8.6l0-8.6l-5.1,0l0,8.6C26.2,8.3,27,8.1,28,8.1C28.8,8.1,29.6,8.3,30.4,8.6L30.4,8.6z"
          />
          <path
            fill="#263184"
            d="M32.4,12.8c-0.9-1.5-2.5-2.6-4.4-2.6c0,0,0,0,0,0c0,0,0,0,0,0c-1.9,0-3.5,1-4.4,2.6C7.4,13.1,6.6,28.6,13,34.4
		l3.6-3.6c-1.4-1.4-2.2-3.4-2.2-5.4c0-2,0.7-7.5,9.2-7.5c0.9,1.5,2.5,2.5,4.3,2.5c0,0,0,0,0,0c0,0,0,0,0,0c1.8,0,3.4-1,4.3-2.5
		c8.5,0,9.2,5.5,9.2,7.5c0,2-0.8,4-2.2,5.4l3.6,3.6C49.2,28.6,48.4,13.1,32.4,12.8z"
          />
        </g>
      );
    case 'webmodule':
      return (
        <path
          className="st0"
          fill={fillColor}
          stroke={fillColor}
          strokeWidth="0.5"
          strokeMiterlimit="10"
          d="M28.1,1.1c-14.9,0-27,12.1-27,27.1c0,14.9,12.1,27.1,27,27.1c14.9,0,27.1-12.1,27.1-27.1
	  C55.2,13.2,43.1,1.1,28.1,1.1L28.1,1.1z M26.2,2.6c-4.7,3.9-8.2,8.8-10.3,14H5.2C9.2,8.8,17,3.3,26.2,2.6L26.2,2.6z M30.1,2.6
	  c9.2,0.7,17,6.2,21,14H40.4C38.3,11.4,34.8,6.5,30.1,2.6L30.1,2.6z M28.8,3.3c4.6,3.7,8,8.3,10,13.3h-10V3.3z M27.4,3.3v13.2h-10
	  C19.5,11.6,22.9,7.1,27.4,3.3z M4.6,18h10.8c-1.1,3.2-1.8,6.6-1.8,9.9c-0.1,3.4,0.4,6.8,1.5,10.1H4.5c-1.3-3-2-6.4-2-9.9
	  C2.5,24.5,3.2,21.1,4.6,18L4.6,18z M16.9,18h10.5v20H16.5c-1.1-3.3-1.6-6.7-1.5-10.1C15,24.6,15.7,21.2,16.9,18L16.9,18z M28.8,18
	  h10.6c1.2,3.2,1.8,6.6,1.9,10c0.1,3.4-0.4,6.8-1.5,10.1h-11V18z M40.9,18h10.8c1.3,3.1,2.1,6.6,2.1,10.2c0,3.5-0.7,6.8-2,9.9H41.2
	  c1.1-3.3,1.6-6.7,1.5-10.1C42.6,24.6,42,21.2,40.9,18L40.9,18z M5.1,39.4h10.4c2,5.3,5.5,10.2,10.6,14.3C16.9,53,9,47.4,5.1,39.4
	  L5.1,39.4z M17,39.4h10.4V53C22.4,49.1,19,44.4,17,39.4z M28.8,39.4h10.5c-2,5-5.4,9.7-10.5,13.6V39.4z M40.8,39.4h10.4
	  c-3.9,7.9-11.8,13.6-21,14.3C35.3,49.6,38.8,44.7,40.8,39.4L40.8,39.4z"
        />
      );
    case 'webpages':
      return (
        <g>
          <path
            className="st0"
            fill="#FFFFFF"
            stroke={fillColor}
            strokeWidth="1.47"
            strokeMiterlimit="10"
            d="M16.4,17.6H52c1.5,0,2.7,1.2,2.7,2.7v27.1c0,1.5-1.2,2.7-2.7,2.7H16.4c-1.5,0-2.7-1.2-2.7-2.7V20.4
		C13.7,18.9,14.9,17.6,16.4,17.6z"
          />
          <path
            className="st0"
            fill="#FFFFFF"
            stroke={fillColor}
            strokeWidth="1.47"
            strokeMiterlimit="10"
            d="M10.9,12.1h35.5c1.5,0,2.7,1.2,2.7,2.7V42c0,1.5-1.2,2.7-2.7,2.7H10.9c-1.5,0-2.7-1.2-2.7-2.7V14.9
		C8.1,13.3,9.4,12.1,10.9,12.1z"
          />
          <path
            className="st0"
            fill="#FFFFFF"
            stroke={fillColor}
            strokeWidth="1.47"
            strokeMiterlimit="10"
            d="M4.5,6.1H40c1.5,0,2.7,1.2,2.7,2.7v27.1c0,1.5-1.2,2.7-2.7,2.7H4.5c-1.5,0-2.7-1.2-2.7-2.7V8.8
		C1.8,7.3,3,6.1,4.5,6.1z"
          />
          <line
            className="st1"
            fill="none"
            stroke={fillColor}
            strokeWidth="1.47"
            strokeMiterlimit="10"
            x1="1.6"
            y1="16"
            x2="43"
            y2="16"
          />
          <g>
            <circle className="st2" fill="#2C3279" cx="27.1" cy="11" r="1.9" />
            <circle className="st2" fill="#2C3279" cx="37.4" cy="11" r="1.9" />
            <circle className="st2" fill="#2C3279" cx="32.2" cy="11" r="1.9" />
          </g>
        </g>
      );
    case 'webmedia':
      return (
        <g>
          <g>
            <g>
              <path
                class="st0"
                fill="none"
                stroke={p4Tokens.colorBrandMenuForeground2}
                strokeWidth="1.3071"
                strokeMiterlimit="10"
                d="M32.5,2.9h-25C6.3,2.9,5.3,3.8,5.3,5V41c0,1.1,0.9,2.1,2.1,2.1h12.3l14.8-14.2V5C34.5,3.8,33.6,2.9,32.5,2.9z"
              />
              <path
                class="st1"
                fill={p4Tokens.colorBrandMenuForeground2}
                d="M30.3,34.5H9.9c-0.2,0-0.3,0.1-0.3,0.3v0.7c0,0.2,0.1,0.3,0.3,0.3h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7C30.7,34.6,30.5,34.5,30.3,34.5z"
              />
              <path
                class="st1"
                fill={p4Tokens.colorBrandMenuForeground2}
                d="M30.3,28.5H9.9c-0.2,0-0.3,0.1-0.3,0.3v0.7c0,0.2,0.1,0.3,0.3,0.3h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7C30.7,28.6,30.5,28.5,30.3,28.5z"
              />
              <path
                class="st1"
                fill={p4Tokens.colorBrandMenuForeground2}
                d="M30.3,22.4H9.9c-0.2,0-0.3,0.1-0.3,0.3v0.7c0,0.2,0.1,0.3,0.3,0.3h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7C30.7,22.6,30.5,22.4,30.3,22.4z"
              />
              <path
                class="st1"
                fill={p4Tokens.colorBrandMenuForeground2}
                d="M30.3,16.4H9.9c-0.2,0-0.3,0.1-0.3,0.3v0.7c0,0.2,0.1,0.3,0.3,0.3h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7C30.7,16.6,30.5,16.4,30.3,16.4z"
              />
              <path
                class="st1"
                fill={p4Tokens.colorBrandMenuForeground2}
                d="M30.3,10.4H9.9c-0.2,0-0.3,0.1-0.3,0.3v0.7c0,0.2,0.1,0.3,0.3,0.3h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7C30.7,10.6,30.5,10.4,30.3,10.4z"
              />
            </g>
            <path
              class="st2"
              fill={p4Tokens.colorBrandMenuBackground1}
              stroke={p4Tokens.colorBrandMenuForeground2}
              strokeWidth="1.3071"
              strokeMiterlimit="10"
              d="M39.5,8.1h-25c-1.1,0-2.1,0.9-2.1,2.1v36.1c0,1.1,0.9,2.1,2.1,2.1h12.3l14.8-14.2V10.2C41.6,9,40.7,8.1,39.5,8.1z"
            />
            <path
              class="st1"
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M37.4,39.7H17c-0.2,0-0.3,0.1-0.3,0.3v0.7c0,0.2,0.1,0.3,0.3,0.3h20.4c0.2,0,0.3-0.1,0.3-0.3V40C37.7,39.8,37.6,39.7,37.4,39.7z"
            />
            <path
              class="st1"
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M37.4,33.6H17c-0.2,0-0.3,0.1-0.3,0.3v0.7c0,0.2,0.1,0.3,0.3,0.3h20.4c0.2,0,0.3-0.1,0.3-0.3V34C37.7,33.8,37.6,33.6,37.4,33.6z"
            />
            <path
              class="st1"
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M37.4,27.6H17c-0.2,0-0.3,0.1-0.3,0.3v0.7c0,0.2,0.1,0.3,0.3,0.3h20.4c0.2,0,0.3-0.1,0.3-0.3V28C37.7,27.8,37.6,27.6,37.4,27.6z"
            />
            <path
              class="st1"
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M37.4,21.6H17c-0.2,0-0.3,0.1-0.3,0.3v0.7c0,0.2,0.1,0.3,0.3,0.3h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7C37.7,21.8,37.6,21.6,37.4,21.6z"
            />
            <path
              class="st1"
              fill={p4Tokens.colorBrandMenuForeground2}
              d="M37.4,15.6H17c-0.2,0-0.3,0.1-0.3,0.3v0.7c0,0.2,0.1,0.3,0.3,0.3h20.4c0.2,0,0.3-0.1,0.3-0.3v-0.7C37.7,15.8,37.6,15.6,37.4,15.6z"
            />
            <g>
              <path
                class="st2"
                fill={p4Tokens.colorBrandMenuBackground1}
                stroke={p4Tokens.colorBrandMenuForeground2}
                strokeWidth="1.3071"
                strokeMiterlimit="10"
                d="M23.8,53.4h25c1.1,0,2.1-0.9,2.1-2.1V15.3c0-1.1-0.9-2.1-2.1-2.1H36.6L21.8,27.4v23.9C21.8,52.5,22.7,53.4,23.8,53.4z"
              />
              <path
                class="st2"
                fill={p4Tokens.colorBrandMenuBackground1}
                stroke={p4Tokens.colorBrandMenuForeground2}
                strokeWidth="1.3071"
                strokeMiterlimit="10"
                d="M23.5,27.2h11c1.1,0,2.1-0.9,2.1-2.1v-11L23.5,27.2z"
              />
              <path
                class="st3"
                fill={p4Tokens.colorBrandMenuBackground1}
                d="M24.1,26.7H34c1,0,1.9-0.8,1.9-1.8v-9.4L24.1,26.7z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                class="st3"
                fill={p4Tokens.colorBrandMenuBackground1}
                d="M28.8,48.8c-0.4,0-0.8-0.4-0.8-0.8V32.7c0-0.4,0.4-0.8,0.8-0.8h15.3c0.4,0,0.8,0.4,0.8,0.8V48c0,0.4-0.4,0.8-0.8,0.8H28.8z"
              />
              <path
                class="st4"
                fill="#2C3279"
                d="M44.2,32.3c0.2,0,0.4,0.2,0.4,0.4v3.4v3.1V48c0,0.2-0.2,0.4-0.4,0.4H28.9c-0.2,0-0.4-0.2-0.4-0.4v-9v-2.9v-3.4c0-0.2,0.2-0.4,0.4-0.4H44.2 M44.2,31.4H28.9c-0.7,0-1.3,0.6-1.3,1.3v3.4V39v9c0,0.7,0.6,1.3,1.3,1.3h15.3c0.7,0,1.3-0.6,1.3-1.3v-8.8v-3.1v-3.4C45.5,32,44.9,31.4,44.2,31.4L44.2,31.4z"
              />
            </g>
            <rect x="27.9" y="45.5" class="st4" width="17.1" height="3" />
            <polygon class="st4" fill="#2C3279" points="30,44.1 43.1,44.1 43.1,38.6 38.9,42.2 34.1,35.8 30,41.2" />
            <g>
              <path
                class="st4"
                fill="#2C3279"
                d="M39.4,38.3c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7C40,38,39.7,38.3,39.4,38.3z"
              />
              <path
                class="st4"
                fill="#2C3279"
                d="M39.4,37.6L39.4,37.6C39.4,37.7,39.4,37.7,39.4,37.6C39.4,37.7,39.3,37.7,39.4,37.6C39.3,37.6,39.3,37.6,39.4,37.6 M39.4,36.3c-0.7,0-1.3,0.6-1.3,1.3c0,0.8,0.6,1.3,1.3,1.3c0.8,0,1.3-0.6,1.3-1.3C40.7,36.9,40.1,36.3,39.4,36.3L39.4,36.3z"
              />
            </g>
          </g>
        </g>
      );

    case 'webpromotions':
      return (
        <g>
          <g>
            <path
              className="st0"
              fill="#18237B"
              d="M21.7,18.2c3.1,0,5.2,2.1,5.2,5.4c0,3.2-2.1,5.4-5.2,5.4c-3,0-5.2-2.1-5.2-5.4C16.5,20.4,18.7,18.2,21.7,18.2z
       M21.7,27.2c1.3,0,1.8-1.2,1.8-3.6S23,20,21.7,20c-1.3,0-1.8,1.2-1.8,3.6S20.4,27.2,21.7,27.2z M32.9,18.2h2.5l-12,19.5h-2.5
      L32.9,18.2z M34.5,27c3.1,0,5.2,2.1,5.2,5.4c0,3.2-2.2,5.4-5.2,5.4c-3,0-5.2-2.1-5.2-5.4C29.4,29.2,31.5,27,34.5,27z M34.6,36
      c1.3,0,1.8-1.2,1.8-3.6s-0.5-3.6-1.8-3.6c-1.3,0-1.8,1.2-1.8,3.6S33.3,36,34.6,36z"
            />
          </g>
          <polygon
            className="st1"
            fill="none"
            stroke={fillColor}
            strokeWidth="1.47"
            strokeMiterlimit="10"
            points="35.9,2.2 39.5,9.7 47.9,9.5 47.2,17.8 54.5,21.8 49.9,28.7 54.2,35.8 46.7,39.5 46.9,47.8 38.6,47.2
      34.6,54.4 27.7,49.8 20.6,54.1 16.9,46.6 8.6,46.8 9.2,38.5 1.9,34.5 6.6,27.6 2.3,20.5 9.8,16.9 9.6,8.5 17.9,9.1 21.9,1.9
      28.8,6.5 "
          />
        </g>
      );
    case P4SVGIcon.StockAdjustmentPrintWorkspace:
      return (
        <g>
          <path
            fill="#808285"
            d="M19.5,50c-0.8-0.3-1.5-0.6-2.3-1c-0.7-0.3-1.4-0.3-2.1,0c-0.4,0.2-0.9,0.4-1.3,0.6c-1.3,0.6-2.3,0-2.3-1.5
			c0-9.8,0-21.6,0-31.4c0-2.8,0-5.5,0-8.3c0-1.4,0.9-2.2,2.3-2.2c9.6,0,19.1,0,28.7,0c1.4,0,2.3,0.8,2.3,2.2c0,12.6,0,27.1,0,39.7
			c0,1-0.5,1.6-1.3,1.6c-0.3,0-0.7-0.1-1-0.2c-0.4-0.2-0.8-0.4-1.2-0.6c-0.7-0.3-1.4-0.3-2.2,0c-0.8,0.3-1.5,0.7-2.3,1
			c-0.4,0-0.8,0-1.3,0c-0.8-0.3-1.5-0.6-2.3-1c-0.8-0.3-1.5-0.3-2.2,0c-0.7,0.3-1.5,0.6-2.3,1c-0.4,0-0.8,0-1.2,0
			c-0.8-0.3-1.5-0.6-2.3-1c-0.7-0.3-1.4-0.3-2.2,0c-0.8,0.3-1.5,0.7-2.3,1C20.4,50,20,50,19.5,50z M43.4,48.5c0-0.2,0-0.4,0-0.5
			c0-12.4,0-26.9,0-39.3c0-0.7-0.2-0.9-1-0.9c-9.5,0-19,0-28.5,0c-0.7,0-1,0.2-1,0.9c0,12.4,0,26.9,0,39.3c0,0.1,0,0.3,0,0.5
			c0.5-0.2,0.9-0.4,1.3-0.6c1.3-0.7,2.7-0.7,4,0c0.1,0.1,0.3,0.1,0.4,0.2c1.1,0.7,2.1,0.6,3.2,0c0.2-0.1,0.5-0.3,0.7-0.4
			c1.1-0.5,2.2-0.5,3.3,0c0.4,0.2,0.8,0.4,1.3,0.6c0.7,0.3,1.4,0.3,2.1,0c0.4-0.2,0.8-0.4,1.2-0.6c1.1-0.5,2.3-0.5,3.4,0
			c0.4,0.2,0.8,0.4,1.2,0.6c0.8,0.4,1.5,0.4,2.3,0c0.4-0.2,0.8-0.4,1.2-0.6c0.4-0.2,0.9-0.3,1.4-0.4c0.8-0.1,1.5,0.1,2.2,0.5
			C42.4,48.1,42.9,48.3,43.4,48.5z"
          />
          <path
            fill="#808285"
            d="M24.3,10.9c2.5,0,5,0,7.5,0c0.3,0,0.6,0,0.8,0.3c0.3,0.5-0.1,1-0.7,1c-1.2,0-2.4,0-3.6,0c-3.8,0-7.5,0-11.3,0
			c-0.2,0-0.4,0-0.6-0.1c-0.3-0.1-0.4-0.4-0.4-0.7c0-0.3,0.2-0.5,0.6-0.6c0.1,0,0.3,0,0.4,0C19.4,10.9,21.8,10.9,24.3,10.9z"
          />
          <path
            fill="#808285"
            d="M24.3,18.5c2.5,0,5,0,7.5,0c0.4,0,0.7,0.1,0.9,0.4c0.2,0.5-0.2,0.9-0.8,0.9c-1.3,0-2.5,0-3.8,0
			c-3.7,0-7.4,0-11.1,0c-0.2,0-0.4,0-0.5-0.1c-0.3-0.1-0.5-0.4-0.4-0.7c0-0.3,0.2-0.5,0.6-0.6c0.2,0,0.3,0,0.5,0
			C19.4,18.5,21.9,18.5,24.3,18.5z"
          />
          <path
            fill="#808285"
            d="M21.6,14.7c1.6,0,3.2,0,4.8,0c0.6,0,0.9,0.4,0.8,0.8c-0.1,0.3-0.4,0.5-0.8,0.5c-1,0-2,0-3,0
			c-2.1,0-4.3,0-6.4,0c-0.2,0-0.4,0-0.5-0.1c-0.4-0.1-0.5-0.4-0.4-0.7c0-0.3,0.3-0.5,0.6-0.6c0.3,0,0.6,0,0.9,0
			C18.8,14.7,20.2,14.7,21.6,14.7C21.6,14.7,21.6,14.7,21.6,14.7z"
          />
          <path
            fill="#808285"
            d="M38.3,10.9c0.5,0,0.9,0,1.4,0c0.4,0,0.7,0.3,0.8,0.6c0,0.4-0.3,0.7-0.7,0.7c-1,0-2,0-3,0
			c-0.5,0-0.8-0.3-0.7-0.7c0-0.4,0.3-0.6,0.8-0.7C37.3,10.9,37.8,10.9,38.3,10.9C38.3,10.9,38.3,10.9,38.3,10.9z"
          />
          <path
            fill="#808285"
            d="M38.3,14.7c0.5,0,0.9,0,1.4,0c0.5,0,0.7,0.2,0.8,0.6c0,0.4-0.3,0.7-0.7,0.7c-1,0-2,0-3,0
			c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7C37.3,14.7,37.8,14.7,38.3,14.7C38.3,14.7,38.3,14.7,38.3,14.7z"
          />
          <path
            fill="#808285"
            d="M38.2,19.9c-0.4,0-0.9,0-1.3,0c-0.5,0-0.9-0.3-0.9-0.7c0-0.4,0.3-0.7,0.8-0.7c0.9,0,1.9,0,2.8,0
			c0.5,0,0.8,0.3,0.8,0.7c0,0.4-0.3,0.7-0.8,0.7C39.2,19.9,38.7,19.9,38.2,19.9z"
          />
          <g>
            <rect x="16" y="23" fill={p4Tokens.colorBrandMenuForeground1} width="24.5" height="21" />
            <g>
              <g>
                <g>
                  <polygon fill={p4Tokens.colorBrandMenuBackground1} points="23.4,27.2 27.9,28.9 27.9,33.9 23.4,32.3" />
                  <polygon fill={p4Tokens.colorBrandMenuBackground1} points="28.6,28.9 33.1,27.2 33.2,32.3 28.6,34" />
                  <polygon fill={p4Tokens.colorBrandMenuBackground1} points="23.7,26.5 28.2,28.2 32.8,26.5 28.2,24.8" />
                </g>
              </g>
              <g>
                <g>
                  <g>
                    <polygon fill={p4Tokens.colorBrandMenuBackground1} points="28.9,35.3 33.4,37 33.4,42.1 28.9,40.4" />
                    <polygon fill={p4Tokens.colorBrandMenuBackground1} points="34.2,37 38.7,35.3 38.7,40.4 34.2,42.1" />
                    <polygon
                      fill={p4Tokens.colorBrandMenuBackground1}
                      points="29.2,34.6 33.8,36.3 38.3,34.6 33.7,32.9"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <polygon fill={p4Tokens.colorBrandMenuBackground1} points="17.8,35.3 22.3,37 22.3,42.1 17.8,40.4" />
                    <polygon fill={p4Tokens.colorBrandMenuBackground1} points="23.1,37 27.6,35.3 27.6,40.4 23.1,42.1" />
                    <polygon
                      fill={p4Tokens.colorBrandMenuBackground1}
                      points="18.2,34.6 22.7,36.3 27.3,34.6 22.7,32.9"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      );
    case 'directdebit':
      return (
        <g transform="scale(2.3)">
          <path
            clipRule="evenodd"
            d="   M22,20.5H2c-0.8284271,0-1.5-0.6715736-1.5-1.5V5c0-0.8284273,0.6715729-1.5,1.5-1.5h20c0.8284264,0,1.5,0.6715727,1.5,1.5v14   C23.5,19.8284264,22.8284264,20.5,22,20.5z"
            fill="none"
            fillRule="evenodd"
            stroke="#808183"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            clipRule="evenodd"
            d="M11.4628286,10.4261408h0.9330654   c0,0,0.9237242-0.0186863,0.9143877,0.8210697c-0.0093145,0.6251574-0.8957272,0.7184668-0.8957272,0.7184668h-0.951726V10.4261408   L11.4628286,10.4261408z M14.2541418,13.4400835c0.0261707,0.1222095,0.1144609,0.2566967,0.4090796,0.2704191   c0.3918791,0.0093117,0.6158209-0.1399689,0.6158209-0.1399689v0.2892494c0,0-0.429224,0.1026268-0.6344757,0.1026268   c-0.2145948,0-0.8490963-0.0466528-0.8490963-0.6344719c0-0.4758463,0.5225334-0.6251612,0.8210983-0.6251612   c0.5224981,0.0186863,0.7744408,0.2052832,0.7650948,0.7371283C15.3816633,13.4477673,14.5219498,13.4419422,14.2541418,13.4400835   L14.2541418,13.4400835z M14.2552414,13.2066526h0.7158871c0,0,0-0.2705917-0.3452177-0.2705917   C14.366106,12.9360609,14.2811813,13.0761452,14.2552414,13.2066526L14.2552414,13.2066526z M16.5200176,12.9144421   c0.1034336-0.112258,0.2773247-0.2023191,0.5691547-0.2023191c0.5785046,0,0.6717854,0.4851923,0.6624775,0.6158152   c-0.009346,0.1306248-0.0559998,0.6251602-0.7277889,0.6251602c-0.2536469,0-0.4089069-0.0865555-0.5038433-0.1941433v0.1568022   h-0.457222v-1.6794825h0.457222V12.9144421L16.5200176,12.9144421z M16.9118938,13.691844   c0.2705936-0.0093431,0.3918762-0.2425957,0.3918762-0.3545599c0-0.1119738-0.0653114-0.3452549-0.4105339-0.3452549   c-0.267952,0-0.3494282,0.2024088-0.3732185,0.3013506v0.1217194C16.5434303,13.5158119,16.6254845,13.691844,16.9118938,13.691844   L16.9118938,13.691844z M20.8587284,13.6451912l0.0093117,0.2612476c0,0-0.2145977,0.0466595-0.354538,0.0466595   c-0.1399651,0-0.5038757-0.0840006-0.5038757-0.4385357c0-0.1443796,0-0.3491659,0-0.5411882h-0.3825302v-0.2425928h0.3825302   c0-0.1677418,0-0.2892551,0-0.2892551h0.4665356v0.2892551h0.3825665v0.2425928H20.476162v0.4665308   c0,0,0,0.2332563,0.1866264,0.2332563C20.8493862,13.6731615,20.8587284,13.6451912,20.8587284,13.6451912L20.8587284,13.6451912z    M19.4404716,10.6780491h0.5411854v1.2969427h0.4571934v-1.2969427h0.5505047v-0.2705946h-1.5488834V10.6780491   L19.4404716,10.6780491z M19.2538757,10.7433596l0.0559711-0.2705908c0,0-0.2332535-0.1026268-0.643816-0.1026268   c-0.4011955,0-1.0450134,0.223938-1.0450134,0.830409c0,0.5971622,0.6811352,0.8024454,1.1010094,0.8024454   c0.4198818,0,0.5598183-0.0653143,0.5598183-0.0653143L19.23522,11.6391153c0,0-0.1866302,0.0559711-0.5038776,0.0559711   c-0.3079071-0.009347-0.6251335-0.2519398-0.6251335-0.5225058c0.0093193-0.2425957,0.2892551-0.5131903,0.6531277-0.5131903   C19.0392532,10.6593904,19.2538757,10.7433596,19.2538757,10.7433596L19.2538757,10.7433596z M15.129755,10.4167948   c0,0,0.7651014-0.0373135,0.7651014,0.4105349c0,0.3825645-0.4385357,0.4105654-0.4385357,0.4105654   s0.1212854,0.0186548,0.1772842,0.1026249c0.0466537,0.0746536,0.3545609,0.6344719,0.3545609,0.6344719h-0.4665346   c0,0-0.0746508-0.0932837-0.1119642-0.1585951c-0.0280037-0.0653114-0.1119728-0.2052803-0.1119728-0.2052803   s-0.0653114-0.233284-0.2892494-0.233284c-0.0056572,0-0.0969143-0.0034513-0.1679392-0.0061502v0.6033096h-0.447875v-1.558197   H15.129755L15.129755,10.4167948z M14.8405056,11.1165819h0.2425966c0,0,0.3359079-0.0186558,0.3545599-0.223938   c0.0093184-0.1959372-0.3265648-0.2239065-0.3265648-0.2239065h-0.2705917V11.1165819L14.8405056,11.1165819z    M16.7159538,11.3591747h0.7464428v-0.2892494h-0.7464428v-0.3545599h0.811758v-0.2985706h-1.2689495v1.558197h1.2782898   v-0.2799053h-0.8210983V11.3591747L16.7159538,11.3591747z M18.5354023,12.5534964h0.457222v-0.3172216h-0.457222V12.5534964   L18.5354023,12.5534964z M18.5354023,13.9157572h0.457222v-1.1849756h-0.457222V13.9157572L18.5354023,13.9157572z    M13.5528746,11.9749918h0.447876v-1.558197h-0.447876V11.9749918L13.5528746,11.9749918z M11.4628286,12.3668995h0.9330654   c0,0,0.9237242-0.0186825,0.9143877,0.8210697c-0.0093145,0.6251602-0.8957272,0.7184696-0.8957272,0.7184696h-0.951726V12.3668995   L11.4628286,12.3668995z M11.920023,13.6171865h0.2985888c0,0,0.6158209-0.0373125,0.6158209-0.5131865   c0-0.4758463-0.6531305-0.5225058-0.6531305-0.5225058H11.920023V13.6171865L11.920023,13.6171865z M11.920023,11.6764278   h0.2985888c0,0,0.6158209-0.0466528,0.6158209-0.5131874c0-0.4851913-0.6531305-0.5225077-0.6531305-0.5225077H11.920023   V11.6764278L11.920023,11.6764278z"
            fill="#1A237E"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M7.2734008,11.3537521v3.1218481   c0,0-1.8101335-0.3265648-1.8101335-1.5675402C5.4632673,11.9183559,6.8032398,11.4821472,7.2734008,11.3537521   L7.2734008,11.3537521z M7.2734008,11.2954912c-1.0879493-0.0787497-3.5549557,0.4312477-3.5549557,1.5472546   c0,0.727788,1.3062861,1.7914782,3.4336717,1.8194828c0.0839691,0,2.500576-0.0933123,2.4632654-2.6872368   C9.5840454,9.7964535,7.9534235,9.4148455,7.4320273,9.3484344V9.2156038   c2.0786977,0.1319313,3.7135825,1.3820429,3.7135825,2.8993568c0,1.6048536-1.8288193,2.9111433-4.0774889,2.9111433   C4.8194485,15.026104,3,13.7198143,3,12.1149607C3,10.5101099,4.8194485,9.203824,7.068121,9.203824   c0.0688787,0,0.1372962,0.0012178,0.2052798,0.0037079V11.2954912L7.2734008,11.2954912z"
            fill="#1A237E"
            fillRule="evenodd"
          />
        </g>
      );
    default:
      return null;
  }
};

const SVGIcon = ({
  width = '100%',
  height = '100%',
  fillColor = '#ccccca',
  icon,
}: {
  width?: string | number;
  height?: string | number;
  fillColor?: string;
  icon: string;
}) => {
  return (
    <svg viewBox="0 0 56.3 56.3" version="1.1" xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
      <Icon icon={icon} fillColor={fillColor} />
    </svg>
  );
};

/**
 * Register SVG Icons for use with fluent UI library.
 */
registerIcons({
  icons: {
    [P4SVGIcon.TradeCounterStockAdjustPlus]: <SVGIcon icon={P4SVGIcon.TradeCounterStockAdjustPlus} />,
    [P4SVGIcon.TradeCounterVoidLine]: <SVGIcon icon={P4SVGIcon.TradeCounterVoidLine} />,
    [P4SVGIcon.TradeCounterBatchAllocation]: <SVGIcon icon={P4SVGIcon.TradeCounterBatchAllocation} />,
  },
});

SVGIcon.defaultProps = {};

export default SVGIcon;
